// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/normalize.css/normalize.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-toastify/dist/ReactToastify.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("config/fonts/sourcesanspro_regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("config/fonts/sourcesanspro_regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("config/fonts/sourcesanspro_italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("config/fonts/sourcesanspro_italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("config/fonts/sourcesanspro_light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("config/fonts/sourcesanspro_light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("config/fonts/sourcesanspro_light_italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("config/fonts/sourcesanspro_light_italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("config/fonts/sourcesanspro_semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("config/fonts/sourcesanspro_semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("config/fonts/sourcesanspro_semibold_italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("config/fonts/sourcesanspro_semibold_italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("config/fonts/sourcesanspro_bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("config/fonts/sourcesanspro_bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('ttf');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('ttf');
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('ttf');
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('ttf');
  font-weight: 300;
  font-style: italic;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('ttf');
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('ttf');
  font-weight: 600;
  font-style: italic;
}
@font-face {
  font-family: "Source Sans Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('ttf');
  font-weight: 800;
  font-style: normal;
}
/*

  Variables
  ---------

  Define variables.

*/
/*

  Media
  -----

  Define media queries.

*/
/*

  Base
  ----

  This file contains the site's base styles.
  It also contains styling for markup that's generated server side as it's too
  convoluted to add classes directly to it.

*/
* {
  box-sizing: border-box;
}
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  max-height: 100vh;
  min-width: 320px;
}
@media screen and (max-width: 520px) {
  html,
  body {
    height: auto;
    max-height: none;
    overflow-y: auto;
  }
}
body {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Source Sans Pro", "Arial", sans-serif;
  line-height: 1.5;
  font-size: 16px;
  color: #111111;
  background-color: #FFFFFF;
}
#app {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
}
.layout-width-constraint {
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
  max-width: 1400px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
@media screen and (max-width: 768px) {
  .layout-width-constraint {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media screen and (max-width: 520px) {
  .layout-width-constraint {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}
button,
input,
textarea,
select {
  color: inherit;
  background-color: transparent;
}
button,
input:not([type=checkbox]):not([type=radio]),
textarea,
select {
  border-radius: 0;
  -moz-appearance: none;
  -webkit-appearance: none;
}
button {
  border: none;
  outline: none;
}
td {
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
}
a {
  color: #00719F;
}
span.wj {
  font-size: 0 !important;
}
span.fc-em {
  font-style: italic;
}
.loading {
  animation: big-loader 2s infinite linear;
  width: 1em;
  height: 1em;
  border: 0.1em solid;
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
}
@-moz-keyframes big-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes big-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes big-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
summary {
  /* Standard property for most browsers (Firefox, Chrome, Edge) */
  list-style: none;
}
/* Specific vendor prefix for WebKit-based browsers (Safari, older Chrome/Edge) */
summary::-webkit-details-marker {
  display: none;
}
.spin-to-win {
  animation: big-loader 2s infinite linear;
}
/*

  Layout
  ------

  Utility classes for layout.

*/
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-hidden {
  overflow: hidden;
}
.overflow-fade {
  overflow: hidden;
  position: relative;
}
.overflow-fade::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4rem;
  background: linear-gradient(to bottom, transparent, #ffffff);
}
.collapse {
  border-collapse: collapse;
  border-spacing: 0;
}
.db {
  display: block;
}
.dib {
  display: inline-block;
}
.di {
  display: inline;
}
.dn {
  display: none;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
@media screen and (max-width: 768px) {
  .db-t {
    display: block;
  }
  .dib-t {
    display: inline-block;
  }
  .di-t {
    display: inline;
  }
  .dn-t {
    display: none;
  }
  .flex-t {
    display: flex;
  }
  .inline-flex-t {
    display: inline-flex;
  }
}
@media screen and (max-width: 520px) {
  .db-m {
    display: block;
  }
  .dib-m {
    display: inline-block;
  }
  .di-m {
    display: inline;
  }
  .dn-m {
    display: none;
  }
  .flex-m {
    display: flex;
  }
  .inline-flex-m {
    display: inline-flex;
  }
  .contents-m {
    display: contents;
  }
}
@media screen and (min-width: 769px) {
  .dn-d {
    display: none;
  }
  .db-d {
    display: block;
  }
}
@media screen and (min-width: 1200px) {
  .db-l {
    display: block;
  }
  .dn-l {
    display: none;
  }
  .flex-l {
    display: flex;
  }
}
.flexy {
  flex: 1 1 auto;
}
.flex-1 {
  flex: 1 1 0%;
}
@media screen and (max-width: 520px) {
  .flexy-m {
    flex: 1 1 auto;
  }
}
.flex-column {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}
.flex-column-reverse {
  flex-direction: column-reverse;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
@media screen and (max-width: 768px) {
  .flex-column-t {
    flex-direction: column;
  }
  .flex-row-t {
    flex-direction: row;
  }
  .flex-column-reverse-t {
    flex-direction: column-reverse;
  }
  .flex-row-reverse-t {
    flex-direction: row-reverse;
  }
}
@media screen and (max-width: 520px) {
  .flex-column-m {
    flex-direction: column;
  }
  .flex-row-m {
    flex-direction: row;
  }
  .flex-column-reverse-m {
    flex-direction: column-reverse;
  }
  .flex-row-reverse-m {
    flex-direction: row-reverse;
  }
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
@media screen and (max-width: 520px) {
  .order-1-m {
    order: 1;
  }
  .order-2-m {
    order: 2;
  }
  .order-3-m {
    order: 3;
  }
  .order-4-m {
    order: 4;
  }
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
@media screen and (max-width: 768px) {
  .flex-wrap-t {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 520px) {
  .flex-wrap-m {
    flex-wrap: wrap;
  }
}
.content-start {
  align-content: flex-start;
}
.content-end {
  align-content: flex-end;
}
.content-center {
  align-content: center;
}
.content-baseline {
  align-content: baseline;
}
.content-stretch {
  align-content: stretch;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
@media screen and (max-width: 768px) {
  .items-start-t {
    align-items: flex-start;
  }
  .items-end-t {
    align-items: flex-end;
  }
  .items-center-t {
    align-items: center;
  }
  .items-baseline-t {
    align-items: baseline;
  }
  .items-stretch-t {
    align-items: stretch;
  }
}
@media screen and (max-width: 520px) {
  .items-start-m {
    align-items: flex-start;
  }
  .items-end-m {
    align-items: flex-end;
  }
  .items-center-m {
    align-items: center;
  }
  .items-baseline-m {
    align-items: baseline;
  }
  .items-stretch-m {
    align-items: stretch;
  }
}
.self-end {
  align-self: flex-end;
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
@media screen and (max-width: 768px) {
  .self-end-t {
    align-self: flex-end;
  }
  .self-start-t {
    align-self: flex-start;
  }
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-evenly {
  justify-content: space-around;
  justify-content: space-evenly;
}
@media screen and (max-width: 768px) {
  .justify-start-t {
    justify-content: flex-start;
  }
  .justify-end-t {
    justify-content: flex-end;
  }
  .justify-center-t {
    justify-content: center;
  }
  .justify-between-t {
    justify-content: space-between;
  }
  .justify-evenly-t {
    justify-content: space-around;
    justify-content: space-evenly;
  }
}
@media screen and (max-width: 520px) {
  .justify-start-m {
    justify-content: flex-start;
  }
  .justify-end-m {
    justify-content: flex-end;
  }
  .justify-center-m {
    justify-content: center;
  }
  .justify-between-m {
    justify-content: space-between;
  }
  .justify-evenly-m {
    justify-content: space-around;
    justify-content: space-evenly;
  }
}
.valign-top {
  vertical-align: top;
}
.valign-text-top {
  vertical-align: text-top;
}
.valign-middle {
  vertical-align: middle;
}
.valign-bottom {
  vertical-align: bottom;
}
.valign-text-bottom {
  vertical-align: text-bottom;
}
.valign-super {
  vertical-align: super;
}
.valign-sub {
  vertical-align: sub;
}
.basis0 {
  flex-basis: 0;
}
.basis-auto {
  min-width: 0;
  min-height: 0;
  flex-basis: auto;
}
.basis-50 {
  flex-basis: 50%;
}
.basis-100 {
  flex-basis: 100%;
}
@media screen and (max-width: 768px) {
  .basis0-t {
    flex-basis: 0;
  }
  .basis-auto-t {
    min-width: 0;
    min-height: 0;
    flex-basis: auto;
  }
  .basis-100-t {
    flex-basis: 100%;
  }
}
.grow-0 {
  flex-grow: 0;
}
.grow-1 {
  flex-grow: 1;
}
.grow-2 {
  flex-grow: 2;
}
.grow-3 {
  flex-grow: 3;
}
.grow-4 {
  flex-grow: 4;
}
.grow-5 {
  flex-grow: 5;
}
.grow-initial {
  flex-grow: initial;
}
@media screen and (max-width: 768px) {
  .grow-0-t {
    flex-grow: 0;
  }
  .grow-1-t {
    flex-grow: 1;
  }
  .grow-2-t {
    flex-grow: 2;
  }
  .grow-3-t {
    flex-grow: 3;
  }
  .grow-4-t {
    flex-grow: 4;
  }
  .grow-5-t {
    flex-grow: 5;
  }
  .grow-initial-t {
    flex-grow: initial;
  }
}
@media screen and (max-width: 520px) {
  .grow-0-m {
    flex-grow: 0;
  }
  .grow-1-m {
    flex-grow: 1;
  }
  .grow-2-m {
    flex-grow: 2;
  }
  .grow-3-m {
    flex-grow: 3;
  }
  .grow-4-m {
    flex-grow: 4;
  }
  .grow-5-m {
    flex-grow: 5;
  }
}
.shrink-0 {
  flex-shrink: 0;
}
.shrink-1 {
  flex-shrink: 1;
}
.shrink-2 {
  flex-shrink: 2;
}
@media screen and (max-width: 768px) {
  .shrink-0-t {
    flex-shrink: 0;
  }
  .shrink-1-t {
    flex-shrink: 1;
  }
}
@media screen and (max-width: 520px) {
  .shrink-0-m {
    flex-shrink: 0;
  }
  .shrink-1-m {
    flex-shrink: 1;
  }
}
.flt-l {
  float: left;
}
.flt-n {
  float: none;
}
.flt-r {
  float: right;
}
.static {
  position: static;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.fixed {
  position: fixed;
}
.sticky {
  position: -webkit-sticky;
  position: sticky;
}
@media screen and (min-width: 1200px) {
  .sticky-l {
    position: -webkit-sticky;
    position: sticky;
  }
}
@media screen and (max-width: 768px) {
  .static-t {
    position: static;
  }
  .relative-t {
    position: relative;
  }
  .absolute-t {
    position: absolute;
  }
  .fixed-t {
    position: fixed;
  }
  .sticky-t {
    position: -webkit-sticky;
    position: sticky;
  }
}
@media screen and (max-width: 520px) {
  .static-m {
    position: static;
  }
  .relative-m {
    position: relative;
  }
  .absolute-m {
    position: absolute;
  }
  .fixed-m {
    position: fixed;
  }
  .sticky-m {
    position: -webkit-sticky;
    position: sticky;
  }
}
.z0 {
  z-index: 0;
}
.z5 {
  z-index: 5;
}
.z10 {
  z-index: 10;
}
.z15 {
  z-index: 15;
}
.z20 {
  z-index: 20;
}
.z25 {
  z-index: 25;
}
.z30 {
  z-index: 30;
}
.z35 {
  z-index: 35;
}
.z40 {
  z-index: 40;
}
.z45 {
  z-index: 45;
}
.z50 {
  z-index: 50;
}
.z55 {
  z-index: 55;
}
.z60 {
  z-index: 60;
}
.z105 {
  z-index: 105;
}
.z1055 {
  z-index: 1055;
}
.right0 {
  right: 0;
}
.right2 {
  right: 0.25rem;
}
.right3 {
  right: 0.375rem;
}
.right4 {
  right: 0.5rem;
}
.right5 {
  right: 0.75rem;
}
.right6 {
  right: 1rem;
}
.right7 {
  right: 1.5rem;
}
.right9 {
  right: 3rem;
}
.right-50 {
  right: 50%;
}
.right-100 {
  right: 100%;
}
.-right3 {
  right: -0.375rem;
}
.left0 {
  left: 0;
}
.left2 {
  left: 0.25rem;
}
.left4 {
  left: 0.5rem;
}
.left5 {
  left: 0.75rem;
}
.left6 {
  left: 1rem;
}
.left7 {
  left: 1.5rem;
}
.left8 {
  left: 2rem;
}
.left-50 {
  left: 50%;
}
.left-100 {
  left: 100%;
}
.-left5 {
  left: -0.75rem;
}
.top0 {
  top: 0;
}
.top1 {
  top: 0.125rem;
}
.top2 {
  top: 0.25rem;
}
.top3 {
  top: 0.375rem;
}
.top4 {
  top: 0.5rem;
}
.top5 {
  top: 0.75rem;
}
.top6 {
  top: 1rem;
}
.top7 {
  top: 1.5rem;
}
.top8 {
  top: 2rem;
}
.top9 {
  top: 3rem;
}
.top10 {
  top: 4rem;
}
.top11 {
  top: 6rem;
}
.top12 {
  top: 8rem;
}
.top-15 {
  top: 15%;
}
.top-25 {
  top: 25%;
}
.top-50 {
  top: 50%;
}
.top-100 {
  top: 100%;
}
.-top9 {
  top: -3rem;
}
.-top10 {
  top: -4rem;
}
@media screen and (max-width: 768px) {
  .top4-t {
    top: 0.5rem;
  }
}
.bottom0 {
  bottom: 0;
}
.bottom1 {
  bottom: 0.125rem;
}
.bottom2 {
  bottom: 0.25rem;
}
.bottom3 {
  bottom: 0.375rem;
}
.bottom4 {
  bottom: 0.5rem;
}
.bottom5 {
  bottom: 0.75rem;
}
.bottom6 {
  bottom: 1rem;
}
.bottom7 {
  bottom: 1.5rem;
}
.bottom12 {
  bottom: 8rem;
}
.bottom13 {
  bottom: 12rem;
}
.bottom-50 {
  bottom: 50%;
}
.bottom-100 {
  bottom: 100%;
}
.-bottom5 {
  bottom: -0.75rem;
}
.w0 {
  width: 0;
}
.w1 {
  width: 0.125rem;
}
.w2 {
  width: 0.25rem;
}
.w3 {
  width: 0.375rem;
}
.w4 {
  width: 0.5rem;
}
.w4-half {
  width: 0.625rem;
}
.w5 {
  width: 0.75rem;
}
.w6 {
  width: 1rem;
}
.w7 {
  width: 1.5rem;
}
.w8 {
  width: 2rem;
}
.w8-half {
  width: 2.5rem;
}
.w9 {
  width: 3rem;
}
.w10 {
  width: 4rem;
}
.w11 {
  width: 6rem;
}
.w11-half {
  width: 7rem;
}
.w12 {
  width: 8rem;
}
.w12-half {
  width: 9.25rem;
}
.w13 {
  width: 12rem;
}
.w14 {
  width: 16rem;
}
.w14-half {
  width: 24rem;
}
.w15 {
  width: 32rem;
}
.w16 {
  width: 48rem;
}
.w17 {
  width: 64rem;
}
.w18 {
  width: 96rem;
}
.w-10 {
  width: 10%;
}
.w-20 {
  width: 20%;
}
.w-25 {
  width: 25%;
}
.w-30 {
  width: 30%;
}
.w-33 {
  width: 33%;
}
.w-34 {
  width: 34%;
}
.w-40 {
  width: 40%;
}
.w-50 {
  width: 50%;
}
.w-55 {
  width: 55%;
}
.w-60 {
  width: 60%;
}
.w-65 {
  width: 65%;
}
.w-70 {
  width: 70%;
}
.w-75 {
  width: 75%;
}
.w-80 {
  width: 80%;
}
.w-90 {
  width: 90%;
}
.w-95 {
  width: 95%;
}
.w-100 {
  width: 100%;
}
.w-third {
  width: calc(100% / 3);
}
.w-two-thirds {
  width: calc(100% / 1.5);
}
.w-auto {
  width: auto;
}
.w-max-content {
  width: max-content;
}
.vw-90 {
  width: 90vw;
}
.vw-100 {
  width: 100vw;
}
@media screen and (max-width: 768px) {
  .w13-t {
    width: 12rem;
  }
  .w-100-t {
    width: 100%;
  }
  .w8-t {
    width: 2rem;
  }
  .w-95-t {
    width: 95%;
  }
  .w-100-t {
    width: 100%;
  }
  .vw-100-t {
    width: 100vw;
  }
}
@media screen and (max-width: 520px) {
  .w5-m {
    width: 0.75rem;
  }
  .w6-m {
    width: 1rem;
  }
  .w7-m {
    width: 1.5rem;
  }
  .w8-m {
    width: 2rem;
  }
  .w10-m {
    width: 4rem;
  }
  .w-100-m {
    width: 100%;
  }
  .w-auto-m {
    width: auto;
  }
  .vw-100-m {
    width: 100vw;
  }
}
@media screen and (min-width: 1200px) {
  .w16-l {
    width: 48rem;
  }
  .w-50-l {
    width: 50%;
  }
}
.max-w0 {
  max-width: 0;
}
.max-w1 {
  max-width: 0.125rem;
}
.max-w2 {
  max-width: 0.25rem;
}
.max-w3 {
  max-width: 0.375rem;
}
.max-w4 {
  max-width: 0.5rem;
}
.max-w5 {
  max-width: 0.75rem;
}
.max-w6 {
  max-width: 1rem;
}
.max-w7 {
  max-width: 1.5rem;
}
.max-w8 {
  max-width: 2rem;
}
.max-w9 {
  max-width: 3rem;
}
.max-w10 {
  max-width: 4rem;
}
.max-w11 {
  max-width: 6rem;
}
.max-w12 {
  max-width: 8rem;
}
.max-w13 {
  max-width: 12rem;
}
.max-w14 {
  max-width: 16rem;
}
.max-w14-half {
  max-width: 24rem;
}
.max-w15 {
  max-width: 32rem;
}
.max-w16 {
  max-width: 48rem;
}
.max-w17 {
  max-width: 64rem;
}
.max-w18 {
  max-width: 96rem;
}
.max-w-90 {
  max-width: 90%;
}
.max-w-94 {
  max-width: 94%;
}
.max-w-100 {
  max-width: 100%;
}
.max-w-90vw {
  max-width: 90vw;
}
.max-w-100vw {
  max-width: 100vw;
}
.max-w-none {
  max-width: none;
}
.max-w-inherit {
  max-width: inherit;
}
.max-w-modal-small {
  max-width: 23.75rem;
}
.max-w-modal-medium {
  max-width: 35rem;
}
.max-w-modal-large {
  max-width: 45rem;
}
@media screen and (max-width: 768px) {
  .max-w-none-t {
    max-width: none;
  }
}
.min-w0 {
  min-width: 0;
}
.min-w1 {
  min-width: 0.125rem;
}
.min-w2 {
  min-width: 0.25rem;
}
.min-w3 {
  min-width: 0.375rem;
}
.min-w4 {
  min-width: 0.5rem;
}
.min-w5 {
  min-width: 0.75rem;
}
.min-w6 {
  min-width: 1rem;
}
.min-w7 {
  min-width: 1.5rem;
}
.min-w8 {
  min-width: 2rem;
}
.min-w9 {
  min-width: 3rem;
}
.min-w10 {
  min-width: 4rem;
}
.min-w11 {
  min-width: 6rem;
}
.min-w12 {
  min-width: 8rem;
}
.min-w13 {
  min-width: 12rem;
}
.min-w14 {
  min-width: 16rem;
}
.min-w15 {
  min-width: 32rem;
}
.min-w16 {
  min-width: 48rem;
}
.min-w17 {
  min-width: 64rem;
}
.min-w18 {
  min-width: 96rem;
}
.min-w-80 {
  min-width: 80%;
}
.min-w-100 {
  min-width: 100%;
}
.min-w-none {
  min-width: 0;
}
.min-w-button {
  min-width: var(--button-width);
}
@media screen and (max-width: 520px) {
  .min-w9-m {
    min-width: 3rem;
  }
}
.h0 {
  height: 0;
}
.h1 {
  height: 1rem;
}
.h2 {
  height: 2rem;
}
.h3 {
  height: 3rem;
}
.h4 {
  height: 4rem;
}
.h5 {
  height: 5rem;
}
.h6 {
  height: 6rem;
}
.h7 {
  height: 7rem;
}
.h8 {
  height: 8rem;
}
.h10 {
  height: 10rem;
}
.h12 {
  height: 12rem;
}
.h14 {
  height: 14rem;
}
.h16 {
  height: 16rem;
}
.h-25 {
  height: 25%;
}
.h-50 {
  height: 50%;
}
.h-75 {
  height: 75%;
}
.h-100 {
  height: 100%;
}
.vh-25 {
  height: 25vh;
}
.vh-50 {
  height: 50vh;
}
.vh-75 {
  height: 75vh;
}
.vh-100 {
  height: 100vh;
}
.h-auto {
  height: auto;
}
.h-inherit {
  height: inherit;
}
.hs0 {
  height: 0;
}
.hs0-half {
  height: 0.0625;
}
.hs1 {
  height: 0.125rem;
}
.hs2 {
  height: 0.25rem;
}
.hs3 {
  height: 0.375rem;
}
.hs4 {
  height: 0.5rem;
}
.hs5 {
  height: 0.75rem;
}
.hs6 {
  height: 1rem;
}
.hs7 {
  height: 1.5rem;
}
.hs8 {
  height: 2rem;
}
.hs8-half {
  height: 2.5rem;
}
.hs9 {
  height: 3rem;
}
.hs10 {
  height: 4rem;
}
.hs11 {
  height: 6rem;
}
.hs12 {
  height: 8rem;
}
.hs13 {
  height: 12rem;
}
.hs14 {
  height: 16rem;
}
@media screen and (max-width: 520px) {
  .h1-m {
    height: 1rem;
  }
  .h2-m {
    height: 2rem;
  }
  .h3-m {
    height: 3rem;
  }
  .h4-m {
    height: 4rem;
  }
  .h5-m {
    height: 5rem;
  }
  .h6-m {
    height: 6rem;
  }
}
.min-h-0 {
  min-height: 0;
}
.min-h2 {
  min-height: 2rem;
}
.min-h3 {
  min-height: 3rem;
}
.min-h4 {
  min-height: 4rem;
}
.min-h8 {
  min-height: 8rem;
}
.min-h12 {
  min-height: 12rem;
}
.min-h-spacing-9 {
  min-height: 3rem;
}
.min-h-spacing-14 {
  min-height: 16rem;
}
.min-h-spacing-15 {
  min-height: 32rem;
}
.min-h-100 {
  min-height: 100%;
}
.min-vh-100 {
  min-height: 100vh;
}
.min-h-inherit {
  min-height: inherit;
}
.max-h0 {
  max-height: 0;
}
.max-h3 {
  max-height: 3rem;
}
.max-h4 {
  max-height: 4rem;
}
.max-h7 {
  max-height: 7rem;
}
.max-h8 {
  max-height: 2rem;
}
.max-h16 {
  max-height: 16rem;
}
.max-h24 {
  max-height: 24rem;
}
.max-h-75 {
  max-height: 75%;
}
@media screen and (max-width: 768px) {
  .max-h8-t {
    max-height: 2rem;
  }
}
/*

  Spacing
  -------

  Utility classes for margins and paddings.

*/
.gap0 {
  gap: 0;
}
.gap1 {
  gap: 0.125rem;
}
.gap2 {
  gap: 0.25rem;
}
.gap3 {
  gap: 0.375rem;
}
.gap4 {
  gap: 0.5rem;
}
.gap4-half {
  gap: 0.625rem;
}
.gap5 {
  gap: 0.75rem;
}
.gap5-half {
  gap: 0.875rem;
}
.gap6 {
  gap: 1rem;
}
.gap7 {
  gap: 1.5rem;
}
.gap8 {
  gap: 2rem;
}
.gap9 {
  gap: 3rem;
}
.gap10 {
  gap: 4rem;
}
.gap11 {
  gap: 6rem;
}
.gap12 {
  gap: 8rem;
}
.gap13 {
  gap: 12rem;
}
.gap14 {
  gap: 16rem;
}
@media screen and (max-width: 520px) {
  .gap8-m {
    gap: 2rem;
  }
}
.pa0 {
  padding: 0;
}
.pa1 {
  padding: 0.125rem;
}
.pa2 {
  padding: 0.25rem;
}
.pa3 {
  padding: 0.375rem;
}
.pa4 {
  padding: 0.5rem;
}
.pa5 {
  padding: 0.75rem;
}
.pa6 {
  padding: 1rem;
}
.pa7 {
  padding: 1.5rem;
}
.pa8 {
  padding: 2rem;
}
.pa9 {
  padding: 3rem;
}
.pa10 {
  padding: 4rem;
}
.pa11 {
  padding: 6rem;
}
.pa12 {
  padding: 8rem;
}
.pa13 {
  padding: 12rem;
}
.pa14 {
  padding: 16rem;
}
@media screen and (max-width: 768px) {
  .pa0-t {
    padding: 0;
  }
  .pa1-t {
    padding: 0.125rem;
  }
  .pa2-t {
    padding: 0.25rem;
  }
  .pa3-t {
    padding: 0.375rem;
  }
  .pa4-t {
    padding: 0.5rem;
  }
  .pa5-t {
    padding: 0.75rem;
  }
  .pa6-t {
    padding: 1rem;
  }
  .pa7-t {
    padding: 1.5rem;
  }
  .pa8-t {
    padding: 2rem;
  }
  .pa9-t {
    padding: 3rem;
  }
  .pa11-t {
    padding: 4rem;
  }
  .pa10-t {
    padding: 6rem;
  }
  .pa12-t {
    padding: 8rem;
  }
  .pa13-t {
    padding: 12rem;
  }
  .pa14-t {
    padding: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pa0-m {
    padding: 0;
  }
  .pa1-m {
    padding: 0.125rem;
  }
  .pa2-m {
    padding: 0.25rem;
  }
  .pa3-m {
    padding: 0.375rem;
  }
  .pa4-m {
    padding: 0.5rem;
  }
  .pa5-m {
    padding: 0.75rem;
  }
  .pa6-m {
    padding: 1rem;
  }
  .pa7-m {
    padding: 1.5rem;
  }
  .pa8-m {
    padding: 2rem;
  }
  .pa9-m {
    padding: 3rem;
  }
  .pa11-m {
    padding: 4rem;
  }
  .pa10-m {
    padding: 6rem;
  }
  .pa12-m {
    padding: 8rem;
  }
  .pa13-m {
    padding: 12rem;
  }
  .pa14-m {
    padding: 16rem;
  }
}
.pl0 {
  padding-left: 0;
}
.pl1 {
  padding-left: 0.125rem;
}
.pl2 {
  padding-left: 0.25rem;
}
.pl3 {
  padding-left: 0.375rem;
}
.pl4 {
  padding-left: 0.5rem;
}
.pl5 {
  padding-left: 0.75rem;
}
.pl6 {
  padding-left: 1rem;
}
.pl7 {
  padding-left: 1.5rem;
}
.pl8 {
  padding-left: 2rem;
}
.pl9 {
  padding-left: 3rem;
}
.pl10 {
  padding-left: 4rem;
}
.pl11 {
  padding-left: 6rem;
}
.pl12 {
  padding-left: 8rem;
}
.pl13 {
  padding-left: 12rem;
}
.pl14 {
  padding-left: 16rem;
}
@media screen and (max-width: 768px) {
  .pl0-t {
    padding-left: 0;
  }
  .pl1-t {
    padding-left: 0.125rem;
  }
  .pl2-t {
    padding-left: 0.25rem;
  }
  .pl3-t {
    padding-left: 0.375rem;
  }
  .pl4-t {
    padding-left: 0.5rem;
  }
  .pl5-t {
    padding-left: 0.75rem;
  }
  .pl6-t {
    padding-left: 1rem;
  }
  .pl7-t {
    padding-left: 1.5rem;
  }
  .pl8-t {
    padding-left: 2rem;
  }
  .pl9-t {
    padding-left: 3rem;
  }
  .pl11-t {
    padding-left: 4rem;
  }
  .pl10-t {
    padding-left: 6rem;
  }
  .pl12-t {
    padding-left: 8rem;
  }
  .pl13-t {
    padding-left: 12rem;
  }
  .pl14-t {
    padding-left: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pl0-m {
    padding-left: 0;
  }
  .pl1-m {
    padding-left: 0.125rem;
  }
  .pl2-m {
    padding-left: 0.25rem;
  }
  .pl3-m {
    padding-left: 0.375rem;
  }
  .pl4-m {
    padding-left: 0.5rem;
  }
  .pl5-m {
    padding-left: 0.75rem;
  }
  .pl6-m {
    padding-left: 1rem;
  }
  .pl7-m {
    padding-left: 1.5rem;
  }
  .pl8-m {
    padding-left: 2rem;
  }
  .pl9-m {
    padding-left: 3rem;
  }
  .pl11-m {
    padding-left: 4rem;
  }
  .pl10-m {
    padding-left: 6rem;
  }
  .pl12-m {
    padding-left: 8rem;
  }
  .pl13-m {
    padding-left: 12rem;
  }
  .pl14-m {
    padding-left: 16rem;
  }
}
@media screen and (min-width: 1200px) {
  .pl5-l {
    padding-left: 0.75rem;
  }
}
.pr0 {
  padding-right: 0;
}
.pr1 {
  padding-right: 0.125rem;
}
.pr2 {
  padding-right: 0.25rem;
}
.pr3 {
  padding-right: 0.375rem;
}
.pr4 {
  padding-right: 0.5rem;
}
.pr5 {
  padding-right: 0.75rem;
}
.pr6 {
  padding-right: 1rem;
}
.pr7 {
  padding-right: 1.5rem;
}
.pr8 {
  padding-right: 2rem;
}
.pr9 {
  padding-right: 3rem;
}
.pr10 {
  padding-right: 4rem;
}
.pr11 {
  padding-right: 6rem;
}
.pr12 {
  padding-right: 8rem;
}
.pr13 {
  padding-right: 12rem;
}
.pr14 {
  padding-right: 16rem;
}
@media screen and (max-width: 768px) {
  .pr0-t {
    padding-right: 0;
  }
  .pr1-t {
    padding-right: 0.125rem;
  }
  .pr2-t {
    padding-right: 0.25rem;
  }
  .pr3-t {
    padding-right: 0.375rem;
  }
  .pr4-t {
    padding-right: 0.5rem;
  }
  .pr5-t {
    padding-right: 0.75rem;
  }
  .pr6-t {
    padding-right: 1rem;
  }
  .pr7-t {
    padding-right: 1.5rem;
  }
  .pr8-t {
    padding-right: 2rem;
  }
  .pr9-t {
    padding-right: 3rem;
  }
  .pr11-t {
    padding-right: 4rem;
  }
  .pr10-t {
    padding-right: 6rem;
  }
  .pr12-t {
    padding-right: 8rem;
  }
  .pr13-t {
    padding-right: 12rem;
  }
  .pr14-t {
    padding-right: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pr0-m {
    padding-right: 0;
  }
  .pr1-m {
    padding-right: 0.125rem;
  }
  .pr2-m {
    padding-right: 0.25rem;
  }
  .pr3-m {
    padding-right: 0.375rem;
  }
  .pr4-m {
    padding-right: 0.5rem;
  }
  .pr5-m {
    padding-right: 0.75rem;
  }
  .pr6-m {
    padding-right: 1rem;
  }
  .pr7-m {
    padding-right: 1.5rem;
  }
  .pr8-m {
    padding-right: 2rem;
  }
  .pr9-m {
    padding-right: 3rem;
  }
  .pr11-m {
    padding-right: 4rem;
  }
  .pr10-m {
    padding-right: 6rem;
  }
  .pr12-m {
    padding-right: 8rem;
  }
  .pr13-m {
    padding-right: 12rem;
  }
  .pr14-m {
    padding-right: 16rem;
  }
}
@media screen and (min-width: 1200px) {
  .pr5-l {
    padding-right: 0.75rem;
  }
}
.pb0 {
  padding-bottom: 0;
}
.pb1 {
  padding-bottom: 0.125rem;
}
.pb2 {
  padding-bottom: 0.25rem;
}
.pb3 {
  padding-bottom: 0.375rem;
}
.pb4 {
  padding-bottom: 0.5rem;
}
.pb5 {
  padding-bottom: 0.75rem;
}
.pb6 {
  padding-bottom: 1rem;
}
.pb7 {
  padding-bottom: 1.5rem;
}
.pb8 {
  padding-bottom: 2rem;
}
.pb9 {
  padding-bottom: 3rem;
}
.pb10 {
  padding-bottom: 4rem;
}
.pb11 {
  padding-bottom: 6rem;
}
.pb12 {
  padding-bottom: 8rem;
}
.pb13 {
  padding-bottom: 12rem;
}
.pb14 {
  padding-bottom: 16rem;
}
.pb-80 {
  padding-bottom: 80%;
}
@media screen and (max-width: 768px) {
  .pb0-t {
    padding-bottom: 0;
  }
  .pb1-t {
    padding-bottom: 0.125rem;
  }
  .pb2-t {
    padding-bottom: 0.25rem;
  }
  .pb3-t {
    padding-bottom: 0.375rem;
  }
  .pb4-t {
    padding-bottom: 0.5rem;
  }
  .pb5-t {
    padding-bottom: 0.75rem;
  }
  .pb6-t {
    padding-bottom: 1rem;
  }
  .pb7-t {
    padding-bottom: 1.5rem;
  }
  .pb8-t {
    padding-bottom: 2rem;
  }
  .pb9-t {
    padding-bottom: 3rem;
  }
  .pb10-t {
    padding-bottom: 4rem;
  }
  .pb11-t {
    padding-bottom: 6rem;
  }
  .pb12-t {
    padding-bottom: 8rem;
  }
  .pb13-t {
    padding-bottom: 12rem;
  }
  .pb14-t {
    padding-bottom: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pb0-m {
    padding-bottom: 0;
  }
  .pb1-m {
    padding-bottom: 0.125rem;
  }
  .pb2-m {
    padding-bottom: 0.25rem;
  }
  .pb3-m {
    padding-bottom: 0.375rem;
  }
  .pb4-m {
    padding-bottom: 0.5rem;
  }
  .pb5-m {
    padding-bottom: 0.75rem;
  }
  .pb6-m {
    padding-bottom: 1rem;
  }
  .pb7-m {
    padding-bottom: 1.5rem;
  }
  .pb8-m {
    padding-bottom: 2rem;
  }
  .pb9-m {
    padding-bottom: 3rem;
  }
  .pb11-m {
    padding-bottom: 4rem;
  }
  .pb10-m {
    padding-bottom: 6rem;
  }
  .pb12-m {
    padding-bottom: 8rem;
  }
  .pb13-m {
    padding-bottom: 12rem;
  }
  .pb14-m {
    padding-bottom: 16rem;
  }
  .pb-80-m {
    padding-bottom: 80%;
  }
}
.pt0 {
  padding-top: 0;
}
.pt1 {
  padding-top: 0.125rem;
}
.pt2 {
  padding-top: 0.25rem;
}
.pt3 {
  padding-top: 0.375rem;
}
.pt4 {
  padding-top: 0.5rem;
}
.pt5 {
  padding-top: 0.75rem;
}
.pt6 {
  padding-top: 1rem;
}
.pt7 {
  padding-top: 1.5rem;
}
.pt8 {
  padding-top: 2rem;
}
.pt9 {
  padding-top: 3rem;
}
.pt10 {
  padding-top: 4rem;
}
.pt11 {
  padding-top: 6rem;
}
.pt12 {
  padding-top: 8rem;
}
.pt13 {
  padding-top: 12rem;
}
.pt14 {
  padding-top: 16rem;
}
@media screen and (max-width: 768px) {
  .pt0-t {
    padding-top: 0;
  }
  .pt1-t {
    padding-top: 0.125rem;
  }
  .pt2-t {
    padding-top: 0.25rem;
  }
  .pt3-t {
    padding-top: 0.375rem;
  }
  .pt4-t {
    padding-top: 0.5rem;
  }
  .pt5-t {
    padding-top: 0.75rem;
  }
  .pt6-t {
    padding-top: 1rem;
  }
  .pt7-t {
    padding-top: 1.5rem;
  }
  .pt8-t {
    padding-top: 2rem;
  }
  .pt9-t {
    padding-top: 3rem;
  }
  .pt11-t {
    padding-top: 4rem;
  }
  .pt10-t {
    padding-top: 6rem;
  }
  .pt12-t {
    padding-top: 8rem;
  }
  .pt13-t {
    padding-top: 12rem;
  }
  .pt14-t {
    padding-top: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pt0-m {
    padding-top: 0;
  }
  .pt1-m {
    padding-top: 0.125rem;
  }
  .pt2-m {
    padding-top: 0.25rem;
  }
  .pt3-m {
    padding-top: 0.375rem;
  }
  .pt4-m {
    padding-top: 0.5rem;
  }
  .pt5-m {
    padding-top: 0.75rem;
  }
  .pt6-m {
    padding-top: 1rem;
  }
  .pt7-m {
    padding-top: 1.5rem;
  }
  .pt8-m {
    padding-top: 2rem;
  }
  .pt9-m {
    padding-top: 3rem;
  }
  .pt11-m {
    padding-top: 4rem;
  }
  .pt10-m {
    padding-top: 6rem;
  }
  .pt12-m {
    padding-top: 8rem;
  }
  .pt13-m {
    padding-top: 12rem;
  }
  .pt14-m {
    padding-top: 16rem;
  }
}
.pv0 {
  padding-top: 0;
  padding-bottom: 0;
}
.pv0-half {
  padding-top: 0.0625;
  padding-bottom: 0.0625;
}
.pv1 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.pv2 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.pv3 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.pv4 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.pv4-half {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.pv5 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.pv6 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pv7 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pv8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pv9 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.pv10 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.pv11 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.pv12 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.pv13 {
  padding-top: 12rem;
  padding-bottom: 12rem;
}
.pv14 {
  padding-top: 16rem;
  padding-bottom: 16rem;
}
@media screen and (max-width: 768px) {
  .pv0-t {
    padding-top: 0;
    padding-bottom: 0;
  }
  .pv1-t {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }
  .pv2-t {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .pv3-t {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .pv4-t {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .pv5-t {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .pv6-t {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .pv7-t {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .pv8-t {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .pv9-t {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .pv11-t {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .pv10-t {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .pv12-t {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .pv13-t {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }
  .pv14-t {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .pv0-m {
    padding-top: 0;
    padding-bottom: 0;
  }
  .pv1-m {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }
  .pv2-m {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .pv3-m {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .pv4-m {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .pv5-m {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .pv6-m {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .pv7-m {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .pv8-m {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .pv9-m {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .pv11-m {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .pv10-m {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .pv12-m {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .pv13-m {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }
  .pv14-m {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }
}
.ph0 {
  padding-left: 0;
  padding-right: 0;
}
.ph1 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.ph2 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.ph3 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.ph4 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.ph5 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.ph6 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.ph7 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.ph8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.ph9 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.ph10 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.ph11 {
  padding-left: 6rem;
  padding-right: 6rem;
}
.ph12 {
  padding-left: 8rem;
  padding-right: 8rem;
}
.ph13 {
  padding-left: 12rem;
  padding-right: 12rem;
}
.ph14 {
  padding-left: 16rem;
  padding-right: 16rem;
}
@media screen and (max-width: 768px) {
  .ph0-t {
    padding-left: 0;
    padding-right: 0;
  }
  .ph1-t {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
  }
  .ph2-t {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .ph3-t {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }
  .ph4-t {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .ph5-t {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .ph6-t {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .ph7-t {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .ph8-t {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .ph9-t {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .ph11-t {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .ph10-t {
    padding-left: 6rem;
    padding-right: 6rem;
  }
  .ph12-t {
    padding-left: 8rem;
    padding-right: 8rem;
  }
  .ph13-t {
    padding-left: 12rem;
    padding-right: 12rem;
  }
  .ph14-t {
    padding-left: 16rem;
    padding-right: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .ph0-m {
    padding-left: 0;
    padding-right: 0;
  }
  .ph1-m {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
  }
  .ph2-m {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .ph3-m {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }
  .ph4-m {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .ph5-m {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .ph6-m {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .ph7-m {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .ph8-m {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .ph9-m {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .ph11-m {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .ph10-m {
    padding-left: 6rem;
    padding-right: 6rem;
  }
  .ph12-m {
    padding-left: 8rem;
    padding-right: 8rem;
  }
  .ph13-m {
    padding-left: 12rem;
    padding-right: 12rem;
  }
  .ph14-m {
    padding-left: 16rem;
    padding-right: 16rem;
  }
}
.ma0 {
  margin: 0;
}
.ma1 {
  margin: 0.125rem;
}
.ma2 {
  margin: 0.25rem;
}
.ma3 {
  margin: 0.375rem;
}
.ma4 {
  margin: 0.5rem;
}
.ma5 {
  margin: 0.75rem;
}
.ma6 {
  margin: 1rem;
}
.ma7 {
  margin: 1.5rem;
}
.ma8 {
  margin: 2rem;
}
.ma9 {
  margin: 3rem;
}
.ma10 {
  margin: 4rem;
}
.ma10-half {
  margin: 5rem;
}
.ma11 {
  margin: 6rem;
}
.ma11-half {
  margin: 7rem;
}
.ma12 {
  margin: 8rem;
}
.ma13 {
  margin: 12rem;
}
.ma14 {
  margin: 16rem;
}
.maauto {
  margin: auto;
}
@media screen and (max-width: 768px) {
  .ma0-t {
    margin: 0;
  }
  .ma1-t {
    margin: 0.125rem;
  }
  .ma2-t {
    margin: 0.25rem;
  }
  .ma3-t {
    margin: 0.375rem;
  }
  .ma4-t {
    margin: 0.5rem;
  }
  .ma5-t {
    margin: 0.75rem;
  }
  .ma6-t {
    margin: 1rem;
  }
  .ma7-t {
    margin: 1.5rem;
  }
  .ma8-t {
    margin: 2rem;
  }
  .ma9-t {
    margin: 3rem;
  }
  .ma10-t {
    margin: 6rem;
  }
  .ma10-half-t {
    margin: 5rem;
  }
  .ma11-t {
    margin: 4rem;
  }
  .ma11-half-t {
    margin: 7rem;
  }
  .ma12-t {
    margin: 8rem;
  }
  .ma13-t {
    margin: 12rem;
  }
  .ma14-t {
    margin: 16rem;
  }
  .maauto-t {
    margin: auto;
  }
}
@media screen and (max-width: 520px) {
  .ma0-m {
    margin: 0;
  }
  .ma1-m {
    margin: 0.125rem;
  }
  .ma2-m {
    margin: 0.25rem;
  }
  .ma3-m {
    margin: 0.375rem;
  }
  .ma4-m {
    margin: 0.5rem;
  }
  .ma5-m {
    margin: 0.75rem;
  }
  .ma6-m {
    margin: 1rem;
  }
  .ma7-m {
    margin: 1.5rem;
  }
  .ma8-m {
    margin: 2rem;
  }
  .ma9-m {
    margin: 3rem;
  }
  .ma10-m {
    margin: 4rem;
  }
  .ma10-half-m {
    margin: 5rem;
  }
  .ma11-m {
    margin: 6rem;
  }
  .ma11-half-m {
    margin: 7rem;
  }
  .ma12-m {
    margin: 8rem;
  }
  .ma13-m {
    margin: 12rem;
  }
  .ma14-m {
    margin: 16rem;
  }
  .maauto-m {
    margin: auto;
  }
}
.ml0 {
  margin-left: 0;
}
.ml1 {
  margin-left: 0.125rem;
}
.ml2 {
  margin-left: 0.25rem;
}
.ml3 {
  margin-left: 0.375rem;
}
.ml4 {
  margin-left: 0.5rem;
}
.ml5 {
  margin-left: 0.75rem;
}
.ml6 {
  margin-left: 1rem;
}
.ml7 {
  margin-left: 1.5rem;
}
.ml8 {
  margin-left: 2rem;
}
.ml9 {
  margin-left: 3rem;
}
.ml10 {
  margin-left: 4rem;
}
.ml10-half {
  margin-left: 5rem;
}
.ml11 {
  margin-left: 6rem;
}
.ml11-half {
  margin-left: 7rem;
}
.ml12 {
  margin-left: 8rem;
}
.ml13 {
  margin-left: 12rem;
}
.ml14 {
  margin-left: 16rem;
}
.mlauto {
  margin-left: auto;
}
.ml-22 {
  margin-left: 22%;
}
@media screen and (max-width: 768px) {
  .ml0-t {
    margin-left: 0;
  }
  .ml1-t {
    margin-left: 0.125rem;
  }
  .ml2-t {
    margin-left: 0.25rem;
  }
  .ml3-t {
    margin-left: 0.375rem;
  }
  .ml4-t {
    margin-left: 0.5rem;
  }
  .ml5-t {
    margin-left: 0.75rem;
  }
  .ml6-t {
    margin-left: 1rem;
  }
  .ml7-t {
    margin-left: 1.5rem;
  }
  .ml8-t {
    margin-left: 2rem;
  }
  .ml9-t {
    margin-left: 3rem;
  }
  .ml10-t {
    margin-left: 4rem;
  }
  .ml10-half-t {
    margin-left: 5rem;
  }
  .ml11-t {
    margin-left: 6rem;
  }
  .ml11-half-t {
    margin-left: 7rem;
  }
  .ml12-t {
    margin-left: 8rem;
  }
  .ml13-t {
    margin-left: 12rem;
  }
  .ml14-t {
    margin-left: 16rem;
  }
  .mlauto-t {
    margin-left: auto;
  }
}
@media screen and (max-width: 520px) {
  .ml0-m {
    margin-left: 0;
  }
  .ml1-m {
    margin-left: 0.125rem;
  }
  .ml2-m {
    margin-left: 0.25rem;
  }
  .ml3-m {
    margin-left: 0.375rem;
  }
  .ml4-m {
    margin-left: 0.5rem;
  }
  .ml5-m {
    margin-left: 0.75rem;
  }
  .ml6-m {
    margin-left: 1rem;
  }
  .ml7-m {
    margin-left: 1.5rem;
  }
  .ml8-m {
    margin-left: 2rem;
  }
  .ml9-m {
    margin-left: 3rem;
  }
  .ml10-m {
    margin-left: 4rem;
  }
  .ml10-half-m {
    margin-left: 5rem;
  }
  .ml11-m {
    margin-left: 6rem;
  }
  .ml11-half-m {
    margin-left: 7rem;
  }
  .ml12-m {
    margin-left: 8rem;
  }
  .ml13-m {
    margin-left: 12rem;
  }
  .ml14-m {
    margin-left: 16rem;
  }
  .mlauto-m {
    margin-left: auto;
  }
}
.mr0 {
  margin-right: 0;
}
.mr1 {
  margin-right: 0.125rem;
}
.mr2 {
  margin-right: 0.25rem;
}
.mr3 {
  margin-right: 0.375rem;
}
.mr4 {
  margin-right: 0.5rem;
}
.mr5 {
  margin-right: 0.75rem;
}
.mr5-half {
  margin-right: 0.875rem;
}
.mr6 {
  margin-right: 1rem;
}
.mr7 {
  margin-right: 1.5rem;
}
.mr8 {
  margin-right: 2rem;
}
.mr9 {
  margin-right: 3rem;
}
.mr10 {
  margin-right: 4rem;
}
.mr10-half {
  margin-right: 5rem;
}
.mr11 {
  margin-right: 6rem;
}
.mr11-half {
  margin-right: 7rem;
}
.mr12 {
  margin-right: 8rem;
}
.mr13 {
  margin-right: 12rem;
}
.mr14 {
  margin-right: 16rem;
}
.mrauto {
  margin-right: auto;
}
@media screen and (min-width: 769px) {
  .mr-0-d {
    margin-right: 0;
  }
}
@media screen and (max-width: 768px) {
  .mr0-t {
    margin-right: 0;
  }
  .mr1-t {
    margin-right: 0.125rem;
  }
  .mr2-t {
    margin-right: 0.25rem;
  }
  .mr3-t {
    margin-right: 0.375rem;
  }
  .mr4-t {
    margin-right: 0.5rem;
  }
  .mr5-t {
    margin-right: 0.75rem;
  }
  .mr6-t {
    margin-right: 1rem;
  }
  .mr7-t {
    margin-right: 1.5rem;
  }
  .mr8-t {
    margin-right: 2rem;
  }
  .mr9-t {
    margin-right: 3rem;
  }
  .mr10-t {
    margin-right: 4rem;
  }
  .mr10-half-t {
    margin-right: 5rem;
  }
  .mr11-t {
    margin-right: 6rem;
  }
  .mr11-half-t {
    margin-right: 7rem;
  }
  .mr12-t {
    margin-right: 8rem;
  }
  .mr13-t {
    margin-right: 12rem;
  }
  .mr14-t {
    margin-right: 16rem;
  }
  .mrauto-t {
    margin-right: auto;
  }
}
@media screen and (max-width: 520px) {
  .mr0-m {
    margin-right: 0;
  }
  .mr1-m {
    margin-right: 0.125rem;
  }
  .mr2-m {
    margin-right: 0.25rem;
  }
  .mr3-m {
    margin-right: 0.375rem;
  }
  .mr4-m {
    margin-right: 0.5rem;
  }
  .mr5-m {
    margin-right: 0.75rem;
  }
  .mr6-m {
    margin-right: 1rem;
  }
  .mr7-m {
    margin-right: 1.5rem;
  }
  .mr8-m {
    margin-right: 2rem;
  }
  .mr9-m {
    margin-right: 3rem;
  }
  .mr10-m {
    margin-right: 4rem;
  }
  .mr10-half-m {
    margin-right: 5rem;
  }
  .mr11-m {
    margin-right: 6rem;
  }
  .mr11-half-m {
    margin-right: 7rem;
  }
  .mr12-m {
    margin-right: 8rem;
  }
  .mr13-m {
    margin-right: 12rem;
  }
  .mr14-m {
    margin-right: 16rem;
  }
  .mrauto-m {
    margin-right: auto;
  }
}
.mb0 {
  margin-bottom: 0;
}
.mb1 {
  margin-bottom: 0.125rem;
}
.mb2 {
  margin-bottom: 0.25rem;
}
.mb3 {
  margin-bottom: 0.375rem;
}
.mb4 {
  margin-bottom: 0.5rem;
}
.mb5 {
  margin-bottom: 0.75rem;
}
.mb6 {
  margin-bottom: 1rem;
}
.mb7 {
  margin-bottom: 1.5rem;
}
.mb8 {
  margin-bottom: 2rem;
}
.mb9 {
  margin-bottom: 3rem;
}
.mb10 {
  margin-bottom: 4rem;
}
.mb10-half {
  margin-bottom: 5rem;
}
.mb11 {
  margin-bottom: 6rem;
}
.mb11-half {
  margin-bottom: 7rem;
}
.mb12 {
  margin-bottom: 8rem;
}
.mb13 {
  margin-bottom: 12rem;
}
.mb14 {
  margin-bottom: 16rem;
}
.mbauto {
  margin-bottom: auto;
}
.-mb2 {
  margin-bottom: -0.25rem;
}
.-mb4 {
  margin-bottom: -0.5rem;
}
.last-child-mb0:last-child {
  margin-bottom: 0;
}
@media screen and (max-width: 768px) {
  .mb0-t {
    margin-bottom: 0;
  }
  .mb1-t {
    margin-bottom: 0.125rem;
  }
  .mb2-t {
    margin-bottom: 0.25rem;
  }
  .mb3-t {
    margin-bottom: 0.375rem;
  }
  .mb4-t {
    margin-bottom: 0.5rem;
  }
  .mb5-t {
    margin-bottom: 0.75rem;
  }
  .mb6-t {
    margin-bottom: 1rem;
  }
  .mb7-t {
    margin-bottom: 1.5rem;
  }
  .mb8-t {
    margin-bottom: 2rem;
  }
  .mb9-t {
    margin-bottom: 3rem;
  }
  .mb10-t {
    margin-bottom: 4rem;
  }
  .mb10-half-t {
    margin-bottom: 5rem;
  }
  .mb11-t {
    margin-bottom: 6rem;
  }
  .mb11-half-t {
    margin-bottom: 7rem;
  }
  .mb12-t {
    margin-bottom: 8rem;
  }
  .mb13-t {
    margin-bottom: 12rem;
  }
  .mb14-t {
    margin-bottom: 16rem;
  }
  .mbauto-t {
    margin-bottom: auto;
  }
}
@media screen and (max-width: 520px) {
  .mb0-m {
    margin-bottom: 0;
  }
  .mb1-m {
    margin-bottom: 0.125rem;
  }
  .mb2-m {
    margin-bottom: 0.25rem;
  }
  .mb3-m {
    margin-bottom: 0.375rem;
  }
  .mb4-m {
    margin-bottom: 0.5rem;
  }
  .mb5-m {
    margin-bottom: 0.75rem;
  }
  .mb6-m {
    margin-bottom: 1rem;
  }
  .mb7-m {
    margin-bottom: 1.5rem;
  }
  .mb8-m {
    margin-bottom: 2rem;
  }
  .mb9-m {
    margin-bottom: 3rem;
  }
  .mb10-m {
    margin-bottom: 4rem;
  }
  .mb10-half-m {
    margin-bottom: 5rem;
  }
  .mb11-m {
    margin-bottom: 6rem;
  }
  .mb11-half-m {
    margin-bottom: 7rem;
  }
  .mb12-m {
    margin-bottom: 8rem;
  }
  .mb13-m {
    margin-bottom: 12rem;
  }
  .mb14-m {
    margin-bottom: 16rem;
  }
  .mbauto-m {
    margin-bottom: auto;
  }
}
.mt0 {
  margin-top: 0;
}
.mt1 {
  margin-top: 0.125rem;
}
.mt2 {
  margin-top: 0.25rem;
}
.mt3 {
  margin-top: 0.375rem;
}
.mt4 {
  margin-top: 0.5rem;
}
.mt5 {
  margin-top: 0.75rem;
}
.mt6 {
  margin-top: 1rem;
}
.mt7 {
  margin-top: 1.5rem;
}
.mt8 {
  margin-top: 2rem;
}
.mt9 {
  margin-top: 3rem;
}
.mt10 {
  margin-top: 4rem;
}
.mt10-half {
  margin-top: 5rem;
}
.mt11 {
  margin-top: 6rem;
}
.mt11-half {
  margin-top: 7rem;
}
.mt12 {
  margin-top: 8rem;
}
.mt13 {
  margin-top: 12rem;
}
.mt14 {
  margin-top: 16rem;
}
.-mt1 {
  margin-top: -0.125rem;
}
.-mt2 {
  margin-top: -0.25rem;
}
.-mt3 {
  margin-top: -0.375rem;
}
.-mt4 {
  margin-top: -0.5rem;
}
.-mt5 {
  margin-top: -0.75rem;
}
.-mt6 {
  margin-top: -1rem;
}
.-mt7 {
  margin-top: -1.5rem;
}
.-mt8 {
  margin-top: -2rem;
}
.-mt9 {
  margin-top: -3rem;
}
@media screen and (min-width: 1200px) {
  .mt0-l {
    margin-top: 0;
  }
}
@media screen and (max-width: 768px) {
  .mt0-t {
    margin-top: 0;
  }
  .mt1-t {
    margin-top: 0.125rem;
  }
  .mt2-t {
    margin-top: 0.25rem;
  }
  .mt3-t {
    margin-top: 0.375rem;
  }
  .mt4-t {
    margin-top: 0.5rem;
  }
  .mt5-t {
    margin-top: 0.75rem;
  }
  .mt6-t {
    margin-top: 1rem;
  }
  .mt7-t {
    margin-top: 1.5rem;
  }
  .mt8-t {
    margin-top: 2rem;
  }
  .mt9-t {
    margin-top: 3rem;
  }
  .mt10-t {
    margin-top: 4rem;
  }
  .mt10-half-t {
    margin-top: 5rem;
  }
  .mt11-t {
    margin-top: 6rem;
  }
  .mt11-half-t {
    margin-top: 7rem;
  }
  .mt12-t {
    margin-top: 8rem;
  }
  .mt13-t {
    margin-top: 12rem;
  }
  .mt14-t {
    margin-top: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .mt0-m {
    margin-top: 0;
  }
  .mt1-m {
    margin-top: 0.125rem;
  }
  .mt2-m {
    margin-top: 0.25rem;
  }
  .mt3-m {
    margin-top: 0.375rem;
  }
  .mt4-m {
    margin-top: 0.5rem;
  }
  .mt5-m {
    margin-top: 0.75rem;
  }
  .mt6-m {
    margin-top: 1rem;
  }
  .mt7-m {
    margin-top: 1.5rem;
  }
  .mt8-m {
    margin-top: 2rem;
  }
  .mt9-m {
    margin-top: 3rem;
  }
  .mt10-m {
    margin-top: 4rem;
  }
  .mt10-half-m {
    margin-top: 5rem;
  }
  .mt11-m {
    margin-top: 6rem;
  }
  .mt11-half-m {
    margin-top: 7rem;
  }
  .mt12-m {
    margin-top: 8rem;
  }
  .mt13-m {
    margin-top: 12rem;
  }
  .mt14-m {
    margin-top: 16rem;
  }
}
.mv0 {
  margin-top: 0;
  margin-bottom: 0;
}
.mv1 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.mv2 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.mv3 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.mv4 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.mv5 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.mv6 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mv7 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.mv8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mv9 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.mv10 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.mv10-half {
  margin-top: 5rem;
  margin-bottom: 5rem;
}
.mv11 {
  margin-top: 6rem;
  margin-bottom: 6rem;
}
.mv11-half {
  margin-top: 7rem;
  margin-bottom: 7rem;
}
.mv12 {
  margin-top: 8rem;
  margin-bottom: 8rem;
}
.mv13 {
  margin-top: 12rem;
  margin-bottom: 12rem;
}
.mv14 {
  margin-top: 16rem;
  margin-bottom: 16rem;
}
@media screen and (max-width: 768px) {
  .mv0-t {
    margin-top: 0;
    margin-bottom: 0;
  }
  .mv1-t {
    margin-top: 0.125rem;
    margin-bottom: 0.125rem;
  }
  .mv2-t {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .mv3-t {
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
  }
  .mv4-t {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .mv5-t {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .mv6-t {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .mv7-t {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .mv8-t {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .mv9-t {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .mv10-t {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
  .mv10-half-t {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
  .mv11-t {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }
  .mv11-half-t {
    margin-top: 7rem;
    margin-bottom: 7rem;
  }
  .mv12-t {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }
  .mv13-t {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }
  .mv14-t {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }
}
@media screen and (max-width: 520px) {
  .mv0-m {
    margin-top: 0;
    margin-bottom: 0;
  }
  .mv1-m {
    margin-top: 0.125rem;
    margin-bottom: 0.125rem;
  }
  .mv2-m {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .mv3-m {
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
  }
  .mv4-m {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .mv5-m {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .mv6-m {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .mv7-m {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .mv8-m {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .mv9-m {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .mv10-m {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
  .mv10-half-m {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
  .mv11-m {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }
  .mv11-half-m {
    margin-top: 7rem;
    margin-bottom: 7rem;
  }
  .mv12-m {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }
  .mv13-m {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }
  .mv14-m {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }
}
.mh0 {
  margin-left: 0;
  margin-right: 0;
}
.mh1 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mh2 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mh3 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mh4 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mh5 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mh6 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mh7 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mh8 {
  margin-left: 2rem;
  margin-right: 2rem;
}
.mh9 {
  margin-left: 3rem;
  margin-right: 3rem;
}
.mh10 {
  margin-left: 4rem;
  margin-right: 4rem;
}
.mh10-half {
  margin-left: 5rem;
  margin-right: 5rem;
}
.mh11 {
  margin-left: 6rem;
  margin-right: 6rem;
}
.mh11-half {
  margin-left: 7rem;
  margin-right: 7rem;
}
.mh12 {
  margin-left: 8rem;
  margin-right: 8rem;
}
.mh13 {
  margin-left: 12rem;
  margin-right: 12rem;
}
.mh14 {
  margin-left: 16rem;
  margin-right: 16rem;
}
.mhauto {
  margin-left: auto;
  margin-right: auto;
}
@media screen and (max-width: 768px) {
  .mh0-t {
    margin-left: 0;
    margin-right: 0;
  }
  .mh1-t {
    margin-left: 0.125rem;
    margin-right: 0.125rem;
  }
  .mh2-t {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .mh3-t {
    margin-left: 0.375rem;
    margin-right: 0.375rem;
  }
  .mh4-t {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .mh5-t {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }
  .mh6-t {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .mh7-t {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .mh8-t {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .mh9-t {
    margin-left: 3rem;
    margin-right: 3rem;
  }
  .mh11-t {
    margin-left: 4rem;
    margin-right: 4rem;
  }
  .mh10-t {
    margin-left: 6rem;
    margin-right: 6rem;
  }
  .mh12-t {
    margin-left: 8rem;
    margin-right: 8rem;
  }
  .mh13-t {
    margin-left: 12rem;
    margin-right: 12rem;
  }
  .mh14-t {
    margin-left: 16rem;
    margin-right: 16rem;
  }
  .mhauto-t {
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (max-width: 520px) {
  .mh0-m {
    margin-left: 0;
    margin-right: 0;
  }
  .mh1-m {
    margin-left: 0.125rem;
    margin-right: 0.125rem;
  }
  .mh2-m {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .mh3-m {
    margin-left: 0.375rem;
    margin-right: 0.375rem;
  }
  .mh4-m {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .mh5-m {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }
  .mh6-m {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .mh7-m {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .mh8-m {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .mh9-m {
    margin-left: 3rem;
    margin-right: 3rem;
  }
  .mh10-m {
    margin-left: 4rem;
    margin-right: 4rem;
  }
  .mh11-m {
    margin-left: 6rem;
    margin-right: 6rem;
  }
  .mh12-m {
    margin-left: 8rem;
    margin-right: 8rem;
  }
  .mh13-m {
    margin-left: 12rem;
    margin-right: 12rem;
  }
  .mh14-m {
    margin-left: 16rem;
    margin-right: 16rem;
  }
  .mhauto-m {
    margin-left: auto;
    margin-right: auto;
  }
}
.gap1 {
  gap: 0.125rem;
}
.gap2 {
  gap: 0.25rem;
}
.gap3 {
  gap: 0.375rem;
}
.gap4 {
  gap: 0.5rem;
}
.gap5 {
  gap: 0.75rem;
}
.gap6 {
  gap: 1rem;
}
.gap7 {
  gap: 1.5rem;
}
.gap8 {
  gap: 2rem;
}
.gap9 {
  gap: 3rem;
}
.gap10 {
  gap: 4rem;
}
/*

  Theming
  -------

  Utility classes for theming.

*/
.bicubic {
  -ms-interpolation-mode: bicubic;
  image-rendering: optimizeQuality;
}
.fit-image {
  object-fit: cover;
}
.position-image-50-30 {
  object-position: 50% 30%;
}
.fit-bg-image {
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}
.hidden {
  visibility: hidden;
}
.no-pointer-events {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.list-reset {
  list-style: none;
}
.list-item-reset {
  list-style-type: none;
}
.list-item-initial {
  list-style-type: initial;
}
.transition-all {
  -webkit-transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -o-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
.transition-all-slow {
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.default-cursor {
  cursor: default;
}
.pointer {
  cursor: pointer;
}
.text {
  cursor: text;
}
.disabled-default-cursor:disabled {
  cursor: default;
}
.not-allowed {
  cursor: not-allowed;
}
.wait {
  cursor: wait;
}
.w-resize {
  cursor: w-resize;
}
.outline-0 {
  outline: 0;
  outline: none;
}
.focus-outline-0:focus {
  outline: 0;
  outline: none;
}
.focus-outline-0:focus select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}
.disable-text-area-resize {
  resize: none;
}
.filter-o-40 {
  filter: opacity(40%);
}
.filter-blur {
  filter: blur(2px);
}
.hover-filter-o-40:hover {
  filter: opacity(40%);
}
.o-100 {
  -webkit-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}
.o-90 {
  -webkit-opacity: 0.9;
  -moz-opacity: 0.9;
  opacity: 0.9;
}
.o-80 {
  -webkit-opacity: 0.8;
  -moz-opacity: 0.8;
  opacity: 0.8;
}
.o-70 {
  -webkit-opacity: 0.7;
  -moz-opacity: 0.7;
  opacity: 0.7;
}
.o-60 {
  -webkit-opacity: 0.6;
  -moz-opacity: 0.6;
  opacity: 0.6;
}
.o-50 {
  -webkit-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}
.o-40 {
  -webkit-opacity: 0.4;
  -moz-opacity: 0.4;
  opacity: 0.4;
}
.o-30 {
  -webkit-opacity: 0.3;
  -moz-opacity: 0.3;
  opacity: 0.3;
}
.o-20 {
  -webkit-opacity: 0.2;
  -moz-opacity: 0.2;
  opacity: 0.2;
}
.o-10 {
  -webkit-opacity: 0.1;
  -moz-opacity: 0.1;
  opacity: 0.1;
}
.o-05 {
  -webkit-opacity: 0.05;
  -moz-opacity: 0.05;
  opacity: 0.05;
}
.o-025 {
  -webkit-opacity: 0.025;
  -moz-opacity: 0.025;
  opacity: 0.025;
}
.o-0 {
  -webkit-opacity: 0;
  -moz-opacity: 0;
  opacity: 0;
}
.hover-o-90:hover {
  -webkit-opacity: 0.9;
  -moz-opacity: 0.9;
  opacity: 0.9;
}
.hover-o-80:hover {
  -webkit-opacity: 0.8;
  -moz-opacity: 0.8;
  opacity: 0.8;
}
.hover-o-100:hover {
  -webkit-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}
.hover-reveal:hover .hover-reveal-target {
  -webkit-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}
.black {
  color: #111111;
}
.bluish-grey {
  color: #738897;
}
.light-bluish-grey {
  color: #e8eef4;
}
.medium-bluish-grey {
  color: #a7b5be;
}
.cadet-blue {
  color: #6288A5;
}
.charcoal {
  color: #404040;
}
.chocolate {
  color: #C85C17;
}
.crimson {
  color: #CC0033;
}
.dark-cyan {
  color: #00719F;
}
.dark-slate-blue {
  color: #3A447A;
}
.dark-orchid {
  color: #84619C;
}
.dim-grey {
  color: #565656;
}
.slate-grey {
  color: #4d606e;
}
.light-slate-grey {
  color: #6b8699;
}
.gains-boro {
  color: #d8d8d8;
}
.grey {
  color: #73797A;
}
.bright-grey {
  color: #edeff0;
}
.ghost-grey {
  color: #F7F9FA;
}
.indian-red {
  color: #D95741;
}
.light-coral {
  color: #F1617D;
}
.lite-grey {
  color: #979797;
}
.dark-coral {
  color: #DB3668;
}
.dark-sea-green {
  color: #5CBE75;
}
.dark-sea-green-2 {
  color: #128a93;
}
.dark-sea-green-3 {
  color: #008C9F;
}
.light-sea-green-1 {
  color: #3FC599;
}
.light-sea-green-2 {
  color: #0bb9b5;
}
.light-turquoise {
  color: #81cbd3;
}
.medium-turquoise {
  color: #35b8d3;
}
.medium-aquamarine {
  color: #6ac498;
}
.navy {
  color: #011279;
}
.pale-green {
  color: #a0f6aa;
}
.pale-violet-red {
  color: #e25c8f;
}
.phantom-grey {
  color: #e8e8e8;
}
.precedents-blue {
  color: #004b7a;
}
.phantom-grey {
  color: #e8e8e8;
}
.royal-blue {
  color: #1460D1;
}
.sienna {
  color: #825F48;
}
.teal {
  color: #004b7a;
}
.tomato {
  color: #F87531;
}
.tangerine-dream {
  color: #FFCA28;
}
.white {
  color: #FFFFFF;
}
.dark-cerulean {
  color: #255c83;
}
.slate-blue-grey {
  color: #4d616e;
}
.star-yellow {
  color: #f7d757;
}
.suez-canal {
  color: #255d85;
}
.placeholder-cadet-blue::placeholder {
  color: #6288A5;
}
.hover-black:hover {
  color: #111111;
}
.hover-cadet-blue:hover {
  color: #6288A5;
}
.hover-dark-sea-green-2:hover {
  color: #128a93;
}
.hover-dark-slate-blue:hover {
  color: #3A447A;
}
.hover-slate-grey:hover {
  color: #4d606e;
}
.hover-dark-sea-green-2:hover {
  color: #128a93;
}
.hover-dark-sea-green-3:hover {
  color: #008C9F;
}
.hover-gains-boro:hover {
  color: #d8d8d8;
}
.hover-white:hover {
  color: #FFFFFF;
}
.hover-slate-grey:hover {
  color: #4d606e;
}
.hover-light-slate-grey:hover {
  color: #6b8699;
}
.focus-light-sea-green-2:focus {
  color: #0bb9b5;
}
.focus-white:focus {
  color: #FFFFFF;
}
.focus-grey:focus {
  color: #73797A;
}
.focus-slate-grey:focus {
  color: #4d606e;
}
.focus-light-slate-grey:focus {
  color: #6b8699;
}
.active-slate-grey:active {
  color: #4d606e;
}
.active-light-slate-grey:active {
  color: #6b8699;
}
.color-inherit {
  color: inherit;
}
.link-children-color-inherit a {
  color: inherit;
}
.bg-black {
  background-color: #111111;
}
.soft-black {
  background-color: #0d0d0d;
}
.bg-cadet-blue {
  background-color: #6288A5;
}
.bg-chocolate {
  background-color: #C85C17;
}
.bg-dark-bluish-grey {
  background-color: #5d6d7b;
}
.bg-light-bluish-grey {
  background-color: #e8eef4;
}
.bg-light-grayish-blue {
  background-color: #e8eef4;
}
.bg-dark-coral {
  background-color: #DB3668;
}
.bg-dark-cyan {
  background-color: #00719F;
}
.bg-dark-sea-green {
  background-color: #5CBE75;
}
.bg-dark-sea-green-2 {
  background-color: #128a93;
}
.bg-dark-sea-green-3 {
  background-color: #008C9F;
}
.bg-dark-slate-blue {
  background-color: #3A447A;
}
.bg-dark-orchid {
  background-color: #84619C;
}
.bg-dim-grey {
  background-color: #565656;
}
.bg-faf-grey {
  background-color: #FAFAFF;
}
.bg-gains-boro {
  background-color: #d8d8d8;
}
.bg-grey {
  background-color: #73797A;
}
.bg-ice-blue {
  background-color: #D5ECFF;
}
.bg-ghost-grey {
  background-color: #F7F9FA;
}
.bg-indian-red {
  background-color: #D95741;
}
.bg-ice-blue {
  background-color: #D5ECFF;
}
.bg-light-coral {
  background-color: #F1617D;
}
.bg-light-yellow {
  background-color: #FCF8E3;
}
.bg-light-sea-green-1 {
  background-color: #3FC599;
}
.bg-light-sea-green-2 {
  background-color: #0bb9b5;
}
.bg-light-turquoise {
  background-color: #81cbd3;
}
.bg-medium-aquamarine {
  background-color: #6ac498;
}
.bg-medium-purple {
  background-color: #9c7fb0;
}
.bg-medium-turquoise {
  background-color: #35b8d3;
}
.bg-navy {
  background-color: #011279;
}
.bg-precedents-blue {
  background-color: #004b7a;
}
.bg-pale-green {
  background-color: #a0f6aa;
}
.bg-pale-violet-red {
  background-color: #e25c8f;
}
.bg-pearl-lusta {
  background-color: #fbf2d1;
}
.bg-phantom-grey {
  background-color: #e8e8e8;
}
.bg-royal-blue {
  background-color: #1460D1;
}
.bg-sienna {
  background-color: #825F48;
}
.bg-slate-grey {
  background-color: #3A447A;
}
.bg-teal {
  background-color: #004b7a;
}
.bg-tomato {
  background-color: #F87531;
}
.bg-white {
  background-color: #FFFFFF;
}
.bg-tangerine-dream {
  background-color: #FFCA28;
}
.bg-transparent {
  background-color: transparent;
}
.bg-twilight-grey {
  background-color: #EDEDED;
}
.bg-void-grey {
  background-color: #EBF0F4;
}
.bg-inherit {
  background-color: inherit;
}
.bg-transparent {
  background: transparent;
}
.bg-casper-white {
  background-color: #e7eef3;
}
.bg-ghost-white {
  background-color: #f0f4f7;
}
.bg-slate-blue-grey {
  background-color: #4d616e;
}
.bg-page-background {
  background-color: #f0f4f7;
}
.bg-dark-cerulean {
  background-color: #255c83;
}
.bg-suez-canal {
  background-color: #255d85;
}
.bg-powder-white {
  background-color: #ebf0f7;
}
.bg-star-yellow {
  background-color: #f7d757;
}
.bg-text-fragment-highlight {
  background-color: rgba(128, 0, 255, 0.2);
}
.hover-bg-transparent:hover {
  background-color: transparent;
  background: transparent;
}
.hover-bg-cadet-blue:hover {
  background-color: #6288A5;
}
.hover-bg-dark-slate-blue:hover {
  background-color: #3A447A;
}
.hover-bg-dark-sea-green:hover {
  background-color: #5CBE75;
}
.hover-bg-dark-sea-green-2:hover {
  background-color: #128a93;
}
.hover-bg-dark-sea-green-3:hover {
  background-color: #008C9F;
}
.hover-bg-light-bluish-grey:hover {
  background-color: #e8eef4;
}
.hover-bg-dim-grey:hover {
  background-color: #565656;
}
.hover-bg-gains-boro:hover {
  background-color: #d8d8d8;
}
.hover-bg-ghost-grey:hover {
  background-color: #F7F9FA;
}
.hover-bg-grey:hover {
  background-color: #73797A;
}
.hover-bg-light-turquoise:hover {
  background-color: #81cbd3;
}
.hover-bg-teal:hover {
  background-color: #004b7a;
}
.hover-bg-phantom-grey:hover {
  background-color: #e8e8e8;
}
.hover-bg-twilight-grey:hover {
  background-color: #EDEDED;
}
.hover-bg-white:hover {
  background-color: #FFFFFF;
}
.hover-bg-light-bluish-grey:hover {
  background-color: #e8eef4;
}
.hover-bg-casper-white:hover {
  background-color: #e7eef3;
}
.hover-bg-ghost-white:hover {
  background-color: #f0f4f7;
}
.hover-bg-slate-blue-grey:hover {
  background-color: #4d616e;
}
.hover-bg-suez-canal:hover {
  background-color: #255d85;
}
.focus-bg-ghost-white:focus {
  background-color: #f0f4f7;
}
.focus-bg-casper-white:focus {
  background-color: #e7eef3;
}
.focus-bg-star-yellow:focus {
  background-color: #f7d757;
}
.focus-bg-slate-blue-grey:focus {
  background-color: #4d616e;
}
.active-bg-ghost-white:active {
  background-color: #f0f4f7;
}
.active-bg-casper-white:active {
  background-color: #e7eef3;
}
.fill-star-yellow {
  fill: #f7d757;
}
.fill-medium-bluish-grey {
  fill: #a7b5be;
}
.fill-light-slate-grey {
  fill: #6b8699;
}
.hover-fill-light-slate-grey:hover {
  fill: #6b8699;
}
.stroke-suez-canal {
  stroke: #255d85;
}
.bg-contain {
  background-size: contain;
}
.bg-center {
  background-position: center;
}
.bg-x-center {
  background-position-x: center;
}
.bg-y-center {
  background-position-y: center;
}
.border-collapse {
  border-collapse: collapse;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.ba {
  border-style: solid;
  border-width: 1px;
}
.ba2 {
  border-style: solid;
  border-width: 2px;
}
.bn {
  border-style: none;
  border-width: 0;
}
.bb {
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
.bl {
  border-left-style: solid;
  border-left-width: 1px;
}
.bt {
  border-top-style: solid;
  border-top-width: 1px;
}
.br {
  border-right-style: solid;
  border-right-width: 1px;
}
.bb-thin {
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
.bb-medium {
  border-bottom-style: solid;
  border-bottom-width: 2px;
}
.bb-thick {
  border-bottom-style: solid;
  border-bottom-width: 4px;
}
.bb-extra-thick {
  border-bottom-style: solid;
  border-bottom-width: 6px;
}
.bt-medium {
  border-top-style: solid;
  border-top-width: 2px;
}
.bt-thick {
  border-top-style: solid;
  border-top-width: 4px;
}
.bt-xl {
  border-top-style: solid;
  border-top-width: 8px;
}
.bl-thick {
  border-left-style: solid;
  border-left-width: 4px;
}
@media screen and (max-width: 520px) {
  .bn-m {
    border-style: none;
    border-width: 0;
  }
  .ba-m {
    border-style: solid;
    border-width: 1px;
  }
}
.hover-bb-thick:hover {
  border-bottom-style: solid;
  border-bottom-width: 4px;
}
.hover-bb-medium:hover {
  border-bottom-style: solid;
  border-bottom-width: 2px;
}
.hover-bt-thick:hover {
  border-top-style: solid;
  border-top-width: 4px;
}
.last-child-bn:last-child {
  border-style: none;
  border-width: 0;
}
.last-of-type-bn:last-of-type {
  border-style: none;
  border-width: 0;
}
@media screen and (max-width: 768px) {
  .bb-t {
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }
  .bn-t {
    border-style: none;
    border-width: 0;
  }
  .bt-t {
    border-top-style: solid;
    border-top-width: 1px;
  }
}
.b--dashed {
  border-style: dashed;
}
.b--dotted {
  border-style: dotted;
}
.b--none {
  border-style: none;
}
.b--solid {
  border-style: solid;
}
.bt--dashed {
  border-top-style: dashed;
}
.bt--dotted {
  border-top-style: dotted;
}
.bt--none {
  border-top-style: none;
}
.bt--solid {
  border-top-style: solid;
}
.br--dashed {
  border-right-style: dashed;
}
.br--dotted {
  border-right-style: dotted;
}
.br--none {
  border-right-style: none;
}
.br--solid {
  border-right-style: solid;
}
.bb--dashed {
  border-bottom-style: dashed;
}
.bb--dotted {
  border-bottom-style: dotted;
}
.bb--none {
  border-bottom-style: none;
}
.bb--solid {
  border-bottom-style: solid;
}
.bl--dashed {
  border-left-style: dashed;
}
.bl--dotted {
  border-left-style: dotted;
}
.bl--none {
  border-left-style: none;
}
.bl--solid {
  border-left-style: solid;
}
.hover-ba:hover {
  border-style: solid;
  border-width: 1px;
}
.hover-ba2:hover {
  border-style: solid;
  border-width: 2px;
}
.b--black {
  border-color: #111111;
}
.b--cadet-blue {
  border-color: #6288A5;
}
.b--chocolate {
  border-color: #C85C17;
}
.b--dark-cyan {
  border-color: #00719F;
}
.b--dark-slate-blue {
  border-color: #3A447A;
}
.b--dark-orchid {
  border-color: #84619C;
}
.b--dark-sea-green-2 {
  border-color: #128a93;
}
.b--dark-sea-green-3 {
  border-color: #008C9F;
}
.b--dim-grey {
  border-color: #565656;
}
.b--gains-boro {
  border-color: #d8d8d8;
}
.b--grey {
  border-color: #73797A;
}
.b--bright-grey {
  border-color: #edeff0;
}
.b--ghost-grey {
  border-color: #F7F9FA;
}
.b--ghost-white {
  border-color: #f0f4f7;
}
.b--indian-red {
  border-color: #D95741;
}
.b--light-coral {
  border-color: #F1617D;
}
.b--light-grey {
  border-color: #979797;
}
.b--light-sea-green-1 {
  border-color: #3FC599;
}
.b--light-sea-green-2 {
  border-color: #0bb9b5;
}
.b--lite-grey {
  border-color: #979797;
}
.b--medium-aquamarine {
  border-color: #6ac498;
}
.b--medium-purple {
  border-color: #9c7fb0;
}
.b--medium-turquoise {
  border-color: #35b8d3;
}
.b--navy {
  border-color: #011279;
}
.b--pale-green {
  border-color: #a0f6aa;
}
.b--pale-violet-red {
  border-color: #e25c8f;
}
.b--precedents-blue {
  border-color: #004b7a;
}
.b--royal-blue {
  border-color: #1460D1;
}
.b--sienna {
  border-color: #825F48;
}
.b--tomato {
  border-color: #F87531;
}
.b--phantom-grey {
  border-color: #e8e8e8;
}
.b--white {
  border-color: #FFFFFF;
}
.b-light-bluish-grey {
  border-color: #e8eef4;
}
.b--transparent {
  border-color: transparent;
}
.b--inherit {
  border-color: inherit;
}
.b--slate-blue-grey {
  border-color: #4d616e;
}
.b--light-bluish-grey {
  border-color: #e8eef4;
}
.b--suez-canal {
  border-color: #255d85;
}
.b--eastern-breeze {
  border-color: #dae1e5;
}
.b--dark-cerulean {
  border-color: #255c83;
}
.bt--transparent {
  border-top-color: transparent;
}
.bt--dark-orchid {
  border-top-color: #84619C;
}
.bt--dark-cyan {
  border-top-color: #00719F;
}
.bt--light-grey {
  border-top-color: #979797;
}
.bt--phantom-grey {
  border-top-color: #e8e8e8;
}
.bt--light-sea-green-2 {
  border-top-color: #0bb9b5;
}
.bt--dark-sea-green-3 {
  border-top-color: #008C9F;
}
.bt--medium-aquamarine {
  border-top-color: #6ac498;
}
.bt--medium-purple {
  border-top-color: #9c7fb0;
}
.bt--eastern-breeze {
  border-color: #dae1e5;
}
.bt--dark-cerulean {
  border-top-color: #255c83;
}
.bb--chocolate {
  border-bottom-color: #C85C17;
}
.bb--dark-cerulean {
  border-bottom-color: #255c83;
}
.bb-light-bluish-grey {
  border-bottom-color: #e8eef4;
}
.hover-b--black:hover {
  border-color: #111111;
}
.hover-b--inherit:hover {
  border-color: inherit;
}
.hover-b--dark-sea-green-2:hover {
  border-color: #128a93;
}
.hover-b--slate-blue-grey:hover {
  border-color: #4d616e;
}
.focus-b--light-sea-green-2:focus {
  border-color: #0bb9b5;
}
.focus-b--cadet-blue:focus {
  border-color: #6288A5;
}
.focus-b--slate-blue-grey:focus {
  border-color: #4d616e;
}
.placeholder-light-slate-grey::placeholder {
  color: #6b8699;
}
.br0 {
  border-radius: 0;
}
.br1 {
  border-radius: 0.125rem;
}
.br2 {
  border-radius: 0.25rem;
}
.br3 {
  border-radius: 0.5rem;
}
.br4 {
  border-radius: 1rem;
}
.br-50 {
  border-radius: 50%;
}
.br-100 {
  border-radius: 100%;
}
.br-pill {
  border-radius: 9999px;
}
.br--bottom {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.br--left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.br--right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.br--top {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
/**
 * Box Shadow
 * offset-x | offset-y | blur-radius | spread-radius | color
 * NOTE: This naming convention is too verbose so I'm open to better
 * suggestions!
 */
.shadow-none {
  box-shadow: none;
}
.shadow-8-04 {
  box-shadow: 0 0 8px 0 rgba(17, 17, 17, 0.4);
}
.shadow-black-1 {
  -webkit-box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);
}
.shadow-black-2 {
  -webkit-box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);
  -moz-box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);
  box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);
}
.shadow-black-3 {
  -webkit-box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);
  -moz-box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);
  box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);
}
.shadow-black-4 {
  -webkit-box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);
  -moz-box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);
  box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);
}
.shadow-black-16 {
  -webkit-box-shadow: 0 2px 16px 0 rgba(77, 96, 110, 0.05);
  -moz-box-shadow: 0 2px 16px 0 rgba(77, 96, 110, 0.05);
  box-shadow: 0 2px 16px 0 rgba(77, 96, 110, 0.05);
}
.shadow-faint-black {
  -webkit-box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
}
@media screen and (max-width: 520px) {
  .shadow-none-m {
    box-shadow: none;
  }
}
@media screen and (min-width: 1200px) {
  .shadow-none-l {
    box-shadow: none;
  }
}
.x--50-y-50 {
  -webkit-transform: translateX(-50%) translateY(50%);
  -moz-transform: translateX(-50%) translateY(50%);
  -o-transform: translateX(-50%) translateY(50%);
  -ms-transform: translateX(-50%) translateY(50%);
  transform: translateX(-50%) translateY(50%);
}
.x--50-y-100 {
  -webkit-transform: translateX(-50%) translateY(100%);
  -moz-transform: translateX(-50%) translateY(100%);
  -o-transform: translateX(-50%) translateY(100%);
  -ms-transform: translateX(-50%) translateY(100%);
  transform: translateX(-50%) translateY(100%);
}
.x--50-y--50 {
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -o-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
.x--50-y--100 {
  -webkit-transform: translateX(-50%) translateY(-100%);
  -moz-transform: translateX(-50%) translateY(-100%);
  -o-transform: translateX(-50%) translateY(-100%);
  -ms-transform: translateX(-50%) translateY(-100%);
  transform: translateX(-50%) translateY(-100%);
}
.x-50 {
  -webkit-transform: translateX(50%);
  -moz-transform: translateX(50%);
  -o-transform: translateX(50%);
  -ms-transform: translateX(50%);
  transform: translateX(50%);
}
.x-100-y--50 {
  -webkit-transform: translateX(100%) translateY(-50%);
  -moz-transform: translateX(100%) translateY(-50%);
  -o-transform: translateX(100%) translateY(-50%);
  -ms-transform: translateX(100%) translateY(-50%);
  transform: translateX(100%) translateY(-50%);
}
.x-100 {
  -webkit-transform: translateX(100%);
  -moz-transform: translateX(100%);
  -o-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
}
.x--50 {
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}
.x--100 {
  -webkit-transform: translateX(-100%);
  -moz-transform: translateX(-100%);
  -o-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%);
}
.x0 {
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -o-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
}
.y--50 {
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.y--100 {
  -webkit-transform: translateY(-100%);
  -moz-transform: translateY(-100%);
  -o-transform: translateY(-100%);
  -ms-transform: translateY(-100%);
  transform: translateY(-100%);
}
.y-100 {
  -webkit-transform: translateY(100%);
  -moz-transform: translateY(100%);
  -o-transform: translateY(100%);
  -ms-transform: translateY(100%);
  transform: translateY(100%);
}
.y0 {
  -webkit-transform: translateY(0);
  -moz-transform: translateY(0);
  -o-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
}
.x-10 {
  -webkit-transform: translateX(10px);
  -moz-transform: translateX(10px);
  -o-transform: translateX(10px);
  -ms-transform: translateX(10px);
  transform: translateX(10px);
}
.x-vw-100 {
  -webkit-transform: translateX(100vw);
  -moz-transform: translateX(100vw);
  -o-transform: translateX(100vw);
  -ms-transform: translateX(100vw);
  transform: translateX(100vw);
}
.y-vh--100 {
  -webkit-transform: translateY(-100vh);
  -moz-transform: translateY(-100vh);
  -o-transform: translateY(-100vh);
  -ms-transform: translateY(-100vh);
  transform: translateY(-100vh);
}
@media screen and (max-width: 520px) {
  .x--100-m {
    -webkit-transform: translateX(-100%);
    -moz-transform: translateX(-100%);
    -o-transform: translateX(-100%);
    -ms-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
@media screen and (min-width: 1200px) {
  .x-0-l {
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -o-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
}
.rotate-90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.rotate-180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}
.rotate--90 {
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
.aspect-ratio {
  height: 0;
  position: relative;
}
.aspect-ratio--16x9 {
  padding-bottom: 56.25%;
}
.aspect-ratio--9x16 {
  padding-bottom: 177.77%;
}
.aspect-ratio--4x3 {
  padding-bottom: 75%;
}
.aspect-ratio--3x4 {
  padding-bottom: 133.33%;
}
.aspect-ratio--6x4 {
  padding-bottom: 66.6%;
}
.aspect-ratio--4x6 {
  padding-bottom: 150%;
}
.aspect-ratio--8x5 {
  padding-bottom: 62.5%;
}
.aspect-ratio--5x8 {
  padding-bottom: 160%;
}
.aspect-ratio--7x5 {
  padding-bottom: 71.42%;
}
.aspect-ratio--5x7 {
  padding-bottom: 140%;
}
.aspect-ratio--1x1 {
  padding-bottom: 100%;
}
.scroll-touch {
  -webkit-overflow-scrolling: touch;
}
.scroll-auto {
  -webkit-overflow-scrolling: auto;
}
.no-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.aol-corporate {
  color: #35B8D3;
}
.bg-aol-corporate {
  background-color: #35B8D3;
}
.bg-aol-corporate-light {
  background-color: #ddf3f7;
}
.b--aol-corporate {
  border-color: #35B8D3;
}
.bb-aol-corporate {
  border-bottom-color: #35B8D3;
}
.aol-employment {
  color: #5CCCAE;
}
.bg-aol-employment {
  background-color: #5CCCAE;
}
.bg-aol-employment-light {
  background-color: #f7fdfb;
}
.b--aol-employment {
  border-color: #5CCCAE;
}
.bb-aol-employment {
  border-bottom-color: #5CCCAE;
}
.aol-ri {
  color: #FF8657;
}
.bg-aol-ri {
  background-color: #FF8657;
}
.bg-aol-ri-light {
  background-color: #ffffff;
}
.b--aol-ri {
  border-color: #FF8657;
}
.bb-aol-ri {
  border-bottom-color: #FF8657;
}
@keyframes fade-in-animation {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-out-animation {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.fade-in-animate {
  opacity: 1;
  animation: fade-in-animation 250ms linear 1;
}
.fade-out-animate {
  opacity: 1;
  animation: fade-out-animation 250ms linear 1;
}
.fade-headless {
  opacity: 1;
  transition: opacity 250ms linear;
}
.fade-headless[data-closed] {
  opacity: 0;
}
/*

  Typography
  ----------

  Utility classes for typography.

*/
.font-default {
  font-family: "Source Sans Pro", "Arial", sans-serif;
}
.f1 {
  font-size: 3rem;
}
.f2 {
  font-size: 2.25rem;
}
.f3 {
  font-size: 1.5rem;
}
.f4 {
  font-size: 1.25rem;
}
.f5 {
  font-size: 1rem;
}
.f6 {
  font-size: 0.875rem;
}
.f7 {
  font-size: 0.75rem;
}
.f8 {
  font-size: 0.625rem;
}
.fht {
  font-size: 1.75rem;
}
@media screen and (max-width: 768px) {
  .f1-t {
    font-size: 3rem;
  }
  .f2-t {
    font-size: 2.25rem;
  }
  .f3-t {
    font-size: 1.5rem;
  }
  .f4-t {
    font-size: 1.25rem;
  }
  .f5-t {
    font-size: 1rem;
  }
  .f6-t {
    font-size: 0.875rem;
  }
  .f7-t {
    font-size: 0.75rem;
  }
}
@media screen and (max-width: 520px) {
  .f1-m {
    font-size: 3rem;
  }
  .f2-m {
    font-size: 2.25rem;
  }
  .f3-m {
    font-size: 1.5rem;
  }
  .f4-m {
    font-size: 1.25rem;
  }
  .f5-m {
    font-size: 1rem;
  }
  .f6-m {
    font-size: 0.875rem;
  }
  .f7-m {
    font-size: 0.75rem;
  }
}
.untracked {
  letter-spacing: normal;
}
.tracked {
  letter-spacing: 0.1rem;
}
.tracked-cosy {
  letter-spacing: -0.005rem;
}
.tracked-tight {
  letter-spacing: -0.05rem;
}
.tracked-mega {
  letter-spacing: 0.25rem;
}
.normal {
  font-weight: normal;
}
.b {
  font-weight: bold;
}
.lighter {
  font-weight: lighter;
}
.fw2 {
  font-weight: 200;
}
.fw3 {
  font-weight: 300;
}
.fw4 {
  font-weight: 400;
}
.fw5 {
  font-weight: 500;
}
.fw6 {
  font-weight: 600;
}
.fw7 {
  font-weight: 700;
}
.fw8 {
  font-weight: 800;
}
.i {
  font-style: italic;
}
.fs-normal {
  font-style: normal;
}
.lh-solid {
  line-height: 1;
}
.lh-headline {
  line-height: 1.17;
}
.lh-title {
  line-height: 1.25;
}
.lh-copy-variant {
  line-height: 1.44;
}
.lh-copy {
  line-height: 1.5;
}
.lh-pagination {
  line-height: 1.75;
}
.lh-copy--spaced {
  line-height: 2.25;
}
.tc {
  text-align: center;
}
.tr {
  text-align: right;
}
.tl {
  text-align: left;
}
@media screen and (max-width: 520px) {
  .tc-m {
    text-align: center;
  }
  .tr-m {
    text-align: right;
  }
  .tl-m {
    text-align: left;
  }
}
.vt {
  vertical-align: top;
}
.vm {
  vertical-align: middle;
}
.vbs {
  vertical-align: baseline;
}
.no-underline {
  text-decoration: none;
}
.underline {
  text-decoration: underline;
}
.decoration-inherit {
  text-decoration: inherit;
}
.hover-underline:hover {
  text-decoration: underline;
}
.hover-no-underline:hover {
  text-decoration: none;
}
.hover-b:hover {
  font-weight: bold;
}
.ws-normal {
  white-space: normal;
}
.nowrap {
  white-space: nowrap;
}
.pre {
  white-space: pre;
}
@media screen and (max-width: 520px) {
  .ws-normal-m {
    white-space: normal;
  }
}
@media screen and (max-width: 768px) {
  .ws-normal-t {
    white-space: normal;
  }
  .nowrap-t {
    white-space: nowrap;
  }
}
.o-auto {
  overflow: auto;
}
.o-hidden {
  overflow: hidden;
}
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ttc {
  text-transform: capitalize;
}
.ttl {
  text-transform: lowercase;
}
.ttn {
  text-transform: none;
}
.ttu {
  text-transform: uppercase;
}
.measure {
  max-width: 30em;
}
.measure-wide {
  max-width: 34em;
}
.measure-narrow {
  max-width: 20em;
}
@media screen and (min-width: 769px) {
  .measure-d {
    max-width: 30em;
  }
  .measure-wide-d {
    max-width: 34em;
  }
  .measure-narrow-d {
    max-width: 20em;
  }
}
.indent {
  text-indent: 1rem;
  margin-top: 0;
  margin-bottom: 0;
}
.disable-select {
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer */
  -webkit-user-select: none;
  /* Chrome, Safari, and Opera */
  user-select: none;
}
.ds {
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer */
  -webkit-user-select: none;
  /* Chrome, Safari, and Opera */
  user-select: none;
}
.wb-all {
  word-break: break-all;
}
.wb-word {
  word-break: break-word;
}
.wb-keep {
  word-break: keep-all;
}
@media screen and (max-width: 768px) {
  .wb-all-t {
    word-break: break-all;
  }
}
@media screen and (max-width: 520px) {
  .wb-word-m {
    word-break: break-word;
  }
}
.ca-grid-card {
  height: 26.25rem;
}
.ca-grid-card a {
  color: #0bb9b5;
  text-decoration: none;
}
.ca-grid-card a:hover {
  text-decoration: underline;
}
.arrow-link {
  text-decoration: none !important;
}
.arrow-link a {
  color: #6288A5 !important;
}
.arrow-link svg {
  color: #111111 !important;
}
.arrow-link:hover * {
  color: #128a93 !important;
  text-decoration: underline !important;
}
.ca-content a {
  color: #0bb9b5;
  text-decoration: none;
}
.ca-content > ul {
  list-style-type: initial;
  padding-left: 1rem;
}
.ca-tile-title p {
  margin: 0 !important;
}
.ca-article-headline-title {
  line-height: 1.17;
  margin-top: 1.5rem;
  margin-bottom: 0.375rem;
}
.announcements-content div:first-child > h3:first-child {
  margin-top: 0;
}
.announcements-content div:not(:first-child) > h3 {
  margin-top: 3rem;
}
.announcements-content h3 {
  font-size: 1.25rem;
  font-weight: 800;
  margin: 1.25rem 0 0.4rem;
  color: #111111;
}
.announcements-content strong {
  color: #111111;
  letter-spacing: 0.1px;
}
.announcements-content p,
.announcements-content li {
  font-size: 0.9375rem;
  color: #404040;
  line-height: 1.17;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.announcements-content li {
  letter-spacing: 0.1px;
}
.announcements-content a {
  text-decoration: none;
}
.announcements-content a:hover {
  text-decoration: underline;
}
.announcements-content ul,
.announcements-content ol {
  padding-left: 1.5rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.announcements-content div:first-child > p:first-child {
  margin-top: 0.5rem;
}
.announcements-content div:first-child > ul:first-child {
  margin-top: 0.5rem;
}
.announcements-content div:first-child > ul:first-child > li:first-child {
  margin-top: 0.25rem;
}
.article-page-icons .svg-base {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
  height: 24px !important;
  width: 24px !important;
}
.article-page-icons .MuiIconButton-root {
  color: #6288A5;
  outline: 0;
  padding: 0;
  height: 2.5rem;
  width: 2.5rem;
  font-size: inherit;
}
.article-page-icons .MuiIconButton-root:hover {
  color: #128a93;
}
.share-buttons-container .MuiIconButton-root {
  color: #6288A5 !important;
  outline: 0;
  font-size: inherit;
  padding: 4px;
}
.share-buttons-container .MuiIconButton-root:hover {
  color: #128a93;
}
.submit-form-button .MuiButton-root {
  padding: 1rem 2rem;
  color: #FFFFFF;
  background-color: #0bb9b5;
}
.submit-form-button .MuiButton-root:hover {
  background-color: #128a93;
}
.submit-form-button .MuiButton-root:disabled {
  background-color: #73797A;
}
.article-grid a {
  outline: 0 !important;
}
.article-section {
  min-height: 60rem;
}
@media screen and (max-width: 632px) {
  .article-section {
    height: 64rem;
  }
}
@media screen and (max-width: 566px) {
  .article-section {
    height: 66rem;
  }
}
@media screen and (max-width: 430px) {
  .article-section {
    height: 70rem;
  }
}
@media screen and (max-width: 420px) {
  .article-section {
    height: 72rem;
  }
}
@media screen and (max-width: 382px) {
  .article-section {
    height: 76rem;
  }
}
@media screen and (max-width: 382px) {
  .article-section {
    height: 80rem;
  }
}
.Toastify__progress-bar--default {
  background: #3FC599;
}
.icon-clipboard-container,
.icon-preview-toggle-container {
  width: 32px;
  height: 32px;
}
.icon-clipboard-container .MuiSvgIcon-root,
.icon-preview-toggle-container .MuiSvgIcon-root {
  width: 32px;
  height: 32px;
}
.icon-clipboard-container:hover,
.icon-preview-toggle-container:hover {
  color: #128a93 !important;
}
.expand-more-button {
  width: 100%;
  height: 0;
  text-align: center;
}
.expand-more-button-container {
  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);
  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);
  background: -ms-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);
  background: -o-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);
  background: linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);
}
.tile-frosted-bottom {
  background: #ffffff;
  background: linear-gradient(0deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  /*.linear-gradient(top, rgba(255, 255, 255, 0), 0%, rgb(255, 255, 255), 100%);*/
}
.tooltip-wrapper::before {
  position: absolute;
  left: 0;
  width: 1.5rem;
  top: 0;
  bottom: 0;
  content: '';
  z-index: 5;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ededed 100%);
}
.tooltip-wrapper::after {
  position: absolute;
  right: 0;
  width: 1.5rem;
  top: 0;
  bottom: 0;
  content: '';
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ededed 100%);
}
.hover-bg-ghost-grey:hover {
  background-color: #F7F9FA;
}
.bg-precedents-blue-30 {
  background-color: rgba(0, 75, 122, 0.3);
}
.bg-precedents-blue-20 {
  background-color: rgba(0, 75, 122, 0.2);
}
.bg-precedents-blue-10 {
  background-color: rgba(0, 75, 122, 0.1);
}
.bg-precedents-blue-5 {
  background-color: rgba(0, 75, 122, 0.05);
}
.hover-bg-precedents-blue-10:hover {
  background-color: rgba(0, 75, 122, 0.1);
}
.hover-bg-precedents-blue-20:hover {
  background-color: rgba(0, 75, 122, 0.2);
}
.precedents-tile .MuiButton-root:hover {
  background-color: rgba(0, 75, 122, 0.1);
}
.precedents-description p {
  margin: 0 0 10px;
}
.bg-precedents-blue-exp {
  background-color: #004b7a !important;
}
.action-buttons button {
  cursor: pointer;
  background-color: #FFFFFF;
}
.menu-list-button {
  -moz-appearance: menulist-button;
  -webkit-appearance: menulist-button;
}
.texteditor .DraftEditor-root {
  padding: 0.5em;
  margin: 0;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(0, 0, 0, 0.1);
  min-height: 17rem;
  position: relative;
}
.texteditor .side-toolbar {
  position: absolute;
  top: 25px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 2em;
  transition: top 0.2s;
}
.texteditor .side-toolbar .svg-icon {
  color: rgba(0, 0, 0, 0.2);
  fill: rgba(0, 0, 0, 0.2);
  font-size: 1.4em;
  cursor: pointer;
  vertical-align: middle;
}
.texteditor .side-toolbar .svg-icon.a-menu {
  font-size: 1.4em;
}
.texteditor .public-DraftEditorPlaceholder-root {
  position: absolute;
}
.texteditor .paragraph,
.public-DraftStyleDefault-ul,
.public-DraftStyleDefault-ol {
  margin-bottom: 0;
}
.public-DraftStyleDefault-ul,
.public-DraftStyleDefault-ol {
  margin-top: 0;
}
.texteditor {
  position: relative;
  padding-left: 2em;
}
.texteditor .paragraph {
  margin-bottom: 0.5em;
}
.texteditor blockquote {
  padding: 10px 20px;
  margin: 0 0 20px;
  border-left: 5px solid #eee;
}
.texteditor img {
  max-width: 100%;
}
.texteditor .toolbar {
  position: absolute;
  z-index: 9999;
  height: 2em;
  cursor: default;
  pointer-events: none;
  transition: opacity 0.2s;
  opacity: 0;
}
.texteditor .toolbar.side {
  top: 0;
  left: -1px;
}
.texteditor .toolbar.active {
  opacity: 1;
  pointer-events: all;
}
.texteditor .toolbar.inline {
  font-size: 1.1em;
}
.texteditor .toolbar .toolbar-icons {
  position: relative;
  z-index: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  list-style: none;
  height: 100%;
  margin: 0;
  padding: 0;
  background: #f5f5f5;
  border: 1px solid #ddd;
  font-size: 1em;
}
.texteditor .toolbar .toolbar-icons .toolbar-static {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background: #ddd;
  width: 2.1em;
  max-width: 2.1em;
}
.texteditor .toolbar .toolbar-icons .toolbar-static .svg-icon {
  fill: #000;
  width: auto;
  height: auto;
  margin: 0;
}
.texteditor .toolbar .toolbar-icons .toolbar-icon {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: baseline;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 100%;
  width: 2.4em;
  line-height: 2.5em;
  max-width: 2.4em;
  font-size: 0.8em;
  color: #aaa;
  transition: all 0.15s linear;
  cursor: pointer;
}
.texteditor .toolbar .toolbar-icons .toolbar-icon.active,
.texteditor .toolbar .toolbar-icons .toolbar-icon:hover {
  color: #222;
}
.texteditor .toolbar .toolbar-icons .toolbar-icon.active .svg-icon,
.texteditor .toolbar .toolbar-icons .toolbar-icon:hover .svg-icon {
  fill: #222;
  color: #222;
}
.texteditor .toolbar-icon:hover .toolbar .toolbar-icons .toolbar-icon i {
  margin: 0;
  padding: 0;
  color: #444;
  font-size: 1.8em;
}
.link-editor {
  display: block;
  max-width: 800px;
  margin: auto;
  width: 96%;
  background: #ffffff;
  padding: 5px 20px 20px;
  font-size: 1.3em;
}
.link-editor .form-actions {
  text-align: right;
  margin-top: 1em;
}
.link-editor .form-actions a {
  display: inline-block;
  font-size: 1em;
  width: 10em;
  margin: 0 0.5em;
}
@media screen and (max-width: 520px) {
  .link-editor .form-actions {
    text-align: center;
    margin: 1em 0;
  }
  .link-editor .form-actions a {
    width: 60%;
    margin: 0.2em 0;
  }
}
.link-editor .input-container {
  padding: 1em 2em;
}
.link-editor .input-container input {
  width: 100%;
  font-size: 1.1em;
  padding: 0.4em;
  outline: none;
  border: 2px solid #eee;
  border-radius: 2px;
}
.group .texteditor {
  padding: 18px 64px 18px 64px;
  font-size: 1.5rem;
  display: block;
  font-weight: 400;
}
.group .toggle-texteditor {
  margin: 0 1em 1em 1em;
}
.group .toggle-texteditor svg {
  fill: #fff;
}
.placeholder-cadet-blue-important input::placeholder {
  color: #6288A5 !important;
  opacity: 1;
}
.date-picker input::placeholder {
  color: #6288A5 !important;
  opacity: 1;
}
.date-picker input {
  background: transparent;
  border: 1px solid;
  width: 11rem;
}
.date-picker .react-datepicker-popper {
  left: -2.25rem !important;
  top: 0 !important;
  z-index: 2;
}
.filter-checkbox-icon {
  width: 1rem;
}
.filter-checkbox-icon svg g {
  stroke: none;
}
.drawer-svg-icon svg {
  top: 0;
}
.header-action-button.MuiButtonBase-root {
  background-color: rgba(255, 202, 40, 0.3);
}
.header-action-button.MuiButtonBase-root:hover {
  background-color: #FFCA28;
}
.header-action-button-disabled.MuiButton-root.Mui-disabled {
  color: #6288A5;
}
.svg-stroke-white svg path,
.svg-stroke-white svg polyline {
  stroke: #FFFFFF;
}
.svg-stroke-cadet-blue svg path,
.svg-stroke-cadet-blue svg polyline {
  stroke: #6288A5;
}
.svg-fill-cadet-blue svg {
  fill: #6288A5;
}
.svg-fill-white svg {
  fill: #FFFFFF;
}
/*

  Fix
  ---

  Fixes! Add a comment explaining what bug it fixes and if you found the
  solution on e.g. StackOverflow then include the link.

*/
.chrome-nested-flex-column-fix {
  min-width: 0;
  min-height: 0;
}
.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}
.clearfix:after {
  clear: both;
}
@media screen and (min-width: 769px) {
  .firefox-flex-grow-fix {
    flex-basis: 0;
  }
}
.ie-fix-justify-evenly {
  justify-content: space-around;
}
@supports (-ms-ime-align: auto) {
  .justify-evenly {
    justify-content: space-around;
  }
}
.ie-hide-default-select-chevron::-ms-expand {
  display: none;
}
.margin-collapse-fix:after {
  content: '';
  overflow: auto;
  display: block;
}
.no-csspositionsticky .ie-sticky-fix {
  position: fixed;
}
.safari-border-image-fix {
  border-right: 0 solid transparent;
}
.muiButtonHoverLinesFix.muiButtonHoverLinesFix:hover {
  text-decoration: none;
}
select::-ms-expand {
  display: none;
}
.ie-min-height-flex-items-center-fix {
  padding-top: 0.875rem !important;
  padding-bottom: 0.875rem !important;
}
.ie-min-height-flex-items-center-fix .ie-prefix-hack {
  top: 0.875rem;
}
.popover.bottom > .arrow::after {
  border-bottom-color: #004b7a !important;
}
.ie-layout-fix {
  max-width: 100%;
}
.ie-layout-fix > div {
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
  max-width: 1400px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
@media screen and (max-width: 768px) {
  .ie-layout-fix > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media screen and (max-width: 520px) {
  .ie-layout-fix > div {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}
.ie-side {
  display: block;
}
.items-center-ie-fix {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.outline-0 select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}
@media screen and (max-width: 520px) {
  .header-icon-mobile-width {
    width: 2.25rem;
  }
}
/* Stops table wrapping onto new line - see FC-1436*/
@media only screen and (min-width: 1200px) {
  /* Duplicating class selector to increase specificity of rule to overwrite layout-width-constraints max-width */
  .deal-watch-width-constraint {
    width: 72vw !important;
  }
}
.deal-watch-width-constraint {
  width: 96vw;
}
.popover-content a {
  color: #FFFFFF;
}
.new-ticker div p {
  margin: 0;
}
.icon-button-bg-color-active {
  background-color: rgba(0, 0, 0, 0.04);
}
.rich-text-editor .public-DraftEditor-content {
  min-height: 12rem;
}
.ie-basis0-fix {
  flex-basis: auto;
}
/*

  Grid
  ----

  You can use the .grid-with-gutters(@n, @gw) mixin to create a grid structure
  with n items per row and gutter width gw.

  Note that the styles inside the media queries don't apply to smaller screen
  widths!
  i.e. if you want a grid that has 4 items per row on desktop and tablet and 1
  on mobile you would need grid-4-gutter-4-d, grid-4-gutter-4-t and
  grid-1-gutter-4-d.

  This is because the margins on the nth children (which are the outermost items
  in the grid) can't be reliably overridden.

*/
.grid-1-gutter-4 {
  display: flex;
  flex-wrap: wrap;
}
.grid-1-gutter-4 > * {
  width: calc((100% / 1) - 0rem);
  margin: 0.25rem;
}
.grid-1-gutter-4 > *:nth-child(1n - 0) {
  margin-left: 0;
}
.grid-1-gutter-4 > *:nth-child(1n) {
  margin-right: 0;
}
.grid-1-gutter-4 > *:nth-child(-n + 1) {
  margin-top: 0;
}
.grid-1-gutter-4 > *:nth-last-child(-n + 1) {
  margin-bottom: 0;
}
.grid-2-gutter-4 {
  display: flex;
  flex-wrap: wrap;
}
.grid-2-gutter-4 > * {
  width: calc((100% / 2) - 1rem);
  margin: 0.25rem;
}
.grid-2-gutter-4 > *:nth-child(2n - 1) {
  margin-left: 0;
}
.grid-2-gutter-4 > *:nth-child(2n) {
  margin-right: 0;
}
.grid-2-gutter-4 > *:nth-child(-n + 2) {
  margin-top: 0;
}
.grid-2-gutter-4 > *:nth-last-child(-n + 2) {
  margin-bottom: 0;
}
.grid-3-gutter-4 {
  display: flex;
  flex-wrap: wrap;
}
.grid-3-gutter-4 > * {
  width: calc((100% / 3) - 1rem);
  margin: 0.25rem;
}
.grid-3-gutter-4 > *:nth-child(3n - 2) {
  margin-left: 0;
}
.grid-3-gutter-4 > *:nth-child(3n) {
  margin-right: 0;
}
.grid-3-gutter-4 > *:nth-child(-n + 3) {
  margin-top: 0;
}
.grid-3-gutter-4 > *:nth-last-child(-n + 3) {
  margin-bottom: 0;
}
.grid-4-gutter-4 {
  display: flex;
  flex-wrap: wrap;
}
.grid-4-gutter-4 > * {
  width: calc((100% / 4) - 1rem);
  margin: 0.25rem;
}
.grid-4-gutter-4 > *:nth-child(4n - 3) {
  margin-left: 0;
}
.grid-4-gutter-4 > *:nth-child(4n) {
  margin-right: 0;
}
.grid-4-gutter-4 > *:nth-child(-n + 4) {
  margin-top: 0;
}
.grid-4-gutter-4 > *:nth-last-child(-n + 4) {
  margin-bottom: 0;
}
.grid-5-gutter-4 {
  display: flex;
  flex-wrap: wrap;
}
.grid-5-gutter-4 > * {
  width: calc((100% / 5) - 1rem);
  margin: 0.25rem;
}
.grid-5-gutter-4 > *:nth-child(5n - 4) {
  margin-left: 0;
}
.grid-5-gutter-4 > *:nth-child(5n) {
  margin-right: 0;
}
.grid-5-gutter-4 > *:nth-child(-n + 5) {
  margin-top: 0;
}
.grid-5-gutter-4 > *:nth-last-child(-n + 5) {
  margin-bottom: 0;
}
@media screen and (min-width: 769px) {
  .grid-1-gutter-4-d {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-1-gutter-4-d > * {
    width: calc((100% / 1) - 0rem);
    margin: 0.25rem;
  }
  .grid-1-gutter-4-d > *:nth-child(1n - 0) {
    margin-left: 0;
  }
  .grid-1-gutter-4-d > *:nth-child(1n) {
    margin-right: 0;
  }
  .grid-1-gutter-4-d > *:nth-child(-n + 1) {
    margin-top: 0;
  }
  .grid-1-gutter-4-d > *:nth-last-child(-n + 1) {
    margin-bottom: 0;
  }
  .grid-2-gutter-4-d {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-2-gutter-4-d > * {
    width: calc((100% / 2) - 1rem);
    margin: 0.25rem;
  }
  .grid-2-gutter-4-d > *:nth-child(2n - 1) {
    margin-left: 0;
  }
  .grid-2-gutter-4-d > *:nth-child(2n) {
    margin-right: 0;
  }
  .grid-2-gutter-4-d > *:nth-child(-n + 2) {
    margin-top: 0;
  }
  .grid-2-gutter-4-d > *:nth-last-child(-n + 2) {
    margin-bottom: 0;
  }
  .grid-3-gutter-4-d {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-3-gutter-4-d > * {
    width: calc((100% / 3) - 1rem);
    margin: 0.25rem;
  }
  .grid-3-gutter-4-d > *:nth-child(3n - 2) {
    margin-left: 0;
  }
  .grid-3-gutter-4-d > *:nth-child(3n) {
    margin-right: 0;
  }
  .grid-3-gutter-4-d > *:nth-child(-n + 3) {
    margin-top: 0;
  }
  .grid-3-gutter-4-d > *:nth-last-child(-n + 3) {
    margin-bottom: 0;
  }
  .grid-4-gutter-4-d {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-4-gutter-4-d > * {
    width: calc((100% / 4) - 1rem);
    margin: 0.25rem;
  }
  .grid-4-gutter-4-d > *:nth-child(4n - 3) {
    margin-left: 0;
  }
  .grid-4-gutter-4-d > *:nth-child(4n) {
    margin-right: 0;
  }
  .grid-4-gutter-4-d > *:nth-child(-n + 4) {
    margin-top: 0;
  }
  .grid-4-gutter-4-d > *:nth-last-child(-n + 4) {
    margin-bottom: 0;
  }
  .grid-5-gutter-4-d {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-5-gutter-4-d > * {
    width: calc((100% / 5) - 1rem);
    margin: 0.25rem;
  }
  .grid-5-gutter-4-d > *:nth-child(5n - 4) {
    margin-left: 0;
  }
  .grid-5-gutter-4-d > *:nth-child(5n) {
    margin-right: 0;
  }
  .grid-5-gutter-4-d > *:nth-child(-n + 5) {
    margin-top: 0;
  }
  .grid-5-gutter-4-d > *:nth-last-child(-n + 5) {
    margin-bottom: 0;
  }
}
@media screen and (min-width: 520px) and (max-width: 768px) {
  .grid-1-gutter-4-t {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-1-gutter-4-t > * {
    width: calc((100% / 1) - 0rem);
    margin: 0.25rem;
  }
  .grid-1-gutter-4-t > *:nth-child(1n - 0) {
    margin-left: 0;
  }
  .grid-1-gutter-4-t > *:nth-child(1n) {
    margin-right: 0;
  }
  .grid-1-gutter-4-t > *:nth-child(-n + 1) {
    margin-top: 0;
  }
  .grid-1-gutter-4-t > *:nth-last-child(-n + 1) {
    margin-bottom: 0;
  }
  .grid-2-gutter-4-t {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-2-gutter-4-t > * {
    width: calc((100% / 2) - 1rem);
    margin: 0.25rem;
  }
  .grid-2-gutter-4-t > *:nth-child(2n - 1) {
    margin-left: 0;
  }
  .grid-2-gutter-4-t > *:nth-child(2n) {
    margin-right: 0;
  }
  .grid-2-gutter-4-t > *:nth-child(-n + 2) {
    margin-top: 0;
  }
  .grid-2-gutter-4-t > *:nth-last-child(-n + 2) {
    margin-bottom: 0;
  }
  .grid-3-gutter-4-t {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-3-gutter-4-t > * {
    width: calc((100% / 3) - 1rem);
    margin: 0.25rem;
  }
  .grid-3-gutter-4-t > *:nth-child(3n - 2) {
    margin-left: 0;
  }
  .grid-3-gutter-4-t > *:nth-child(3n) {
    margin-right: 0;
  }
  .grid-3-gutter-4-t > *:nth-child(-n + 3) {
    margin-top: 0;
  }
  .grid-3-gutter-4-t > *:nth-last-child(-n + 3) {
    margin-bottom: 0;
  }
  .grid-4-gutter-4-t {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-4-gutter-4-t > * {
    width: calc((100% / 4) - 1rem);
    margin: 0.25rem;
  }
  .grid-4-gutter-4-t > *:nth-child(4n - 3) {
    margin-left: 0;
  }
  .grid-4-gutter-4-t > *:nth-child(4n) {
    margin-right: 0;
  }
  .grid-4-gutter-4-t > *:nth-child(-n + 4) {
    margin-top: 0;
  }
  .grid-4-gutter-4-t > *:nth-last-child(-n + 4) {
    margin-bottom: 0;
  }
  .grid-5-gutter-4-t {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-5-gutter-4-t > * {
    width: calc((100% / 5) - 1rem);
    margin: 0.25rem;
  }
  .grid-5-gutter-4-t > *:nth-child(5n - 4) {
    margin-left: 0;
  }
  .grid-5-gutter-4-t > *:nth-child(5n) {
    margin-right: 0;
  }
  .grid-5-gutter-4-t > *:nth-child(-n + 5) {
    margin-top: 0;
  }
  .grid-5-gutter-4-t > *:nth-last-child(-n + 5) {
    margin-bottom: 0;
  }
}
@media screen and (max-width: 520px) {
  .grid-1-gutter-4-m {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-1-gutter-4-m > * {
    width: calc((100% / 1) - 0rem);
    margin: 0.25rem;
  }
  .grid-1-gutter-4-m > *:nth-child(1n - 0) {
    margin-left: 0;
  }
  .grid-1-gutter-4-m > *:nth-child(1n) {
    margin-right: 0;
  }
  .grid-1-gutter-4-m > *:nth-child(-n + 1) {
    margin-top: 0;
  }
  .grid-1-gutter-4-m > *:nth-last-child(-n + 1) {
    margin-bottom: 0;
  }
  .grid-2-gutter-4-m {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-2-gutter-4-m > * {
    width: calc((100% / 2) - 1rem);
    margin: 0.25rem;
  }
  .grid-2-gutter-4-m > *:nth-child(2n - 1) {
    margin-left: 0;
  }
  .grid-2-gutter-4-m > *:nth-child(2n) {
    margin-right: 0;
  }
  .grid-2-gutter-4-m > *:nth-child(-n + 2) {
    margin-top: 0;
  }
  .grid-2-gutter-4-m > *:nth-last-child(-n + 2) {
    margin-bottom: 0;
  }
  .grid-3-gutter-4-m {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-3-gutter-4-m > * {
    width: calc((100% / 3) - 1rem);
    margin: 0.25rem;
  }
  .grid-3-gutter-4-m > *:nth-child(3n - 2) {
    margin-left: 0;
  }
  .grid-3-gutter-4-m > *:nth-child(3n) {
    margin-right: 0;
  }
  .grid-3-gutter-4-m > *:nth-child(-n + 3) {
    margin-top: 0;
  }
  .grid-3-gutter-4-m > *:nth-last-child(-n + 3) {
    margin-bottom: 0;
  }
  .grid-4-gutter-4-m {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-4-gutter-4-m > * {
    width: calc((100% / 4) - 1rem);
    margin: 0.25rem;
  }
  .grid-4-gutter-4-m > *:nth-child(4n - 3) {
    margin-left: 0;
  }
  .grid-4-gutter-4-m > *:nth-child(4n) {
    margin-right: 0;
  }
  .grid-4-gutter-4-m > *:nth-child(-n + 4) {
    margin-top: 0;
  }
  .grid-4-gutter-4-m > *:nth-last-child(-n + 4) {
    margin-bottom: 0;
  }
  .grid-5-gutter-4-m {
    display: flex;
    flex-wrap: wrap;
  }
  .grid-5-gutter-4-m > * {
    width: calc((100% / 5) - 1rem);
    margin: 0.25rem;
  }
  .grid-5-gutter-4-m > *:nth-child(5n - 4) {
    margin-left: 0;
  }
  .grid-5-gutter-4-m > *:nth-child(5n) {
    margin-right: 0;
  }
  .grid-5-gutter-4-m > *:nth-child(-n + 5) {
    margin-top: 0;
  }
  .grid-5-gutter-4-m > *:nth-last-child(-n + 5) {
    margin-bottom: 0;
  }
}
/*

  Helpers
  -------

  This file is for mixins and helpful generic classes that aren't simple enough
  to be considered a utility class. Should be used sparingly!

*/
.screen-reader-text {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  width: 1px;
  word-wrap: normal !important;
}
.center {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.center-h {
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}
.center-v {
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
/*
 * Hamburgers
 * @description Tasty CSS-animated hamburgers
 * @author Jonathan Suh @jonsuh
 * @site https://jonsuh.com/hamburgers
 * @link https://github.com/jonsuh/hamburgers
 */
.hamburger {
  padding: 0;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
  position: relative;
  width: 100%;
  height: 100%;
}
.hamburger:hover {
  opacity: 0.7;
}
.hamburger-box {
  width: 100%;
  height: 100%;
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.hamburger-inner {
  display: block;
  width: 100%;
  height: 2px;
  border-radius: 4px;
  position: absolute;
  background-color: #111111;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.hamburger-inner-1 {
  top: 0;
}
.hamburger-inner-2 {
  top: 50%;
}
.hamburger-inner-3 {
  top: 100%;
}
/*

  Custom
  ------

  Add any styling that can't be constructed from the generic styles to this
  file. Include a comment explaining what the styling does.

  This file should be used as a last resort.

*/
.logo-width {
  width: 12rem;
}
@media screen and (max-width: 768px) {
  .logo-width {
    width: 3rem;
  }
}
@media screen and (max-width: 520px) {
  .logo-width {
    width: 2rem;
  }
}
.nav-full-right {
  width: 16rem;
  -webkit-transform: translate(16rem, 0);
  -moz-transform: translate(16rem, 0);
  -o-transform: translate(16rem, 0);
  -ms-transform: translate(16rem, 0);
  transform: translate(16rem, 0);
}
.application-header,
.application-content,
.nav-full-right {
  -webkit-transition: transform 0.3s;
  -moz-transition: transform 0.3s;
  -ms-transition: transform 0.3s;
  -o-transition: transform 0.3s;
  transition: transform 0.3s;
}
.show-navigation .application-header,
.show-navigation .application-content {
  -webkit-transform: translate(-16rem, 0);
  -moz-transform: translate(-16rem, 0);
  -o-transform: translate(-16rem, 0);
  -ms-transform: translate(-16rem, 0);
  transform: translate(-16rem, 0);
}
.show-navigation .nav-full-right {
  -webkit-transform: translate(0.0001px, 0);
  -moz-transform: translate(0.0001px, 0);
  -o-transform: translate(0.0001px, 0);
  -ms-transform: translate(0.0001px, 0);
  transform: translate(0.0001px, 0);
}
.accordion-header-center {
  line-height: 3rem;
}
.pop-faqs-icon svg {
  margin-top: 4px;
}
.o-50-hover:hover {
  -webkit-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}
.feedback-container {
  position: relative;
  min-height: 8rem;
  -webkit-transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -o-transition: all 0.25s ease;
  transition: all 0.25s ease;
  width: 32rem;
}
@media screen and (max-width: 555px) {
  .feedback-container {
    max-width: 390px;
  }
}
@media screen and (max-width: 425px) {
  .feedback-container {
    max-width: 380px;
  }
}
@media screen and (max-width: 375px) {
  .feedback-container {
    max-width: 330px;
  }
}
@media screen and (max-width: 320px) {
  .feedback-container {
    max-width: 280px;
  }
}
.feedback-button {
  left: 0;
  transform: rotate(270deg) translateY(-5rem) translateX(-2.95rem);
}
.fade-out-overlay::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(rgba(255, 255, 255, 0), #F7F9FA);
}
.account-item-rows > a,
.account-item-rows > div,
.account-item-rows > li {
  text-decoration: none;
}
.account-item-rows > a:nth-child(even),
.account-item-rows > div:nth-child(even),
.account-item-rows > li:nth-child(even) {
  background-color: #FFFFFF;
}
.account-overlay {
  max-width: 800px;
  margin: auto;
  width: 96%;
  background: #FFFFFF;
  padding: 5px 20px 20px;
  flex-direction: column;
}
.careerText p {
  margin-bottom: 1rem;
}
@media screen and (max-width: 520px) {
  .mob-team-img-position {
    background-position: 50% 30%;
  }
}
.legislation-tile .MuiButton-root:hover {
  background-color: rgba(132, 97, 156, 0.1);
}
.hover-default-tab-button-bg:hover {
  background-color: rgba(0, 140, 159, 0.15);
}
.qa-tile-full .MuiButton-root:hover {
  background-color: rgba(53, 184, 211, 0.1);
}
.qa-tile-semi .MuiButton-root:hover {
  background-color: rgba(63, 197, 153, 0.1);
}
.qa-tile-skimmed .MuiButton-root:hover {
  background-color: rgba(241, 97, 125, 0.1);
}
.MuiIconButton-colorSecondary.Mui-checked {
  color: inherit;
}
.MuiIconButton-colorSecondary:hover {
  background-color: inherit;
}
.news-ticker-toggle-button.Mui-disabled {
  color: #fff;
}
.bg-news-publication {
  background-color: #eaf7f0 !important;
}
.bg-news-publication:hover {
  background-color: #c5e8d7 !important;
}
.bg-news-publication.darker {
  background-color: #b3e1cb !important;
}
.bg-flavour-full {
  background-color: #ddf3f7 !important;
}
.bg-flavour-full.darker,
.bg-flavour-full:hover {
  background-color: #b3e4ee !important;
}
.bg-flavour-full .MuiCheckbox-colorSecondary {
  color: #35b8d3 !important;
}
.bg-flavour-full .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(53, 184, 211, 0.1) !important;
}
.bg-flavour-full .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #35b8d3 !important;
}
.full .MuiCheckbox-colorSecondary {
  color: #35b8d3 !important;
}
.full .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(53, 184, 211, 0.1) !important;
}
.full .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #35b8d3 !important;
}
.bg-flavour-semi {
  background-color: #dcf4ec !important;
}
.bg-flavour-semi.darker,
.bg-flavour-semi:hover {
  background-color: #b5e8d7 !important;
}
.bg-flavour-semi .MuiCheckbox-colorSecondary {
  color: #3FC599 !important;
}
.bg-flavour-semi .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(63, 197, 153, 0.1) !important;
}
.bg-flavour-semi .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #3FC599 !important;
}
.semi .MuiCheckbox-colorSecondary {
  color: #3FC599 !important;
}
.semi .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(63, 197, 153, 0.1) !important;
}
.semi .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #3FC599 !important;
}
.bg-flavour-skimmed {
  background-color: #fdeef1 !important;
}
.bg-flavour-skimmed.darker,
.bg-flavour-skimmed:hover {
  background-color: #f9bfca !important;
}
.bg-flavour-skimmed .MuiCheckbox-colorSecondary {
  color: #F1617D !important;
}
.bg-flavour-skimmed .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(241, 97, 125, 0.1) !important;
}
.bg-flavour-skimmed .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #F1617D !important;
}
.skimmed .MuiCheckbox-colorSecondary {
  color: #F1617D !important;
}
.skimmed .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(241, 97, 125, 0.1) !important;
}
.skimmed .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #F1617D !important;
}
.b--flavour-full {
  border-color: #35b8d3;
}
.b--flavour-semi {
  border-color: #3FC599;
}
.b--flavour-skimmed {
  border-color: #F1617D;
}
.hover-bg-flavour-full:hover {
  background-color: #ddf3f7 !important;
}
.hover-bg-flavour-full:hover.darker,
.hover-bg-flavour-full:hover:hover {
  background-color: #b3e4ee !important;
}
.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary {
  color: #35b8d3 !important;
}
.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(53, 184, 211, 0.1) !important;
}
.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #35b8d3 !important;
}
.hover-bg-flavour-semi:hover {
  background-color: #dcf4ec !important;
}
.hover-bg-flavour-semi:hover.darker,
.hover-bg-flavour-semi:hover:hover {
  background-color: #b5e8d7 !important;
}
.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary {
  color: #3FC599 !important;
}
.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(63, 197, 153, 0.1) !important;
}
.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #3FC599 !important;
}
.hover-bg-flavour-skimmed:hover {
  background-color: #fdeef1 !important;
}
.hover-bg-flavour-skimmed:hover.darker,
.hover-bg-flavour-skimmed:hover:hover {
  background-color: #f9bfca !important;
}
.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary {
  color: #F1617D !important;
}
.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary:hover {
  background-color: rgba(241, 97, 125, 0.1) !important;
}
.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {
  color: #F1617D !important;
}
.btc--flavour-full {
  border-top-color: #35b8d3;
}
.btc--flavour-semi {
  border-top-color: #3FC599;
}
.btc--flavour-skimmed {
  border-top-color: #F1617D;
}
.highlight-yellow {
  background-color: #FCF8E3 !important;
}
.flavour-tabs {
  font-size: 0.65rem;
}
.h1-5 {
  height: 1.5rem;
}
mark {
  background-color: #fcf8e3;
  color: inherit;
}
.pseudo-arrows > li::after {
  content: ' > ';
  margin: 0 0.25rem;
}
.pseudo-arrows > li:last-child::after {
  content: '';
}
.w-date {
  width: 14.28571429%;
}
.bg-teal-darken-10 {
  background-color: #002c47;
}
.bg-teal-darken-5 {
  background-color: #003b61;
}
.hover-bg-teal-darken-5:hover {
  background-color: #003b61;
}
.hover-bg-teal-darken-10:hover {
  background-color: #002c47;
}
.MuiSpeedDial-actions.comment-menu-speed-dial-actions {
  margin-top: -1.5rem;
  padding-top: 2rem;
}
.side-width,
.ca-left-width {
  width: 20rem;
}
.marketplace-search-button,
.marketplace-search-button.Mui-disabled,
.account-nav-button.Mui-disabled {
  background-color: #255c83;
}
button.qa-search-button,
button.qa-search-button.Mui-disabled,
.qa-search-button,
.qa-search-button.Mui-disabled {
  background-color: #35b8d3 !important;
}
.search-drop-down-menu.qa-search-button.MuiButton-contained:hover,
.search-drop-down-menu.marketplace-search-button.MuiButton-contained:hover {
  background-color: #2698af;
}
.faq-header-expanded {
  background-color: #c7fcfa;
}
.faq-header-expanded-content {
  background-color: #088986;
}
.legislation-search-button,
.legislation-search-button.Mui-disabled {
  background-color: #84619C;
}
.search-drop-down-menu.legislation-search-button.MuiButton-contained:hover {
  background-color: #694d7d;
}
.news-search-button,
.news-search-button.Mui-disabled {
  background-color: #0bb9b5;
}
button.qa-search-button,
button.qa-search-button.Mui-disabled,
.qa-search-button,
.qa-search-button.Mui-disabled {
  background-color: #35b8d3 !important;
}
.search-drop-down-menu.news-search-button.MuiButton-contained:hover {
  background-color: #088986;
}
button.precedents-search-button,
button.precedents-search-button.Mui-disabled,
.precedents-search-button,
.precedents-search-button.Mui-disabled {
  background-color: #004b7a !important;
}
.search-drop-down-menu.precedents-search-button.MuiButton-contained:hover {
  background-color: #002c47;
}
.markets-search-button,
.markets-search-button.Mui-disabled {
  background-color: #008C9F;
}
.search-drop-down-menu.markets-search-button.MuiButton-contained:hover {
  background-color: #005f6c;
}
.news-date-picker-search-button.MuiButton-root:hover {
  background-color: #5CBE75;
}
.search-drop-down-menu.news-date-picker-search-button.MuiButton-contained:hover {
  background-color: #42a55b;
}
.bg-qa-tab::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 100%;
  -webkit-transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -o-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
.bg-qa-tab.selected::before {
  height: 100%;
}
.bg-qa-tab.full:hover::before,
.bg-qa-tab.full.selected::before {
  background-color: #35b8d3;
}
.bg-qa-tab.semi:hover::before,
.bg-qa-tab.semi.selected::before {
  background-color: #3FC599;
}
.bg-qa-tab.skimmed:hover::before,
.bg-qa-tab.skimmed.selected::before {
  background-color: #F1617D;
}
.bg-qa-tab.archive:hover::before,
.bg-qa-tab.archive.selected::before {
  background-color: #73797A;
}
.bg-qa-tab.legislation:hover::before,
.bg-qa-tab.legislation.selected::before {
  background-color: #83619C;
}
.popover.bottom > .arrow {
  position: absolute;
  top: -11px;
}
.popover.bottom > .arrow::after {
  content: ' ';
  top: 1px;
  margin-left: -10px;
  border-width: 10px;
  border-top-width: 0;
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent;
}
.ca-filter-link:hover {
  color: #6288A5;
}
.privacy-filter-link:hover svg g {
  stroke: #004b7a;
}
.filter-link:hover svg g {
  stroke: #008C9F;
}
.account-input-label:hover svg g {
  stroke: #004b7a;
}
.account-input-label:hover svg {
  fill: #004b7a;
}
.account-input-checked svg {
  color: #004b7a;
}
.teal-save-button.MuiButton-root:hover {
  background-color: #002c47;
}
.white-cancel-button.MuiButton-root:hover {
  background-color: #e6e6e6;
}
.react-datepicker__navigation {
  border: 0.45rem solid transparent;
}
.react-datepicker__navigation--next {
  border-left-color: #ccc;
}
.react-datepicker__navigation--previous {
  border-right-color: #ccc;
}
.ca-homepage ol li,
.ca-homepage ul li {
  margin: 0.5rem 0;
}
.folder-badge {
  min-width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.75rem;
}
.form-submit-button:hover {
  background-color: #0bb9b5;
}
.form-cancel-button:hover:hover {
  background-color: #D5ECFF;
}
.trial-select-organisation-button:hover {
  background-color: #008C9F;
}
.trial-select-individual-button:hover {
  background-color: #008C9F;
}
.trial-thank-you-finish-button:hover {
  background-color: #5CBE75;
}
.ca-search-date-submit-button:hover {
  background-color: #5CBE75;
}
.dealwatch-search-date-submit-button:hover {
  background-color: #128a93;
}
@media screen and (max-width: 346px) {
  .MuiPickersBasePicker-pickerView {
    padding-right: 1.25rem;
  }
}
.markdown-content p {
  margin-top: 0;
}
.speech-bubble {
  background-color: #ebf0f4;
  padding: 10px 16px;
  position: relative;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
}
.speech-bubble:after {
  content: "";
  position: absolute;
  bottom: -2.25rem;
  /* value = - border-top-width - border-bottom-width */
  left: 5.25rem;
  /* controls horizontal position */
  border-width: 2.25rem 3rem 0 0;
  /* vary these values to change the angle of the vertex */
  border-style: solid;
  border-color: #ebf0f3 transparent;
  /* reduce the damage in FF3.0 */
  display: block;
  width: 0;
}
.markets-overview-tile {
  font-size: 18px;
}
.markets-overview-tile:hover {
  background: #d3fdff;
}
.overlay-parameter-header:before {
  content: ' ';
  position: absolute;
  width: 10px;
  height: 10px;
  background: #979797;
}
.overlay-parameter-header-enabled:before {
  background: #73797A;
}
.deal-increase {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #5CBE75;
}
.deal-decrease {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #CC0033;
}
.comment-controls .mini-speed-dial {
  min-height: 2rem;
  height: 2rem;
  width: 2rem;
}
.comment-controls .MuiSpeedDial-directionDown .MuiSpeedDial-actions {
  padding-top: 42px;
}
.transition-fade-out-slow {
  animation: fadeOut 500ms forwards;
  animation-delay: 0s;
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    display: none;
  }
}
.indented-section {
  display: block;
  padding-left: 2rem;
}
.esv-interview-label > p {
  margin: 0;
  word-wrap: break-word;
}
.esv-interview-hide-break > br {
  display: none;
}
.esv-interview-toolbar-width {
  width: 100%;
}
@media screen and (min-width: 1200px) {
  .esv-interview-toolbar-width {
    width: calc(100% - 20rem);
  }
}
@media screen and (min-width: 1500px) {
  .esv-interview-toolbar-spacing,
  .esv-footer-spacing {
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (min-width: 1450px) {
  .esv-interview-db-l {
    display: block;
  }
  .esv-interview-dn-l {
    display: none;
  }
  .esv-interview-preview-width-l {
    width: 50rem;
  }
}
.compact-switch-label {
  text-align: left;
  font-size: 0.875rem;
  color: #73797A;
}
.account-menu-dropdown {
  min-width: 128px;
}
.tile-border {
  position: relative;
  padding-bottom: 6px;
  border: 1px solid transparent;
}
.tile-border::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 6px;
  background: #255c83;
}
.tile-border:hover,
.tile-border:focus-within {
  border-color: #255c83;
}
.tile-border:hover::after,
.tile-border:focus-within::after {
  background: #255c83;
}
.tile-border.aol-corporate:hover,
.tile-border.aol-corporate:focus-within {
  border-color: #35B8D3;
}
.tile-border.aol-corporate:hover::after,
.tile-border.aol-corporate:focus-within::after {
  background: #35B8D3;
}
.tile-border.aol-employment:hover,
.tile-border.aol-employment:focus-within {
  border-color: #5CCCAE;
}
.tile-border.aol-employment:hover::after,
.tile-border.aol-employment:focus-within::after {
  background: #5CCCAE;
}
.tile-border.aol-ri:hover,
.tile-border.aol-ri:focus-within {
  border-color: #FF8657;
}
.tile-border.aol-ri:hover::after,
.tile-border.aol-ri:focus-within::after {
  background: #FF8657;
}
.tile-unavailable {
  position: relative;
  padding-bottom: 6px;
  border: 1px solid transparent;
}
.tile-unavailable::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 6px;
  background: #d8d8d8;
}
.tile-unavailable:hover,
.tile-unavailable:focus-within {
  border-color: #d8d8d8;
}
.tile-unavailable:hover::after,
.tile-unavailable:focus-within::after {
  background: #d8d8d8;
}
.smartsearch-switch {
  transform: translateX(0.5rem);
}
.description-line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
/* pdfjs-dist/web/pdf_viewer.css covers textLayer, annotationLayer, and pdfViewer page styles */
.pdf-viewer-wrapper {
  height: calc(100vh - 13rem);
  max-width: 1000px;
}
#pdfViewer .page {
  box-sizing: content-box;
}
#pdfViewer .textLayer {
  text-rendering: auto;
  -webkit-font-smoothing: auto;
}
.navigation-item-title .archived-label {
  display: none;
}
.archived-label {
  font-style: normal;
  font-size: 0.9rem;
  background: #83619C;
  padding: 5px;
  padding-right: 5px;
  padding-left: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 9999px;
  margin-left: 15px;
  margin-top: -2px;
  color: #fff;
}
.cd-accordion-menu {
  /*background: @color-accordion-base;*/
  list-style: none;
  margin: 0 auto 1.2em auto;
  padding: 0;
}
.cd-accordion-menu a {
  text-decoration: none;
}
.cd-accordion-menu ul.group {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 2;
}
.cd-accordion-menu .sticky,
.cd-accordion-menu .toggle {
  position: relative;
  z-index: 2;
}
.cd-accordion-menu .toggle {
  background: #FFFFFF;
}
.cd-accordion-menu li {
  padding: 0;
  margin: 0;
  position: relative;
  top: 0;
  left: 0;
}
.cd-accordion-menu input[type=checkbox] {
  /* hide native checkbox */
  position: absolute;
  opacity: 0;
}
.cd-accordion-menu .prefix {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 1.4em;
  height: 100%;
  width: 64px;
  min-width: 10px;
  padding: 19px 0 0 0;
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
  z-index: 20;
  color: #000;
  text-decoration: none;
  line-height: 1.8em;
}
@media screen and (max-width: 520px) {
  .cd-accordion-menu .prefix {
    width: 28px;
    font-size: 1.2em;
    line-height: 1em;
  }
}
.cd-accordion-menu .comment,
.cd-accordion-menu .selector {
  cursor: pointer;
  font-size: 1.4em;
  width: 2em;
  height: 4.5em;
  text-align: center;
  position: absolute;
  z-index: 20;
  box-shadow: none;
  background: transparent;
  color: inherit;
  padding: 0;
}
@media screen and (max-width: 520px) {
  .cd-accordion-menu .comment,
  .cd-accordion-menu .selector {
    height: 3.4em;
  }
}
.cd-accordion-menu .comment {
  right: 3em;
}
.cd-accordion-menu .comment i {
  font-size: 1.2em;
  margin-top: 1px;
  position: absolute;
  display: block;
  top: 50%;
  left: 0;
  width: 100%;
  letter-spacing: -1px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.cd-accordion-menu .no-title .comment {
  right: 1em;
}
@media screen and (max-width: 520px) {
  .cd-accordion-menu .no-title .comment {
    display: none;
  }
}
.cd-accordion-menu .selector {
  right: 1em;
}
.cd-accordion-menu .selector .indicator {
  position: absolute;
  display: block;
  top: 50%;
  left: 0;
  width: 100%;
  letter-spacing: -1px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.cd-accordion-menu .selector .indicator .svg-icon {
  position: relative;
  font-size: 1.2em;
}
.cd-accordion-menu .group-prefix {
  display: inline-block;
  font-weight: lighter;
  vertical-align: middle;
  font-size: 0.8em;
  text-transform: uppercase;
  margin-right: 1em;
}
.cd-accordion-menu .sticky-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: block;
  z-index: 1;
}
.cd-accordion-menu .sticky-bottom.show.depth-1 {
  z-index: 34;
}
.cd-accordion-menu .sticky-bottom.show.depth-2 {
  z-index: 35;
}
.cd-accordion-menu .sticky-bottom.show.depth-3 {
  z-index: 36;
}
.cd-accordion-menu .sticky-bottom.show.depth-4 {
  z-index: 37;
}
.cd-accordion-menu .sticky-bottom.show.depth-5 {
  z-index: 38;
}
.cd-accordion-menu .sticky-bottom.show.depth-6 {
  z-index: 39;
}
.cd-accordion-menu .sticky-bottom.show.depth-7 {
  z-index: 40;
}
.cd-accordion-menu .highlight.content,
.cd-accordion-menu .highlight.group,
.cd-accordion-menu .highlight.content label.content {
  background: #fcf8e3 !important;
}
.cd-accordion-menu label .before {
  /* icons */
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  margin: -0.1em 0 0 -0.1em;
}
.cd-accordion-menu label {
  cursor: pointer;
}
.cd-accordion-menu label.group .before {
  background-image: none;
  color: inherit;
  line-height: 1em;
  font-size: 1em;
  /* arrow icon */
  left: 18px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.cd-accordion-menu label .suffix {
  float: right;
  font-size: 0.8em;
  line-height: 1.8em;
  font-weight: lighter;
}
.cd-accordion-menu label.group-header-archived {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cd-accordion-menu .is-loading label::before {
  content: ' ';
  animation: accordion-loader 1.2s infinite linear;
  border: 2px solid;
  border-right-color: transparent;
  border-radius: 50%;
}
.cd-accordion-menu .is-loading label .before {
  display: none;
}
@-moz-keyframes accordion-loader {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  100% {
    transform: translateY(-50%) rotate(360deg);
  }
}
@-webkit-keyframes accordion-loader {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  100% {
    transform: translateY(-50%) rotate(360deg);
  }
}
@keyframes accordion-loader {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  100% {
    transform: translateY(-50%) rotate(360deg);
  }
}
.cd-accordion-menu input[type=checkbox]:checked + label .before {
  /* rotate arrow */
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.cd-accordion-menu input[type=checkbox]:checked + label::after {
  /* show open folder icon if item is checked */
  background-position: -32px 0;
}
.cd-accordion-menu input[type=checkbox]:checked + label + ul,
.cd-accordion-menu input[type=checkbox]:checked + label:nth-of-type(n) + ul {
  /* use label:nth-of-type(n) to fix a bug on safari (<= 8.0.8) with multiple adjacent-sibling selectors*/
  /* show children when item is checked */
  display: block;
}
.no-touch .cd-accordion-menu ul.group label:hover {
  background: #ededed;
}
.cd-accordion-menu li.depth-1 {
  margin-bottom: 2px;
}
.cd-accordion-menu li.depth-1.group {
  margin-bottom: 0;
}
.cd-accordion-menu label.depth-1.group {
  color: #222;
  fill: #222;
  background: #FFF;
  box-shadow: 0 0 0 1px rgba(127, 127, 127, 0.2) inset;
  padding-left: 38px;
}
.cd-accordion-menu label.depth-1.group .before {
  left: 16px;
}
.cd-accordion-menu label.depth-1.group.expanded {
  background: #555;
}
.cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #4f4f4f;
}
.cd-accordion-menu label.depth-2.group.expanded {
  background: #767676;
}
.cd-accordion-menu label.depth-2.group.expanded:hover {
  background: #707070;
}
.cd-accordion-menu .disabled label.depth-1.group,
.cd-accordion-menu .disabled label.depth-2.group {
  color: #666;
  fill: #666;
}
.cd-accordion-menu label.depth-1.group.expanded,
.cd-accordion-menu label.depth-2.group.expanded {
  color: #FFF !important;
  fill: #FFF !important;
  box-shadow: none !important;
}
.cd-accordion-menu .selector.expanded .indicator,
.cd-accordion-menu .depth-1.pinned .selector .indicator,
.cd-accordion-menu .depth-2.pinned .selector .indicator {
  color: #FFF;
  fill: #FFF;
}
.cd-accordion-menu .depth-3 .selector.expanded .indicator {
  color: inherit;
  fill: inherit;
}
.cd-accordion-menu label.depth-2.group,
.cd-accordion-menu label.depth-3.group,
.cd-accordion-menu label.depth-4.group,
.cd-accordion-menu label.depth-5.group,
.cd-accordion-menu label.depth-6.group {
  color: #222;
  fill: #222;
  box-shadow: 0 -1px 0 0 rgba(127, 127, 127, 0.2) inset, -1px 0 0 0 rgba(127, 127, 127, 0.2) inset, 1px 0 0 0 rgba(127, 127, 127, 0.2) inset, 0 -1px 0 0 rgba(127, 127, 127, 0.2) inset;
}
.cd-accordion-menu label.depth-2.group {
  background: #e6e6e6;
  padding-left: 56px;
}
.cd-accordion-menu label.depth-2.group .before {
  left: 34px;
}
.cd-accordion-menu label.depth-2.group:hover {
  background: #dfdfdf;
}
.cd-accordion-menu label.depth-3.group {
  background: #ececec;
  padding-left: 74px;
}
.cd-accordion-menu label.depth-3.group .before {
  left: 52px;
}
.cd-accordion-menu label.depth-3.group:hover {
  background: #e6e6e6;
}
.cd-accordion-menu label.depth-4.group {
  background: #f2f2f2;
  padding-left: 92px;
}
.cd-accordion-menu label.depth-4.group .before {
  left: 70px;
}
.cd-accordion-menu label.depth-4.group:hover {
  background: #ececec;
}
.cd-accordion-menu label.depth-5.group {
  background: #f9f9f9;
  padding-left: 110px;
}
.cd-accordion-menu label.depth-5.group .before {
  left: 88px;
}
.cd-accordion-menu label.depth-5.group:hover {
  background: #f2f2f2;
}
.cd-accordion-menu label.depth-6.group {
  background: #ffffff;
  padding-left: 128px;
}
.cd-accordion-menu label.depth-6.group .before {
  left: 106px;
}
.cd-accordion-menu label.depth-6.group:hover {
  background: #f9f9f9;
}
.cd-accordion-menu label.content {
  padding-left: 64px;
}
.cd-accordion-menu .selectable label.content,
.cd-accordion-menu .selectable label.group {
  padding-right: 4em;
}
.cd-accordion-menu .content,
.cd-accordion-menu .content label.content {
  background: #FFFFFF !important;
  color: #222222;
  fill: #222222;
}
.cd-accordion-menu .content .selector .indicator,
.cd-accordion-menu .content label.content .selector .indicator {
  color: #222222;
  fill: #222222;
}
.cd-accordion-menu .highlight-yellow .content,
.cd-accordion-menu .highlight-yellow .content label.content {
  background-color: #FCF8E3 !important;
}
.cd-accordion-menu .content label .before,
.cd-accordion-menu .content label::after {
  display: none;
}
.cd-accordion-menu .content label .prefix {
  left: 6px;
  width: 54px;
  text-align: center;
  display: inline-block;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  letter-spacing: -0.8px;
}
.cd-accordion-menu .content .content-text {
  padding: 18px 64px 18px 0;
  font-size: 1.2em;
  display: block;
  font-weight: 400;
}
@media screen and (max-width: 520px) {
  .cd-accordion-menu .content .content-text {
    padding: 0 0.5rem 0 0;
  }
}
.cd-accordion-menu .content .content-text p,
.cd-accordion-menu .content .content-text ul li {
  margin: 0.5em 0;
}
.cd-accordion-menu label::before {
  /* this class is used if you're using jquery to animate the accordion */
  -webkit-transition: transform 0.1s;
  -moz-transition: transform 0.1s;
  -ms-transition: transform 0.1s;
  -o-transition: transform 0.1s;
  transition: transform 0.1s;
}
.precedents .cd-accordion-menu label.depth-1.group.expanded {
  background: #011aac;
}
.precedents .cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #01189f;
}
.precedents .cd-accordion-menu label.depth-2.group.expanded {
  background: #0928e6;
}
.precedents .cd-accordion-menu label.depth-2.group.expanded:hover {
  background: #0926da;
}
.precedents .cd-accordion-menu .disabled label.depth-1.group,
.precedents .cd-accordion-menu .disabled label.depth-2.group {
  color: #666;
  fill: #666;
}
.content-review .cd-accordion-menu label .before {
  display: none !important;
}
.content-review .cd-accordion-menu label {
  cursor: default !important;
}
.ca .cd-accordion-menu label.depth-1,
.ca .cd-accordion-menu label.depth-1.group.expanded {
  background: #FFF;
  color: #F87531 !important;
  padding-left: 0;
  font-size: 1.7em;
  box-shadow: inset 0 -1px #fdd8c5 !important;
}
.ca .cd-accordion-menu label.depth-1:hover,
.ca .cd-accordion-menu label.depth-1.group.expanded:hover {
  background: #FFF;
}
.ca .cd-accordion-menu label.group .before {
  display: none;
}
.ca .cd-accordion-menu label.selector {
  color: #222;
  fill: #222;
}
.cd-accordion-header {
  /*position: absolute;
  width: 96%;
  left: 50%;
  height: 0;
  margin: 0;
  max-width: @page-max-width;
  margin-left: auto;
  margin-right: auto;*/
  background: transparent;
  bottom: -3px;
  /*.transform(translate(-50%, 0));*/
}
.cd-accordion-header .prefix.selectable .indicator {
  border-bottom: 3px solid #EEE;
  width: auto;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.cd-accordion-header .prefix.selectable .indicator::after {
  display: none;
}
.cd-accordion-header .prefix.selectable.selected .indicator {
  border-bottom: 3px solid;
}
.cd-accordion-header .selectable .selector {
  height: 2.7em;
}
@media screen and (max-width: 520px) {
  .cd-accordion-header .selectable .selector {
    height: 2.1em;
  }
}
.cd-accordion-header .prefix {
  pointer-events: none;
}
.cd-accordion-header .cd-accordion-menu {
  width: 100%;
  margin: 0;
}
.cd-accordion-header .cd-accordion-menu .content label {
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);
}
.cd-accordion-header .cd-list-container {
  width: 100%;
  /*margin: 0;
    max-width: @page-max-width;
    .transform(translate(0,0));
    -webkit-transition: -webkit-transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;
    -moz-transition: -moz-transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;
    transition: transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;*/
  position: relative;
  /*    top: 0;
    left: 0;*/
}
.cd-accordion-header .fadeout {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  opacity: 0.6;
  z-index: 2;
}
.cd-accordion-header.view-right {
  /*max-width: @page-max-width !important;*/
}
.cd-accordion-header.view-right .cd-list-container {
  /*width: 96%;
      margin: auto;*/
  -webkit-transform: translate(-700px, 0);
  -moz-transform: translate(-700px, 0);
  -o-transform: translate(-700px, 0);
  -ms-transform: translate(-700px, 0);
  transform: translate(-700px, 0);
  pointer-events: none;
}
.cd-accordion-header.view-right .cd-list-container .fadeout {
  display: block;
}
@media screen and (min-width: 1270px) {
  .cd-accordion-header.view-right .cd-list-container {
    -webkit-transform: translate(-550px, 0);
    -moz-transform: translate(-550px, 0);
    -o-transform: translate(-550px, 0);
    -ms-transform: translate(-550px, 0);
    transform: translate(-550px, 0);
  }
}
@media screen and (min-width: 1570px) {
  .cd-accordion-header.view-right .cd-list-container {
    pointer-events: all;
    -webkit-transform: translate(-300px, 0);
    -moz-transform: translate(-300px, 0);
    -o-transform: translate(-300px, 0);
    -ms-transform: translate(-300px, 0);
    transform: translate(-300px, 0);
  }
  .cd-accordion-header.view-right .cd-list-container .fadeout {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .cd-accordion-header.view-right .cd-list-container {
    -webkit-transform: translate(-520px, 0);
    -moz-transform: translate(-520px, 0);
    -o-transform: translate(-520px, 0);
    -ms-transform: translate(-520px, 0);
    transform: translate(-520px, 0);
  }
}
@media screen and (max-width: 520px) {
  .cd-accordion-header.view-right .cd-list-container {
    -webkit-transform: translate(-325px, 0);
    -moz-transform: translate(-325px, 0);
    -o-transform: translate(-325px, 0);
    -ms-transform: translate(-325px, 0);
    transform: translate(-325px, 0);
  }
}
.cd-accordion-header.view-left {
  max-width: 970px !important;
  pointer-events: none;
}
.cd-accordion-header.view-left .cd-list-container {
  width: 100%;
  margin: auto;
  -webkit-transform: translate(300px, 0);
  -moz-transform: translate(300px, 0);
  -o-transform: translate(300px, 0);
  -ms-transform: translate(300px, 0);
  transform: translate(300px, 0);
}
.cd-accordion-header li label {
  -webkit-transition: padding 0.1s;
  -moz-transition: padding 0.1s;
  -ms-transition: padding 0.1s;
  -o-transition: padding 0.1s;
  transition: padding 0.1s;
}
.cd-accordion-header li {
  position: relative;
  top: 0;
  left: 0;
  z-index: 2;
}
.cd-accordion-header li label {
  padding-top: 7px;
  padding-bottom: 7px;
}
@media screen and (max-width: 520px) {
  .cd-accordion-header li label {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}
.cd-accordion-header .prefix {
  padding-top: 7px;
}
.cd-accordion-header li:last-child {
  z-index: 1;
}
@media screen and (min-width: 1270px) {
  .has-left .cd-accordion-header.view-left,
  .has-left .cd-accordion-header.view-main {
    max-width: 970px !important;
  }
  .has-left .cd-accordion-header.view-left .cd-list-container,
  .has-left .cd-accordion-header.view-main .cd-list-container {
    width: 96%;
    margin: auto;
    -webkit-transform: translate(150px, 0);
    -moz-transform: translate(150px, 0);
    -o-transform: translate(150px, 0);
    -ms-transform: translate(150px, 0);
    transform: translate(150px, 0);
  }
}
.browser-ie .cd-list-container {
  -ms-transition: none !important;
  transition: none !important;
}
.accordion-comments {
  padding: 18px 64px 18px 64px;
  font-size: 1.8em;
  display: block;
  font-weight: 400;
}
@media screen and (max-width: 520px) {
  .accordion-comments {
    font-size: 1.5em;
    padding: 18px 0 18px 18px;
  }
}
.accordion-navigator {
  font-size: 1.4em;
  line-height: 1.3;
  margin: 0.6em 0 0 1em;
}
.accordion-navigator .navigation-group {
  margin: 0;
}
.accordion-navigator .navigation-group.depth-1 {
  margin: 0;
  padding: 0;
  border: none;
}
.accordion-navigator .navigation-group.depth-1 > .navigation-item {
  border-left: none;
  padding-left: 0;
}
.accordion-navigator .navigation-group.depth-1 > .navigation-item:before,
.accordion-navigator .navigation-group.depth-1 > .navigation-item:after {
  display: none;
}
.accordion-navigator .navigation-item {
  padding: 0.5em 0 0em 0.7em;
  border-left: 2px solid #FAFAFA;
  position: relative;
  margin-left: 3px;
  transition: border-color 0.2s;
}
.accordion-navigator a {
  color: inherit;
  margin: 0;
}
.accordion-navigator .navigation-item-title {
  display: block;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 0.5em;
  color: #AAA;
  fill: #AAA;
}
.accordion-navigator .navigation-item-title .prefix {
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: lighter;
  margin-right: 0.6em;
}
.accordion-navigator .navigation-item-title a {
  cursor: pointer;
  transition: color 0.2s;
}
.accordion-navigator .navigation-item-title a:hover {
  text-decoration: none;
  color: #000;
  fill: #000;
}
.accordion-navigator .active > .navigation-item-title {
  color: #000;
  fill: #000;
}
.accordion-navigator .active-after.navigation-item {
  border-color: #000;
}
.accordion-navigator .navigation-item:before {
  content: " ";
  display: block;
  position: absolute;
  height: 1.3em;
  width: 0;
  top: 0;
  border-left: 2px solid transparent;
  left: -2px;
  transition: border-color 0.2s;
}
.accordion-navigator .navigation-item.active:before {
  border-left: 2px solid #000 !important;
}
.accordion-navigator .navigation-item:last-child {
  border-left: 2px solid transparent;
}
.accordion-navigator .navigation-item:last-child:before {
  border-left: 2px solid #FAFAFA;
}
.accordion-navigator .navigation-item:after {
  content: " ";
  display: block;
  position: absolute;
  top: 1.2em;
  height: 0;
  width: 0.3em;
  border-bottom: 0.2em solid transparent;
  left: -2px;
  transition: border-color 0.2s;
}
.accordion-navigator .navigation-item.active:after {
  border-bottom-color: #000;
}
.key-picks.row::before {
  content: '';
  display: table;
}
.key-picks.row::after {
  content: '';
  display: table;
  clear: both;
}
.content-view {
  /* === Sections / Targetted Styles === */
  /* Smaller Section styles */
  /* Level 2 heading */
  /* Level 3 heading */
  /* === Typography/Headings Styles === */
  /* Questions - Collapsable */
  /* === Section / Level Specific Styles === */
  /* Mobile Devices */
}
.content-view.table-of-contents {
  font-size: 1.2em;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
.content-view.table-of-contents ul {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  list-style: none;
  padding-left: 0;
  -webkit-transition: top ease-in-out 250ms;
  -moz-transition: top ease-in-out 250ms;
  -ms-transition: top ease-in-out 250ms;
  -o-transition: top ease-in-out 250ms;
  transition: top ease-in-out 250ms;
}
.content-view.table-of-contents ul li {
  padding: 0.5em 1em 0.5em 0.5em;
  color: #aaa;
}
.content-view.table-of-contents ul li a {
  display: block;
  text-decoration: none !important;
  color: inherit;
}
.content-view.table-of-contents ul li.highlight {
  color: #000000;
}
.content-view.table-of-contents ul .depth-1 {
  padding-left: 1.5em;
  font-weight: bold;
}
.content-view.table-of-contents ul .depth-2 {
  padding-left: 1.5em;
}
.content-view.table-of-contents ul .depth-3 {
  padding-left: 2.5em;
}
.content-view.table-of-contents ul .depth-4 {
  padding-left: 3.5em;
}
.content-view.table-of-contents ul .depth-5 {
  padding-left: 4.5em;
}
.content-view.table-of-contents ul .depth-6 {
  padding-left: 5.5em;
}
.content-view.table-of-contents ul li:last-child {
  margin-bottom: 1em;
}
.content-view .lr-treeheader {
  display: block;
  font-size: 1.8em;
  padding: 0.5em;
}
.content-view .lr-treeheader a {
  color: #000;
  font-weight: 600;
}
.content-view .lr-treeheader.lr-container {
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);
}
.content-view .lr-treeheader.lr-container.depth-1 {
  padding-left: 1em;
  background: #dfdfdf;
}
.content-view .lr-treeheader.lr-container.depth-2 {
  padding-left: 2em;
  background: #e6e6e6;
}
.content-view .lr-treeheader.lr-container.depth-3 {
  padding-left: 3em;
  background: #ececec;
}
.content-view .lr-treeheader.lr-container.depth-4 {
  padding-left: 4em;
  background: #f2f2f2;
}
.content-view .lr-treeheader.lr-container.depth-5 {
  padding-left: 5em;
  background: #f9f9f9;
}
.content-view .lr-treeheader.lr-container.depth-6 {
  padding-left: 6em;
  background: #ffffff;
}
.content-view .lr-treeheader a.fc-question {
  font-size: 1em;
}
.content-view .lr-treeheader a:hover {
  text-decoration: underline !important;
}
.content-view .lr-treeheader .lr-breadcrumbs {
  display: block;
  font-size: 0.7em;
  margin-top: 0.2em;
}
.content-view .lr-treeheader .lr-breadcrumbs a {
  color: #006621;
}
.content-view .lr-treeheader .lr-breadcrumbs span + span::before {
  content: " > ";
  color: #006621;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.content-view .lr-treeheader.lr-leaf.depth-1 {
  margin-top: 1em;
}
.content-view .lr-treenode .fc-qa {
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);
}
.content-view .ca-heading-heading {
  display: flex;
  flex-direction: column;
}
.content-view .section-heading {
  font-weight: 700;
  font-size: 2.4em;
  line-height: 1.4;
  z-index: 2;
  position: relative;
  background-color: #ffffff;
}
.content-view .section-heading a {
  color: inherit;
}
.content-view .section-heading a:hover {
  text-decoration: none;
}
@media screen and (max-width: 768px) {
  .content-view .section-heading {
    font-size: 2.4em;
  }
}
@media screen and (max-width: 520px) {
  .content-view .section-heading {
    font-size: 2.2em;
  }
}
.content-view .section-heading .right-align {
  font-size: 0.6em;
  font-weight: normal;
  float: right;
  color: #999;
  fill: #999;
  line-height: 2.6em;
}
.content-view .section-heading .right-align i {
  font-size: 2em;
  vertical-align: middle;
}
.content-view .section-heading .right-align a,
.content-view .section-heading .right-align a:hover {
  text-decoration: none;
  display: inline;
}
.content-view .section-heading .right-align .svg-icon {
  font-size: 1.4em;
  position: relative;
  top: 0.1em;
  margin: 0 0.3em;
}
.content-view .section-heading .right-align a:hover {
  color: #666;
  fill: #666;
}
.content-view .section-heading .right-align .spacer {
  margin: 0 1em 0 2em;
}
.content-view .section-heading .right-align .spacer::before {
  content: "|";
}
.content-view .section-heading .right-align .flavoured {
  font-weight: bold;
}
.content-view table:not(.tinymce-generated-content) {
  width: 100%;
}
.content-view table:not(.tinymce-generated-content) td {
  vertical-align: top;
}
.content-view table:not(.tinymce-generated-content) td.button {
  width: 1em;
  font-weight: normal;
}
.content-view table:not(.tinymce-generated-content) td.button a {
  color: inherit;
}
.content-view table:not(.tinymce-generated-content) .align-middle {
  vertical-align: middle;
}
.content-view .ca-content table {
  width: unset;
}
.content-view .ca-content table td {
  vertical-align: unset;
}
.content-view .checkbox-widget {
  margin: 0;
  font-size: 18px;
}
.content-view.header {
  width: 100%;
  background-color: #e5e5e5;
}
.content-view.header .container {
  max-width: 970px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
}
@media screen and (max-width: 970px) {
  .content-view.header .container {
    width: 96%;
  }
}
.content-view.header .container .fc-section-header {
  padding-left: 0;
  padding-right: 0;
}
.content-view.header .fc-section-checkbox {
  display: block;
  background-color: #e5e5e5;
  font-size: 1.8em;
  line-height: 1.1em;
  color: #000000;
  font-weight: 400;
  padding: 0.5em 5px;
}
@media screen and (max-width: 520px) {
  .content-view.header .fc-section-checkbox {
    font-size: 1.5em;
    padding: 0.5em 0;
  }
  .content-view.header .fc-section-checkbox table tr td.button {
    padding: 0 5px;
  }
  .content-view.header .fc-section-checkbox table tr td.button.big {
    padding: 0 5px 0 0;
  }
}
.content-view.header .fc-section-checkbox table td {
  vertical-align: middle;
  height: inherit;
}
.content-view.header .fc-section-checkbox table td.button {
  padding: 0 10px 0 5px;
}
.content-view.header .fc-section-checkbox table td.button.big {
  padding: 0 5px;
  font-size: 1.1em;
}
.content-view.header .fc-section-checkbox input {
  height: 1.7em;
  border: 1px solid #000000;
  padding: 0 10px;
  font-size: 0.8em;
  margin-left: 5%;
  width: 94%;
  outline: none;
  display: inline-block;
  vertical-align: top;
}
.content-view .excerpt {
  font-size: 1.8em;
  font-weight: 200;
  margin: 0 0 2em;
}
@media screen and (max-width: 520px) {
  .content-view .excerpt {
    padding: 0 18px;
    font-size: 1.3em;
  }
}
.content-view .navigation {
  font-size: 1.9em;
}
.content-view .navigation a {
  display: block;
  padding: 0.3em 0.5em;
  background: #666;
  color: #fff;
  text-decoration: none;
}
.content-view .navigation a:focus {
  text-decoration: none;
}
@media screen and (max-width: 520px) {
  .content-view .navigation {
    font-size: 1.4em;
  }
}
.content-view .indented {
  font-size: 7px;
}
.content-view .indented .node-crossheading {
  margin-left: 2em;
}
.content-view .indented a {
  color: inherit;
  display: block;
  text-decoration: underline;
}
.content-view .indented .fc-section-header {
  padding-right: 15px;
}
.content-view .indented .header-depth-1 {
  padding-left: 10px;
}
.content-view .indented .header-depth-2 {
  padding-left: 20px;
}
.content-view .indented .header-depth-3 {
  padding-left: 30px;
}
.content-view .indented .header-depth-4 {
  padding-left: 40px;
}
.content-view .indented .header-depth-5 {
  padding-left: 50px;
}
.content-view .indented .header-depth-6 {
  padding-left: 60px;
}
@media screen and (max-width: 520px) {
  .content-view .indented .header-depth-1 {
    padding-left: 1em;
  }
  .content-view .indented .header-depth-2 {
    padding-left: 2em;
  }
  .content-view .indented .header-depth-3 {
    padding-left: 2.5em;
    font-size: 1.5em;
  }
  .content-view .indented .header-depth-4 {
    padding-left: 3em;
  }
  .content-view .indented .header-depth-5 {
    padding-left: 3.5em;
  }
  .content-view .indented .header-depth-6 {
    padding-left: 4em;
  }
}
.content-view .padded .fc-section-header,
.content-view .padded .fc-qa {
  padding-left: 15px;
  padding-right: 15px;
}
.content-view .fc-section-header {
  border: none;
  background-color: #000000;
  margin: 0px 0;
  line-height: 1.2em;
  padding: 0.5em 0;
  width: 100%;
  margin: 0;
}
.content-view .fc-section-header .number {
  display: inline-block;
  margin-right: 1em;
  font-size: 0.7em;
  line-height: 1.8em;
  vertical-align: top;
  text-transform: uppercase;
}
.content-view .fc-section-header.header-depth-1 {
  border-bottom: none;
  font-size: 3em;
  color: #ffffff;
}
.content-view .fc-section-header.header-depth-1 table td.button {
  color: #ffffff;
}
.content-view .fc-section-header.header-depth-2 {
  background-color: #e5e5e5;
  border-bottom: none;
  font-weight: 500;
  font-size: 2.6em;
}
.content-view .fc-section-header.header-depth-3 {
  background-color: #fff;
  color: #002a5b;
  border-bottom: 1px solid #e5e5e5;
  font-size: 2.4em;
}
.content-view .fc-section-header.header-depth-4 {
  background-color: #fff;
  color: #002a5b;
  border-bottom: 1px solid #e5e5e5;
  font-size: 2.2em;
}
.content-view .fc-section-header.header-depth-5 {
  background-color: #fff;
  color: #002a5b;
  font-size: 2em;
}
.content-view .fc-section-header.header-depth-6 {
  background-color: #fff;
  color: #002a5b;
  font-size: 2em;
}
@media screen and (max-width: 520px) {
  .content-view .fc-section-header.header-depth-1 {
    font-size: 2em;
  }
  .content-view .fc-section-header.header-depth-2 {
    font-size: 1.8em;
  }
  .content-view .fc-section-header.header-depth-3 {
    font-size: 1.7em;
  }
  .content-view .fc-section-header.header-depth-4 {
    font-size: 1.6em;
  }
  .content-view .fc-section-header.header-depth-5 {
    font-size: 1.5em;
  }
  .content-view .fc-section-header.header-depth-6 {
    font-size: 1.4em;
  }
}
.content-view .space-maker {
  opacity: 0;
}
.content-view > .fc-section-tree {
  margin-top: 9px;
}
.content-view .small-sections .fc-section-header h1,
.content-view .small-sections .fc-section-header h2,
.content-view .small-sections .fc-section-header h3 {
  line-height: 55px;
  font-size: 30px;
}
.content-view .small-sections .fc-section-header h3,
.content-view .small-sections .fc-section-header h4,
.content-view .small-sections .fc-section-header h5 {
  padding: 0px;
}
.content-view .small-sections .pull-right {
  height: 55px;
}
.content-view .fc-section-body .fc-section-header,
.content-view .panel {
  background-color: #e5e5e5;
}
.content-view .fc-section-tree .fc-section-children .fc-section-body .fc-section-header {
  background-color: #fff;
  color: #002a5b;
}
.content-view h3,
.content-view h4,
.content-view h5,
.content-view h6 {
  color: #2c2e83;
}
.content-view h1 {
  font-size: 3.6em;
  line-height: 40px;
  padding: 19px 0px 21px 0;
}
.content-view h2 {
  font-size: 3.4em;
  line-height: 41px;
}
.content-view h3 {
  font-size: 2.8em;
  line-height: 33px;
}
.content-view h4 {
  font-size: 2.4em;
  line-height: 28px;
}
.content-view h5 {
  font-size: 2.2em;
  line-height: 26px;
}
.content-view h6 {
  font-size: 2em;
  line-height: 24px;
}
.content-view section h1 {
  font-size: 3em;
}
.content-view ol:not(.tinymce-generated-content) {
  counter-reset: li;
}
.content-view ol:not(.tinymce-generated-content) > li {
  position: relative;
  list-style: none;
  margin-bottom: 0.2em;
}
.content-view ol:not(.tinymce-generated-content) > li::before {
  content: "(" counter(li, lower-alpha) ")";
  counter-increment: li;
  position: absolute;
  left: -2em;
  font-size: 0.9em;
  line-height: 1.7em;
  color: #444;
}
.content-view ol:not(.tinymce-generated-content) ol li::before {
  content: "(" counter(li, lower-roman) ")";
}
.content-view .ca-content ol:not(.tinymce-generated-content) > li {
  list-style: inherit;
}
.content-view .ca-content ol:not(.tinymce-generated-content) > li::before {
  content: none;
}
.content-view .ca-content ol:not(.tinymce-generated-content) ol li::before {
  content: none;
}
.content-view .capitalize::first-letter {
  text-transform: uppercase;
}
.content-view .no-border {
  border: none !important;
}
.content-view .fc-qa {
  padding: 0.7em 2em 0.8em 0;
}
@media screen and (max-width: 520px) {
  .content-view .fc-qa {
    padding: 0.7em 0.5em 0.8em 0;
  }
}
.content-view .fc-qa.expanded {
  border-bottom: 1px solid #e5e5e5;
}
.content-view .fc-qa:last-child {
  padding-bottom: 2em;
}
@media screen and (max-width: 520px) {
  .content-view .fc-qa:last-child {
    padding-bottom: 0;
  }
}
.content-view .fc-qa:last-child .fc-answer {
  border-bottom: none;
  margin-bottom: 0px;
}
.content-view .fc-qa:first-child {
  padding-top: 1.5em;
}
@media screen and (max-width: 520px) {
  .content-view .fc-qa:first-child {
    padding-top: 1em;
  }
}
.content-view .fc-qa.selected:last-child {
  border-bottom: none;
}
.content-view .fc-qa.selected + .fc-qa {
  margin-top: 8px;
}
.content-view .fc-qa.selected.highlight {
  margin: 8px 0;
  border-left: 8px solid #e5e5e5;
  padding-left: 10px;
}
.content-view .fc-qa table td.button,
.content-view .fc-section-header table td.button {
  font-size: 18px;
  color: #000000;
  padding: 0 11px;
}
@media screen and (max-width: 520px) {
  .content-view .fc-qa table td.button,
  .content-view .fc-section-header table td.button {
    padding: 0 5px;
  }
}
.content-view .fc-answer.section-content {
  font-size: 1.6em;
}
.content-view .fc-em {
  font-style: italic;
}
.content-view .fc-p,
.content-view .fc-indent {
  padding-left: 2.2em;
  display: block;
  position: relative;
  top: 0;
  left: 0;
  margin: 0.5em 0;
}
.content-view .fc-p .reference,
.content-view .fc-indent .reference,
.content-view .fc-p .fc-reference,
.content-view .fc-indent .fc-reference {
  position: absolute;
  top: 0;
  left: 0.2em;
  color: inherit;
  display: block;
  font-size: 0.9em;
  line-height: 1.7em;
  font-weight: normal;
}
.content-view .fc-p .reference .fc-stacked-reference-2,
.content-view .fc-indent .reference .fc-stacked-reference-2,
.content-view .fc-p .fc-reference .fc-stacked-reference-2,
.content-view .fc-indent .fc-reference .fc-stacked-reference-2 {
  position: absolute;
  left: -2.6em;
}
.content-view .fc-p .reference .fc-stacked-reference-3,
.content-view .fc-indent .reference .fc-stacked-reference-3,
.content-view .fc-p .fc-reference .fc-stacked-reference-3,
.content-view .fc-indent .fc-reference .fc-stacked-reference-3 {
  position: absolute;
  left: -5.2em;
}
.content-view .fc-p .reference .fc-stacked-reference-4,
.content-view .fc-indent .reference .fc-stacked-reference-4,
.content-view .fc-p .fc-reference .fc-stacked-reference-4,
.content-view .fc-indent .fc-reference .fc-stacked-reference-4 {
  position: absolute;
  left: -7.8em;
}
.content-view .fc-p.mark,
.content-view .fc-indent.mark {
  background-color: #FCF8E3;
  padding: 0 0 0 2.2em;
}
@media screen and (max-width: 520px) {
  .content-view .fc-p,
  .content-view .fc-indent {
    padding-left: 1.3em;
  }
  .content-view .fc-p .reference,
  .content-view .fc-indent .reference,
  .content-view .fc-p .fc-reference,
  .content-view .fc-indent .fc-reference {
    left: 0;
  }
  .content-view .fc-p .reference .fc-stacked-reference-2,
  .content-view .fc-indent .reference .fc-stacked-reference-2,
  .content-view .fc-p .fc-reference .fc-stacked-reference-2,
  .content-view .fc-indent .fc-reference .fc-stacked-reference-2 {
    position: absolute;
    left: -1.6em;
  }
  .content-view .fc-p .reference .fc-stacked-reference-3,
  .content-view .fc-indent .reference .fc-stacked-reference-3,
  .content-view .fc-p .fc-reference .fc-stacked-reference-3,
  .content-view .fc-indent .fc-reference .fc-stacked-reference-3 {
    position: absolute;
    left: -3.2em;
  }
  .content-view .fc-p .reference .fc-stacked-reference-4,
  .content-view .fc-indent .reference .fc-stacked-reference-4,
  .content-view .fc-p .fc-reference .fc-stacked-reference-4,
  .content-view .fc-indent .fc-reference .fc-stacked-reference-4 {
    position: absolute;
    left: -4.8em;
  }
}
.content-view .fc-indent {
  margin-left: 2.2em;
}
.content-view .fc-indent .fc-indent {
  margin-left: 0;
}
.content-view .fc-amend {
  display: block;
  position: relative;
  margin: 2em 0;
  padding-left: 1em;
  border-left: 3px solid #eeeeee;
}
.content-view .fc-amend .fc-crossheading > .fc-title {
  font-weight: bold;
  margin: 0 0 1em -1em;
}
.content-view .fc-amend .fc-schedule {
  padding-left: 2.2em;
  position: relative;
}
.content-view .fc-amend .fc-schedule .fc-title {
  margin: 0 0 0 1em;
}
.content-view .fc-amend .fc-schedule .fc-part {
  display: block;
}
.content-view .fc-amend .fc-schedule > .reference {
  left: -1em;
  font-weight: bold;
  font-size: 0.8em;
  line-height: 1.7em;
}
.content-view .fc-amend .fc-crossheading,
.content-view .fc-amend .fc-section,
.content-view .fc-amend .fc-part,
.content-view .fc-amend .fc-chapter {
  padding-left: 2.2em;
  position: relative;
}
.content-view .fc-amend .fc-crossheading > .reference,
.content-view .fc-amend .fc-section > .reference,
.content-view .fc-amend .fc-part > .reference,
.content-view .fc-amend .fc-chapter > .reference {
  left: -1em;
  font-weight: bold;
  font-size: 0.8em;
  line-height: 1.7em;
}
.content-view .fc-amend .fc-section {
  display: block;
}
.content-view .fc-title {
  font-weight: bold;
  position: relative;
}
.content-view .fc-title .reference {
  display: inline-block;
  position: relative;
  margin-left: -2em;
  margin-right: 0.5em;
  font-size: 1em;
  font-weight: bold;
}
.content-view .fc-table {
  display: table;
  padding: 0 2em;
  margin: 1em 0 3em;
  width: 100%;
}
.content-view .fc-table .fc-tr {
  display: table-row;
}
.content-view .fc-table .fc-td {
  display: table-cell;
  padding: 0.2em 1em;
}
.content-view .fc-table .fc-td > .fc-p {
  padding-left: 0;
}
.content-view .fc-section-qas {
  border-bottom: 1px solid #e5e5e5;
}
.content-view .fc-question {
  display: table-row;
  color: #1460d1;
  font-size: 1.8em;
  padding: 11px 0px 0px 0px;
  line-height: 1.3em;
  margin-bottom: 0px;
  /*25*/
  font-weight: 700;
  text-decoration: none !important;
}
.content-view .fc-question .fc-question-number {
  vertical-align: top;
  display: table-cell;
  white-space: nowrap;
  padding-right: 0.4em;
}
.content-view .fc-question .fc-question {
  vertical-align: top;
  display: table-cell;
  font-size: 1em;
  padding: 0;
}
.content-view .fc-question .fc-question-number,
.content-view .fc-question .fc-question {
  padding-top: 0.1em;
}
@media screen and (max-width: 768px) {
  .content-view .fc-question .fc-question-number,
  .content-view .fc-question .fc-question {
    padding-top: 0.3em;
  }
}
.content-view .fc-question .path {
  font-weight: normal;
  font-size: 0.75em;
  color: #006621;
  margin: 0.5em 0 0;
}
.content-view .fc-question .path span + span:before {
  content: " > ";
  color: #006621;
}
.content-view .row .col-fluid {
  display: table-cell;
  vertical-align: top;
  width: 100%;
  padding: 0 17px;
}
.content-view .row .col-checkbox {
  display: table-cell;
  vertical-align: top;
}
.content-view .row .col-checkbox:first-child {
  padding: 0 0 0 17px;
}
.content-view .row .col-checkbox:last-child {
  padding: 0 17px 0 0;
}
@media screen and (max-width: 768px) {
  .content-view .row .col-checkbox:last-child {
    padding-right: 8px;
  }
  .content-view .row .col-checkbox:first-child {
    padding-left: 8px;
  }
  .content-view .row .col-fluid {
    padding: 0 8px;
  }
}
.content-view .fc-qa.review,
.content-view .fc-section-header.review {
  padding-left: 18px;
}
.content-view .fc-answer.collapse.in {
  margin-bottom: 8px;
}
.content-view .fc-answer {
  display: block;
  padding-bottom: 0.8em;
}
.content-view .fc-answer p {
  margin: 0.5em 0;
}
.content-view .fc-answer p:last-child {
  margin-bottom: 0;
}
.content-view .fc-answer ol {
  list-style-type: lower-alpha;
  padding-left: 2em;
  margin-bottom: 0px;
}
.content-view .fc-answer ol ol {
  list-style-type: lower-roman;
}
.content-view .fc-answer a {
  overflow: hidden;
  display: inline;
  vertical-align: top;
}
.content-view .fc-answer-wrap p,
.content-view .fc-glossary,
.content-view .fc-legislation {
  font-weight: 400;
  color: #231f20;
  font-size: 1em;
}
.content-view .fc-legislation {
  border-bottom: 1px dashed #a6a6a6;
  top: 0;
  left: 0;
  outline: none;
  cursor: pointer;
}
.content-view .fc-legislation .fc-reference,
.content-view .fc-legislation .fc-labels {
  display: none;
}
.content-view .fc-legislation .fc-glossary {
  border-bottom: none;
}
.content-view .legislation-reference-title {
  width: 100%;
}
.content-view .legislation-reference-title td.title {
  max-width: 0;
  padding-bottom: 0.4em;
}
.content-view .legislation-reference-title a {
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
}
.content-view .legislation-reference-body {
  position: absolute;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  bottom: 0;
  top: 6em;
  z-index: 1;
  padding-right: 10px;
  right: 0;
  left: 15px;
}
.content-view .legislation-reference-body .fc-section-body .fc-section-header {
  background: none;
  border-bottom: none;
}
.content-view .legislation-reference-body .fc-section-body .header-depth-2 {
  font-size: 1.8em;
  font-weight: bold;
}
.content-view .legislation-reference-body .fc-section-body .header-depth-3 {
  font-size: 1.8em;
  font-weight: bold;
}
.content-view .legislation-reference-body .fc-section-body .header-depth-4 {
  font-size: 1.8em;
  margin-left: 1em;
}
.content-view .legislation-reference-body .fc-section-qas {
  border-bottom: none;
}
.content-view .legislation-reference-body .fc-section-qas .fc-qa {
  border-bottom: none;
  padding: 0 !important;
}
@media screen and (max-width: 768px) {
  .content-view .legislation-reference-body {
    top: 6em;
  }
}
.content-view .fc-answer-wrap ul,
.content-view .fc-answer-wrap ol {
  font-weight: 400;
}
.content-view .fc-glossary {
  white-space: nowrap;
  border-bottom: 1px dashed #a6a6a6;
  top: 0;
  left: 0;
  outline: none;
  cursor: pointer;
}
.content-view .fc-glossary.focus {
  position: relative;
}
@media screen and (max-width: 520px) {
  .content-view .fc-glossary.focus {
    background: #DDDDDD;
  }
}
.content-view a.fc-cross-reference,
.content-view a.fc-news-reference,
.content-view a.fc-document-reference {
  color: #1460D1;
  display: inline;
}
.content-view a.fc-cross-reference:hover,
.content-view a.fc-news-reference:hover,
.content-view a.fc-document-reference:hover {
  text-decoration: underline;
}
.content-view li p {
  margin-bottom: 0px;
}
.content-view p {
  margin-bottom: 9px;
}
.content-view p a {
  color: #1460D1;
}
.content-view .fc-legislation-reference,
.content-view .fc-legislation-reference-range,
.content-view .fc-canonical-case-reference {
  display: none;
  visibility: hidden;
}
.content-view .fc-case-reference {
  font-weight: bold;
}
.content-view .popover {
  max-width: 300px;
}
.content-view .fc-partialnote,
.content-view .fc-jurisdictionnote {
  font-size: 0.8em;
  font-style: italic;
  color: #555;
  display: inline-block;
  font-weight: normal;
  padding: 0.4em 1em;
  background: #eee;
}
@media screen and (max-width: 768px) {
  .content-view {
    /* Targetted */
  }
  .content-view h1,
  .content-view .fc-section-header h1 {
    font-size: 1.7em;
  }
  .content-view .fc-section-header h2 {
    font-size: 1.8em;
  }
  .content-view .fc-section-header h3 {
    font-size: 1.7em;
  }
  .content-view .fc-section-header h4 {
    font-size: 1.6em;
  }
  .content-view .fc-section-header h5 {
    font-size: 1.6em;
  }
  .content-view .fc-section-header h6 {
    font-size: 1.6em;
  }
  .content-view .fc-question {
    padding-left: 0px;
    padding-right: 20px;
    font-size: 1.4em;
  }
  .content-view .fc-answer > p {
    padding-left: 0px;
    padding-right: 20px;
  }
  .content-view .fc-answer ol {
    padding-left: 1.5em;
    padding-right: 1.5em;
    margin-bottom: 1em;
  }
  .content-view > section > .fc-section-body > .fc-section-children > section > .fc-section-body > .fc-section-children > section > .fc-section-header h3 {
    padding: 12px 1px 12px 0px;
  }
}
.content-view .reference-range {
  font-size: 14px;
}
@media screen and (max-width: 520px) {
  .content-view .reference-range {
    font-size: 11px;
  }
}
@media screen and (max-width: 520px) {
  .content-view .fc-answer ol {
    padding-left: 18px;
  }
  .content-view .fc-qa:last-child {
    margin-bottom: 16px;
  }
  .content-view .fc-qa:last-child .fc-answer-wrap {
    padding-bottom: 0px;
  }
}
.content-view.content-review .fc-answer-wrap {
  font-size: 1.8em;
  margin: 1.4em 0 0;
  display: block;
}
.content-view .copyright-footer {
  font-size: 1.4em;
  line-height: 1.3;
  padding: 1.5em 2em;
  color: #888;
}
.content-view .large {
  font-size: 1.8em;
}
.content-view .content-text > :not(.ca-content) table:not(.tinymce-generated-content),
.content-view .content-text > table:not(.tinymce-generated-content) {
  border-spacing: 1.5em;
  border-collapse: separate;
  margin: 0 -1.5em;
}
.content-view .content-text [class^="icon-bottle"] {
  font-size: 1.5em;
  vertical-align: sub;
}
.content-view .bottle-icon {
  display: inline-block;
  vertical-align: middle;
  width: 2.4em;
  height: 2.4em;
  background-size: 2.4em !important;
}
.content-view .nowrap {
  white-space: nowrap;
}
span.wj {
  font-size: 0 !important;
}
.flavour-full .section-heading .right-align .flavoured,
.color-full {
  color: #35b8d3;
  fill: #35b8d3;
}
.flavour-full .section-heading .right-align .flavoured.active,
.color-full.active {
  color: #FFFFFF;
  fill: #FFFFFF;
}
.flavour-semi .section-heading .right-align .flavoured,
.color-semi {
  color: #3fc599;
  fill: #3fc599;
}
.flavour-semi .section-heading .right-align .flavoured.active,
.color-semi.active {
  color: #FFFFFF;
  fill: #FFFFFF;
}
.flavour-skimmed .section-heading .right-align .flavoured,
.color-skimmed {
  color: #f1617d;
  fill: #f1617d;
}
.flavour-skimmed .section-heading .right-align .flavoured.active,
.color-skimmed.active {
  color: #FFFFFF;
  fill: #FFFFFF;
}
.flavour-archive .section-heading .right-align .flavoured,
.color-archive {
  color: #73797a;
  fill: #73797a;
}
.flavour-archive .section-heading .right-align .flavoured.active,
.color-archive.active {
  color: #FFFFFF;
  fill: #FFFFFF;
}
.color-legislation {
  color: #83619C;
  fill: #83619C;
}
.color-legislation.active {
  color: #FFFFFF;
  fill: #FFFFFF;
}
.content-depth {
  font-size: 1em;
  color: #fff;
  margin-right: 0.2em;
  margin-left: 1em;
}
.content-depth .content-depth-text {
  display: inline-block;
  vertical-align: middle;
}
.content-depth .desc {
  color: #666;
}
.content-depth i {
  font-size: 1.7em !important;
  vertical-align: sub;
}
.content-depth.full {
  color: #35b8d3;
}
.content-depth.semi {
  color: #3fc599;
}
.content-depth.skimmed {
  color: #f1617d;
}
.popover-container {
  font-size: 1.6em;
}
.popover-container .popover {
  margin-top: 10px;
  max-width: 450px;
  font-size: 0.8em;
  -webkit-transition: opacity 0.2s;
  -moz-transition: opacity 0.2s;
  -ms-transition: opacity 0.2s;
  -o-transition: opacity 0.2s;
  transition: opacity 0.2s;
}
.popover-container .popover p {
  margin: 0;
}
.popover-container .popover p + p {
  margin: 1em 0 0;
}
@media screen and (max-width: 520px) {
  .popover-container .popover {
    font-size: 1em;
    max-width: calc(100vw - 1.5rem);
  }
}
.popover-container .popover.show {
  opacity: 1;
}
.popover-container .popover.show.fade-leave-active {
  opacity: 0;
}
.comment-body .public-DraftEditor-content h1,
.comment-body .content-view h1 {
  font-size: 1.4em;
  font-weight: normal;
  margin: 0 0 0.3em;
  padding: 0;
  line-height: normal;
}
.comment-body .public-DraftEditor-content h2,
.comment-body .content-view h2,
.comment-body .public-DraftEditor-content h3,
.comment-body .content-view h3,
.comment-body .public-DraftEditor-content h4,
.comment-body .content-view h4,
.comment-body .public-DraftEditor-content h5,
.comment-body .content-view h5,
.comment-body .public-DraftEditor-content h6,
.comment-body .content-view h6 {
  font-size: 1.2em;
  font-weight: normal;
  margin: 0 0 0.4em 0.8em;
  padding: 0;
  line-height: normal;
}
.comment-body .public-DraftEditor-content p,
.comment-body .content-view p,
.comment-body .public-DraftEditor-content .paragraph,
.comment-body .content-view .paragraph {
  margin: 0 0 0.5em 1em;
}
.comment-body .public-DraftEditor-content ol,
.comment-body .content-view ol,
.comment-body .public-DraftEditor-content ul,
.comment-body .content-view ul {
  margin-left: 0.5em;
}
.comment-body .public-DraftEditor-content ol li::before,
.comment-body .content-view ol li::before {
  content: "(" counter(li) ")";
}
.comment-body .public-DraftEditor-content .paragraph {
  margin: 0 0 0.5rem 0;
}
.svg-base {
  display: inline-block;
  line-height: 1;
}
.svg-base svg {
  fill: currentColor;
  vertical-align: middle;
  width: 100%;
  height: 100%;
}
.svg-base svg g {
  stroke: currentColor;
}
.svg-base svg path {
  fill: inherit;
}
.icon-base {
  position: relative;
  height: auto;
}
.icon-base svg {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.icon-base:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./../config/fonts/stylesheet.less","webpack://./styles/index.less","webpack://./../base.less","webpack://./../config/media.less","webpack://./../utils/theming.less","webpack://./../utils/spacing.less","webpack://./../config/legacy-variables.less","webpack://./../utils/layout.less","webpack://./../fix.less","webpack://./../helpers.less","webpack://./../utils/typography.less","webpack://./../home-page.less","webpack://./../precedents.less","webpack://./../texteditor.less","webpack://./../markets-search.less","webpack://./../icons.less","webpack://./../grid.less","webpack://./../hamburger.less","webpack://./../custom.less","webpack://./../pdf.less","webpack://./../accordion-legacy.less","webpack://./../content.less","webpack://./../index.less"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,kHAAA;EACA,gBAAA;EACA,kBAAA;ACGF;ADAA;EACE,8BAAA;EACA,kHAAA;EACA,gBAAA;EACA,kBAAA;ACEF;ADCA;EACE,8BAAA;EACA,kHAAA;EACA,gBAAA;EACA,kBAAA;ACCF;ADEA;EACE,8BAAA;EACA,kHAAA;EACA,gBAAA;EACA,kBAAA;ACAF;ADGA;EACE,8BAAA;EACA,kHAAA;EACA,gBAAA;EACA,kBAAA;ACDF;ADIA;EACE,8BAAA;EACA,oHAAA;EACA,gBAAA;EACA,kBAAA;ACFF;ADKA;EACE,8BAAA;EACA,oHAAA;EACA,gBAAA;EACA,kBAAA;ACHF;AACA;;;;;;;CAOC;AACD;;;;;;;CAOC;AACD;;;;;;;;;CASC;AC1DD;EACE,sBAAA;AD4DF;ACzDA;;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AD4DF;AEzEE;EAAA;;IDeE,YAAA;IACA,gBAAA;IACA,gBAAA;ED+DF;AACF;AC5DA;EACE,kCAAA;EACA,4CAAA;EACA,kCAAA;EACA,mDAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EEgLsB,yBAAA;AHjHxB;AC3DA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AD6DF;AC1DA;EGuQY,cAAA;EAAyB,iBAAA;EAkcxB,aAAA;EAAwB,gBAAA;EA6EtB,iBAAA;EAAmB,kBAAA;EHlxBhC,iBAAA;EACA,oBAAA;EACA,qBAAA;AD+DF;AE5GE;EAAA;ID+CE,oBAAA;IACA,qBAAA;EDiEF;AACF;AElHE;EAAA;IDmDE,qBAAA;IACA,sBAAA;EDmEF;AACF;AC/DA;;;;EAIE,cAAA;EACA,6BAAA;ADiEF;AC3DA;;;;EAIE,gBAAA;EACA,qBAAA;EACA,wBAAA;AD6DF;AC1DA;EACE,YAAA;EACA,aAAA;AD4DF;ACzDA;EACE,wBAAA;EACA,uBAAA;AD2DF;ACxDA;EACE,cAAA;AD0DF;ACtDE;EACE,uBAAA;ADwDJ;ACtDE;EACE,kBAAA;ADwDJ;ACpDA;EACE,wCAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,+BAAA;EACA,kBAAA;EACA,qBAAA;ADsDF;AK3HE;EJyEA;IAAM,uBAAA;EDsDN;ECrDA;IAAQ,yBAAA;EDwDR;AACF;AKlIE;EJwEA;IAAM,uBAAA;ED8DN;EC7DA;IAAQ,yBAAA;EDgER;AACF;AKzIE;EJuEA;IAAM,uBAAA;EDsEN;ECrEA;IAAQ,yBAAA;EDwER;AACF;ACtEA;EDwEE,gEAAgE;ECtEhE,gBAAA;ADwEF;AACA,iFAAiF;ACrEjF;EACE,aAAA;ADuEF;ACpEA;EACE,wCAAA;ADsEF;AACA;;;;;;;CAOC;AM5MD;EAAoB,cAAA;AN+MpB;AM9MA;EAAoB,gBAAA;ANiNpB;AMhNA;EAAoB,gBAAA;ANmNpB;AMlNA;EAAoB,iBAAA;ANqNpB;AMpNA;EAAqB,gBAAA;ANuNrB;AMtNA;EACE,gBAAA;EACA,kBAAA;ANwNF;AMrNA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,4DAAA;ANuNF;AMjNA;EAAY,yBAAA;EAA2B,iBAAA;ANqNvC;AMjNA;EAAe,cAAA;ANoNf;AMnNA;EAAe,qBAAA;ANsNf;AMrNA;EAAe,eAAA;ANwNf;AMvNA;EAAe,aAAA;AN0Nf;AMzNA;EAAe,aAAA;AN4Nf;AM3NA;EAAe,oBAAA;AN8Nf;AE9PE;EImCA;IARa,cAAA;ENuOb;EM9NA;IARa,qBAAA;ENyOb;EMhOA;IARa,eAAA;EN2Ob;EMlOA;IARa,aAAA;EN6Ob;EMpOA;IARa,aAAA;EN+Ob;EMtOA;IARa,oBAAA;ENiPb;AACF;AElRE;EI4CA;IAjBa,cAAA;EN2Pb;EMzOA;IAjBa,qBAAA;EN6Pb;EM3OA;IAjBa,eAAA;EN+Pb;EM7OA;IAjBa,aAAA;ENiQb;EM/OA;IAjBa,aAAA;ENmQb;EMjPA;IAjBa,oBAAA;ENqQb;EMnPA;IAAiB,iBAAA;ENsPjB;AACF;AE/QE;EI4BA;IAxBa,aAAA;EN+Qb;EMtPA;IA5Ba,cAAA;ENqRb;AACF;AE3QE;EIqBA;IAhCa,cAAA;EN0Rb;EMzPA;IA9Ba,aAAA;EN0Rb;EM3PA;IA9Ba,aAAA;EN4Rb;AACF;AM3PA;EAAU,cAAA;AN8PV;AM7PA;EAAU,YAAA;ANgQV;AElUE;EIqEA;IAJQ,cAAA;ENqQR;AACF;AM7PA;EAAuB,sBAAA;ANgQvB;AM/PA;EAAuB,mBAAA;ANkQvB;AMjQA;EAAuB,8BAAA;ANoQvB;AMnQA;EAAuB,2BAAA;ANsQvB;AEnVE;EIgFA;IANqB,sBAAA;EN6QrB;EMtQA;IANqB,mBAAA;EN+QrB;EMxQA;IANqB,8BAAA;ENiRrB;EM1QA;IANqB,2BAAA;ENmRrB;AACF;AEjWE;EIuFA;IAbqB,sBAAA;EN2RrB;EM7QA;IAbqB,mBAAA;EN6RrB;EM/QA;IAbqB,8BAAA;EN+RrB;EMjRA;IAbqB,2BAAA;ENiSrB;AACF;AMjRA;EAAW,QAAA;ANoRX;AMnRA;EAAW,QAAA;ANsRX;AMrRA;EAAW,QAAA;ANwRX;AExXE;EImGA;IAAa,QAAA;ENyRb;EMxRA;IAAa,QAAA;EN2Rb;EM1RA;IAAa,QAAA;EN6Rb;EM5RA;IAAa,QAAA;EN+Rb;AACF;AM5RA;EAAuB,eAAA;AN+RvB;AM9RA;EAAuB,iBAAA;ANiSvB;AMhSA;EAAuB,uBAAA;ANmSvB;AE/YE;EI+GA;IALqB,eAAA;ENySrB;AACF;AEpZE;EImHA;IATqB,eAAA;EN8SrB;AACF;AMlSA;EAAoB,yBAAA;ANqSpB;AMpSA;EAAoB,uBAAA;ANuSpB;AMtSA;EAAoB,qBAAA;ANySpB;AMxSA;EAAoB,uBAAA;AN2SpB;AM1SA;EAAoB,sBAAA;AN6SpB;AMzSA;EAAkB,uBAAA;AN4SlB;AM3SA;EAAkB,qBAAA;AN8SlB;AM7SA;EAAkB,mBAAA;ANgTlB;AM/SA;EAAkB,qBAAA;ANkTlB;AMjTA;EAAkB,oBAAA;ANoTlB;AEvbE;EIsIA;IAPgB,uBAAA;EN4ThB;EMpTA;IAPgB,qBAAA;EN8ThB;EMtTA;IAPgB,mBAAA;ENgUhB;EMxTA;IAPgB,qBAAA;ENkUhB;EM1TA;IAPgB,oBAAA;ENoUhB;AACF;AExcE;EI8IA;IAfgB,uBAAA;EN6UhB;EM7TA;IAfgB,qBAAA;EN+UhB;EM/TA;IAfgB,mBAAA;ENiVhB;EMjUA;IAfgB,qBAAA;ENmVhB;EMnUA;IAfgB,oBAAA;ENqVhB;AACF;AMlUA;EAAc,oBAAA;ANqUd;AMpUA;EAAc,sBAAA;ANuUd;AMtUA;EAAe,kBAAA;ANyUf;AEleE;EI4JA;IALY,oBAAA;EN+UZ;EMzUA;IALY,sBAAA;ENiVZ;AACF;AMxUA;EAAmB,2BAAA;AN2UnB;AM1UA;EAAmB,yBAAA;AN6UnB;AM5UA;EAAmB,uBAAA;AN+UnB;AM9UA;EAAmB,8BAAA;ANiVnB;AMhVA;EAAmB,6BAAA;ANmVnB;AMlVA;EC1IE,6BAAA;ED0I2C,6BAAA;ANsV7C;AE7fE;EI0KA;IARiB,2BAAA;EN+VjB;EMtVA;IARiB,yBAAA;ENiWjB;EMxVA;IARiB,uBAAA;ENmWjB;EM1VA;IARiB,8BAAA;ENqWjB;EM5VA;ICjJA,6BAAA;ID0I2C,6BAAA;ENuW3C;AACF;AE/gBE;EIkLA;IAhBiB,2BAAA;ENiXjB;EMhWA;IAhBiB,yBAAA;ENmXjB;EMlWA;IAhBiB,uBAAA;ENqXjB;EMpWA;IAhBiB,8BAAA;ENuXjB;EMtWA;ICzJA,6BAAA;ID0I2C,6BAAA;ENyX3C;AACF;AMtWA;EAAsB,mBAAA;ANyWtB;AMxWA;EAAsB,wBAAA;AN2WtB;AM1WA;EAAsB,sBAAA;AN6WtB;AM5WA;EAAsB,sBAAA;AN+WtB;AM9WA;EAAsB,2BAAA;ANiXtB;AMhXA;EAAsB,qBAAA;ANmXtB;AMlXA;EAAsB,mBAAA;ANqXtB;AMjXA;EAAc,aAAA;ANoXd;AMnXA;ECnME,YAAA;EACA,aAAA;EDkM8C,gBAAA;ANwXhD;AMvXA;EAAc,eAAA;AN0Xd;AMzXA;EAAc,gBAAA;AN4Xd;AEpkBE;EI2MA;IANY,aAAA;ENmYZ;EM5XA;ICzMA,YAAA;IACA,aAAA;IDkM8C,gBAAA;ENuY9C;EMhYA;IALY,gBAAA;ENwYZ;AACF;AM/XA;EAAU,YAAA;ANkYV;AMjYA;EAAU,YAAA;ANoYV;AMnYA;EAAU,YAAA;ANsYV;AMrYA;EAAU,YAAA;ANwYV;AMvYA;EAAU,YAAA;AN0YV;AMzYA;EAAU,YAAA;AN4YV;AM1YA;EAAgB,kBAAA;AN6YhB;AEtmBE;EI4NA;IAVQ,YAAA;ENwZR;EM7YA;IAVQ,YAAA;EN0ZR;EM/YA;IAVQ,YAAA;EN4ZR;EMjZA;IAVQ,YAAA;EN8ZR;EMnZA;IAVQ,YAAA;ENgaR;EMrZA;IAVQ,YAAA;ENkaR;EMtZA;IAVc,kBAAA;ENmad;AACF;AE7nBE;EIuOA;IArBQ,YAAA;EN+aR;EMzZA;IArBQ,YAAA;ENibR;EM3ZA;IArBQ,YAAA;ENmbR;EM7ZA;IArBQ,YAAA;ENqbR;EM/ZA;IArBQ,YAAA;ENubR;EMjaA;IArBQ,YAAA;ENybR;AACF;AMhaA;EAAY,cAAA;ANmaZ;AMlaA;EAAY,cAAA;ANqaZ;AMpaA;EAAY,cAAA;ANuaZ;AE1pBE;EIsPA;IALU,cAAA;EN6aV;EMvaA;IALU,cAAA;EN+aV;AACF;AElqBE;EI2PA;IAVU,cAAA;ENqbV;EM1aA;IAVU,cAAA;ENubV;AACF;AMzaA;EAAS,WAAA;AN4aT;AM3aA;EAAS,WAAA;AN8aT;AM7aA;EAAS,YAAA;ANgbT;AM5aA;EAAY,gBAAA;AN+aZ;AM9aA;EAAY,kBAAA;ANibZ;AMhbA;EAAY,kBAAA;ANmbZ;AMlbA;EAAY,eAAA;ANqbZ;AMpbA;EACE,wBAAA;EACA,gBAAA;ANsbF;AE7pBE;EI2OA;IALA,wBAAA;IACA,gBAAA;EN2bA;AACF;AEzsBE;EIqRA;IAdU,gBAAA;ENscV;EMvbA;IAdU,kBAAA;ENwcV;EMzbA;IAdU,kBAAA;EN0cV;EM3bA;IAdU,eAAA;EN4cV;EM7bA;IAbA,wBAAA;IACA,gBAAA;EN6cA;AACF;AE3tBE;EI6RA;IAtBU,gBAAA;ENwdV;EMjcA;IAtBU,kBAAA;EN0dV;EMncA;IAtBU,kBAAA;EN4dV;EMrcA;IAtBU,eAAA;EN8dV;EMvcA;IArBA,wBAAA;IACA,gBAAA;EN+dA;AACF;AMvcA;EAAQ,UAAA;AN0cR;AMzcA;EAAQ,UAAA;AN4cR;AM3cA;EAAQ,WAAA;AN8cR;AM7cA;EAAQ,WAAA;ANgdR;AM/cA;EAAQ,WAAA;ANkdR;AMjdA;EAAQ,WAAA;ANodR;AMndA;EAAQ,WAAA;ANsdR;AMrdA;EAAQ,WAAA;ANwdR;AMvdA;EAAQ,WAAA;AN0dR;AMzdA;EAAQ,WAAA;AN4dR;AM3dA;EAAQ,WAAA;AN8dR;AM7dA;EAAQ,WAAA;ANgeR;AM/dA;EAAQ,WAAA;ANkeR;AMjeA;EAAQ,YAAA;ANoeR;AMneA;EAAS,aAAA;ANseT;AMneA;EAAa,QAAA;ANseb;AMreA;EAAa,cAAA;ANweb;AMveA;EAAa,eAAA;AN0eb;AMzeA;EAAa,aAAA;AN4eb;AM3eA;EAAa,cAAA;AN8eb;AM7eA;EAAa,WAAA;ANgfb;AM/eA;EAAa,aAAA;ANkfb;AMjfA;EAAa,WAAA;ANofb;AMnfA;EAAa,UAAA;ANsfb;AMrfA;EAAa,WAAA;ANwfb;AMtfA;EAAa,gBAAA;ANyfb;AMtfA;EAAY,OAAA;ANyfZ;AMxfA;EAAY,aAAA;AN2fZ;AM1fA;EAAY,YAAA;AN6fZ;AM5fA;EAAY,aAAA;AN+fZ;AM9fA;EAAY,UAAA;ANigBZ;AMhgBA;EAAY,YAAA;ANmgBZ;AMlgBA;EAAY,UAAA;ANqgBZ;AMpgBA;EAAY,SAAA;ANugBZ;AMtgBA;EAAY,UAAA;ANygBZ;AMvgBA;EAAY,cAAA;AN0gBZ;AMvgBA;EAAW,MAAA;AN0gBX;AMzgBA;EAAW,aAAA;AN4gBX;AM3gBA;EAAW,YAAA;AN8gBX;AM7gBA;EAAW,aAAA;ANghBX;AM/gBA;EAAW,WAAA;ANkhBX;AMjhBA;EAAW,YAAA;ANohBX;AMnhBA;EAAW,SAAA;ANshBX;AMrhBA;EAAW,WAAA;ANwhBX;AMvhBA;EAAW,SAAA;AN0hBX;AMzhBA;EAAW,SAAA;AN4hBX;AM3hBA;EAAW,SAAA;AN8hBX;AM7hBA;EAAW,SAAA;ANgiBX;AM/hBA;EAAW,SAAA;ANkiBX;AMhiBA;EAAW,QAAA;ANmiBX;AMliBA;EAAW,QAAA;ANqiBX;AMpiBA;EAAW,QAAA;ANuiBX;AMtiBA;EAAW,SAAA;ANyiBX;AMviBA;EAAW,UAAA;AN0iBX;AMziBA;EAAW,UAAA;AN4iBX;AEl5BE;EIyWA;IAnBS,WAAA;ENgkBT;AACF;AM1iBA;EAAc,SAAA;AN6iBd;AM5iBA;EAAc,gBAAA;AN+iBd;AM9iBA;EAAc,eAAA;ANijBd;AMhjBA;EAAc,gBAAA;ANmjBd;AMljBA;EAAc,cAAA;ANqjBd;AMpjBA;EAAc,eAAA;ANujBd;AMtjBA;EAAc,YAAA;ANyjBd;AMxjBA;EAAc,cAAA;AN2jBd;AM1jBA;EAAe,YAAA;AN6jBf;AM5jBA;EAAe,aAAA;AN+jBf;AM9jBA;EAAc,WAAA;ANikBd;AMhkBA;EAAc,YAAA;ANmkBd;AMjkBA;EAAc,gBAAA;ANokBd;AMjkBA;EAAY,QAAA;ANokBZ;AMnkBA;EAAY,eAAA;ANskBZ;AMrkBA;EAAY,cAAA;ANwkBZ;AMvkBA;EAAY,eAAA;AN0kBZ;AMzkBA;EAAY,aAAA;AN4kBZ;AM3kBA;EAAY,eAAA;AN8kBZ;AM7kBA;EAAY,cAAA;ANglBZ;AM/kBA;EAAY,WAAA;ANklBZ;AMjlBA;EAAY,aAAA;ANolBZ;AMnlBA;EAAY,WAAA;ANslBZ;AMrlBA;EAAY,aAAA;ANwlBZ;AMvlBA;EAAY,WAAA;AN0lBZ;AMzlBA;EAAY,WAAA;AN4lBZ;AM3lBA;EAAY,WAAA;AN8lBZ;AM7lBA;EAAY,WAAA;ANgmBZ;AM/lBA;EAAY,WAAA;ANkmBZ;AMjmBA;EAAY,cAAA;ANomBZ;AMnmBA;EAAY,YAAA;ANsmBZ;AMrmBA;EAAY,YAAA;ANwmBZ;AMvmBA;EAAW,YAAA;AN0mBX;AMzmBA;EAAY,YAAA;AN4mBZ;AM3mBA;EAAY,YAAA;AN8mBZ;AM7mBA;EAAY,YAAA;ANgnBZ;AM/mBA;EAAY,YAAA;ANknBZ;AMhnBA;EAAS,UAAA;ANmnBT;AMlnBA;EAAS,UAAA;ANqnBT;AMpnBA;EAAS,UAAA;ANunBT;AMtnBA;EAAS,UAAA;ANynBT;AMxnBA;EAAS,UAAA;AN2nBT;AM1nBA;EAAS,UAAA;AN6nBT;AM5nBA;EAAS,UAAA;AN+nBT;AM9nBA;EAAS,UAAA;ANioBT;AMhoBA;EAAS,UAAA;ANmoBT;AMloBA;EAAS,UAAA;ANqoBT;AMpoBA;EAAS,UAAA;ANuoBT;AMtoBA;EAAS,UAAA;ANyoBT;AMxoBA;EAAS,UAAA;AN2oBT;AM1oBA;EAAS,UAAA;AN6oBT;AM5oBA;EAAS,UAAA;AN+oBT;AM9oBA;EAAS,UAAA;ANipBT;AMhpBA;EAAS,WAAA;ANmpBT;AMjpBA;EAAkB,qBAAA;ANopBlB;AMnpBA;EAAkB,uBAAA;ANspBlB;AMrpBA;EAAkB,WAAA;ANwpBlB;AMvpBA;EAAkB,kBAAA;AN0pBlB;AMxpBA;EAAU,WAAA;AN2pBV;AM1pBA;EAAU,YAAA;AN6pBV;AE3kCE;EIibA;IAnCU,YAAA;ENisBV;EM7pBA;IAZO,WAAA;EN4qBP;EM/pBA;IA7CU,WAAA;EN+sBV;EMjqBA;IAfO,UAAA;ENmrBP;EMnqBA;IAfO,WAAA;ENqrBP;EMrqBA;IARQ,YAAA;ENgrBR;AACF;AE/lCE;EI0bA;IAvDU,cAAA;ENguBV;EMxqBA;IAvDU,WAAA;ENkuBV;EM1qBA;IAvDU,aAAA;ENouBV;EM5qBA;IAvDU,WAAA;ENsuBV;EM9qBA;IArDU,WAAA;ENsuBV;EMhrBA;IAzBO,WAAA;EN4sBP;EMlrBA;IAtBgB,WAAA;EN2sBhB;EMprBA;IAnBQ,YAAA;EN0sBR;AACF;AEnlCE;EI+ZA;IAnDU,YAAA;EN2uBV;EMvrBA;IAzCO,UAAA;ENmuBP;AACF;AMvrBA;EAAW,YAAA;AN0rBX;AMzrBA;EAAW,mBAAA;AN4rBX;AM3rBA;EAAW,kBAAA;AN8rBX;AM7rBA;EAAW,mBAAA;ANgsBX;AM/rBA;EAAW,iBAAA;ANksBX;AMjsBA;EAAW,kBAAA;ANosBX;AMnsBA;EAAW,eAAA;ANssBX;AMrsBA;EAAW,iBAAA;ANwsBX;AMvsBA;EAAW,eAAA;AN0sBX;AMzsBA;EAAW,eAAA;AN4sBX;AM3sBA;EAAW,eAAA;AN8sBX;AM7sBA;EAAW,eAAA;ANgtBX;AM/sBA;EAAW,eAAA;ANktBX;AMjtBA;EAAW,gBAAA;ANotBX;AMntBA;EAAW,gBAAA;ANstBX;AMrtBA;EAAgB,gBAAA;ANwtBhB;AMvtBA;EAAW,gBAAA;AN0tBX;AMztBA;EAAW,gBAAA;AN4tBX;AM3tBA;EAAW,gBAAA;AN8tBX;AM7tBA;EAAW,gBAAA;ANguBX;AM9tBA;EAAa,cAAA;ANiuBb;AMhuBA;EAAa,cAAA;ANmuBb;AMluBA;EAAa,eAAA;ANquBb;AMnuBA;EAAe,eAAA;ANsuBf;AMruBA;EAAe,gBAAA;ANwuBf;AMtuBA;EAAc,eAAA;ANyuBd;AMxuBA;EAAiB,kBAAA;AN2uBjB;AMzuBA;EAAsB,mBAAA;AN4uBtB;AM3uBA;EAAsB,gBAAA;AN8uBtB;AM7uBA;EAAsB,gBAAA;ANgvBtB;AE3tCE;EI8eA;IARY,eAAA;ENyvBZ;AACF;AM9uBA;EAAW,YAAA;ANivBX;AMhvBA;EAAW,mBAAA;ANmvBX;AMlvBA;EAAW,kBAAA;ANqvBX;AMpvBA;EAAW,mBAAA;ANuvBX;AMtvBA;EAAW,iBAAA;ANyvBX;AMxvBA;EAAW,kBAAA;AN2vBX;AM1vBA;EAAW,eAAA;AN6vBX;AM5vBA;EAAW,iBAAA;AN+vBX;AM9vBA;EAAW,eAAA;ANiwBX;AMhwBA;EAAW,eAAA;ANmwBX;AMlwBA;EAAW,eAAA;ANqwBX;AMpwBA;EAAW,eAAA;ANuwBX;AMtwBA;EAAW,eAAA;ANywBX;AMxwBA;EAAW,gBAAA;AN2wBX;AM1wBA;EAAW,gBAAA;AN6wBX;AM5wBA;EAAW,gBAAA;AN+wBX;AM9wBA;EAAW,gBAAA;ANixBX;AMhxBA;EAAW,gBAAA;ANmxBX;AMlxBA;EAAW,gBAAA;ANqxBX;AMnxBA;EAAa,cAAA;ANsxBb;AMrxBA;EAAa,eAAA;ANwxBb;AMtxBA;EAAc,YAAA;ANyxBd;AMtxBA;EAAgB,8BAAA;ANyxBhB;AEryCE;EI+gBA;IApBS,eAAA;EN8yBT;AACF;AMvxBA;EAAO,SAAA;AN0xBP;AMzxBA;EAAO,YAAA;AN4xBP;AM3xBA;EAAO,YAAA;AN8xBP;AM7xBA;EAAO,YAAA;ANgyBP;AM/xBA;EAAO,YAAA;ANkyBP;AMjyBA;EAAO,YAAA;ANoyBP;AMnyBA;EAAO,YAAA;ANsyBP;AMryBA;EAAO,YAAA;ANwyBP;AMvyBA;EAAO,YAAA;AN0yBP;AMzyBA;EAAQ,aAAA;AN4yBR;AM3yBA;EAAO,aAAA;AN8yBP;AM7yBA;EAAO,aAAA;ANgzBP;AM/yBA;EAAO,aAAA;ANkzBP;AMhzBA;EAAS,WAAA;ANmzBT;AMlzBA;EAAS,WAAA;ANqzBT;AMpzBA;EAAS,WAAA;ANuzBT;AMtzBA;EAAS,YAAA;ANyzBT;AMvzBA;EAAU,YAAA;AN0zBV;AMzzBA;EAAU,YAAA;AN4zBV;AM3zBA;EAAU,YAAA;AN8zBV;AM7zBA;EAAU,aAAA;ANg0BV;AM9zBA;EAAa,YAAA;ANi0Bb;AMh0BA;EAAa,eAAA;ANm0Bb;AMh0BA;EAAa,SAAA;ANm0Bb;AMl0BA;EAAa,cAAA;ANq0Bb;AMp0BA;EAAa,gBAAA;ANu0Bb;AMt0BA;EAAa,eAAA;ANy0Bb;AMx0BA;EAAa,gBAAA;AN20Bb;AM10BA;EAAa,cAAA;AN60Bb;AM50BA;EAAa,eAAA;AN+0Bb;AM90BA;EAAa,YAAA;ANi1Bb;AMh1BA;EAAa,cAAA;ANm1Bb;AMl1BA;EAAa,YAAA;ANq1Bb;AMp1BA;EAAa,cAAA;ANu1Bb;AMt1BA;EAAa,YAAA;ANy1Bb;AMx1BA;EAAa,YAAA;AN21Bb;AM11BA;EAAa,YAAA;AN61Bb;AM51BA;EAAa,YAAA;AN+1Bb;AM91BA;EAAa,aAAA;ANi2Bb;AMh2BA;EAAa,aAAA;ANm2Bb;AEl6CE;EIkkBA;IA9CK,YAAA;ENk5BL;EMn2BA;IA9CK,YAAA;ENo5BL;EMr2BA;IA9CK,YAAA;ENs5BL;EMv2BA;IA9CK,YAAA;ENw5BL;EMz2BA;IA9CK,YAAA;EN05BL;EM32BA;IA9CK,YAAA;EN45BL;AACF;AM12BA;EAAc,aAAA;AN62Bd;AM52BA;EAAa,gBAAA;AN+2Bb;AM92BA;EAAc,gBAAA;ANi3Bd;AMh3BA;EAAc,gBAAA;ANm3Bd;AMl3BA;EAAc,gBAAA;ANq3Bd;AMp3BA;EAAc,iBAAA;ANu3Bd;AMr3BA;EAAuB,gBAAA;ANw3BvB;AMv3BA;EAAuB,iBAAA;AN03BvB;AMz3BA;EAAuB,iBAAA;AN43BvB;AM13BA;EAAkB,gBAAA;AN63BlB;AM53BA;EAAkB,iBAAA;AN+3BlB;AM93BA;EAAkB,mBAAA;ANi4BlB;AM93BA;EAAc,aAAA;ANi4Bd;AMh4BA;EAAc,gBAAA;ANm4Bd;AMl4BA;EAAc,gBAAA;ANq4Bd;AMp4BA;EAAc,gBAAA;ANu4Bd;AMt4BA;EAAc,gBAAA;ANy4Bd;AMx4BA;EAAc,iBAAA;AN24Bd;AM14BA;EAAc,iBAAA;AN64Bd;AM54BA;EAAc,eAAA;AN+4Bd;AEl/CE;EIsmBA;IANY,gBAAA;ENs5BZ;AACF;AACA;;;;;;;CAOC;AI//CD;EAAS,MAAA;AJkgDT;AIjgDA;EAAS,aAAA;AJogDT;AIngDA;EAAS,YAAA;AJsgDT;AIrgDA;EAAS,aAAA;AJwgDT;AIvgDA;EAAS,WAAA;AJ0gDT;AIzgDA;EAAc,aAAA;AJ4gDd;AI3gDA;EAAS,YAAA;AJ8gDT;AI7gDA;EAAc,aAAA;AJghDd;AI/gDA;EAAS,SAAA;AJkhDT;AIjhDA;EAAS,WAAA;AJohDT;AInhDA;EAAS,SAAA;AJshDT;AIrhDA;EAAS,SAAA;AJwhDT;AIvhDA;EAAS,SAAA;AJ0hDT;AIzhDA;EAAS,SAAA;AJ4hDT;AI3hDA;EAAS,SAAA;AJ8hDT;AI7hDA;EAAS,UAAA;AJgiDT;AI/hDA;EAAS,UAAA;AJkiDT;AEljDE;EEmBA;IAAU,SAAA;EJmiDV;AACF;AIhiDA;EAAQ,UAAA;AJmiDR;AIliDA;EAAQ,iBAAA;AJqiDR;AIpiDA;EAAQ,gBAAA;AJuiDR;AItiDA;EAAQ,iBAAA;AJyiDR;AIxiDA;EAAQ,eAAA;AJ2iDR;AI1iDA;EAAQ,gBAAA;AJ6iDR;AI5iDA;EAAQ,aAAA;AJ+iDR;AI9iDA;EAAQ,eAAA;AJijDR;AIhjDA;EAAQ,aAAA;AJmjDR;AIljDA;EAAQ,aAAA;AJqjDR;AIpjDA;EAAQ,aAAA;AJujDR;AItjDA;EAAQ,aAAA;AJyjDR;AIxjDA;EAAQ,aAAA;AJ2jDR;AI1jDA;EAAQ,cAAA;AJ6jDR;AI5jDA;EAAQ,cAAA;AJ+jDR;AEpmDE;EEwCA;IAjBM,UAAA;EJilDN;EI/jDA;IAjBM,iBAAA;EJmlDN;EIjkDA;IAjBM,gBAAA;EJqlDN;EInkDA;IAjBM,iBAAA;EJulDN;EIrkDA;IAjBM,eAAA;EJylDN;EIvkDA;IAjBM,gBAAA;EJ2lDN;EIzkDA;IAjBM,aAAA;EJ6lDN;EI3kDA;IAjBM,eAAA;EJ+lDN;EI7kDA;IAjBM,aAAA;EJimDN;EI/kDA;IAjBM,aAAA;EJmmDN;EIjlDA;IAjBM,aAAA;EJqmDN;EInlDA;IAjBM,aAAA;EJumDN;EIrlDA;IAjBM,aAAA;EJymDN;EIvlDA;IAjBM,cAAA;EJ2mDN;EIzlDA;IAjBM,cAAA;EJ6mDN;AACF;AEnpDE;EE0DA;IAnCM,UAAA;EJgoDN;EI5lDA;IAnCM,iBAAA;EJkoDN;EI9lDA;IAnCM,gBAAA;EJooDN;EIhmDA;IAnCM,iBAAA;EJsoDN;EIlmDA;IAnCM,eAAA;EJwoDN;EIpmDA;IAnCM,gBAAA;EJ0oDN;EItmDA;IAnCM,aAAA;EJ4oDN;EIxmDA;IAnCM,eAAA;EJ8oDN;EI1mDA;IAnCM,aAAA;EJgpDN;EI5mDA;IAnCM,aAAA;EJkpDN;EI9mDA;IAnCM,aAAA;EJopDN;EIhnDA;IAnCM,aAAA;EJspDN;EIlnDA;IAnCM,aAAA;EJwpDN;EIpnDA;IAnCM,cAAA;EJ0pDN;EItnDA;IAnCM,cAAA;EJ4pDN;AACF;AIrnDA;EAAQ,eAAA;AJwnDR;AIvnDA;EAAQ,sBAAA;AJ0nDR;AIznDA;EAAQ,qBAAA;AJ4nDR;AI3nDA;EAAQ,sBAAA;AJ8nDR;AI7nDA;EAAQ,oBAAA;AJgoDR;AI/nDA;EAAQ,qBAAA;AJkoDR;AIjoDA;EAAQ,kBAAA;AJooDR;AInoDA;EAAQ,oBAAA;AJsoDR;AIroDA;EAAQ,kBAAA;AJwoDR;AIvoDA;EAAQ,kBAAA;AJ0oDR;AIzoDA;EAAQ,kBAAA;AJ4oDR;AI3oDA;EAAQ,kBAAA;AJ8oDR;AI7oDA;EAAQ,kBAAA;AJgpDR;AI/oDA;EAAQ,mBAAA;AJkpDR;AIjpDA;EAAQ,mBAAA;AJopDR;AE/uDE;EE8FA;IAjBM,eAAA;EJsqDN;EIppDA;IAjBM,sBAAA;EJwqDN;EItpDA;IAjBM,qBAAA;EJ0qDN;EIxpDA;IAjBM,sBAAA;EJ4qDN;EI1pDA;IAjBM,oBAAA;EJ8qDN;EI5pDA;IAjBM,qBAAA;EJgrDN;EI9pDA;IAjBM,kBAAA;EJkrDN;EIhqDA;IAjBM,oBAAA;EJorDN;EIlqDA;IAjBM,kBAAA;EJsrDN;EIpqDA;IAjBM,kBAAA;EJwrDN;EItqDA;IAjBM,kBAAA;EJ0rDN;EIxqDA;IAjBM,kBAAA;EJ4rDN;EI1qDA;IAjBM,kBAAA;EJ8rDN;EI5qDA;IAjBM,mBAAA;EJgsDN;EI9qDA;IAjBM,mBAAA;EJksDN;AACF;AE9xDE;EEgHA;IAnCM,eAAA;EJqtDN;EIjrDA;IAnCM,sBAAA;EJutDN;EInrDA;IAnCM,qBAAA;EJytDN;EIrrDA;IAnCM,sBAAA;EJ2tDN;EIvrDA;IAnCM,oBAAA;EJ6tDN;EIzrDA;IAnCM,qBAAA;EJ+tDN;EI3rDA;IAnCM,kBAAA;EJiuDN;EI7rDA;IAnCM,oBAAA;EJmuDN;EI/rDA;IAnCM,kBAAA;EJquDN;EIjsDA;IAnCM,kBAAA;EJuuDN;EInsDA;IAnCM,kBAAA;EJyuDN;EIrsDA;IAnCM,kBAAA;EJ2uDN;EIvsDA;IAnCM,kBAAA;EJ6uDN;EIzsDA;IAnCM,mBAAA;EJ+uDN;EI3sDA;IAnCM,mBAAA;EJivDN;AACF;AEvyDE;EE4FA;IAhDM,qBAAA;EJ+vDN;AACF;AI5sDA;EAAQ,gBAAA;AJ+sDR;AI9sDA;EAAQ,uBAAA;AJitDR;AIhtDA;EAAQ,sBAAA;AJmtDR;AIltDA;EAAQ,uBAAA;AJqtDR;AIptDA;EAAQ,qBAAA;AJutDR;AIttDA;EAAQ,sBAAA;AJytDR;AIxtDA;EAAQ,mBAAA;AJ2tDR;AI1tDA;EAAQ,qBAAA;AJ6tDR;AI5tDA;EAAQ,mBAAA;AJ+tDR;AI9tDA;EAAQ,mBAAA;AJiuDR;AIhuDA;EAAQ,mBAAA;AJmuDR;AIluDA;EAAQ,mBAAA;AJquDR;AIpuDA;EAAQ,mBAAA;AJuuDR;AItuDA;EAAQ,oBAAA;AJyuDR;AIxuDA;EAAQ,oBAAA;AJ2uDR;AE/3DE;EEuJA;IAjBM,gBAAA;EJ6vDN;EI3uDA;IAjBM,uBAAA;EJ+vDN;EI7uDA;IAjBM,sBAAA;EJiwDN;EI/uDA;IAjBM,uBAAA;EJmwDN;EIjvDA;IAjBM,qBAAA;EJqwDN;EInvDA;IAjBM,sBAAA;EJuwDN;EIrvDA;IAjBM,mBAAA;EJywDN;EIvvDA;IAjBM,qBAAA;EJ2wDN;EIzvDA;IAjBM,mBAAA;EJ6wDN;EI3vDA;IAjBM,mBAAA;EJ+wDN;EI7vDA;IAjBM,mBAAA;EJixDN;EI/vDA;IAjBM,mBAAA;EJmxDN;EIjwDA;IAjBM,mBAAA;EJqxDN;EInwDA;IAjBM,oBAAA;EJuxDN;EIrwDA;IAjBM,oBAAA;EJyxDN;AACF;AE96DE;EEyKA;IAnCM,gBAAA;EJ4yDN;EIxwDA;IAnCM,uBAAA;EJ8yDN;EI1wDA;IAnCM,sBAAA;EJgzDN;EI5wDA;IAnCM,uBAAA;EJkzDN;EI9wDA;IAnCM,qBAAA;EJozDN;EIhxDA;IAnCM,sBAAA;EJszDN;EIlxDA;IAnCM,mBAAA;EJwzDN;EIpxDA;IAnCM,qBAAA;EJ0zDN;EItxDA;IAnCM,mBAAA;EJ4zDN;EIxxDA;IAnCM,mBAAA;EJ8zDN;EI1xDA;IAnCM,mBAAA;EJg0DN;EI5xDA;IAnCM,mBAAA;EJk0DN;EI9xDA;IAnCM,mBAAA;EJo0DN;EIhyDA;IAnCM,oBAAA;EJs0DN;EIlyDA;IAnCM,oBAAA;EJw0DN;AACF;AEv7DE;EEqJA;IAhDM,sBAAA;EJs1DN;AACF;AInyDA;EAAQ,iBAAA;AJsyDR;AIryDA;EAAQ,wBAAA;AJwyDR;AIvyDA;EAAQ,uBAAA;AJ0yDR;AIzyDA;EAAQ,wBAAA;AJ4yDR;AI3yDA;EAAQ,sBAAA;AJ8yDR;AI7yDA;EAAQ,uBAAA;AJgzDR;AI/yDA;EAAQ,oBAAA;AJkzDR;AIjzDA;EAAQ,sBAAA;AJozDR;AInzDA;EAAQ,oBAAA;AJszDR;AIrzDA;EAAQ,oBAAA;AJwzDR;AIvzDA;EAAQ,oBAAA;AJ0zDR;AIzzDA;EAAQ,oBAAA;AJ4zDR;AI3zDA;EAAQ,oBAAA;AJ8zDR;AI7zDA;EAAQ,qBAAA;AJg0DR;AI/zDA;EAAQ,qBAAA;AJk0DR;AIh0DA;EAAS,mBAAA;AJm0DT;AElhEE;EEkNA;IAnBM,iBAAA;EJu1DN;EIn0DA;IAnBM,wBAAA;EJy1DN;EIr0DA;IAnBM,uBAAA;EJ21DN;EIv0DA;IAnBM,wBAAA;EJ61DN;EIz0DA;IAnBM,sBAAA;EJ+1DN;EI30DA;IAnBM,uBAAA;EJi2DN;EI70DA;IAnBM,oBAAA;EJm2DN;EI/0DA;IAnBM,sBAAA;EJq2DN;EIj1DA;IAnBM,oBAAA;EJu2DN;EIn1DA;IAnBM,oBAAA;EJy2DN;EIr1DA;IAnBM,oBAAA;EJ22DN;EIv1DA;IAnBM,oBAAA;EJ62DN;EIz1DA;IAnBM,oBAAA;EJ+2DN;EI31DA;IAnBM,qBAAA;EJi3DN;EI71DA;IAnBM,qBAAA;EJm3DN;AACF;AEjkEE;EEoOA;IArCM,iBAAA;EJs4DN;EIh2DA;IArCM,wBAAA;EJw4DN;EIl2DA;IArCM,uBAAA;EJ04DN;EIp2DA;IArCM,wBAAA;EJ44DN;EIt2DA;IArCM,sBAAA;EJ84DN;EIx2DA;IArCM,uBAAA;EJg5DN;EI12DA;IArCM,oBAAA;EJk5DN;EI52DA;IArCM,sBAAA;EJo5DN;EI92DA;IArCM,oBAAA;EJs5DN;EIh3DA;IArCM,oBAAA;EJw5DN;EIl3DA;IArCM,oBAAA;EJ05DN;EIp3DA;IArCM,oBAAA;EJ45DN;EIt3DA;IArCM,oBAAA;EJ85DN;EIx3DA;IArCM,qBAAA;EJg6DN;EI13DA;IArCM,qBAAA;EJk6DN;EI53DA;IApCO,mBAAA;EJm6DP;AACF;AI33DA;EAAQ,cAAA;AJ83DR;AI73DA;EAAQ,qBAAA;AJg4DR;AI/3DA;EAAQ,oBAAA;AJk4DR;AIj4DA;EAAQ,qBAAA;AJo4DR;AIn4DA;EAAQ,mBAAA;AJs4DR;AIr4DA;EAAQ,oBAAA;AJw4DR;AIv4DA;EAAQ,iBAAA;AJ04DR;AIz4DA;EAAQ,mBAAA;AJ44DR;AI34DA;EAAQ,iBAAA;AJ84DR;AI74DA;EAAQ,iBAAA;AJg5DR;AI/4DA;EAAQ,iBAAA;AJk5DR;AIj5DA;EAAQ,iBAAA;AJo5DR;AIn5DA;EAAQ,iBAAA;AJs5DR;AIr5DA;EAAQ,kBAAA;AJw5DR;AIv5DA;EAAQ,kBAAA;AJ05DR;AEhqEE;EEyQA;IAjBM,cAAA;EJ46DN;EI15DA;IAjBM,qBAAA;EJ86DN;EI55DA;IAjBM,oBAAA;EJg7DN;EI95DA;IAjBM,qBAAA;EJk7DN;EIh6DA;IAjBM,mBAAA;EJo7DN;EIl6DA;IAjBM,oBAAA;EJs7DN;EIp6DA;IAjBM,iBAAA;EJw7DN;EIt6DA;IAjBM,mBAAA;EJ07DN;EIx6DA;IAjBM,iBAAA;EJ47DN;EI16DA;IAjBM,iBAAA;EJ87DN;EI56DA;IAjBM,iBAAA;EJg8DN;EI96DA;IAjBM,iBAAA;EJk8DN;EIh7DA;IAjBM,iBAAA;EJo8DN;EIl7DA;IAjBM,kBAAA;EJs8DN;EIp7DA;IAjBM,kBAAA;EJw8DN;AACF;AE/sEE;EE2RA;IAnCM,cAAA;EJ29DN;EIv7DA;IAnCM,qBAAA;EJ69DN;EIz7DA;IAnCM,oBAAA;EJ+9DN;EI37DA;IAnCM,qBAAA;EJi+DN;EI77DA;IAnCM,mBAAA;EJm+DN;EI/7DA;IAnCM,oBAAA;EJq+DN;EIj8DA;IAnCM,iBAAA;EJu+DN;EIn8DA;IAnCM,mBAAA;EJy+DN;EIr8DA;IAnCM,iBAAA;EJ2+DN;EIv8DA;IAnCM,iBAAA;EJ6+DN;EIz8DA;IAnCM,iBAAA;EJ++DN;EI38DA;IAnCM,iBAAA;EJi/DN;EI78DA;IAnCM,iBAAA;EJm/DN;EI/8DA;IAnCM,kBAAA;EJq/DN;EIj9DA;IAnCM,kBAAA;EJu/DN;AACF;AIh9DA;EAAY,cAAA;EAAyB,iBAAA;AJo9DrC;AIn9DA;EAAY,mBAAA;EAA8B,sBAAA;AJu9D1C;AIt9DA;EAAY,qBAAA;EAAyB,wBAAA;AJ09DrC;AIz9DA;EAAY,oBAAA;EAAyB,uBAAA;AJ69DrC;AI59DA;EAAY,qBAAA;EAAyB,wBAAA;AJg+DrC;AI/9DA;EAAY,mBAAA;EAAyB,sBAAA;AJm+DrC;AIl+DA;EAAY,qBAAA;EAA8B,wBAAA;AJs+D1C;AIr+DA;EAAY,oBAAA;EAAyB,uBAAA;AJy+DrC;AIx+DA;EAAY,iBAAA;EAAyB,oBAAA;AJ4+DrC;AI3+DA;EAAY,mBAAA;EAAyB,sBAAA;AJ++DrC;AI9+DA;EAAY,iBAAA;EAAyB,oBAAA;AJk/DrC;AIj/DA;EAAY,iBAAA;EAAyB,oBAAA;AJq/DrC;AIp/DA;EAAY,iBAAA;EAA0B,oBAAA;AJw/DtC;AIv/DA;EAAY,iBAAA;EAA0B,oBAAA;AJ2/DtC;AI1/DA;EAAY,iBAAA;EAA0B,oBAAA;AJ8/DtC;AI7/DA;EAAY,kBAAA;EAA0B,qBAAA;AJigEtC;AIhgEA;EAAY,kBAAA;EAA0B,qBAAA;AJogEtC;AEl0EE;EEiUA;IAnBU,cAAA;IAAyB,iBAAA;EJyhEnC;EIrgEA;IAlBU,qBAAA;IAAyB,wBAAA;EJ2hEnC;EIxgEA;IAlBU,oBAAA;IAAyB,uBAAA;EJ8hEnC;EI3gEA;IAlBU,qBAAA;IAAyB,wBAAA;EJiiEnC;EI9gEA;IAlBU,mBAAA;IAAyB,sBAAA;EJoiEnC;EIjhEA;IAjBU,oBAAA;IAAyB,uBAAA;EJsiEnC;EIphEA;IAjBU,iBAAA;IAAyB,oBAAA;EJyiEnC;EIvhEA;IAjBU,mBAAA;IAAyB,sBAAA;EJ4iEnC;EI1hEA;IAjBU,iBAAA;IAAyB,oBAAA;EJ+iEnC;EI7hEA;IAjBU,iBAAA;IAAyB,oBAAA;EJkjEnC;EIhiEA;IAjBU,iBAAA;IAA0B,oBAAA;EJqjEpC;EIniEA;IAjBU,iBAAA;IAA0B,oBAAA;EJwjEpC;EItiEA;IAjBU,iBAAA;IAA0B,oBAAA;EJ2jEpC;EIziEA;IAjBU,kBAAA;IAA0B,qBAAA;EJ8jEpC;EI5iEA;IAjBU,kBAAA;IAA0B,qBAAA;EJikEpC;AACF;AEh4EE;EEmVA;IArCU,cAAA;IAAyB,iBAAA;EJulEnC;EIjjEA;IApCU,qBAAA;IAAyB,wBAAA;EJylEnC;EIpjEA;IApCU,oBAAA;IAAyB,uBAAA;EJ4lEnC;EIvjEA;IApCU,qBAAA;IAAyB,wBAAA;EJ+lEnC;EI1jEA;IApCU,mBAAA;IAAyB,sBAAA;EJkmEnC;EI7jEA;IAnCU,oBAAA;IAAyB,uBAAA;EJomEnC;EIhkEA;IAnCU,iBAAA;IAAyB,oBAAA;EJumEnC;EInkEA;IAnCU,mBAAA;IAAyB,sBAAA;EJ0mEnC;EItkEA;IAnCU,iBAAA;IAAyB,oBAAA;EJ6mEnC;EIzkEA;IAnCU,iBAAA;IAAyB,oBAAA;EJgnEnC;EI5kEA;IAnCU,iBAAA;IAA0B,oBAAA;EJmnEpC;EI/kEA;IAnCU,iBAAA;IAA0B,oBAAA;EJsnEpC;EIllEA;IAnCU,iBAAA;IAA0B,oBAAA;EJynEpC;EIrlEA;IAnCU,kBAAA;IAA0B,qBAAA;EJ4nEpC;EIxlEA;IAnCU,kBAAA;IAA0B,qBAAA;EJ+nEpC;AACF;AIxlEA;EAAQ,eAAA;EAA0B,gBAAA;AJ4lElC;AI3lEA;EAAQ,sBAAA;EAA0B,uBAAA;AJ+lElC;AI9lEA;EAAQ,qBAAA;EAA0B,sBAAA;AJkmElC;AIjmEA;EAAQ,sBAAA;EAA0B,uBAAA;AJqmElC;AIpmEA;EAAQ,oBAAA;EAA0B,qBAAA;AJwmElC;AIvmEA;EAAQ,qBAAA;EAA0B,sBAAA;AJ2mElC;AI1mEA;EAAQ,kBAAA;EAA0B,mBAAA;AJ8mElC;AI7mEA;EAAQ,oBAAA;EAA0B,qBAAA;AJinElC;AIhnEA;EAAQ,kBAAA;EAA0B,mBAAA;AJonElC;AInnEA;EAAQ,kBAAA;EAA0B,mBAAA;AJunElC;AItnEA;EAAQ,kBAAA;EAA2B,mBAAA;AJ0nEnC;AIznEA;EAAQ,kBAAA;EAA2B,mBAAA;AJ6nEnC;AI5nEA;EAAQ,kBAAA;EAA2B,mBAAA;AJgoEnC;AI/nEA;EAAQ,mBAAA;EAA2B,oBAAA;AJmoEnC;AIloEA;EAAQ,mBAAA;EAA2B,oBAAA;AJsoEnC;AE1/EE;EEuXA;IAjBM,eAAA;IAA0B,gBAAA;EJypEhC;EIvoEA;IAjBM,sBAAA;IAA0B,uBAAA;EJ4pEhC;EI1oEA;IAjBM,qBAAA;IAA0B,sBAAA;EJ+pEhC;EI7oEA;IAjBM,sBAAA;IAA0B,uBAAA;EJkqEhC;EIhpEA;IAjBM,oBAAA;IAA0B,qBAAA;EJqqEhC;EInpEA;IAjBM,qBAAA;IAA0B,sBAAA;EJwqEhC;EItpEA;IAjBM,kBAAA;IAA0B,mBAAA;EJ2qEhC;EIzpEA;IAjBM,oBAAA;IAA0B,qBAAA;EJ8qEhC;EI5pEA;IAjBM,kBAAA;IAA0B,mBAAA;EJirEhC;EI/pEA;IAjBM,kBAAA;IAA0B,mBAAA;EJorEhC;EIlqEA;IAjBM,kBAAA;IAA2B,mBAAA;EJurEjC;EIrqEA;IAjBM,kBAAA;IAA2B,mBAAA;EJ0rEjC;EIxqEA;IAjBM,kBAAA;IAA2B,mBAAA;EJ6rEjC;EI3qEA;IAjBM,mBAAA;IAA2B,oBAAA;EJgsEjC;EI9qEA;IAjBM,mBAAA;IAA2B,oBAAA;EJmsEjC;AACF;AExjFE;EEyYA;IAnCM,eAAA;IAA0B,gBAAA;EJutEhC;EInrEA;IAnCM,sBAAA;IAA0B,uBAAA;EJ0tEhC;EItrEA;IAnCM,qBAAA;IAA0B,sBAAA;EJ6tEhC;EIzrEA;IAnCM,sBAAA;IAA0B,uBAAA;EJguEhC;EI5rEA;IAnCM,oBAAA;IAA0B,qBAAA;EJmuEhC;EI/rEA;IAnCM,qBAAA;IAA0B,sBAAA;EJsuEhC;EIlsEA;IAnCM,kBAAA;IAA0B,mBAAA;EJyuEhC;EIrsEA;IAnCM,oBAAA;IAA0B,qBAAA;EJ4uEhC;EIxsEA;IAnCM,kBAAA;IAA0B,mBAAA;EJ+uEhC;EI3sEA;IAnCM,kBAAA;IAA0B,mBAAA;EJkvEhC;EI9sEA;IAnCM,kBAAA;IAA2B,mBAAA;EJqvEjC;EIjtEA;IAnCM,kBAAA;IAA2B,mBAAA;EJwvEjC;EIptEA;IAnCM,kBAAA;IAA2B,mBAAA;EJ2vEjC;EIvtEA;IAnCM,mBAAA;IAA2B,oBAAA;EJ8vEjC;EI1tEA;IAnCM,mBAAA;IAA2B,oBAAA;EJiwEjC;AACF;AIxtEA;EAAe,SAAA;AJ2tEf;AI1tEA;EAAe,gBAAA;AJ6tEf;AI5tEA;EAAe,eAAA;AJ+tEf;AI9tEA;EAAe,gBAAA;AJiuEf;AIhuEA;EAAe,cAAA;AJmuEf;AIluEA;EAAe,eAAA;AJquEf;AIpuEA;EAAe,YAAA;AJuuEf;AItuEA;EAAe,cAAA;AJyuEf;AIxuEA;EAAe,YAAA;AJ2uEf;AI1uEA;EAAe,YAAA;AJ6uEf;AI5uEA;EAAe,YAAA;AJ+uEf;AI9uEA;EAAe,YAAA;AJivEf;AIhvEA;EAAe,YAAA;AJmvEf;AIlvEA;EAAe,YAAA;AJqvEf;AIpvEA;EAAe,YAAA;AJuvEf;AItvEA;EAAe,aAAA;AJyvEf;AIxvEA;EAAe,aAAA;AJ2vEf;AI1vEA;EAAe,YAAA;AJ6vEf;AE5qFE;EEkbA;IApBa,SAAA;EJkxEb;EI7vEA;IApBa,gBAAA;EJoxEb;EI/vEA;IApBa,eAAA;EJsxEb;EIjwEA;IApBa,gBAAA;EJwxEb;EInwEA;IApBa,cAAA;EJ0xEb;EIrwEA;IApBa,eAAA;EJ4xEb;EIvwEA;IApBa,YAAA;EJ8xEb;EIzwEA;IApBa,cAAA;EJgyEb;EI3wEA;IApBa,YAAA;EJkyEb;EI7wEA;IApBa,YAAA;EJoyEb;EI/wEA;IAlBa,YAAA;EJoyEb;EIjxEA;IApBa,YAAA;EJwyEb;EInxEA;IAtBa,YAAA;EJ4yEb;EIrxEA;IApBa,YAAA;EJ4yEb;EIvxEA;IApBa,YAAA;EJ8yEb;EIzxEA;IApBa,aAAA;EJgzEb;EI3xEA;IApBa,aAAA;EJkzEb;EI7xEA;IApBa,YAAA;EJozEb;AACF;AEpuFE;EEucA;IAzCa,SAAA;EJ00Eb;EIhyEA;IAzCa,gBAAA;EJ40Eb;EIlyEA;IAzCa,eAAA;EJ80Eb;EIpyEA;IAzCa,gBAAA;EJg1Eb;EItyEA;IAzCa,cAAA;EJk1Eb;EIxyEA;IAzCa,eAAA;EJo1Eb;EI1yEA;IAzCa,YAAA;EJs1Eb;EI5yEA;IAzCa,cAAA;EJw1Eb;EI9yEA;IAzCa,YAAA;EJ01Eb;EIhzEA;IAzCa,YAAA;EJ41Eb;EIlzEA;IAzCa,YAAA;EJ81Eb;EIpzEA;IAzCa,YAAA;EJg2Eb;EItzEA;IAzCa,YAAA;EJk2Eb;EIxzEA;IAzCa,YAAA;EJo2Eb;EI1zEA;IAzCa,YAAA;EJs2Eb;EI5zEA;IAzCa,aAAA;EJw2Eb;EI9zEA;IAzCa,aAAA;EJ02Eb;EIh0EA;IAzCa,YAAA;EJ42Eb;AACF;AI/zEA;EAAe,cAAA;AJk0Ef;AIj0EA;EAAe,qBAAA;AJo0Ef;AIn0EA;EAAe,oBAAA;AJs0Ef;AIr0EA;EAAe,qBAAA;AJw0Ef;AIv0EA;EAAe,mBAAA;AJ00Ef;AIz0EA;EAAe,oBAAA;AJ40Ef;AI30EA;EAAe,iBAAA;AJ80Ef;AI70EA;EAAe,mBAAA;AJg1Ef;AI/0EA;EAAe,iBAAA;AJk1Ef;AIj1EA;EAAe,iBAAA;AJo1Ef;AIn1EA;EAAe,iBAAA;AJs1Ef;AIr1EA;EAAe,iBAAA;AJw1Ef;AIv1EA;EAAe,iBAAA;AJ01Ef;AIz1EA;EAAe,iBAAA;AJ41Ef;AI31EA;EAAe,iBAAA;AJ81Ef;AI71EA;EAAe,kBAAA;AJg2Ef;AI/1EA;EAAe,kBAAA;AJk2Ef;AIj2EA;EAAe,iBAAA;AJo2Ef;AIl2EA;EAAS,gBAAA;AJq2ET;AEr1FE;EEmfA;IAtBa,cAAA;EJ43Eb;EIr2EA;IAtBa,qBAAA;EJ83Eb;EIv2EA;IAtBa,oBAAA;EJg4Eb;EIz2EA;IAtBa,qBAAA;EJk4Eb;EI32EA;IAtBa,mBAAA;EJo4Eb;EI72EA;IAtBa,oBAAA;EJs4Eb;EI/2EA;IAtBa,iBAAA;EJw4Eb;EIj3EA;IAtBa,mBAAA;EJ04Eb;EIn3EA;IAtBa,iBAAA;EJ44Eb;EIr3EA;IAtBa,iBAAA;EJ84Eb;EIv3EA;IAtBa,iBAAA;EJg5Eb;EIz3EA;IAtBa,iBAAA;EJk5Eb;EI33EA;IAtBa,iBAAA;EJo5Eb;EI73EA;IAtBa,iBAAA;EJs5Eb;EI/3EA;IAtBa,iBAAA;EJw5Eb;EIj4EA;IAtBa,kBAAA;EJ05Eb;EIn4EA;IAtBa,kBAAA;EJ45Eb;EIr4EA;IAtBa,iBAAA;EJ85Eb;AACF;AE74FE;EEwgBA;IA3Ca,cAAA;EJo7Eb;EIx4EA;IA3Ca,qBAAA;EJs7Eb;EI14EA;IA3Ca,oBAAA;EJw7Eb;EI54EA;IA3Ca,qBAAA;EJ07Eb;EI94EA;IA3Ca,mBAAA;EJ47Eb;EIh5EA;IA3Ca,oBAAA;EJ87Eb;EIl5EA;IA3Ca,iBAAA;EJg8Eb;EIp5EA;IA3Ca,mBAAA;EJk8Eb;EIt5EA;IA3Ca,iBAAA;EJo8Eb;EIx5EA;IA3Ca,iBAAA;EJs8Eb;EI15EA;IA3Ca,iBAAA;EJw8Eb;EI55EA;IA3Ca,iBAAA;EJ08Eb;EI95EA;IA3Ca,iBAAA;EJ48Eb;EIh6EA;IA3Ca,iBAAA;EJ88Eb;EIl6EA;IA3Ca,iBAAA;EJg9Eb;EIp6EA;IA3Ca,kBAAA;EJk9Eb;EIt6EA;IA3Ca,kBAAA;EJo9Eb;EIx6EA;IA3Ca,iBAAA;EJs9Eb;AACF;AIv6EA;EAAe,eAAA;AJ06Ef;AIz6EA;EAAe,sBAAA;AJ46Ef;AI36EA;EAAe,qBAAA;AJ86Ef;AI76EA;EAAe,sBAAA;AJg7Ef;AI/6EA;EAAe,oBAAA;AJk7Ef;AIj7EA;EAAe,qBAAA;AJo7Ef;AIn7EA;EAAe,sBAAA;AJs7Ef;AIr7EA;EAAe,kBAAA;AJw7Ef;AIv7EA;EAAe,oBAAA;AJ07Ef;AIz7EA;EAAe,kBAAA;AJ47Ef;AI37EA;EAAe,kBAAA;AJ87Ef;AI77EA;EAAe,kBAAA;AJg8Ef;AI/7EA;EAAe,kBAAA;AJk8Ef;AIj8EA;EAAe,kBAAA;AJo8Ef;AIn8EA;EAAe,kBAAA;AJs8Ef;AIr8EA;EAAe,kBAAA;AJw8Ef;AIv8EA;EAAe,mBAAA;AJ08Ef;AIz8EA;EAAe,mBAAA;AJ48Ef;AI38EA;EAAe,kBAAA;AJ88Ef;AEp+FE;EEyhBA;IArBa,eAAA;EJo+Eb;AACF;AEngGE;EEujBA;IAzBa,eAAA;EJy+Eb;EI/8EA;IAzBa,sBAAA;EJ2+Eb;EIj9EA;IAzBa,qBAAA;EJ6+Eb;EIn9EA;IAzBa,sBAAA;EJ++Eb;EIr9EA;IAzBa,oBAAA;EJi/Eb;EIv9EA;IAzBa,qBAAA;EJm/Eb;EIz9EA;IAxBa,kBAAA;EJo/Eb;EI39EA;IAxBa,oBAAA;EJs/Eb;EI79EA;IAxBa,kBAAA;EJw/Eb;EI/9EA;IAxBa,kBAAA;EJ0/Eb;EIj+EA;IAxBa,kBAAA;EJ4/Eb;EIn+EA;IAxBa,kBAAA;EJ8/Eb;EIr+EA;IAxBa,kBAAA;EJggFb;EIv+EA;IAxBa,kBAAA;EJkgFb;EIz+EA;IAxBa,kBAAA;EJogFb;EI3+EA;IAxBa,mBAAA;EJsgFb;EI7+EA;IAxBa,mBAAA;EJwgFb;EI/+EA;IAxBa,kBAAA;EJ0gFb;AACF;AE3jGE;EE4kBA;IA9Ca,eAAA;EJiiFb;EIl/EA;IA9Ca,sBAAA;EJmiFb;EIp/EA;IA9Ca,qBAAA;EJqiFb;EIt/EA;IA9Ca,sBAAA;EJuiFb;EIx/EA;IA9Ca,oBAAA;EJyiFb;EI1/EA;IA9Ca,qBAAA;EJ2iFb;EI5/EA;IA7Ca,kBAAA;EJ4iFb;EI9/EA;IA7Ca,oBAAA;EJ8iFb;EIhgFA;IA7Ca,kBAAA;EJgjFb;EIlgFA;IA7Ca,kBAAA;EJkjFb;EIpgFA;IA7Ca,kBAAA;EJojFb;EItgFA;IA7Ca,kBAAA;EJsjFb;EIxgFA;IA7Ca,kBAAA;EJwjFb;EI1gFA;IA7Ca,kBAAA;EJ0jFb;EI5gFA;IA7Ca,kBAAA;EJ4jFb;EI9gFA;IA7Ca,mBAAA;EJ8jFb;EIhhFA;IA7Ca,mBAAA;EJgkFb;EIlhFA;IA7Ca,kBAAA;EJkkFb;AACF;AIjhFA;EAAe,gBAAA;AJohFf;AInhFA;EAAe,uBAAA;AJshFf;AIrhFA;EAAe,sBAAA;AJwhFf;AIvhFA;EAAe,uBAAA;AJ0hFf;AIzhFA;EAAe,qBAAA;AJ4hFf;AI3hFA;EAAe,sBAAA;AJ8hFf;AI7hFA;EAAe,mBAAA;AJgiFf;AI/hFA;EAAe,qBAAA;AJkiFf;AIjiFA;EAAe,mBAAA;AJoiFf;AIniFA;EAAe,mBAAA;AJsiFf;AIriFA;EAAe,mBAAA;AJwiFf;AIviFA;EAAe,mBAAA;AJ0iFf;AIziFA;EAAe,mBAAA;AJ4iFf;AI3iFA;EAAe,mBAAA;AJ8iFf;AI7iFA;EAAe,mBAAA;AJgjFf;AI/iFA;EAAe,oBAAA;AJkjFf;AIjjFA;EAAe,oBAAA;AJojFf;AInjFA;EAAe,mBAAA;AJsjFf;AIpjFA;EAAU,uBAAA;AJujFV;AItjFA;EAAU,sBAAA;AJyjFV;AIvjFA;EAtBe,gBAAA;AJglFf;AElrGE;EE2nBA;IAzBa,gBAAA;EJolFb;EI1jFA;IAzBa,uBAAA;EJslFb;EI5jFA;IAzBa,sBAAA;EJwlFb;EI9jFA;IAzBa,uBAAA;EJ0lFb;EIhkFA;IAzBa,qBAAA;EJ4lFb;EIlkFA;IAzBa,sBAAA;EJ8lFb;EIpkFA;IAzBa,mBAAA;EJgmFb;EItkFA;IAzBa,qBAAA;EJkmFb;EIxkFA;IAzBa,mBAAA;EJomFb;EI1kFA;IAzBa,mBAAA;EJsmFb;EI5kFA;IAzBa,mBAAA;EJwmFb;EI9kFA;IAzBa,mBAAA;EJ0mFb;EIhlFA;IAzBa,mBAAA;EJ4mFb;EIllFA;IAzBa,mBAAA;EJ8mFb;EIplFA;IAzBa,mBAAA;EJgnFb;EItlFA;IAzBa,oBAAA;EJknFb;EIxlFA;IAzBa,oBAAA;EJonFb;EI1lFA;IAzBa,mBAAA;EJsnFb;AACF;AE1uGE;EEgpBA;IA9Ca,gBAAA;EJ4oFb;EI7lFA;IA9Ca,uBAAA;EJ8oFb;EI/lFA;IA9Ca,sBAAA;EJgpFb;EIjmFA;IA9Ca,uBAAA;EJkpFb;EInmFA;IA9Ca,qBAAA;EJopFb;EIrmFA;IA9Ca,sBAAA;EJspFb;EIvmFA;IA9Ca,mBAAA;EJwpFb;EIzmFA;IA9Ca,qBAAA;EJ0pFb;EI3mFA;IA9Ca,mBAAA;EJ4pFb;EI7mFA;IA9Ca,mBAAA;EJ8pFb;EI/mFA;IA9Ca,mBAAA;EJgqFb;EIjnFA;IA9Ca,mBAAA;EJkqFb;EInnFA;IA9Ca,mBAAA;EJoqFb;EIrnFA;IA9Ca,mBAAA;EJsqFb;EIvnFA;IA9Ca,mBAAA;EJwqFb;EIznFA;IA9Ca,oBAAA;EJ0qFb;EI3nFA;IA9Ca,oBAAA;EJ4qFb;EI7nFA;IA9Ca,mBAAA;EJ8qFb;AACF;AI5nFA;EAAc,aAAA;AJ+nFd;AI9nFA;EAAc,oBAAA;AJioFd;AIhoFA;EAAc,mBAAA;AJmoFd;AIloFA;EAAc,oBAAA;AJqoFd;AIpoFA;EAAc,kBAAA;AJuoFd;AItoFA;EAAc,mBAAA;AJyoFd;AIxoFA;EAAc,gBAAA;AJ2oFd;AI1oFA;EAAc,kBAAA;AJ6oFd;AI5oFA;EAAc,gBAAA;AJ+oFd;AI9oFA;EAAc,gBAAA;AJipFd;AIhpFA;EAAc,gBAAA;AJmpFd;AIlpFA;EAAc,gBAAA;AJqpFd;AIppFA;EAAc,gBAAA;AJupFd;AItpFA;EAAc,gBAAA;AJypFd;AIxpFA;EAAc,gBAAA;AJ2pFd;AI1pFA;EAAc,iBAAA;AJ6pFd;AI5pFA;EAAc,iBAAA;AJ+pFd;AI7pFA;EAAS,qBAAA;AJgqFT;AI/pFA;EAAS,oBAAA;AJkqFT;AIjqFA;EAAS,qBAAA;AJoqFT;AInqFA;EAAS,mBAAA;AJsqFT;AIrqFA;EAAS,oBAAA;AJwqFT;AIvqFA;EAAS,iBAAA;AJ0qFT;AIzqFA;EAAS,mBAAA;AJ4qFT;AI3qFA;EAAS,iBAAA;AJ8qFT;AI7qFA;EAAS,iBAAA;AJgrFT;AE10GE;EE6pBA;IA7BY,aAAA;EJ8sFZ;AACF;AEr3GE;EEusBA;IAjCY,aAAA;EJmtFZ;EIjrFA;IAjCY,oBAAA;EJqtFZ;EInrFA;IAjCY,mBAAA;EJutFZ;EIrrFA;IAjCY,oBAAA;EJytFZ;EIvrFA;IAjCY,kBAAA;EJ2tFZ;EIzrFA;IAjCY,mBAAA;EJ6tFZ;EI3rFA;IAjCY,gBAAA;EJ+tFZ;EI7rFA;IAjCY,kBAAA;EJiuFZ;EI/rFA;IAjCY,gBAAA;EJmuFZ;EIjsFA;IAjCY,gBAAA;EJquFZ;EInsFA;IAjCY,gBAAA;EJuuFZ;EIrsFA;IAjCY,gBAAA;EJyuFZ;EIvsFA;IAjCY,gBAAA;EJ2uFZ;EIzsFA;IAjCY,gBAAA;EJ6uFZ;EI3sFA;IAjCY,gBAAA;EJ+uFZ;EI7sFA;IAjCY,iBAAA;EJivFZ;EI/sFA;IAjCY,iBAAA;EJmvFZ;AACF;AE16GE;EE2tBA;IArDY,aAAA;EJwwFZ;EIltFA;IArDY,oBAAA;EJ0wFZ;EIptFA;IArDY,mBAAA;EJ4wFZ;EIttFA;IArDY,oBAAA;EJ8wFZ;EIxtFA;IArDY,kBAAA;EJgxFZ;EI1tFA;IArDY,mBAAA;EJkxFZ;EI5tFA;IArDY,gBAAA;EJoxFZ;EI9tFA;IArDY,kBAAA;EJsxFZ;EIhuFA;IArDY,gBAAA;EJwxFZ;EIluFA;IArDY,gBAAA;EJ0xFZ;EIpuFA;IArDY,gBAAA;EJ4xFZ;EItuFA;IArDY,gBAAA;EJ8xFZ;EIxuFA;IArDY,gBAAA;EJgyFZ;EI1uFA;IArDY,gBAAA;EJkyFZ;EI5uFA;IArDY,gBAAA;EJoyFZ;EI9uFA;IArDY,iBAAA;EJsyFZ;EIhvFA;IArDY,iBAAA;EJwyFZ;AACF;AI/uFA;EAAa,aAAA;EAAwB,gBAAA;AJmvFrC;AIlvFA;EAAa,oBAAA;EAAwB,uBAAA;AJsvFrC;AIrvFA;EAAa,mBAAA;EAAwB,sBAAA;AJyvFrC;AIxvFA;EAAa,oBAAA;EAAwB,uBAAA;AJ4vFrC;AI3vFA;EAAa,kBAAA;EAAwB,qBAAA;AJ+vFrC;AI9vFA;EAAa,mBAAA;EAAwB,sBAAA;AJkwFrC;AIjwFA;EAAa,gBAAA;EAAwB,mBAAA;AJqwFrC;AIpwFA;EAAa,kBAAA;EAAwB,qBAAA;AJwwFrC;AIvwFA;EAAa,gBAAA;EAAwB,mBAAA;AJ2wFrC;AI1wFA;EAAa,gBAAA;EAAwB,mBAAA;AJ8wFrC;AI7wFA;EAAa,gBAAA;EAAyB,mBAAA;AJixFtC;AIhxFA;EAAa,gBAAA;EAA8B,mBAAA;AJoxF3C;AInxFA;EAAa,gBAAA;EAAyB,mBAAA;AJuxFtC;AItxFA;EAAa,gBAAA;EAA8B,mBAAA;AJ0xF3C;AIzxFA;EAAa,gBAAA;EAAyB,mBAAA;AJ6xFtC;AI5xFA;EAAa,iBAAA;EAAyB,oBAAA;AJgyFtC;AI/xFA;EAAa,iBAAA;EAAyB,oBAAA;AJmyFtC;AEniHE;EEmwBA;IAnBW,aAAA;IAAwB,gBAAA;EJwzFnC;EIpyFA;IAnBW,oBAAA;IAAwB,uBAAA;EJ2zFnC;EIvyFA;IAnBW,mBAAA;IAAwB,sBAAA;EJ8zFnC;EI1yFA;IAnBW,oBAAA;IAAwB,uBAAA;EJi0FnC;EI7yFA;IAnBW,kBAAA;IAAwB,qBAAA;EJo0FnC;EIhzFA;IAnBW,mBAAA;IAAwB,sBAAA;EJu0FnC;EInzFA;IAnBW,gBAAA;IAAwB,mBAAA;EJ00FnC;EItzFA;IAnBW,kBAAA;IAAwB,qBAAA;EJ60FnC;EIzzFA;IAnBW,gBAAA;IAAwB,mBAAA;EJg1FnC;EI5zFA;IAnBW,gBAAA;IAAwB,mBAAA;EJm1FnC;EI/zFA;IAnBW,gBAAA;IAAyB,mBAAA;EJs1FpC;EIl0FA;IAnBW,gBAAA;IAA8B,mBAAA;EJy1FzC;EIr0FA;IAnBW,gBAAA;IAAyB,mBAAA;EJ41FpC;EIx0FA;IAnBW,gBAAA;IAA8B,mBAAA;EJ+1FzC;EI30FA;IAnBW,gBAAA;IAAyB,mBAAA;EJk2FpC;EI90FA;IAnBW,iBAAA;IAAyB,oBAAA;EJq2FpC;EIj1FA;IAnBW,iBAAA;IAAyB,oBAAA;EJw2FpC;AACF;AEzmHE;EEuxBA;IAvCW,aAAA;IAAwB,gBAAA;EJ83FnC;EIt1FA;IAvCW,oBAAA;IAAwB,uBAAA;EJi4FnC;EIz1FA;IAvCW,mBAAA;IAAwB,sBAAA;EJo4FnC;EI51FA;IAvCW,oBAAA;IAAwB,uBAAA;EJu4FnC;EI/1FA;IAvCW,kBAAA;IAAwB,qBAAA;EJ04FnC;EIl2FA;IAvCW,mBAAA;IAAwB,sBAAA;EJ64FnC;EIr2FA;IAvCW,gBAAA;IAAwB,mBAAA;EJg5FnC;EIx2FA;IAvCW,kBAAA;IAAwB,qBAAA;EJm5FnC;EI32FA;IAvCW,gBAAA;IAAwB,mBAAA;EJs5FnC;EI92FA;IAvCW,gBAAA;IAAwB,mBAAA;EJy5FnC;EIj3FA;IAvCW,gBAAA;IAAyB,mBAAA;EJ45FpC;EIp3FA;IAvCW,gBAAA;IAA8B,mBAAA;EJ+5FzC;EIv3FA;IAvCW,gBAAA;IAAyB,mBAAA;EJk6FpC;EI13FA;IAvCW,gBAAA;IAA8B,mBAAA;EJq6FzC;EI73FA;IAvCW,gBAAA;IAAyB,mBAAA;EJw6FpC;EIh4FA;IAvCW,iBAAA;IAAyB,oBAAA;EJ26FpC;EIn4FA;IAvCW,iBAAA;IAAyB,oBAAA;EJ86FpC;AACF;AIn4FA;EAAe,cAAA;EAAyB,eAAA;AJu4FxC;AIt4FA;EAAe,qBAAA;EAAyB,sBAAA;AJ04FxC;AIz4FA;EAAe,oBAAA;EAAyB,qBAAA;AJ64FxC;AI54FA;EAAe,qBAAA;EAAyB,sBAAA;AJg5FxC;AI/4FA;EAAe,mBAAA;EAAyB,oBAAA;AJm5FxC;AIl5FA;EAAe,oBAAA;EAAyB,qBAAA;AJs5FxC;AIr5FA;EAAe,iBAAA;EAAyB,kBAAA;AJy5FxC;AIx5FA;EAAe,mBAAA;EAAyB,oBAAA;AJ45FxC;AI35FA;EAAe,iBAAA;EAAyB,kBAAA;AJ+5FxC;AI95FA;EAAe,iBAAA;EAAyB,kBAAA;AJk6FxC;AIj6FA;EAAe,iBAAA;EAA0B,kBAAA;AJq6FzC;AIp6FA;EAAe,iBAAA;EAA+B,kBAAA;AJw6F9C;AIv6FA;EAAe,iBAAA;EAA0B,kBAAA;AJ26FzC;AI16FA;EAAgB,iBAAA;EAA+B,kBAAA;AJ86F/C;AI76FA;EAAe,iBAAA;EAA0B,kBAAA;AJi7FzC;AIh7FA;EAAe,kBAAA;EAA0B,mBAAA;AJo7FzC;AIn7FA;EAAe,kBAAA;EAA0B,mBAAA;AJu7FzC;AIt7FA;EAAe,iBAAA;EAAmB,kBAAA;AJ07FlC;AEvvHE;EEg0BA;IApBa,cAAA;IAAyB,eAAA;EJg9FtC;EI37FA;IApBa,qBAAA;IAAyB,sBAAA;EJm9FtC;EI97FA;IApBa,oBAAA;IAAyB,qBAAA;EJs9FtC;EIj8FA;IApBa,qBAAA;IAAyB,sBAAA;EJy9FtC;EIp8FA;IApBa,mBAAA;IAAyB,oBAAA;EJ49FtC;EIv8FA;IApBa,oBAAA;IAAyB,qBAAA;EJ+9FtC;EI18FA;IApBa,iBAAA;IAAyB,kBAAA;EJk+FtC;EI78FA;IApBa,mBAAA;IAAyB,oBAAA;EJq+FtC;EIh9FA;IApBa,iBAAA;IAAyB,kBAAA;EJw+FtC;EIn9FA;IApBa,iBAAA;IAAyB,kBAAA;EJ2+FtC;EIt9FA;IApBa,iBAAA;IAA0B,kBAAA;EJ8+FvC;EIz9FA;IAnBa,iBAAA;IAA0B,kBAAA;EJg/FvC;EI59FA;IAlBa,iBAAA;IAA0B,kBAAA;EJk/FvC;EI/9FA;IAlBa,kBAAA;IAA0B,mBAAA;EJq/FvC;EIl+FA;IAlBa,kBAAA;IAA0B,mBAAA;EJw/FvC;EIr+FA;IAlBa,iBAAA;IAAmB,kBAAA;EJ2/FhC;AACF;AEzzHE;EEm1BA;IAvCa,cAAA;IAAyB,eAAA;EJkhGtC;EI1+FA;IAvCa,qBAAA;IAAyB,sBAAA;EJqhGtC;EI7+FA;IAvCa,oBAAA;IAAyB,qBAAA;EJwhGtC;EIh/FA;IAvCa,qBAAA;IAAyB,sBAAA;EJ2hGtC;EIn/FA;IAvCa,mBAAA;IAAyB,oBAAA;EJ8hGtC;EIt/FA;IAvCa,oBAAA;IAAyB,qBAAA;EJiiGtC;EIz/FA;IAvCa,iBAAA;IAAyB,kBAAA;EJoiGtC;EI5/FA;IAvCa,mBAAA;IAAyB,oBAAA;EJuiGtC;EI//FA;IAvCa,iBAAA;IAAyB,kBAAA;EJ0iGtC;EIlgGA;IAvCa,iBAAA;IAAyB,kBAAA;EJ6iGtC;EIrgGA;IAvCa,iBAAA;IAA0B,kBAAA;EJgjGvC;EIxgGA;IAtCa,iBAAA;IAA0B,kBAAA;EJkjGvC;EI3gGA;IArCa,iBAAA;IAA0B,kBAAA;EJojGvC;EI9gGA;IArCa,kBAAA;IAA0B,mBAAA;EJujGvC;EIjhGA;IArCa,kBAAA;IAA0B,mBAAA;EJ0jGvC;EIphGA;IArCa,iBAAA;IAAmB,kBAAA;EJ6jGhC;AACF;AIthGA;EAAQ,aAAA;AJyhGR;AIxhGA;EAAQ,YAAA;AJ2hGR;AI1hGA;EAAQ,aAAA;AJ6hGR;AI5hGA;EAAQ,WAAA;AJ+hGR;AI9hGA;EAAQ,YAAA;AJiiGR;AIhiGA;EAAQ,SAAA;AJmiGR;AIliGA;EAAQ,WAAA;AJqiGR;AIpiGA;EAAQ,SAAA;AJuiGR;AItiGA;EAAQ,SAAA;AJyiGR;AIxiGA;EAAS,SAAA;AJ2iGT;AACA;;;;;;;CAOC;AGh6HD;EAAW,+BAAA;EAAiC,gCAAA;AHo6H5C;AGn6HA;EAAa,iBAAA;AHs6Hb;AGr6HA;EAAwB,wBAAA;AHw6HxB;AGv6HA;EACE,WAAA;EACA,sBAAA;EACA,4BAAA;EACA,4BAAA;AHy6HF;AGr6HA;EAAU,kBAAA;AHw6HV;AGp6HA;EAAqB,oBAAA;AHu6HrB;AGt6HA;EAAuB,oBAAA;AHy6HvB;AGr6HA;EAAc,gBAAA;AHw6Hd;AGv6HA;EAAkB,qBAAA;AH06HlB;AGz6HA;EAAoB,wBAAA;AH46HpB;AGz6HA;EACE,kCAAA;EACA,+BAAA;EACA,6BAAA;EACA,0BAAA;AH26HF;AGx6HA;EACE,iCAAA;EACA,8BAAA;EACA,4BAAA;EACA,yBAAA;AH06HF;AGt6HA;EAAkB,eAAA;AHy6HlB;AGx6HA;EAAkB,eAAA;AH26HlB;AG16HA;EAAkB,YAAA;AH66HlB;AG56HA;EAHkB,eAAA;AHk7HlB;AG96HA;EAAkB,mBAAA;AHi7HlB;AGh7HA;EAAkB,YAAA;AHm7HlB;AGl7HA;EAAkB,gBAAA;AHq7HlB;AGj7HA;EAAa,UAAA;EAAY,aAAA;AHq7HzB;AGn7HA;EAFa,UAAA;EAAY,aAAA;AHy7HzB;AGv7HA;EImEI,kBAAA;EACA,uBAAA;APu3HJ;AGx7HA;EAA4B,YAAA;AH27H5B;AGx7HA;EAAe,oBAAA;AH27Hf;AG17HA;EAAe,iBAAA;AH67Hf;AG37HA;EAHe,oBAAA;AHi8Hf;AG17HA;EKhCE,kBAAA;EACA,eAAA;EACA,UAAA;AR69HF;AG97HA;EKjCE,oBAAA;EACA,iBAAA;EACA,YAAA;ARk+HF;AGl8HA;EKlCE,oBAAA;EACA,iBAAA;EACA,YAAA;ARu+HF;AGt8HA;EKnCE,oBAAA;EACA,iBAAA;EACA,YAAA;AR4+HF;AG18HA;EKpCE,oBAAA;EACA,iBAAA;EACA,YAAA;ARi/HF;AG98HA;EKrCE,oBAAA;EACA,iBAAA;EACA,YAAA;ARs/HF;AGl9HA;EKtCE,oBAAA;EACA,iBAAA;EACA,YAAA;AR2/HF;AGt9HA;EKvCE,oBAAA;EACA,iBAAA;EACA,YAAA;ARggIF;AG19HA;EKxCE,oBAAA;EACA,iBAAA;EACA,YAAA;ARqgIF;AG99HA;EKzCE,oBAAA;EACA,iBAAA;EACA,YAAA;AR0gIF;AGl+HA;EK1CE,qBAAA;EACA,kBAAA;EACA,aAAA;AR+gIF;AGt+HA;EK3CE,sBAAA;EACA,mBAAA;EACA,cAAA;ARohIF;AG1+HA;EK5CE,kBAAA;EACA,eAAA;EACA,UAAA;ARyhIF;AG7+HA;EK9CE,oBAAA;EACA,iBAAA;EACA,YAAA;AR8hIF;AGj/HA;EK/CE,oBAAA;EACA,iBAAA;EACA,YAAA;ARmiIF;AGr/HA;EKhDE,kBAAA;EACA,eAAA;EACA,UAAA;ARwiIF;AGv/HA;EKnDE,kBAAA;EACA,eAAA;EACA,UAAA;AR6iIF;AGx/HA;EAAqB,cAAA;AH2/HrB;AG1/HA;EAAqB,cAAA;AH6/HrB;AG5/HA;EAAqB,cAAA;AH+/HrB;AG9/HA;EAAqB,cAAA;AHigIrB;AGhgIA;EAAqB,cAAA;AHmgIrB;AGlgIA;EAAqB,cAAA;AHqgIrB;AGpgIA;EAAqB,cAAA;AHugIrB;AGtgIA;EAAqB,cAAA;AHygIrB;AGxgIA;EAAqB,cAAA;AH2gIrB;AG1gIA;EAAqB,cAAA;AH6gIrB;AG5gIA;EAAqB,cAAA;AH+gIrB;AG9gIA;EAAqB,cAAA;AHihIrB;AGhhIA;EAAqB,cAAA;AHmhIrB;AGlhIA;EAAqB,cAAA;AHqhIrB;AGphIA;EAAqB,cAAA;AHuhIrB;AGthIA;EAAqB,cAAA;AHyhIrB;AGxhIA;EAAqB,cAAA;AH2hIrB;AG1hIA;EAAqB,cAAA;AH6hIrB;AG5hIA;EAAqB,cAAA;AH+hIrB;AG9hIA;EAAqB,cAAA;AHiiIrB;AGhiIA;EAAqB,cAAA;AHmiIrB;AGliIA;EAAqB,cAAA;AHqiIrB;AGpiIA;EAAqB,cAAA;AHuiIrB;AGtiIA;EAAqB,cAAA;AHyiIrB;AGxiIA;EAAqB,cAAA;AH2iIrB;AG1iIA;EAAqB,cAAA;AH6iIrB;AG5iIA;EAAqB,cAAA;AH+iIrB;AG9iIA;EAAqB,cAAA;AHijIrB;AGhjIA;EAAqB,cAAA;AHmjIrB;AGljIA;EAAqB,cAAA;AHqjIrB;AGpjIA;EAAqB,cAAA;AHujIrB;AGtjIA;EAAqB,cAAA;AHyjIrB;AGxjIA;EAAqB,cAAA;AH2jIrB;AG1jIA;EAAqB,cAAA;AH6jIrB;AG5jIA;EAAqB,cAAA;AH+jIrB;AG9jIA;EAAqB,cAAA;AHikIrB;AGhkIA;EAAqB,cAAA;AHmkIrB;AGlkIA;EAAqB,cAAA;AHqkIrB;AGpkIA;EAAqB,cAAA;AHukIrB;AGtkIA;EAAqB,cAAA;AHykIrB;AGxkIA;EAAqB,cAAA;AH2kIrB;AG1kIA;EAAqB,cAAA;AH6kIrB;AG5kIA;EAAqB,cAAA;AH+kIrB;AG9kIA;EAAqB,cAAA;AHilIrB;AGhlIA;EAAqB,cAAA;AHmlIrB;AGllIA;EAAqB,cAAA;AHqlIrB;AGnlIA;EA3CqB,cAAA;AHioIrB;AGplIA;EAAqB,cAAA;AHulIrB;AGtlIA;EA9CqB,cAAA;AHuoIrB;AGxlIA;EAAgC,cAAA;AH2lIhC;AG1lIA;EAA+B,cAAA;AH6lI/B;AG5lIA;EAA0B,cAAA;AH+lI1B;AG9lIA;EAAgC,cAAA;AHimIhC;AGhmIA;EAAgC,cAAA;AHmmIhC;AGlmIA;EA1CqB,cAAA;AH+oIrB;AGpmIA;EAhBqB,cAAA;AHunIrB;AGtmIA;EA9CqB,cAAA;AHupIrB;AGxmIA;EA9CqB,cAAA;AHypIrB;AGzmIA;EAnCqB,cAAA;AH+oIrB;AG3mIA;EArBqB,cAAA;AHmoIrB;AG7mIA;EAhDqB,cAAA;AHgqIrB;AG/mIA;EApDqB,cAAA;AHsqIrB;AGjnIA;EApDqB,cAAA;AHwqIrB;AGlnIA;EAvDqB,cAAA;AH4qIrB;AGpnIA;EAvDqB,cAAA;AH8qIrB;AGrnIA;EAAiB,cAAA;AHwnIjB;AGvnIA;EADiB,cAAA;AH2nIjB;AGvnIA;EAAwB,yBAAA;AH0nIxB;AGznIA;EAAwB,yBAAA;AH4nIxB;AG3nIA;EAAwB,yBAAA;AH8nIxB;AG7nIA;EAAwB,yBAAA;AHgoIxB;AG/nIA;EAAwB,yBAAA;AHkoIxB;AGjoIA;EAAwB,yBAAA;AHooIxB;AGnoIA;EAAyB,yBAAA;AHsoIzB;AGroIA;EAAwB,yBAAA;AHwoIxB;AGvoIA;EAAwB,yBAAA;AH0oIxB;AGzoIA;EAAwB,yBAAA;AH4oIxB;AG3oIA;EAAwB,yBAAA;AH8oIxB;AG7oIA;EAAwB,yBAAA;AHgpIxB;AG/oIA;EAAwB,yBAAA;AHkpIxB;AGjpIA;EAAwB,yBAAA;AHopIxB;AGnpIA;EAAwB,yBAAA;AHspIxB;AGrpIA;EAAwB,yBAAA;AHwpIxB;AGvpIA;EAAwB,yBAAA;AH0pIxB;AGzpIA;EAAwB,yBAAA;AH4pIxB;AG3pIA;EAAwB,yBAAA;AH8pIxB;AG7pIA;EAAwB,yBAAA;AHgqIxB;AG/pIA;EAAwB,yBAAA;AHkqIxB;AGjqIA;EAAwB,yBAAA;AHoqIxB;AGnqIA;EAAwB,yBAAA;AHsqIxB;AGrqIA;EAAwB,yBAAA;AHwqIxB;AGvqIA;EAAwB,yBAAA;AH0qIxB;AGzqIA;EAAwB,yBAAA;AH4qIxB;AG3qIA;EAAwB,yBAAA;AH8qIxB;AG7qIA;EAAwB,yBAAA;AHgrIxB;AG/qIA;EAAwB,yBAAA;AHkrIxB;AGjrIA;EAAwB,yBAAA;AHorIxB;AGnrIA;EAAwB,yBAAA;AHsrIxB;AGrrIA;EAAwB,yBAAA;AHwrIxB;AGvrIA;EAAwB,yBAAA;AH0rIxB;AGzrIA;EAAwB,yBAAA;AH4rIxB;AG3rIA;EAAwB,yBAAA;AH8rIxB;AG7rIA;EAAwB,yBAAA;AHgsIxB;AG/rIA;EAAwB,yBAAA;AHksIxB;AGjsIA;EAAwB,yBAAA;AHosIxB;AGnsIA;EAAwB,yBAAA;AHssIxB;AGrsIA;EAAwB,yBAAA;AHwsIxB;AGvsIA;EAAwB,yBAAA;AH0sIxB;AGzsIA;EAAwB,yBAAA;AH4sIxB;AG3sIA;EAAwB,yBAAA;AH8sIxB;AG7sIA;EAAwB,6BAAA;AHgtIxB;AG/sIA;EAAwB,yBAAA;AHktIxB;AGjtIA;EAAwB,yBAAA;AHotIxB;AGntIA;EAAwB,yBAAA;AHstIxB;AGrtIA;EAAwB,uBAAA;AHwtIxB;AGvtIA;EAAyB,yBAAA;AH0tIzB;AGztIA;EAAwB,yBAAA;AH4tIxB;AG3tIA;EAAwB,yBAAA;AH8tIxB;AG7tIA;EAAwB,yBAAA;AHguIxB;AG/tIA;EAAwB,yBAAA;AHkuIxB;AGjuIA;EAAwB,yBAAA;AHouIxB;AGnuIA;EAAwB,yBAAA;AHsuIxB;AGruIA;EAAwB,yBAAA;AHwuIxB;AGvuIA;EAA8B,wCAAA;AH0uI9B;AGxuIA;EAfwB,6BAAA;EAIA,uBAAA;AHuvIxB;AG3uIA;EAzDwB,yBAAA;AHuyIxB;AG7uIA;EAhDwB,yBAAA;AHgyIxB;AG/uIA;EApDwB,yBAAA;AHsyIxB;AGjvIA;EApDwB,yBAAA;AHwyIxB;AGnvIA;EApDwB,yBAAA;AH0yIxB;AGrvIA;EA3DwB,yBAAA;AHmzIxB;AGvvIA;EAnDwB,yBAAA;AH6yIxB;AGzvIA;EAlDwB,yBAAA;AH8yIxB;AG3vIA;EAhDwB,yBAAA;AH8yIxB;AG7vIA;EAnDwB,yBAAA;AHmzIxB;AG/vIA;EA3CwB,yBAAA;AH6yIxB;AGjwIA;EA/BwB,yBAAA;AHmyIxB;AGnwIA;EApCwB,yBAAA;AH0yIxB;AGrwIA;EA5BwB,yBAAA;AHoyIxB;AGvwIA;EAhCwB,yBAAA;AH0yIxB;AGzwIA;EArEwB,yBAAA;AHi1IxB;AG3wIA;EA3ByB,yBAAA;AHyyIzB;AG7wIA;EA3BwB,yBAAA;AH2yIxB;AG/wIA;EA3BwB,yBAAA;AH6yIxB;AGjxIA;EAzBwB,yBAAA;AH6yIxB;AGlxIA;EA/BwB,yBAAA;AHozIxB;AGpxIA;EAjCyB,yBAAA;AHwzIzB;AGtxIA;EA3BwB,yBAAA;AHozIxB;AGxxIA;EAjCwB,yBAAA;AH4zIxB;AGzxIA;EApCwB,yBAAA;AHg0IxB;AG3xIA;EAtCyB,yBAAA;AHo0IzB;AG3xIA;EAA2B,aAAA;AH8xI3B;AG7xIA;EAA2B,aAAA;AHgyI3B;AG/xIA;EAA2B,aAAA;AHkyI3B;AG/xIA;EAH2B,aAAA;AHqyI3B;AG/xIA;EAAqB,eAAA;AHkyIrB;AG/xIA;EAAc,wBAAA;AHkyId;AG/xIA;EAAe,2BAAA;AHkyIf;AGjyIA;EAAe,6BAAA;AHoyIf;AGnyIA;EAAe,6BAAA;AHsyIf;AGlyIA;EAAmB,yBAAA;AHqyInB;AGlyIA;EAAgB,4BAAA;AHqyIhB;AGlyIA;EAAa,mBAAA;EAAqB,iBAAA;AHsyIlC;AGryIA;EAAa,mBAAA;EAAqB,iBAAA;AHyyIlC;AGxyIA;EAAa,kBAAA;EAAoB,eAAA;AH4yIjC;AG3yIA;EAAa,0BAAA;EAA4B,wBAAA;AH+yIzC;AG9yIA;EAAa,wBAAA;EAA0B,sBAAA;AHkzIvC;AGjzIA;EAAa,uBAAA;EAAyB,qBAAA;AHqzItC;AGpzIA;EAAa,yBAAA;EAA2B,uBAAA;AHwzIxC;AGvzIA;EAAa,0BAAA;EAA4B,wBAAA;AH2zIzC;AG1zIA;EAAa,0BAAA;EAA4B,wBAAA;AH8zIzC;AG7zIA;EAAa,0BAAA;EAA4B,wBAAA;AHi0IzC;AGh0IA;EAAmB,0BAAA;EAA4B,wBAAA;AHo0I/C;AGn0IA;EAAa,uBAAA;EAAyB,qBAAA;AHu0ItC;AGt0IA;EAAa,uBAAA;EAAyB,qBAAA;AH00ItC;AGz0IA;EAAa,uBAAA;EAAyB,qBAAA;AH60ItC;AG50IA;EAAa,wBAAA;EAA0B,sBAAA;AHg1IvC;AEpnJE;ECuSA;IAfW,kBAAA;IAAoB,eAAA;EHi2I/B;EGj1IA;IAlBW,mBAAA;IAAqB,iBAAA;EHu2IhC;AACF;AGn1IA;EAZa,0BAAA;EAA4B,wBAAA;AHm2IzC;AGt1IA;EAda,0BAAA;EAA4B,wBAAA;AHw2IzC;AGz1IA;EAXa,uBAAA;EAAyB,qBAAA;AHw2ItC;AG51IA;EAtBa,kBAAA;EAAoB,eAAA;AHs3IjC;AG/1IA;EAvBa,kBAAA;EAAoB,eAAA;AH03IjC;AElpJE;ECkTA;IAzBW,0BAAA;IAA4B,wBAAA;EH83IvC;EGp2IA;IA3BW,kBAAA;IAAoB,eAAA;EHm4I/B;EGv2IA;IAzBW,uBAAA;IAAyB,qBAAA;EHo4IpC;AACF;AGv2IA;EAAc,oBAAA;AH02Id;AGz2IA;EAAc,oBAAA;AH42Id;AG32IA;EAAc,kBAAA;AH82Id;AG72IA;EAAc,mBAAA;AHg3Id;AG/2IA;EAAc,wBAAA;AHk3Id;AGj3IA;EAAc,wBAAA;AHo3Id;AGn3IA;EAAc,sBAAA;AHs3Id;AGr3IA;EAAc,uBAAA;AHw3Id;AGv3IA;EAAc,0BAAA;AH03Id;AGz3IA;EAAc,0BAAA;AH43Id;AG33IA;EAAc,wBAAA;AH83Id;AG73IA;EAAc,yBAAA;AHg4Id;AG/3IA;EAAc,2BAAA;AHk4Id;AGj4IA;EAAc,2BAAA;AHo4Id;AGn4IA;EAAc,yBAAA;AHs4Id;AGr4IA;EAAc,0BAAA;AHw4Id;AGv4IA;EAAc,yBAAA;AH04Id;AGz4IA;EAAc,yBAAA;AH44Id;AG34IA;EAAc,uBAAA;AH84Id;AG74IA;EAAc,wBAAA;AHg5Id;AG94IA;EAxDa,mBAAA;EAAqB,iBAAA;AH08IlC;AGj5IA;EAxDa,mBAAA;EAAqB,iBAAA;AH68IlC;AGj5IA;EAAwB,qBAAA;AHo5IxB;AGn5IA;EAAwB,qBAAA;AHs5IxB;AGr5IA;EAAwB,qBAAA;AHw5IxB;AGv5IA;EAAwB,qBAAA;AH05IxB;AGz5IA;EAAwB,qBAAA;AH45IxB;AG35IA;EAAwB,qBAAA;AH85IxB;AG75IA;EAAwB,qBAAA;AHg6IxB;AG/5IA;EAAwB,qBAAA;AHk6IxB;AGj6IA;EAAwB,qBAAA;AHo6IxB;AGn6IA;EAAwB,qBAAA;AHs6IxB;AGr6IA;EAAwB,qBAAA;AHw6IxB;AGv6IA;EAAwB,qBAAA;AH06IxB;AGz6IA;EAAwB,qBAAA;AH46IxB;AG36IA;EAAwB,qBAAA;AH86IxB;AG76IA;EAAwB,qBAAA;AHg7IxB;AG/6IA;EAAwB,qBAAA;AHk7IxB;AGj7IA;EAAwB,qBAAA;AHo7IxB;AGn7IA;EAAwB,qBAAA;AHs7IxB;AGr7IA;EAAwB,qBAAA;AHw7IxB;AGv7IA;EAAwB,qBAAA;AH07IxB;AGz7IA;EAAwB,qBAAA;AH47IxB;AG37IA;EAAwB,qBAAA;AH87IxB;AG77IA;EAAwB,qBAAA;AHg8IxB;AG/7IA;EAAwB,qBAAA;AHk8IxB;AGj8IA;EAAwB,qBAAA;AHo8IxB;AGn8IA;EAAwB,qBAAA;AHs8IxB;AGr8IA;EAAwB,qBAAA;AHw8IxB;AGv8IA;EAAwB,qBAAA;AH08IxB;AGz8IA;EAAwB,qBAAA;AH48IxB;AG38IA;EAAwB,qBAAA;AH88IxB;AG78IA;EAAwB,qBAAA;AHg9IxB;AG/8IA;EAAwB,qBAAA;AHk9IxB;AGj9IA;EAAwB,qBAAA;AHo9IxB;AGn9IA;EAAwB,yBAAA;AHs9IxB;AGr9IA;EAAwB,qBAAA;AHw9IxB;AGv9IA;EAAwB,qBAAA;AH09IxB;AGz9IA;EAAwB,qBAAA;AH49IxB;AG39IA;EAAwB,qBAAA;AH89IxB;AG79IA;EAAwB,qBAAA;AHg+IxB;AG/9IA;EAAwB,qBAAA;AHk+IxB;AGh+IA;EAA0B,6BAAA;AHm+I1B;AGl+IA;EAA0B,yBAAA;AHq+I1B;AGp+IA;EAA0B,yBAAA;AHu+I1B;AGt+IA;EAA0B,yBAAA;AHy+I1B;AGx+IA;EAA0B,yBAAA;AH2+I1B;AG1+IA;EAA0B,yBAAA;AH6+I1B;AG5+IA;EAA0B,yBAAA;AH++I1B;AG9+IA;EAA0B,yBAAA;AHi/I1B;AGh/IA;EAA0B,yBAAA;AHm/I1B;AGl/IA;EAA0B,qBAAA;AHq/I1B;AGp/IA;EAA0B,yBAAA;AHu/I1B;AGr/IA;EAA0B,4BAAA;AHw/I1B;AGv/IA;EAA0B,4BAAA;AH0/I1B;AGz/IA;EAA0B,4BAAA;AH4/I1B;AG1/IA;EAzDwB,qBAAA;AHsjJxB;AG5/IA;EAxBwB,qBAAA;AHuhJxB;AG9/IA;EArDwB,qBAAA;AHsjJxB;AGhgJA;EAzBwB,qBAAA;AH4hJxB;AGjgJA;EA5CwB,qBAAA;AHgjJxB;AGngJA;EA9DwB,qBAAA;AHokJxB;AGrgJA;EA7BwB,qBAAA;AHqiJxB;AGrgJA;EAhTqB,cAAA;AHwzJrB;AGrgJA;EAAW,gBAAA;AHwgJX;AGvgJA;EAAW,uBAAA;AH0gJX;AGzgJA;EAAW,sBAAA;AH4gJX;AG3gJA;EAAW,qBAAA;AH8gJX;AG7gJA;EAAW,mBAAA;AHghJX;AG/gJA;EAAW,kBAAA;AHkhJX;AGjhJA;EAAW,mBAAA;AHohJX;AGnhJA;EAAW,qBAAA;AHshJX;AGphJA;EAAc,yBAAA;EAA2B,0BAAA;AHwhJzC;AGvhJA;EAAc,0BAAA;EAA4B,6BAAA;AH2hJ1C;AG1hJA;EAAc,yBAAA;EAA2B,4BAAA;AH8hJzC;AG7hJA;EAAc,4BAAA;EAA8B,6BAAA;AHiiJ5C;AACA;;;;;EAKE;AG7hJF;EAAe,gBAAA;AHgiJf;AG9hJA;EAAe,2CAAA;AHiiJf;AGhiJA;EK1YE,sDAAA;EACA,mDAAA;EACA,8CAAA;AR66JF;AGpiJA;EK3YE,wDAAA;EACA,qDAAA;EACA,gDAAA;ARk7JF;AGxiJA;EK5YE,qDAAA;EACA,kDAAA;EACA,6CAAA;ARu7JF;AG5iJA;EK7YE,qDAAA;EACA,kDAAA;EACA,6CAAA;AR47JF;AGhjJA;EK9YE,wDAAA;EACA,qDAAA;EACA,gDAAA;ARi8JF;AGnjJA;EKhZE,mDAAA;EACA,gDAAA;EACA,2CAAA;ARs8JF;AEh/JE;EC2bA;IAZa,gBAAA;EHqkJb;AACF;AE/8JE;ECyZA;IAhBa,gBAAA;EH0kJb;AACF;AGtjJA;EKpbE,mDAAA;EACA,gDAAA;EACA,8CAAA;EACA,+CAAA;EACA,2CAAA;AR6+JF;AG5jJA;EKrbE,oDAAA;EACA,iDAAA;EACA,+CAAA;EACA,gDAAA;EACA,4CAAA;ARo/JF;AGlkJA;EKtbE,oDAAA;EACA,iDAAA;EACA,+CAAA;EACA,gDAAA;EACA,4CAAA;AR2/JF;AGxkJA;EKvbE,qDAAA;EACA,kDAAA;EACA,gDAAA;EACA,iDAAA;EACA,6CAAA;ARkgKF;AG9kJA;EKxbE,kCAAA;EACA,+BAAA;EACA,6BAAA;EACA,8BAAA;EACA,0BAAA;ARygKF;AGplJA;EKzbE,oDAAA;EACA,iDAAA;EACA,+CAAA;EACA,gDAAA;EACA,4CAAA;ARghKF;AG1lJA;EK1bE,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;ARuhKF;AGhmJA;EK3bE,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;AR8hKF;AGtmJA;EK5bE,oCAAA;EACA,iCAAA;EACA,+BAAA;EACA,gCAAA;EACA,4BAAA;ARqiKF;AG5mJA;EK7bE,gCAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;AR4iKF;AGlnJA;EK9bE,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;ARmjKF;AGxnJA;EK/bE,oCAAA;EACA,iCAAA;EACA,+BAAA;EACA,gCAAA;EACA,4BAAA;AR0jKF;AG9nJA;EKhcE,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;ARikKF;AGpoJA;EKjcE,gCAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;ARwkKF;AGzoJA;EKncE,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;AR+kKF;AG9oJA;EKrcE,oCAAA;EACA,iCAAA;EACA,+BAAA;EACA,gCAAA;EACA,4BAAA;ARslKF;AGnpJA;EKvcE,qCAAA;EACA,kCAAA;EACA,gCAAA;EACA,iCAAA;EACA,6BAAA;AR6lKF;AEjnKE;EC0dA;IK1cA,oCAAA;IACA,iCAAA;IACA,+BAAA;IACA,gCAAA;IACA,4BAAA;ERqmKA;AACF;AEplKE;ECwbA;IK9cA,gCAAA;IACA,6BAAA;IACA,2BAAA;IACA,4BAAA;IACA,wBAAA;ER8mKA;AACF;AGlqJA;EKjdE,gCAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;ARsnKF;AGxqJA;EKldE,iCAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;AR6nKF;AG9qJA;EKndE,iCAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;ARooKF;AGlrJA;EAAsB,SAAA;EAAW,kBAAA;AHsrJjC;AGrrJA;EAAsB,sBAAA;AHwrJtB;AGvrJA;EAAsB,uBAAA;AH0rJtB;AGzrJA;EAAsB,mBAAA;AH4rJtB;AG3rJA;EAAsB,uBAAA;AH8rJtB;AG7rJA;EAAsB,qBAAA;AHgsJtB;AG/rJA;EAAsB,oBAAA;AHksJtB;AGjsJA;EAAsB,qBAAA;AHosJtB;AGnsJA;EAAsB,oBAAA;AHssJtB;AGrsJA;EAAsB,sBAAA;AHwsJtB;AGvsJA;EAAsB,oBAAA;AH0sJtB;AGzsJA;EAAsB,oBAAA;AH4sJtB;AGzsJA;EAAgB,iCAAA;AH4sJhB;AG3sJA;EAAgB,gCAAA;AH8sJhB;AG5sJA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AH8sJF;AG1sJG;EAAqB,cAAA;AH6sJxB;AG5sJG;EAAqB,yBAAA;AH+sJxB;AG9sJG;EAAuB,yBAAA;AHitJ1B;AGhtJG;EAAqB,qBAAA;AHmtJxB;AGltJG;EAAoB,4BAAA;AHqtJvB;AGztJG;EAAqB,cAAA;AH4tJxB;AG3tJG;EAAqB,yBAAA;AH8tJxB;AG7tJG;EAAuB,yBAAA;AHguJ1B;AG/tJG;EAAqB,qBAAA;AHkuJxB;AGjuJG;EAAoB,4BAAA;AHouJvB;AGxuJG;EAAqB,cAAA;AH2uJxB;AG1uJG;EAAqB,yBAAA;AH6uJxB;AG5uJG;EAAuB,yBAAA;AH+uJ1B;AG9uJG;EAAqB,qBAAA;AHivJxB;AGhvJG;EAAoB,4BAAA;AHmvJvB;AG5uJA;EACE;IAAK,UAAA;EH+uJL;EG9uJA;IAAO,UAAA;EHivJP;AACF;AG/uJA;EACE;IAAK,UAAA;EHkvJL;EGjvJA;IAAO,UAAA;EHovJP;AACF;AGlvJA;EACE,UAAA;EACA,2CAAA;AHovJF;AGjvJA;EACE,UAAA;EACA,4CAAA;AHmvJF;AGhvJA;EACE,UAAA;EACA,gCAAA;AHkvJF;AGhvJE;EACE,UAAA;AHkvJJ;AACA;;;;;;;CAOC;AS5xKD;EAAgB,mDAAA;AT+xKhB;AS5xKA;EAAM,eAAA;AT+xKN;AS9xKA;EAAM,kBAAA;ATiyKN;AShyKA;EAAM,iBAAA;ATmyKN;ASlyKA;EAAM,kBAAA;ATqyKN;ASpyKA;EAAM,eAAA;ATuyKN;AStyKA;EAAM,mBAAA;ATyyKN;ASxyKA;EAAM,kBAAA;AT2yKN;AS1yKA;EAAM,mBAAA;AT6yKN;AS5yKA;EAAO,kBAAA;AT+yKP;AE3zKE;EOeA;IAXI,eAAA;ET2zKJ;ES/yKA;IAXI,kBAAA;ET6zKJ;ESjzKA;IAXI,iBAAA;ET+zKJ;ESnzKA;IAXI,kBAAA;ETi0KJ;ESrzKA;IAXI,eAAA;ETm0KJ;ESvzKA;IAXI,mBAAA;ETq0KJ;ESzzKA;IAXI,kBAAA;ETu0KJ;AACF;AEl1KE;EOyBA;IArBI,eAAA;ETk1KJ;ES5zKA;IArBI,kBAAA;ETo1KJ;ES9zKA;IArBI,iBAAA;ETs1KJ;ESh0KA;IArBI,kBAAA;ETw1KJ;ESl0KA;IArBI,eAAA;ET01KJ;ESp0KA;IArBI,mBAAA;ET41KJ;ESt0KA;IArBI,kBAAA;ET81KJ;AACF;ASt0KA;EAAiB,sBAAA;ATy0KjB;ASx0KA;EAAiB,sBAAA;AT20KjB;AS10KA;EAAiB,yBAAA;AT60KjB;AS50KA;EAAiB,wBAAA;AT+0KjB;AS90KA;EAAiB,uBAAA;ATi1KjB;AS90KA;EAAW,mBAAA;ATi1KX;ASh1KA;EAAW,iBAAA;ATm1KX;ASl1KA;EAAW,oBAAA;ATq1KX;ASp1KA;EAAW,gBAAA;ATu1KX;ASt1KA;EAAW,gBAAA;ATy1KX;ASx1KA;EAAW,gBAAA;AT21KX;AS11KA;EAAW,gBAAA;AT61KX;AS51KA;EAAW,gBAAA;AT+1KX;AS91KA;EAAW,gBAAA;ATi2KX;ASh2KA;EAAW,gBAAA;ATm2KX;ASh2KA;EAAa,kBAAA;ATm2Kb;ASl2KA;EAAa,kBAAA;ATq2Kb;ASl2KA;EAAmB,cAAA;ATq2KnB;ASp2KA;EAAmB,iBAAA;ATu2KnB;ASt2KA;EAAmB,iBAAA;ATy2KnB;ASx2KA;EAAmB,iBAAA;AT22KnB;AS12KA;EAAmB,gBAAA;AT62KnB;AS52KA;EAAmB,iBAAA;AT+2KnB;AS92KA;EAAmB,iBAAA;ATi3KnB;AS92KA;EAAM,kBAAA;ATi3KN;ASh3KA;EAAM,iBAAA;ATm3KN;ASl3KA;EAAM,gBAAA;ATq3KN;AE17KE;EOwEA;IAAQ,kBAAA;ETs3KR;ESr3KA;IAAQ,iBAAA;ETw3KR;ESv3KA;IAAQ,gBAAA;ET03KR;AACF;ASv3KA;EAAO,mBAAA;AT03KP;ASz3KA;EAAO,sBAAA;AT43KP;AS33KA;EAAO,wBAAA;AT83KP;AS33KA;EAAgB,qBAAA;AT83KhB;AS73KA;EAAgB,0BAAA;ATg4KhB;AS/3KA;EAAsB,wBAAA;ATk4KtB;ASh4KA;EAHgB,0BAAA;ATs4KhB;ASl4KA;EALgB,qBAAA;AT04KhB;ASp4KA;EA9CW,iBAAA;ATq7KX;ASp4KA;EAAa,mBAAA;ATu4Kb;ASt4KA;EAAa,mBAAA;ATy4Kb;ASx4KA;EAAa,gBAAA;AT24Kb;AEz+KE;EOiGA;IALW,mBAAA;ETi5KX;AACF;AE9+KE;EOqGA;IATW,mBAAA;ETs5KX;ES54KA;IATW,mBAAA;ETw5KX;AACF;AS74KA;EAAY,cAAA;ATg5KZ;AS/4KA;EAAY,gBAAA;ATk5KZ;AS/4KA;EAhBa,mBAAA;EAaD,gBAAA;EAMV,uBAAA;ATi5KF;AS74KA;EAAO,0BAAA;ATg5KP;AS/4KA;EAAO,yBAAA;ATk5KP;ASj5KA;EAAO,oBAAA;ATo5KP;ASn5KA;EAAO,yBAAA;ATs5KP;ASn5KA;EAAkB,eAAA;ATs5KlB;ASr5KA;EAAkB,eAAA;ATw5KlB;ASv5KA;EAAkB,eAAA;AT05KlB;AE5/KE;EOqGA;IALgB,eAAA;ETg6KhB;ES15KA;IALgB,eAAA;ETk6KhB;ES55KA;IALgB,eAAA;ETo6KhB;AACF;AS35KA;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;AT65KF;AS15KA;EACE,sBAAA;ET45KA,YAAY;ES35KZ,qBAAA;ET65KA,sBAAsB;ES55KtB,yBAAA;ET85KA,8BAA8B;ES75K9B,iBAAA;AT+5KF;AS55KA;EANE,sBAAA;ETq6KA,YAAY;ESp6KZ,qBAAA;ETs6KA,sBAAsB;ESr6KtB,yBAAA;ETu6KA,8BAA8B;ESt6K9B,iBAAA;ATw6KF;ASl6KA;EAAY,qBAAA;ATq6KZ;ASp6KA;EAAY,sBAAA;ATu6KZ;ASt6KA;EAAY,oBAAA;ATy6KZ;AEjkLE;EO2JA;IALU,qBAAA;ET+6KV;AACF;AEtkLE;EO+JA;IARU,sBAAA;ETm7KV;AACF;AUplLA;EACE,gBAAA;AVslLF;AUvlLA;EAGI,cAAA;EACA,qBAAA;AVulLJ;AU3lLA;EAOI,0BAAA;AVulLJ;AUnlLA;EACE,gCAAA;AVqlLF;AUplLE;EACE,yBAAA;AVslLJ;AUplLE;EACE,yBAAA;AVslLJ;AUplLE;EACE,yBAAA;EACA,qCAAA;AVslLJ;AUllLA;EAEI,cAAA;EACA,qBAAA;AVmlLJ;AUjlLE;EPEkB,wBAAA;EOAhB,kBAAA;AVmlLJ;AU/kLA;EAEM,oBAAA;AVglLN;AU5kLA;ED0BmB,iBAAA;ELknBL,kBAAA;EAxEC,uBAAA;AJ6gKf;AU3kLA;EAEI,aAAA;AV4kLJ;AU9kLA;EAKI,gBAAA;AV4kLJ;AUjlLA;EAQI,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AV4kLJ;AUvlLA;EAcI,cAAA;EACA,qBAAA;AV4kLJ;AU3lLA;;EAkBI,oBAAA;EACA,cAAA;EDCe,iBAAA;EL0rBN,mBAAA;EAAwB,sBAAA;AJq5JrC;AUnmLA;EAwBI,qBAAA;AV8kLJ;AUtmLA;EA2BI,qBAAA;AV8kLJ;AUzmLA;EA8BI,0BAAA;AV8kLJ;AU5mLA;;EAiCI,oBAAA;EN6qBS,mBAAA;EAAwB,sBAAA;AJo6JrC;AUlnLA;ENmoBc,kBAAA;AJk/Jd;AUrnLA;ENmoBc,kBAAA;AJq/Jd;AUxnLA;ENioBc,mBAAA;AJ0/Jd;AU1kLA;ENutBe,qBAAA;EAAyB,sBAAA;EMptBpC,uBAAA;EACA,sBAAA;AV4kLJ;AUhlLA;EAOI,cAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AV4kLJ;AU3kLI;EACE,cAAA;AV6kLN;AUxkLA;EAEI,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AVykLJ;AUxkLI;EACE,cAAA;AV0kLN;AUrkLA;EAEI,kBAAA;EACA,cAAA;EACA,yBAAA;AVskLJ;AUrkLI;EACE,yBAAA;AVukLN;AUrkLI;EACE,yBAAA;AVukLN;AUlkLA;EAEI,qBAAA;AVmkLJ;AU9jLA;EACE,iBAAA;AVgkLF;AU/jLE;EAAA;IACE,aAAA;EVkkLF;AACF;AUjkLE;EAAA;IACE,aAAA;EVokLF;AACF;AUnkLE;EAAA;IACE,aAAA;EVskLF;AACF;AUrkLE;EAAA;IACE,aAAA;EVwkLF;AACF;AUvkLE;EAAA;IACE,aAAA;EV0kLF;AACF;AUzkLE;EAAA;IACE,aAAA;EV4kLF;AACF;AUzkLA;EACE,mBAAA;AV2kLF;AUzkLA;;EACE,WAAA;EACA,YAAA;AV4kLF;AU9kLA;;EAII,WAAA;EACA,YAAA;AV8kLJ;AU5kLE;;EACE,yBAAA;AV+kLJ;AU3kLA;EACE,WAAA;EACA,SAAA;EACA,kBAAA;AV6kLF;AU3kLA;EF7HE,gFAAA;EACA,6EAAA;EACA,4EAAA;EACA,2EAAA;EACA,wEAAA;AR2sLF;AU/kLA;EACE,mBAAA;EACA,0EAAA;EVilLA,+EAA+E;AACjF;AU7kLE;EJyEU,kBAAA;EA4DA,OAAA;EAgEA,aAAA;EAnDD,MAAA;EA2BG,SAAA;EIvKV,WAAA;EJiGI,UAAA;EI/FJ,4EAAA;AV+kLJ;AU7kLE;EJ+DU,kBAAA;EA8CC,QAAA;EA8ED,aAAA;EAnDD,MAAA;EA2BG,SAAA;EI7JV,WAAA;EACA,2EAAA;AV+kLJ;AW1yLA;ERgMwB,yBAAA;AH6mLxB;AW5yLA;EAAyB,uCAAA;AX+yLzB;AW9yLA;EAAyB,uCAAA;AXizLzB;AWhzLA;EAAyB,uCAAA;AXmzLzB;AWlzLA;EAAwB,wCAAA;AXqzLxB;AWpzLA;EAFyB,uCAAA;AXyzLzB;AWtzLA;EAJyB,uCAAA;AX6zLzB;AWtzLI;EACE,uCAAA;AXwzLN;AWpzLA;EAEI,gBAAA;AXqzLJ;AWlzLA;EACE,oCAAA;AXozLF;AWlzLA;ER8BkB,eAAA;EAkKM,yBAAA;AHsnLxB;AW/yLA;EACE,gCAAA;EACA,mCAAA;AXizLF;AYh1LA;EAEI,cAAA;EACA,SAAA;EACA,oCAAA;EACA,oCAAA;EACA,iBAAA;EACA,kBAAA;AZi1LJ;AYx1LA;EAWI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,oBAAA;AZg1LJ;AYj2LA;EAoBM,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AZg1LN;AYx2LA;EA4BM,gBAAA;AZ+0LN;AY32LA;EAiCI,kBAAA;AZ60LJ;AYv0LA;;;EACE,gBAAA;AZ20LF;AYx0LA;;EACE,aAAA;AZ20LF;AYx0LA;EACE,kBAAA;EACA,iBAAA;AZ00LF;AY50LA;EAKI,oBAAA;AZ00LJ;AY/0LA;EASI,kBAAA;EACA,gBAAA;EACA,2BAAA;AZy0LJ;AYp1LA;EAeI,eAAA;AZw0LJ;AYv1LA;EAmBI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,wBAAA;EACA,UAAA;AZu0LJ;AYr0LI;EACE,MAAA;EACA,UAAA;AZu0LN;AYp0LI;EACE,UAAA;EACA,mBAAA;AZs0LN;AYn0LI;EACE,gBAAA;AZq0LN;AY32LA;EA0CM,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,sCAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AZo0LN;AY/3LA;EA8DQ,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AZo0LR;AY74LA;EA4EU,UAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AZo0LV;AYn5LA;EAoFQ,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,eAAA;AZk0LR;AYt6LA;;EAyGQ,WAAA;AZi0LR;AY16LA;;EA4GU,UAAA;EACA,WAAA;AZk0LV;AY/6LA;EAoHI,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AZ8zLJ;AY1zLA;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AZ4zLF;AYn0LA;EAUI,iBAAA;EACA,eAAA;AZ4zLJ;AYv0LA;EAcM,qBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AZ4zLN;AE7+LE;EAAA;IUqLI,kBAAA;IACA,aAAA;EZ4zLJ;EEl/LA;IUyLM,UAAA;IACA,eAAA;EZ4zLN;AACF;AYv1LA;EAgCI,gBAAA;AZ0zLJ;AY11LA;EAmCM,WAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AZ0zLN;AYrzLA;EACE,4BAAA;EHxMI,iBAAA;EG0MJ,cAAA;EACA,gBAAA;AZuzLF;AYpzLA;EACE,qBAAA;AZszLF;AYnzLA;EACE,UAAA;AZqzLF;AaxhMA;EAEI,yBAAA;EACA,UAAA;AbyhMJ;AarhMA;EALI,yBAAA;EACA,UAAA;Ab6hMJ;AazhMA;EAGI,uBAAA;EACA,iBAAA;EACA,YAAA;AbyhMJ;Aa9hMA;EAQI,yBAAA;EACA,iBAAA;EACA,UAAA;AbyhMJ;AarhMA;EACE,WAAA;AbuhMF;AaxhMA;EAGI,YAAA;AbwhMJ;AaphMA;EAEI,MAAA;AbqhMJ;AajhMA;EACE,yCAAA;AbmhMF;AalhME;EACE,yBAAA;AbohMJ;AahhMA;EACE,cAAA;AbkhMF;Ac5jMA;;EAGM,eAAA;Ad6jMN;AcxjMA;;EAGM,eAAA;AdyjMN;AcpjMA;EAEI,aAAA;AdqjMJ;AcjjMA;EAEI,aAAA;AdkjMJ;AACA;;;;;;;;CAQC;AOvkMD;EACE,YAAA;EACA,aAAA;APykMF;AOnkME;;EAEE,YAAA;EACA,cAAA;APqkMJ;AOnkME;EACE,WAAA;APqkMJ;AE3jME;EAAA;IKJE,aAAA;EPmkMF;AACF;AO9jMA;EACE,6BAAA;APgkMF;AO5jMA;EACE;IACE,6BAAA;EP8jMF;AACF;AOzjMA;EACE,aAAA;AP2jMF;AOpjME;EACE,WAAA;EACA,cAAA;EACA,cAAA;APsjMJ;AOhjMA;EACE,eAAA;APkjMF;AO5iMA;EACE,iCAAA;AP8iMF;AOniMA;EEMgB,qBAAA;ATgiMhB;AOjiMA;EACE,aAAA;APmiMF;AO/hMA;EACE,gCAAA;EACA,mCAAA;APiiMF;AOniMA;EAII,aAAA;APkiMJ;AO9hMA;EACI,uCAAA;APgiMJ;AO5hMA;ED6Xa,eAAA;ANkqLb;AO/hMA;EH0MY,cAAA;EAAyB,iBAAA;EAkcxB,aAAA;EAAwB,gBAAA;EA6EtB,iBAAA;EAAmB,kBAAA;EHlxBhC,iBAAA;EACA,oBAAA;EACA,qBAAA;ADimMF;AE9oME;EAAA;ID+CE,oBAAA;IACA,qBAAA;EDmmMF;AACF;AEppME;EAAA;IDmDE,qBAAA;IACA,sBAAA;EDqmMF;AACF;AOhjMA;ED/Ee,cAAA;ANkoMf;AO9iMA;EDqbS,YAAA;EArgBM,aAAA;EA2CQ,sBAAA;ANwlMvB;AO5iMA;EAEI,kBAAA;EACA,uBAAA;AP6iMJ;AEtqME;EK+HA;IACE,cAAA;EP0iMF;AACF;AACA,oDAAoD;AOviMpD;EPyiME,+GAA+G;EOviM/G;IACE,sBAAA;EPyiMF;AACF;AOviMA;EACE,WAAA;APyiMF;AOriMA;EJdqB,cAAA;AHsjMrB;AOpiMA;EH0Qe,SAAA;AJ6xLf;AO/hMA;EACE,qCAAA;APiiMF;AO7hMA;EACE,iBAAA;AP+hMF;AO1hMA;EACE,gBAAA;AP4hMF;AACA;;;;;;;;;;;;;;;;;CAiBC;AejrMD;ETNe,aAAA;EA2EQ,eAAA;ANgnMvB;AerrMA;EArBI,8BAAA;EACA,eAAA;Af6sMJ;Ae3sMI;EX0cW,cAAA;AJowLf;Ae1sMI;EXugBW,eAAA;AJssLf;AezsMI;EX2oBU,aAAA;AJikLd;AexsMI;EXmkBW,gBAAA;AJwoLf;AepsMA;ETPe,aAAA;EA2EQ,eAAA;ANooMvB;AexsMA;EAtBI,8BAAA;EACA,eAAA;AfiuMJ;Ae/tMI;EX0cW,cAAA;AJwxLf;Ae9tMI;EXugBW,eAAA;AJ0tLf;Ae7tMI;EX2oBU,aAAA;AJqlLd;Ae5tMI;EXmkBW,gBAAA;AJ4pLf;AevtMA;ETRe,aAAA;EA2EQ,eAAA;ANwpMvB;Ae3tMA;EAvBI,8BAAA;EACA,eAAA;AfqvMJ;AenvMI;EX0cW,cAAA;AJ4yLf;AelvMI;EXugBW,eAAA;AJ8uLf;AejvMI;EX2oBU,aAAA;AJymLd;AehvMI;EXmkBW,gBAAA;AJgrLf;Ae1uMA;ETTe,aAAA;EA2EQ,eAAA;AN4qMvB;Ae9uMA;EAxBI,8BAAA;EACA,eAAA;AfywMJ;AevwMI;EX0cW,cAAA;AJg0Lf;AetwMI;EXugBW,eAAA;AJkwLf;AerwMI;EX2oBU,aAAA;AJ6nLd;AepwMI;EXmkBW,gBAAA;AJosLf;Ae7vMA;ETVe,aAAA;EA2EQ,eAAA;ANgsMvB;AejwMA;EAzBI,8BAAA;EACA,eAAA;Af6xMJ;Ae3xMI;EX0cW,cAAA;AJo1Lf;Ae1xMI;EXugBW,eAAA;AJsxLf;AezxMI;EX2oBU,aAAA;AJipLd;AexxMI;EXmkBW,gBAAA;AJwtLf;AEhyME;EakBA;ITba,aAAA;IA2EQ,eAAA;ENqtMrB;EenxMA;IA5BE,8BAAA;IACA,eAAA;EfkzMF;EehzME;IX0cW,cAAA;EJy2Lb;Ee/yME;IXugBW,eAAA;EJ2yLb;Ee9yME;IX2oBU,aAAA;EJsqLZ;Ee7yME;IXmkBW,gBAAA;EJ6uLb;EelyMA;ITda,aAAA;IA2EQ,eAAA;ENyuMrB;EetyMA;IA7BE,8BAAA;IACA,eAAA;Efs0MF;Eep0ME;IX0cW,cAAA;EJ63Lb;Een0ME;IXugBW,eAAA;EJ+zLb;Eel0ME;IX2oBU,aAAA;EJ0rLZ;Eej0ME;IXmkBW,gBAAA;EJiwLb;EerzMA;ITfa,aAAA;IA2EQ,eAAA;EN6vMrB;EezzMA;IA9BE,8BAAA;IACA,eAAA;Ef01MF;Eex1ME;IX0cW,cAAA;EJi5Lb;Eev1ME;IXugBW,eAAA;EJm1Lb;Eet1ME;IX2oBU,aAAA;EJ8sLZ;Eer1ME;IXmkBW,gBAAA;EJqxLb;Eex0MA;IThBa,aAAA;IA2EQ,eAAA;ENixMrB;Ee50MA;IA/BE,8BAAA;IACA,eAAA;Ef82MF;Ee52ME;IX0cW,cAAA;EJq6Lb;Ee32ME;IXugBW,eAAA;EJu2Lb;Ee12ME;IX2oBU,aAAA;EJkuLZ;Eez2ME;IXmkBW,gBAAA;EJyyLb;Ee31MA;ITjBa,aAAA;IA2EQ,eAAA;ENqyMrB;Ee/1MA;IAhCE,8BAAA;IACA,eAAA;Efk4MF;Eeh4ME;IX0cW,cAAA;EJy7Lb;Ee/3ME;IXugBW,eAAA;EJ23Lb;Ee93ME;IX2oBU,aAAA;EJsvLZ;Ee73ME;IXmkBW,gBAAA;EJ6zLb;AACF;AEt5ME;Ea0CA;ITrBa,aAAA;IA2EQ,eAAA;EN2zMrB;Eej3MA;IApCE,8BAAA;IACA,eAAA;Efw5MF;Eet5ME;IX0cW,cAAA;EJ+8Lb;Eer5ME;IXugBW,eAAA;EJi5Lb;Eep5ME;IX2oBU,aAAA;EJ4wLZ;Een5ME;IXmkBW,gBAAA;EJm1Lb;Eeh4MA;ITtBa,aAAA;IA2EQ,eAAA;EN+0MrB;Eep4MA;IArCE,8BAAA;IACA,eAAA;Ef46MF;Ee16ME;IX0cW,cAAA;EJm+Lb;Eez6ME;IXugBW,eAAA;EJq6Lb;Eex6ME;IX2oBU,aAAA;EJgyLZ;Eev6ME;IXmkBW,gBAAA;EJu2Lb;Een5MA;ITvBa,aAAA;IA2EQ,eAAA;ENm2MrB;Eev5MA;IAtCE,8BAAA;IACA,eAAA;Efg8MF;Ee97ME;IX0cW,cAAA;EJu/Lb;Ee77ME;IXugBW,eAAA;EJy7Lb;Ee57ME;IX2oBU,aAAA;EJozLZ;Ee37ME;IXmkBW,gBAAA;EJ23Lb;Eet6MA;ITxBa,aAAA;IA2EQ,eAAA;ENu3MrB;Ee16MA;IAvCE,8BAAA;IACA,eAAA;Efo9MF;Eel9ME;IX0cW,cAAA;EJ2gMb;Eej9ME;IXugBW,eAAA;EJ68Lb;Eeh9ME;IX2oBU,aAAA;EJw0LZ;Ee/8ME;IXmkBW,gBAAA;EJ+4Lb;Eez7MA;ITzBa,aAAA;IA2EQ,eAAA;EN24MrB;Ee77MA;IAxCE,8BAAA;IACA,eAAA;Efw+MF;Eet+ME;IX0cW,cAAA;EJ+hMb;Eer+ME;IXugBW,eAAA;EJi+Lb;Eep+ME;IX2oBU,aAAA;EJ41LZ;Een+ME;IXmkBW,gBAAA;EJm6Lb;AACF;AEtgNE;Ea4DA;IT7Ba,aAAA;IA2EQ,eAAA;ENi6MrB;Ee/8MA;IA5CE,8BAAA;IACA,eAAA;Ef8/MF;Ee5/ME;IX0cW,cAAA;EJqjMb;Ee3/ME;IXugBW,eAAA;EJu/Lb;Ee1/ME;IX2oBU,aAAA;EJk3LZ;Eez/ME;IXmkBW,gBAAA;EJy7Lb;Ee99MA;IT9Ba,aAAA;IA2EQ,eAAA;ENq7MrB;Eel+MA;IA7CE,8BAAA;IACA,eAAA;EfkhNF;EehhNE;IX0cW,cAAA;EJykMb;Ee/gNE;IXugBW,eAAA;EJ2gMb;Ee9gNE;IX2oBU,aAAA;EJs4LZ;Ee7gNE;IXmkBW,gBAAA;EJ68Lb;Eej/MA;IT/Ba,aAAA;IA2EQ,eAAA;ENy8MrB;Eer/MA;IA9CE,8BAAA;IACA,eAAA;EfsiNF;EepiNE;IX0cW,cAAA;EJ6lMb;EeniNE;IXugBW,eAAA;EJ+hMb;EeliNE;IX2oBU,aAAA;EJ05LZ;EejiNE;IXmkBW,gBAAA;EJi+Lb;EepgNA;IThCa,aAAA;IA2EQ,eAAA;EN69MrB;EexgNA;IA/CE,8BAAA;IACA,eAAA;Ef0jNF;EexjNE;IX0cW,cAAA;EJinMb;EevjNE;IXugBW,eAAA;EJmjMb;EetjNE;IX2oBU,aAAA;EJ86LZ;EerjNE;IXmkBW,gBAAA;EJq/Lb;EevhNA;ITjCa,aAAA;IA2EQ,eAAA;ENi/MrB;Ee3hNA;IAhDE,8BAAA;IACA,eAAA;Ef8kNF;Ee5kNE;IX0cW,cAAA;EJqoMb;Ee3kNE;IXugBW,eAAA;EJukMb;Ee1kNE;IX2oBU,aAAA;EJk8LZ;EezkNE;IXmkBW,gBAAA;EJygMb;AACF;AACA;;;;;;;;CAQC;AQpnND;EACE,SAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;EACA,4BAAA;ARsnNF;AQ9jNA;EACE,QAAA;EACA,SAAA;EArDA,wCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,gCAAA;ARsnNF;AQhkNA;EACE,SAAA;EA3DA,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;AR8nNF;AQlkNA;EACE,QAAA;EAjEA,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;ARsoNF;AACA;;;;;;EAME;AgBnqNF;EACE,UAAA;EACA,qBAAA;EACA,eAAA;EACA,oCAAA;EACA,0BAAA;EACA,kCAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EAEA,WAAA;EAEA,YAAA;AhBmqNF;AgBjqNA;EACE,YAAA;AhBmqNF;AgBhqNA;EAEE,WAAA;EAEA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ERdA,wCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,gCAAA;AR+qNF;AgBjqNA;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;ERxBA,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;AR4rNF;AgBrqNA;EACE,MAAA;AhBuqNF;AgBrqNA;EACE,QAAA;AhBuqNF;AgBpqNA;EACE,SAAA;AhBsqNF;AACA;;;;;;;;;;CAUC;AiBjuND;EACE,YAAA;AjBmuNF;AEvuNE;EAAA;IIwYU,WAAA;ENm2MV;AACF;AE5uNE;EAAA;IIsYU,WAAA;EN02MV;AACF;AiBnuNA;EXiYY,YAAA;EE/XV,sCAAA;EACA,mCAAA;EACA,iCAAA;EACA,kCAAA;EACA,8BAAA;ARquNF;AiBvuNA;;;ETOE,kCAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;ARquNF;AiB7uNA;;ETLE,uCAAA;EACA,oCAAA;EACA,kCAAA;EACA,mCAAA;EACA,+BAAA;ARsvNF;AiBrvNA;ETLE,yCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,iCAAA;AR6vNF;AiBlvNA;EACE,iBAAA;AjBovNF;AiBhvNA;EACE,eAAA;AjBkvNF;AiB/uNA;ETNE,oBAAA;EACA,iBAAA;EACA,YAAA;ARwvNF;AiB/uNA;EX2NY,kBAAA;EAwUE,gBAAA;EHrjBZ,kCAAA;EACA,+BAAA;EACA,6BAAA;EACA,0BAAA;EGmXU,YAAA;ANo5MZ;AiBnvNE;EAAA;IACE,gBAAA;EjBsvNF;AACF;AiBrvNE;EAAA;IACE,gBAAA;EjBwvNF;AACF;AiBvvNE;EAAA;IACE,gBAAA;EjB0vNF;AACF;AiBzvNE;EAAA;IACE,gBAAA;EjB4vNF;AACF;AiBrvNA;EXiQY,OAAA;EW/PV,gEAAA;AjBuvNF;AiBnvNA;EACE,WAAA;EX8LU,kBAAA;EAyED,MAAA;EAbC,OAAA;EAdC,QAAA;EAsDC,SAAA;EW3RZ,4DAAA;AjBovNF;AiBjvNA;;;ERFgB,qBAAA;ATwvNhB;AiBpvNE;;;EdqHsB,yBAAA;AHooNxB;AiBpvNA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AjBsvNF;AiBnvNA;EAEI,mBAAA;AjBovNJ;AE31NE;Ee6GA;IACE,4BAAA;EjBivNF;AACF;AiB3uNI;EACE,yCAAA;AjB6uNN;AiBxuNA;EACE,yCAAA;AjB0uNF;AiBpuNI;EACE,yCAAA;AjBsuNN;AiBhuNI;EACE,yCAAA;AjBkuNN;AiB5tNI;EACE,yCAAA;AjB8tNN;AiBxtNE;EACE,cAAA;AjB0tNJ;AiBxtNE;EACE,yBAAA;AjB0tNJ;AiBntNA;EACE,WAAA;AjBqtNF;AiBltNA;EACE,oCAAA;AjBotNF;AiBntNE;EACE,oCAAA;AjBqtNJ;AiBntNE;EACE,oCAAA;AjBqtNJ;AiBjtNA;EACE,oCAAA;AjBmtNF;AiBltNE;;EACE,oCAAA;AjBqtNJ;AiBxtNA;EAMI,yBAAA;AjBqtNJ;AiBptNI;EACE,oDAAA;AjBstNN;AiB9tNA;EAWM,yBAAA;AjBstNN;AiBltNA;EAEI,yBAAA;AjBmtNJ;AiBltNI;EACE,oDAAA;AjBotNN;AiBxtNA;EAOM,yBAAA;AjBotNN;AiB/sNA;EACE,oCAAA;AjBitNF;AiBhtNE;;EACE,oCAAA;AjBmtNJ;AiBttNA;EAMI,yBAAA;AjBmtNJ;AiBltNI;EACE,oDAAA;AjBotNN;AiB5tNA;EAWM,yBAAA;AjBotNN;AiBhtNA;EAEI,yBAAA;AjBitNJ;AiBhtNI;EACE,oDAAA;AjBktNN;AiBttNA;EAOM,yBAAA;AjBktNN;AiB7sNA;EACE,oCAAA;AjB+sNF;AiB9sNE;;EACE,oCAAA;AjBitNJ;AiBptNA;EAMI,yBAAA;AjBitNJ;AiBhtNI;EACE,oDAAA;AjBktNN;AiB1tNA;EAWM,yBAAA;AjBktNN;AiB9sNA;EAEI,yBAAA;AjB+sNJ;AiB9sNI;EACE,oDAAA;AjBgtNN;AiBptNA;EAOM,yBAAA;AjBgtNN;AiB1sNE;EACE,qBAAA;AjB4sNJ;AiB1sNE;EACE,qBAAA;AjB4sNJ;AiB1sNE;EACE,qBAAA;AjB4sNJ;AiBtsNA;EA9FE,oCAAA;AjBuyNF;AiBtyNE;;EACE,oCAAA;AjByyNJ;AiB7sNA;EAzFI,yBAAA;AjByyNJ;AiBxyNI;EACE,oDAAA;AjB0yNN;AiBntNA;EApFM,yBAAA;AjB0yNN;AiBrtNA;EApEE,oCAAA;AjB4xNF;AiB3xNE;;EACE,oCAAA;AjB8xNJ;AiB5tNA;EA/DI,yBAAA;AjB8xNJ;AiB7xNI;EACE,oDAAA;AjB+xNN;AiBluNA;EA1DM,yBAAA;AjB+xNN;AiBpuNA;EA1CE,oCAAA;AjBixNF;AiBhxNE;;EACE,oCAAA;AjBmxNJ;AiB3uNA;EArCI,yBAAA;AjBmxNJ;AiBlxNI;EACE,oDAAA;AjBoxNN;AiBjvNA;EAhCM,yBAAA;AjBoxNN;AiBlvNA;EAAqB,yBAAA;AjBqvNrB;AiBpvNA;EAAqB,yBAAA;AjBuvNrB;AiBtvNA;EAAwB,yBAAA;AjByvNxB;AiBvvNA;EACE,oCAAA;AjByvNF;AiBtvNA;EACE,kBAAA;AjBwvNF;AiBpvNA;EACE,cAAA;AjBsvNF;AiBlvNA;EACE,yBAAA;EACA,cAAA;AjBovNF;AiB/uNE;EACE,cAAA;EACA,iBAAA;AjBivNJ;AiB/uNE;EACE,WAAA;AjBivNJ;AiB5uNA;EACE,mBAAA;AjB8uNF;AiB3uNA;EAAqB,yBAAA;AjB8uNrB;AiB7uNA;EAAoB,yBAAA;AjBgvNpB;AiB/uNA;EADoB,yBAAA;AjBmvNpB;AiBjvNA;EAHqB,yBAAA;AjBuvNrB;AiBlvNA;Eb+XS,mBAAA;EA9bD,iBAAA;AJqzNR;AiBjvNA;;EAEE,YAAA;AjBmvNF;AiB9uNA;;;EdpHwB,yBAAA;AHu2NxB;AiB5uNA;;;;EAIE,oCAAA;AjB8uNF;AiBzuNE;;EACE,yBAAA;AjB4uNJ;AiBtuNA;EACE,yBAAA;AjBwuNF;AiBruNA;EACE,yBAAA;AjBuuNF;AiBpuNA;;Ed1LwB,yBAAA;AHk6NxB;AiBnuNE;EACE,yBAAA;AjBquNJ;AiBjuNA;;EdxLwB,yBAAA;AH65NxB;AiBhuNA;;;;EAIE,oCAAA;AjBkuNF;AiB/tNE;EACE,yBAAA;AjBiuNJ;AiB7tNA;;;;EAIE,oCAAA;AjB+tNF;AiB3tNE;EACE,yBAAA;AjB6tNJ;AiBztNA;;EdpOwB,yBAAA;AHi8NxB;AiBxtNE;EACE,yBAAA;AjB0tNJ;AiBttNA;EdhPwB,yBAAA;AHy8NxB;AiBptNE;EACE,yBAAA;AjBstNJ;AiB/sNE;EACE,WAAA;EXjKQ,kBAAA;EAoGE,SAAA;EAxCF,OAAA;EWyGR,WAAA;EXRK,WAAA;EH3YP,kCAAA;EACA,+BAAA;EACA,6BAAA;EACA,0BAAA;AHsmOF;AiBltNE;EXkHO,YAAA;ANmmNT;AiBjtNI;;EdtPoB,yBAAA;AH28NxB;AiB/sNI;;EdjQoB,yBAAA;AHo9NxB;AiB7sNI;;EdzQoB,yBAAA;AH09NxB;AiB3sNI;;EdpRoB,yBAAA;AHm+NxB;AiBzsNI;;EAEE,yBAAA;AjB2sNN;AiBtsNA;EACE,kBAAA;EACA,UAAA;AjBwsNF;AiBvsNE;EACE,YAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EXpNQ,kBAAA;EA9OG,cAAA;EAkWH,QAAA;EAsJL,SAAA;EHvNO,mBAAA;EAwDU,yBAAA;AHwzNxB;AiBpsNE;EACE,cAAA;AjBssNJ;AiBjsNE;EAEI,eAAA;AjBksNN;AiB5rNE;EAEI,eAAA;AjB6rNN;AiBvrNE;EAEI,eAAA;AjBwrNN;AiBlrNE;EAEI,aAAA;AjBmrNN;AiB9qNA;EAEI,cAAA;AjB+qNJ;AiB1qNE;EACE,yBAAA;AjB4qNJ;AiBvqNE;EACE,yBAAA;AjByqNJ;AiBpqNA;EACE,iCAAA;AjBsqNF;AiBpqNA;EACE,uBAAA;AjBsqNF;AiBpqNA;EACE,wBAAA;AjBsqNF;AiBlqNA;;EAEI,gBAAA;AjBoqNJ;AiBhqNA;EACE,iBAAA;EACA,cAAA;EACA,sBAAA;AjBkqNF;AiB/pNA;Ed3XwB,yBAAA;AH6hOxB;AiB9pNA;EdnYwB,yBAAA;AHoiOxB;AiB7pNA;EdjZwB,yBAAA;AHijOxB;AiB5pNA;EdrZwB,yBAAA;AHojOxB;AiB3pNA;Ed3ZwB,yBAAA;AHyjOxB;AiB1pNA;Ed/ZwB,yBAAA;AH4jOxB;AiBzpNA;EdlawB,yBAAA;AH8jOxB;AiBppNE;EAAA;IACE,sBAAA;EjBupNF;AACF;AiBnpNA;EACE,aAAA;AjBqpNF;AiBjpNA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,wBAAA;EACA,mBAAA;AjBmpNF;AiBhpNA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EjBkpNA,qDAAqD;EiBjpNrD,aAAA;EjBmpNA,iCAAiC;EiBlpNjC,8BAAA;EjBopNA,wDAAwD;EiBnpNxD,mBAAA;EACA,iCAAA;EjBqpNA,+BAA+B;EiBnpN/B,cAAA;EACA,QAAA;AjBqpNF;AiBlpNA;EACE,eAAA;AjBopNF;AiBnpNE;EACE,mBAAA;AjBqpNJ;AiBjpNA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AjBmpNF;AiBhpNA;EACE,mBAAA;AjBkpNF;AiB/oNA;EACE,kCAAA;EACA,mCAAA;EACA,gCAAA;AjBipNF;AiB9oNA;EACE,kCAAA;EACA,mCAAA;EACA,6BAAA;AjBgpNF;AiB7oNA;EAEI,gBAAA;EACA,YAAA;EACA,WAAA;AjB8oNJ;AiBlpNA;EAOI,iBAAA;AjB8oNJ;AiB1oNA;EACE,iCAAA;EACA,mBAAA;AjB4oNF;AiBzoNA;EACE;IAAM,UAAA;EjB4oNN;EiB3oNA;IAAI,UAAA;IAAY,aAAA;EjB+oNhB;AACF;AiB5oNA;EACE,cAAA;EbzlBM,kBAAA;AJwuOR;AiB1oNE;EACE,SAAA;EACA,qBAAA;AjB4oNJ;AiBvoNE;EX5pBa,aAAA;ANsyOf;AiBroNA;EXzRS,WAAA;ANi6NT;AEjyOE;EAAA;Ie4pBE,yBAAA;EjByoNF;AACF;AiBroNE;EAAA;;IbsHa,iBAAA;IAAmB,kBAAA;EJqhNhC;AACF;AiBtoNA;EACE;IXnrBa,cAAA;EN4zOb;EiBxoNA;IXjrBa,aAAA;EN4zOb;EiB1oNA;IAAiC,YAAA;EjB6oNjC;AACF;AiB3oNA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AjB6oNF;AiB1oNA;EACE,gBAAA;AjB4oNF;AiBvmNA;EAtBE,kBAAA;EACA,mBAAA;EACA,6BAAA;AjBgoNF;AiB9nNE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AjBgoNJ;AiB7nNE;;EACE,qBAAA;AjBgoNJ;AiB/nNI;;EACE,mBAAA;AjBkoNN;AiB5pNG;;EACC,qBAAA;AjB+pNJ;AiB9pNI;;EACE,mBAAA;AjBiqNN;AiBpqNG;;EACC,qBAAA;AjBuqNJ;AiBtqNI;;EACE,mBAAA;AjByqNN;AiB5qNG;;EACC,qBAAA;AjB+qNJ;AiB9qNI;;EACE,mBAAA;AjBirNN;AiB9oNA;EA7BE,kBAAA;EACA,mBAAA;EACA,6BAAA;AjB8qNF;AiB5qNE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AjB8qNJ;AiB3qNE;;EACE,qBAAA;AjB8qNJ;AiB7qNI;;EACE,mBAAA;AjBgrNN;AiB9pNA;EACE,6BAAA;AjBgqNF;AiB7pNA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AjB+pNF;AACA,+FAA+F;AkB57O/F;EACE,2BAAA;EACA,iBAAA;AlB87OF;AkB37OA;EACE,uBAAA;AlB67OF;AkB17OA;EACE,oBAAA;EACA,4BAAA;AlB47OF;AmBl8OA;EACE,aAAA;AnBo8OF;AmBj8OA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AnBm8OF;AmBh8OA;EnBk8OE,qCAAqC;EmBh8OrC,gBAAA;EACA,yBAAA;EAEA,UAAA;AnBi8OF;AmBt8OA;EAQI,qBAAA;AnBi8OJ;AmBz8OA;EAYI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AnBg8OJ;AmBh9OA;;EAoBI,kBAAA;EACA,UAAA;AnBg8OJ;AmBr9OA;EAyBI,mBAAA;AnB+7OJ;AmBx9OA;EA8BI,UAAA;EACA,SAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AnB67OJ;AmB/9OA;EnBi+OE,yBAAyB;EmB17OvB,kBAAA;EACA,UAAA;AnB47OJ;AmBp+OA;EA4CI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AnB27OJ;AErgPE;EAAA;IiB6EI,WAAA;IACA,gBAAA;IACA,gBAAA;EnB47OJ;AACF;AmB5/OA;;EAoEI,eAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;AnB47OJ;AE1hPE;EAAA;;IiBiGI,aAAA;EnB87OJ;AACF;AmBhhPA;EAsFI,UAAA;AnB67OJ;AmBnhPA;EAyFM,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,oBAAA;EXhGJ,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;AR8hPF;AmBliPA;EAsGI,UAAA;AnB+7OJ;AErjPE;EAAA;IiByHI,aAAA;EnBg8OJ;AACF;AmB1iPA;EA8GI,UAAA;AnB+7OJ;AmB7iPA;EAiHM,kBAAA;EACA,cAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,oBAAA;EXtHJ,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;ARsjPF;AmB1jPA;EA0HQ,kBAAA;EACA,gBAAA;AnBm8OR;AmB9jPA;EAmII,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AnB87OJ;AmBtkPA;EA4II,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;AnB67OJ;AmBz7OM;EAAY,WAAA;AnB47OlB;AmB37OM;EAAY,WAAA;AnB87OlB;AmB77OM;EAAY,WAAA;AnBg8OlB;AmB/7OM;EAAY,WAAA;AnBk8OlB;AmBj8OM;EAAY,WAAA;AnBo8OlB;AmBn8OM;EAAY,WAAA;AnBs8OlB;AmBr8OM;EAAY,WAAA;AnBw8OlB;AmBlmPA;;;EA+JI,8BAAA;AnBw8OJ;AmBvmPA;EnBymPE,UAAU;EmBr8OR,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EXzKF,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;EWuKE,yBAAA;AnB28OJ;AmBtnPA;EA+KI,eAAA;AnB08OJ;AmBn8OI;EACE,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EnBq8OJ,eAAe;EmBn8OX,UAAA;EX5LJ,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;ARkoPF;AmBtoPA;EAwMM,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AnBi8ON;AmB97OI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AnBg8ON;AmBjpPA;EAsNI,YAAA;EACA,gDAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;AnB87OJ;AmBxpPA;EA8NI,aAAA;AnB67OJ;AKroPE;Ec6ME;IAAM,wCAAA;EnB47OR;EmB37OE;IAAQ,0CAAA;EnB87OV;AACF;AK5oPE;Ec4ME;IAAM,wCAAA;EnBo8OR;EmBn8OE;IAAQ,0CAAA;EnBs8OV;AACF;AKnpPE;Ec2ME;IAAM,wCAAA;EnB48OR;EmB38OE;IAAQ,0CAAA;EnB88OV;AACF;AmBnrPA;EnBqrPE,iBAAiB;EQrrPjB,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;ARurPF;AmB3rPA;EnB6rPE,6CAA6C;EmBx8O3C,4BAAA;AnB08OJ;AmB/rPA;;EnBksPE,uGAAuG;EACvG,uCAAuC;EmBv8OrC,cAAA;AnBy8OJ;AmBp8OI;EACE,mBAAA;AnBs8ON;AmBxsPA;EAgRI,kBAAA;AnB27OJ;AmB17OI;EACE,gBAAA;AnB47ON;AmB9sPA;EAwRI,WAAA;EACA,UAAA;EACA,gBAAA;EACA,oDAAA;EACA,kBAAA;AnBy7OJ;AmBx7OI;EACE,UAAA;AnB07ON;AmBxtPA;EA4fI,gBAAA;AnB+tOJ;AmB9tOI;EACE,mBAAA;AnBguON;AmB9tPA;EAmgBI,mBAAA;AnB8tOJ;AmB7tOI;EACE,mBAAA;AnB+tON;AmBpuPA;;EA2gBI,WAAA;EACA,UAAA;AnB6tOJ;AmBzuPA;;EAwSI,sBAAA;EACA,qBAAA;EACA,2BAAA;AnBq8OJ;AmB/uPA;;;EAiTI,WAAA;EACA,UAAA;AnBm8OJ;AmBrvPA;EAqTI,cAAA;EACA,aAAA;AnBm8OJ;AmBzvPA;;;;;EA2TI,WAAA;EACA,UAAA;EACA,qLAAA;AnBq8OJ;AmBlwPA;EAoUI,mBAAA;EACA,kBAAA;AnBi8OJ;AmBh8OI;EACE,UAAA;AnBk8ON;AmBh8OI;EACE,mBAAA;AnBk8ON;AmB5wPA;EA+UI,mBAAA;EACA,kBAAA;AnBg8OJ;AmB/7OI;EACE,UAAA;AnBi8ON;AmB/7OI;EACE,mBAAA;AnBi8ON;AmBtxPA;EA0VI,mBAAA;EACA,kBAAA;AnB+7OJ;AmB97OI;EACE,UAAA;AnBg8ON;AmB97OI;EACE,mBAAA;AnBg8ON;AmBhyPA;EAqWI,mBAAA;EACA,mBAAA;AnB87OJ;AmB77OI;EACE,UAAA;AnB+7ON;AmB77OI;EACE,mBAAA;AnB+7ON;AmB1yPA;EAgXI,mBAAA;EACA,mBAAA;AnB67OJ;AmB57OI;EACE,WAAA;AnB87ON;AmB57OI;EACE,mBAAA;AnB87ON;AmBpzPA;EA2XI,kBAAA;AnB47OJ;AmBvzPA;;EA+XI,kBAAA;AnB47OJ;AmB3zPA;;EAmYI,8BAAA;EACA,cAAA;EACA,aAAA;AnB47OJ;AmBj0PA;;EAwYM,cAAA;EACA,aAAA;AnB67ON;AmBt0PA;;EA+YM,oCAAA;AnB27ON;AmBt7OI;;EACE,aAAA;AnBy7ON;AmB90PA;EAyZM,SAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EX9ZJ,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;EW4ZI,sBAAA;AnB47ON;AmB51PA;EAsaI,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AnBy7OJ;AEl3PE;EAAA;IiB4bI,qBAAA;EnB07OJ;AACF;AmBv2PA;;EAgbM,eAAA;AnB27ON;AmB32PA;EnB62PE,uEAAuE;EQp2PvE,kCAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;ARs2PF;AmBl2OA;EArBI,mBAAA;AnB03OJ;AmBz3OI;EACE,mBAAA;AnB23ON;AmBx2OA;EAdI,mBAAA;AnBy3OJ;AmBx3OI;EACE,mBAAA;AnB03ON;AmB92OA;;EANI,WAAA;EACA,UAAA;AnBw3OJ;AmB/2OA;EAEI,wBAAA;AnBg3OJ;AmBl3OA;EAKI,0BAAA;AnBg3OJ;AmB32OA;;EAII,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AnB22OJ;AmB12OI;;EACE,gBAAA;AnB62ON;AmBv3OA;EAgBI,aAAA;AnB02OJ;AmB13OA;EAoBI,WAAA;EACA,UAAA;AnBy2OJ;AmBr2OA;EnBu2OE;;;;;;;sBAOoB;EmBr2OpB,uBAAA;EACA,YAAA;EnBu2OA,kCAAkC;AACpC;AmBl3OA;EAsBM,6BAAA;EACA,WAAA;EACA,SAAA;EXhlBJ,wCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,gCAAA;ARg7PF;AmB53OA;EA4BM,aAAA;AnBm2ON;AmBj2OI;EACE,wBAAA;AnBm2ON;AmBl4OA;EAoCI,aAAA;AnBi2OJ;AE78PE;EAAA;IiB+mBI,aAAA;EnBk2OJ;AACF;AmB14OA;EA4CI,oBAAA;AnBi2OJ;AmB74OA;EAgDI,WAAA;EACA,SAAA;AnBg2OJ;AmBj5OA;EAoDM,2CAAA;AnBg2ON;AmBp5OA;EAyDI,WAAA;EnB81OF;;;;;6EAK2E;EmB51OzE,kBAAA;EnB81OF;aACW;AACb;AmBh6OA;EAsEI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;AnB61OJ;AmB11OE;EnB41OA,yCAAyC;AAC3C;AmB71OE;EnB+1OA;oBACkB;EQz+PlB,uCAAA;EACA,oCAAA;EACA,kCAAA;EACA,mCAAA;EACA,+BAAA;EW6oBI,oBAAA;AnB+1ON;AmBv2OE;EAWM,cAAA;AnB+1OR;AEj9PE;EAAA;IMlCA,uCAAA;IACA,oCAAA;IACA,kCAAA;IACA,mCAAA;IACA,+BAAA;ERu/PA;AACF;AEr9PE;EAAA;IiBqnBM,mBAAA;IX5pBN,uCAAA;IACA,oCAAA;IACA,kCAAA;IACA,mCAAA;IACA,+BAAA;ERigQA;EE99PA;IiBynBQ,aAAA;EnBw2OR;AACF;AEzhQE;EAAA;IMgBA,uCAAA;IACA,oCAAA;IACA,kCAAA;IACA,mCAAA;IACA,+BAAA;ER6gQA;AACF;AEliQE;EAAA;IMgBA,uCAAA;IACA,oCAAA;IACA,kCAAA;IACA,mCAAA;IACA,+BAAA;ERshQA;AACF;AmB/2OE;EACE,2BAAA;EACA,oBAAA;AnBi3OJ;AmBn3OE;EAKI,WAAA;EACA,YAAA;EXlrBJ,sCAAA;EACA,mCAAA;EACA,iCAAA;EACA,kCAAA;EACA,8BAAA;ARoiQF;AmBh/OA;EX/iBE,gCAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;ARkiQF;AmBv/OA;EAqII,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AnBq3OJ;AmB7/OA;EA2IM,gBAAA;EACA,mBAAA;AnBq3ON;AEzkQE;EAAA;IiButBM,gBAAA;IACA,mBAAA;EnBs3ON;AACF;AmBvgPA;EAsJI,gBAAA;AnBo3OJ;AmB1gPA;EA0JI,UAAA;AnBm3OJ;AEniQE;EiByrBA;;IACE,2BAAA;EnB82OF;EmB/2OA;;IAII,UAAA;IACA,YAAA;IXhuBJ,sCAAA;IACA,mCAAA;IACA,iCAAA;IACA,kCAAA;IACA,8BAAA;ERglQA;AACF;AmB72OA;EACE,+BAAA;EACA,2BAAA;AnB+2OF;AmB52OA;EACE,4BAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AnB82OF;AE/mQE;EAAA;IiBowBE,gBAAA;IACA,yBAAA;EnB+2OF;AACF;AmB12OA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;AnB42OF;AmB/2OA;EAMI,SAAA;AnB42OJ;AmBl3OA;EAUI,SAAA;EACA,UAAA;EACA,YAAA;AnB22OJ;AmBz2OI;EACE,iBAAA;EACA,eAAA;AnB22ON;AmBz2OM;;EACE,aAAA;AnB42OR;AmB/3OA;EAyBI,0BAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;AnBy2OJ;AmBt4OA;EAiCI,cAAA;EACA,SAAA;AnBw2OJ;AmB14OA;EAsCI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;AnBu2OJ;AmBn5OA;EA+CM,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AnBu2ON;AmBz5OA;EAsDM,eAAA;EACA,sBAAA;AnBs2ON;AmB75OA;EA2DM,qBAAA;EACA,WAAA;EACA,UAAA;AnBq2ON;AmBl6OA;EAkEI,WAAA;EACA,UAAA;AnBm2OJ;AmBt6OA;EAuEI,kBAAA;AnBk2OJ;AmBz6OA;EA2EI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,MAAA;EACA,kCAAA;EACA,UAAA;EACA,6BAAA;AnBi2OJ;AmBp7OA;EAuFI,sCAAA;AnBg2OJ;AmBv7OA;EA2FI,kCAAA;AnB+1OJ;AmB71OI;EACE,8BAAA;AnB+1ON;AmB77OA;EAmGI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,sCAAA;EACA,UAAA;EACA,6BAAA;AnB61OJ;AmBx8OA;EA+GI,yBAAA;AnB41OJ;AmBv1OE;EACE,WAAA;EACA,cAAA;AnBy1OJ;AmBv1OE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AnBy1OJ;AoBzuQA;EpB2uQE,wCAAwC;EACxC,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,uCAAuC;EACvC,4BAA4B;EAC5B,4CAA4C;EAC5C,mBAAmB;AACrB;AoBlvQE;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ApBovQJ;AoB5vQE;EAeI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EZcJ,yCAAA;EACA,sCAAA;EACA,qCAAA;EACA,oCAAA;EACA,iCAAA;ARmuQF;AoBzwQE;EAwBM,8BAAA;EACA,WAAA;ApBovQR;AoB7wQE;EA4BQ,cAAA;EACA,gCAAA;EACA,cAAA;ApBovQV;AoBjvQQ;EACE,cAAA;ApBmvQV;AoBrxQE;EAuCM,mBAAA;EACA,iBAAA;ApBivQR;AoBzxQE;EA2CM,mBAAA;ApBivQR;AoB5xQE;EA8CM,mBAAA;ApBivQR;AoB/xQE;EAiDM,mBAAA;ApBivQR;AoBlyQE;EAoDM,mBAAA;ApBivQR;AoBryQE;EAuDM,mBAAA;ApBivQR;AoBxyQE;EA+DM,kBAAA;ApB4uQR;AoB5yQA;EAsEI,cAAA;EACA,gBAAA;EACA,cAAA;ApByuQJ;AoBjzQA;EA2EM,WAAA;EACA,gBAAA;ApByuQN;AoBtuQI;EACE,2CAAA;ApBwuQN;AoBtuQM;EACE,iBAAA;EACA,mBAAA;ApBwuQR;AoBtuQM;EACE,iBAAA;EACA,mBAAA;ApBwuQR;AoBtuQM;EACE,iBAAA;EACA,mBAAA;ApBwuQR;AoBtuQM;EACE,iBAAA;EACA,mBAAA;ApBwuQR;AoBtuQM;EACE,iBAAA;EACA,mBAAA;ApBwuQR;AoBtuQM;EACE,iBAAA;EACA,mBAAA;ApBwuQR;AoBh1QA;EA6GM,cAAA;ApBsuQN;AoBn1QA;EAiHM,qCAAA;ApBquQN;AoBt1QA;EAqHM,cAAA;EACA,gBAAA;EACA,iBAAA;ApBouQN;AoB31QA;EA0HQ,cAAA;ApBouQR;AoB91QA;EA6HQ,cAAA;EACA,cAAA;EhBoPA,qBAAA;EAA0B,sBAAA;AJk/PlC;AoBjuQI;EACE,eAAA;ApBmuQN;AoBv2QA;EAyII,2CAAA;ApBiuQJ;AoB12QA;EA6II,aAAA;EACA,sBAAA;ApBguQJ;AoB92QA;EAkJI,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;ApB+tQJ;AoBt3QA;EA0JM,cAAA;ApB+tQN;AoB9tQM;EACE,qBAAA;ApBguQR;AEl3QE;EAAA;IkBuJI,gBAAA;EpB+tQJ;AACF;AEv3QE;EAAA;IkB0JI,gBAAA;EpBiuQJ;AACF;AoBt4QA;EAwKM,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;ApBiuQN;AoB94QA;EAgLQ,cAAA;EACA,sBAAA;ApBiuQR;AoBl5QA;;EAsLQ,qBAAA;EACA,eAAA;ApBguQR;AoBv5QA;EA2LQ,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;ApB+tQR;AoB75QA;EAkMQ,WAAA;EACA,UAAA;ApB8tQR;AoBj6QA;EAuMQ,mBAAA;ApB6tQR;AoB5tQQ;EACE,YAAA;ApB8tQV;AoBv6QA;EA8MQ,iBAAA;ApB4tQR;AoB16QA;EAoNI,WAAA;ApBytQJ;AoB76QA;EAuNM,mBAAA;ApBytQN;AoBxtQM;EACE,UAAA;EACA,mBAAA;ApB0tQR;AoB5tQM;EAKI,cAAA;ApB0tQV;AoBv7QA;EAmOM,sBAAA;ApButQN;AoB17QA;EAwOI,YAAA;ApBqtQJ;AoB77QA;EA0OM,qBAAA;ApBstQN;AoBh8QA;EA+OI,SAAA;EACA,eAAA;ApBotQJ;AoBjtQE;EACE,WAAA;EACA,yBAAA;ApBmtQJ;AoBrtQE;EAKI,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;ApBmtQN;AEx4QE;EAAA;IkBwLM,UAAA;EpBotQN;AACF;AoBjuQE;EAgBM,eAAA;EACA,gBAAA;ApBotQR;AoBruQE;EA4BI,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ApB4sQN;AEv9QE;EAAA;IkB8QM,gBAAA;IACA,gBAAA;EpB6sQN;EE59QA;IkBkRQ,cAAA;EpB6sQR;EE/9QA;IkBqRQ,kBAAA;EpB6sQR;AACF;AoB1vQE;EAkDQ,sBAAA;EACA,eAAA;ApB2sQV;AoBzsQU;EACE,qBAAA;ApB2sQZ;AoBxsQU;EACE,cAAA;EACA,gBAAA;ApB0sQZ;AoBrwQE;EAiEM,aAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;ApBusQR;AoBngRA;EAkUI,gBAAA;EACA,gBAAA;EACA,eAAA;ApBosQJ;AE9/QE;EAAA;IkB6TI,eAAA;IACA,gBAAA;EpBqsQJ;AACF;AoB9gRA;EA6UI,gBAAA;ApBosQJ;AoBjhRA;EAgVM,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;ApBosQN;AoBlsQM;EACE,qBAAA;ApBosQR;AEjhRE;EAAA;IkBkVI,gBAAA;EpBmsQJ;AACF;AoBhiRA;EAiWI,cAAA;ApBksQJ;AoBniRA;EAoWM,gBAAA;ApBksQN;AoBtiRA;EAwWM,cAAA;EACA,cAAA;EACA,0BAAA;ApBisQN;AoB3iRA;EA8WM,mBAAA;ApBgsQN;AoB9iRA;EAkXM,kBAAA;ApB+rQN;AoBjjRA;EAqXM,kBAAA;ApB+rQN;AoBpjRA;EAwXM,kBAAA;ApB+rQN;AoBvjRA;EA2XM,kBAAA;ApB+rQN;AoB1jRA;EA8XM,kBAAA;ApB+rQN;AoB7jRA;EAiYM,kBAAA;ApB+rQN;AEtjRE;EAAA;IkB2XsB,iBAAA;EpB+rQtB;EE1jRA;IkB4XsB,iBAAA;EpBisQtB;EE7jRA;IkB6XsB,mBAAA;IAAqB,gBAAA;EpBosQ3C;EEjkRA;IkB8XsB,iBAAA;EpBssQtB;EEpkRA;IkB+XsB,mBAAA;EpBwsQtB;EEvkRA;IkBgYsB,iBAAA;EpB0sQtB;AACF;AoBrlRA;;EAiZM,kBAAA;EACA,mBAAA;ApBwsQN;AoB1lRA;EAwZI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;ApBqsQJ;AoBnmRA;EAiaM,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;ApBqsQN;AoBlsQI;EACE,mBAAA;EACA,cAAA;EACA,cAAA;ApBosQN;AoBvsQI;EAKI,cAAA;ApBqsQR;AoBjsQI;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;ApBmsQN;AoBhsQI;EACE,sBAAA;EACA,cAAA;EACA,gCAAA;EACA,gBAAA;ApBksQN;AoBhsQI;EACE,sBAAA;EACA,cAAA;EACA,gCAAA;EACA,gBAAA;ApBksQN;AoBhsQI;EACE,sBAAA;EACA,cAAA;EACA,cAAA;ApBksQN;AoBhsQI;EACE,sBAAA;EACA,cAAA;EACA,cAAA;ApBksQN;AEroRE;EkBucI;IACE,cAAA;EpBisQN;EoB9rQI;IACE,gBAAA;EpBgsQN;EoB7rQI;IACE,gBAAA;EpB+rQN;EoB7rQI;IACE,gBAAA;EpB+rQN;EoB7rQI;IACE,gBAAA;EpB+rQN;EoB7rQI;IACE,gBAAA;EpB+rQN;AACF;AoBnqRA;EAyeI,UAAA;ApB6rQJ;AoB1rQE;EACE,eAAA;ApB4rQJ;AoBzqRA;;;EAqfM,iBAAA;EACA,eAAA;ApByrQN;AoB/qRA;;;EA2fM,YAAA;ApByrQN;AoBprRA;EAggBI,YAAA;ApBurQJ;AoBvrRA;;EAsgBI,yBAAA;ApBqrQJ;AoB3rRA;EA2gBI,sBAAA;EACA,cAAA;ApBmrQJ;AoB/rRA;;;;EAohBI,cAAA;ApBirQJ;AoBrsRA;EAwhBI,gBAAA;EACA,iBAAA;EACA,wBAAA;ApBgrQJ;AoB1sRA;EA8hBI,gBAAA;EACA,iBAAA;ApB+qQJ;AoB9sRA;EAmiBI,gBAAA;EACA,iBAAA;ApB8qQJ;AoBltRA;EAwiBI,gBAAA;EACA,iBAAA;ApB6qQJ;AoBttRA;EA6iBI,gBAAA;EACA,iBAAA;ApB4qQJ;AoB1tRA;EAkjBI,cAAA;EACA,iBAAA;ApB2qQJ;AoB9tRA;EAujBI,cAAA;ApB0qQJ;AoBjuRA;EA2jBI,iBAAA;ApByqQJ;AoBvqQI;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;ApByqQN;AoBvqQM;EACE,yCAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;ApByqQR;AoBlvRA;EA8kBM,yCAAA;ApBuqQN;AoBhqQM;EACE,mBAAA;ApBkqQR;AoBjqQQ;EACE,aAAA;ApBmqQV;AoB3vRA;EA6lBQ,aAAA;ApBiqQR;AoB9vRA;EAmmBI,yBAAA;ApB8pQJ;AoBjwRA;EAumBI,uBAAA;ApB6pQJ;AoBpwRA;EA4mBI,0BAAA;ApB2pQJ;AE7vRE;EAAA;IkBqmBI,4BAAA;EpB4pQJ;AACF;AoB1pQI;EACE,gCAAA;ApB4pQN;AoBzpQI;EACE,mBAAA;ApB2pQN;AExwRE;EAAA;IkB+mBM,iBAAA;EpB6pQN;AACF;AoBjqQI;EAOI,mBAAA;EACA,kBAAA;ApB6pQR;AoB1pQI;EACE,kBAAA;ApB4pQN;AEpxRE;EAAA;IkB0nBM,gBAAA;EpB8pQN;AACF;AoB3pQI;EACE,mBAAA;ApB6pQN;AoB1pQI;EACE,eAAA;ApB4pQN;AoBzpQI;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;ApB2pQN;AoB9yRA;;EA4pBM,eAAA;EACA,cAAA;EACA,eAAA;ApBspQN;AE1yRE;EAAA;;IkBupBM,cAAA;EpBwpQN;AACF;AoB1zRA;EAuqBI,gBAAA;ApBspQJ;AoB7zRA;EA+qBI,kBAAA;ApBipQJ;AoBh0RA;;EAorBI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;ApBgpQJ;AoBz0RA;;;;EA6rBM,kBAAA;EACA,MAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;ApBkpQN;AoBt1RA;;;;EAusBQ,kBAAA;EACA,YAAA;ApBqpQR;AoB71RA;;;;EA2sBQ,kBAAA;EACA,YAAA;ApBwpQR;AoBp2RA;;;;EA+sBQ,kBAAA;EACA,YAAA;ApB2pQR;AoBvpQI;;EjBhhBoB,yBAAA;EiBkhBlB,oBAAA;ApB0pQN;AEt2RE;EAAA;;IkBgtBI,mBAAA;EpB2pQJ;EE32RA;;;;IkBmtBM,OAAA;EpB8pQN;EEj3RA;;;;IkBstBQ,kBAAA;IACA,YAAA;EpBiqQR;EEx3RA;;;;IkB0tBQ,kBAAA;IACA,YAAA;EpBoqQR;EE/3RA;;;;IkB8tBQ,kBAAA;IACA,YAAA;EpBuqQR;AACF;AoBj5RA;EAivBI,kBAAA;ApBmqQJ;AoBp5RA;EAmvBM,cAAA;ApBoqQN;AoBv5RA;EAwvBI,cAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EAEA,8BAAA;ApBiqQJ;AoB95RA;EAgwBM,iBAAA;EACA,oBAAA;ApBiqQN;AoBl6RA;EAowBM,mBAAA;EACA,kBAAA;ApBiqQN;AoBt6RA;EAwwBQ,iBAAA;ApBiqQR;AoBz6RA;EA2wBQ,cAAA;ApBiqQR;AoB/pQM;EACE,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;ApBiqQR;AoBl7RA;;;;EAyxBM,mBAAA;EACA,kBAAA;ApB+pQN;AoB7pQM;;;;EACE,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;ApBkqQR;AoBl8RA;EAqyBM,cAAA;ApBgqQN;AoBr8RA;EA0yBI,iBAAA;EACA,kBAAA;ApB8pQJ;AoBz8RA;EA8yBM,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;ApB8pQN;AoBj9RA;EAwzBI,cAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;ApB4pQJ;AoBv9RA;EA8zBM,kBAAA;ApB4pQN;AoB19RA;EAk0BM,mBAAA;EACA,kBAAA;ApB2pQN;AoBzpQM;EACE,eAAA;ApB2pQR;AoBj+RA;EA40BI,gCAAA;ApBwpQJ;AoBp+RA;EAg1BI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EpBupQF,KAAK;EoBtpQH,gBAAA;EACA,gCAAA;ApBwpQJ;AoB/+RA;EA01BM,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;ApBwpQN;AoBr/RA;EAi2BM,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;ApBupQN;AoB3/RA;;EAy2BM,kBAAA;ApBspQN;AEr/RE;EAAA;;IkBk2BM,kBAAA;EpBwpQN;AACF;AoBrgSA;EAi3BM,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;ApBupQN;AoB3gSA;EAu3BQ,cAAA;EACA,cAAA;ApBupQR;AoB/gSA;EA+3BM,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;ApBmpQN;AoBrhSA;EAs4BM,mBAAA;EACA,mBAAA;ApBkpQN;AoBjpQM;EACE,mBAAA;ApBmpQR;AoBjpQM;EACE,mBAAA;ApBmpQR;AErhSE;EAAA;IkBw4BM,kBAAA;EpBipQN;EEzhSA;IkB24BM,iBAAA;EpBipQN;EE5hSA;IkB84BM,cAAA;EpBipQN;AACF;AoB3oQI;;EACE,kBAAA;ApB8oQN;AoB9iSA;EAu6BI,kBAAA;ApB0oQJ;AoBjjSA;EA26BI,cAAA;EAEA,qBAAA;ApBwoQJ;AoBrjSA;EAi7BM,eAAA;ApBuoQN;AoBroQM;EACE,gBAAA;ApBuoQR;AoB3jSA;EAy7BM,4BAAA;EACA,iBAAA;EACA,kBAAA;ApBqoQN;AoBhkSA;EA67BQ,4BAAA;ApBsoQR;AoBnkSA;EAm8BM,gBAAA;EAIA,eAAA;EACA,mBAAA;ApBgoQN;AoBxkSA;;;EA+8BI,gBAAA;EACA,cAAA;EAEA,cAAA;ApB6nQJ;AoB/kSA;EAs9BI,iCAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,eAAA;ApB4nQJ;AoBtlSA;;EAk+BM,aAAA;ApBwnQN;AoB1lSA;EAs+BM,mBAAA;ApBunQN;AoB7lSA;EA2+BI,WAAA;ApBqnQJ;AoBhmSA;EA8+BM,YAAA;EACA,qBAAA;ApBqnQN;AoBpmSA;EAm/BM,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;ApBonQN;AoB1mSA;EAmgCI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;ApB0mQJ;AoBtnSA;EAghCQ,gBAAA;EACA,mBAAA;ApBymQR;AoB1nSA;EAqhCQ,gBAAA;EACA,iBAAA;ApBwmQR;AoB9nSA;EAyhCQ,gBAAA;EACA,iBAAA;ApBwmQR;AoBloSA;EA6hCQ,gBAAA;EACA,gBAAA;ApBwmQR;AoBtoSA;EAmiCM,mBAAA;ApBsmQN;AoBzoSA;EAqiCQ,mBAAA;EACA,qBAAA;ApBumQR;AEnoSE;EAAA;IkBiiCI,QAAA;EpBsmQJ;AACF;AoBlpSA;;EAijCI,gBAAA;ApBqmQJ;AoBtpSA;EAqjCI,mBAAA;EACA,iCAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,eAAA;ApBomQJ;AoBlmQI;EACE,kBAAA;ApBomQN;AEvpSE;EAAA;IkBsjCM,mBAAA;EpBqmQN;AACF;AoBtqSA;;;EAwkCI,cAAA;EACA,eAAA;ApBmmQJ;AoBjmQI;;;EACE,0BAAA;ApBqmQN;AoBjrSA;EAilCI,kBAAA;ApBmmQJ;AoBprSA;EAqlCI,kBAAA;ApBkmQJ;AoBvrSA;EAylCI,cAAA;ApBimQJ;AoB1rSA;;;EA+lCI,aAAA;EACA,kBAAA;ApBgmQJ;AoBhsSA;EAomCI,iBAAA;ApB+lQJ;AoBnsSA;EAwmCI,gBAAA;ApB8lQJ;AoBtsSA;;EA6mCI,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ApB6lQJ;AEtsSE;EAAA;IFysSE,cAAc;EAChB;EE1sSA;;IkB8mCI,gBAAA;EpBgmQJ;EE9sSA;IkBmnCM,gBAAA;EpB8lQN;EEjtSA;IkBsnCM,gBAAA;EpB8lQN;EEptSA;IkBynCM,gBAAA;EpB8lQN;EEvtSA;IkB4nCM,gBAAA;EpB8lQN;EE1tSA;IkB+nCM,gBAAA;EpB8lQN;EE7tSA;IkBooCI,iBAAA;IACA,mBAAA;IACA,gBAAA;EpB4lQJ;EEluSA;IkB0oCI,iBAAA;IACA,mBAAA;EpB2lQJ;EEtuSA;IkB+oCI,mBAAA;IACA,oBAAA;IACA,kBAAA;EpB0lQJ;EoBtlQE;IAEE,0BAAA;EpBulQJ;AACF;AoBzvSA;EAsqCI,eAAA;ApBslQJ;AElvSE;EAAA;IkB8pCI,eAAA;EpBwlQJ;AACF;AEvvSE;EAAA;IkBsqCI,kBAAA;EpBqlQJ;EE3vSA;IkB8qCI,mBAAA;EpBglQJ;EE9vSA;IkBgrCM,mBAAA;EpBilQN;AACF;AoB5kQE;EAEI,gBAAA;EACA,iBAAA;EACA,cAAA;ApB6kQN;AoBjxSA;EAysCI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;ApB2kQJ;AoBvxSA;EAgtCI,gBAAA;ApB0kQJ;AoB1xSA;;EAstCI,qBAAA;EACA,yBAAA;EACA,gBAAA;ApBwkQJ;AoBhySA;EA4tCI,gBAAA;EACA,mBAAA;ApBukQJ;AoBpySA;EAiuCI,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,iCAAA;ApBskQJ;AoB3ySA;EAyuCI,mBAAA;ApBqkQJ;AoBjkQA;EACE,uBAAA;ApBmkQF;AoBhkQA;;EAEE,cAAA;EACA,aAAA;ApBkkQF;AoBjkQE;;EACE,cAAA;EACA,aAAA;ApBokQJ;AoBjkQA;;EAEE,cAAA;EACA,aAAA;ApBmkQF;AoBlkQE;;EACE,cAAA;EACA,aAAA;ApBqkQJ;AoBlkQA;;EAEE,cAAA;EACA,aAAA;ApBokQF;AoBnkQE;;EACE,cAAA;EACA,aAAA;ApBskQJ;AoBnkQA;;EAEE,cAAA;EACA,aAAA;ApBqkQF;AoBpkQE;;EACE,cAAA;EACA,aAAA;ApBukQJ;AoBnkQA;EACE,cAAA;EACA,aAAA;ApBqkQF;AoBpkQE;EACE,cAAA;EACA,aAAA;ApBskQJ;AoBlkQA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;ApBokQF;AoBxkQA;EAOI,qBAAA;EACA,sBAAA;ApBokQJ;AoB5kQA;EAYI,WAAA;ApBmkQJ;AoB/kQA;EAgBI,2BAAA;EACA,mBAAA;ApBkkQJ;AoB/jQE;EACE,cAAA;ApBikQJ;AoB/jQE;EACE,cAAA;ApBikQJ;AoB/jQE;EACE,cAAA;ApBikQJ;AoB7jQA;EACE,gBAAA;ApB+jQF;AoBhkQA;EAII,gBAAA;EACA,gBAAA;EACA,gBAAA;EZjyCF,gCAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;ARi2SF;AoB1kQA;EAUM,SAAA;ApBmkQN;AoB7kQA;EAcM,eAAA;ApBkkQN;AEp4SE;EAAA;IkBs0CI,cAAA;IACA,+BAAA;EpBkkQJ;AACF;AoBhkQI;EACE,UAAA;ApBkkQN;AoBjkQM;EACE,UAAA;ApBmkQR;AoB7jQA;;EAGI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;ApB8jQJ;AoBrkQA;;;;;;;;;;EAcI,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;ApBmkQJ;AoBrlQA;;;;EAsBI,qBAAA;ApBqkQJ;AoB3lQA;;;;EA2BI,kBAAA;ApBskQJ;AoBjmQA;;EA+BI,4BAAA;ApBskQJ;AoBlkQA;EACE,oBAAA;ApBokQF;AqBh6SA;EACE,qBAAA;EACA,cAAA;ArBk6SF;AqBp6SA;EAII,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;ArBm6SJ;AqB16SA;EASM,oBAAA;ArBo6SN;AqB76SA;EAYM,aAAA;ArBo6SN;AqB/5SA;EACE,kBAAA;EACA,YAAA;ArBi6SF;AqBn6SA;EAII,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;ArBk6SJ;AqB95SA;EACE,WAAA;EACA,cAAA;EACA,oBAAA;ArBg6SF;AACA,oCAAoC","sourcesContent":["@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('sourcesanspro_regular.woff') format('woff'), url('sourcesanspro_regular.ttf') format('ttf');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('sourcesanspro_italic.woff') format('woff'), url('sourcesanspro_italic.ttf') format('ttf');\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('sourcesanspro_light.woff') format('woff'), url('sourcesanspro_light.ttf') format('ttf');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('sourcesanspro_light_italic.woff') format('woff'), url('sourcesanspro_light_italic.ttf') format('ttf');\n  font-weight: 300;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('sourcesanspro_semibold.woff') format('woff'), url('sourcesanspro_semibold.ttf') format('ttf');\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('sourcesanspro_semibold_italic.woff') format('woff'), url('sourcesanspro_semibold_italic.ttf') format('ttf');\n  font-weight: 600;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('sourcesanspro_bold.woff') format('woff'), url('sourcesanspro_bold.ttf') format('ttf');\n  font-weight: 800;\n  font-style: normal;\n}\n","@import '../../node_modules/normalize.css/normalize.css';\n@import '../../node_modules/react-toastify/dist/ReactToastify.css';\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_regular.woff') format('woff'), url('config/fonts/sourcesanspro_regular.ttf') format('ttf');\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_italic.woff') format('woff'), url('config/fonts/sourcesanspro_italic.ttf') format('ttf');\n  font-weight: 400;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_light.woff') format('woff'), url('config/fonts/sourcesanspro_light.ttf') format('ttf');\n  font-weight: 300;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_light_italic.woff') format('woff'), url('config/fonts/sourcesanspro_light_italic.ttf') format('ttf');\n  font-weight: 300;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_semibold.woff') format('woff'), url('config/fonts/sourcesanspro_semibold.ttf') format('ttf');\n  font-weight: 600;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_semibold_italic.woff') format('woff'), url('config/fonts/sourcesanspro_semibold_italic.ttf') format('ttf');\n  font-weight: 600;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Source Sans Pro\";\n  src: url('config/fonts/sourcesanspro_bold.woff') format('woff'), url('config/fonts/sourcesanspro_bold.ttf') format('ttf');\n  font-weight: 800;\n  font-style: normal;\n}\n/*\n\n  Variables\n  ---------\n\n  Define variables.\n\n*/\n/*\n\n  Media\n  -----\n\n  Define media queries.\n\n*/\n/*\n\n  Base\n  ----\n\n  This file contains the site's base styles.\n  It also contains styling for markup that's generated server side as it's too\n  convoluted to add classes directly to it.\n\n*/\n* {\n  box-sizing: border-box;\n}\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  max-height: 100vh;\n  min-width: 320px;\n}\n@media screen and (max-width: 520px) {\n  html,\n  body {\n    height: auto;\n    max-height: none;\n    overflow-y: auto;\n  }\n}\nbody {\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: subpixel-antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: \"Source Sans Pro\", \"Arial\", sans-serif;\n  line-height: 1.5;\n  font-size: 16px;\n  color: #111111;\n  background-color: #FFFFFF;\n}\n#app {\n  position: relative;\n  width: 100vw;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n.layout-width-constraint {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1400px;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n@media screen and (max-width: 768px) {\n  .layout-width-constraint {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .layout-width-constraint {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n}\nbutton,\ninput,\ntextarea,\nselect {\n  color: inherit;\n  background-color: transparent;\n}\nbutton,\ninput:not([type=checkbox]):not([type=radio]),\ntextarea,\nselect {\n  border-radius: 0;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\nbutton {\n  border: none;\n  outline: none;\n}\ntd {\n  -webkit-margin-before: 0;\n  -webkit-margin-after: 0;\n}\na {\n  color: #00719F;\n}\nspan.wj {\n  font-size: 0 !important;\n}\nspan.fc-em {\n  font-style: italic;\n}\n.loading {\n  animation: big-loader 2s infinite linear;\n  width: 1em;\n  height: 1em;\n  border: 0.1em solid;\n  border-right-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n}\n@-moz-keyframes big-loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes big-loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes big-loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\nsummary {\n  /* Standard property for most browsers (Firefox, Chrome, Edge) */\n  list-style: none;\n}\n/* Specific vendor prefix for WebKit-based browsers (Safari, older Chrome/Edge) */\nsummary::-webkit-details-marker {\n  display: none;\n}\n.spin-to-win {\n  animation: big-loader 2s infinite linear;\n}\n/*\n\n  Layout\n  ------\n\n  Utility classes for layout.\n\n*/\n.overflow-auto {\n  overflow: auto;\n}\n.overflow-hidden {\n  overflow: hidden;\n}\n.overflow-y-auto {\n  overflow-y: auto;\n}\n.overflow-visible {\n  overflow: visible;\n}\n.overflow-x-hidden {\n  overflow: hidden;\n}\n.overflow-fade {\n  overflow: hidden;\n  position: relative;\n}\n.overflow-fade::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4rem;\n  background: linear-gradient(to bottom, transparent, #ffffff);\n}\n.collapse {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n.db {\n  display: block;\n}\n.dib {\n  display: inline-block;\n}\n.di {\n  display: inline;\n}\n.dn {\n  display: none;\n}\n.flex {\n  display: flex;\n}\n.inline-flex {\n  display: inline-flex;\n}\n@media screen and (max-width: 768px) {\n  .db-t {\n    display: block;\n  }\n  .dib-t {\n    display: inline-block;\n  }\n  .di-t {\n    display: inline;\n  }\n  .dn-t {\n    display: none;\n  }\n  .flex-t {\n    display: flex;\n  }\n  .inline-flex-t {\n    display: inline-flex;\n  }\n}\n@media screen and (max-width: 520px) {\n  .db-m {\n    display: block;\n  }\n  .dib-m {\n    display: inline-block;\n  }\n  .di-m {\n    display: inline;\n  }\n  .dn-m {\n    display: none;\n  }\n  .flex-m {\n    display: flex;\n  }\n  .inline-flex-m {\n    display: inline-flex;\n  }\n  .contents-m {\n    display: contents;\n  }\n}\n@media screen and (min-width: 769px) {\n  .dn-d {\n    display: none;\n  }\n  .db-d {\n    display: block;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .db-l {\n    display: block;\n  }\n  .dn-l {\n    display: none;\n  }\n  .flex-l {\n    display: flex;\n  }\n}\n.flexy {\n  flex: 1 1 auto;\n}\n.flex-1 {\n  flex: 1 1 0%;\n}\n@media screen and (max-width: 520px) {\n  .flexy-m {\n    flex: 1 1 auto;\n  }\n}\n.flex-column {\n  flex-direction: column;\n}\n.flex-row {\n  flex-direction: row;\n}\n.flex-column-reverse {\n  flex-direction: column-reverse;\n}\n.flex-row-reverse {\n  flex-direction: row-reverse;\n}\n@media screen and (max-width: 768px) {\n  .flex-column-t {\n    flex-direction: column;\n  }\n  .flex-row-t {\n    flex-direction: row;\n  }\n  .flex-column-reverse-t {\n    flex-direction: column-reverse;\n  }\n  .flex-row-reverse-t {\n    flex-direction: row-reverse;\n  }\n}\n@media screen and (max-width: 520px) {\n  .flex-column-m {\n    flex-direction: column;\n  }\n  .flex-row-m {\n    flex-direction: row;\n  }\n  .flex-column-reverse-m {\n    flex-direction: column-reverse;\n  }\n  .flex-row-reverse-m {\n    flex-direction: row-reverse;\n  }\n}\n.order-1 {\n  order: 1;\n}\n.order-2 {\n  order: 2;\n}\n.order-3 {\n  order: 3;\n}\n@media screen and (max-width: 520px) {\n  .order-1-m {\n    order: 1;\n  }\n  .order-2-m {\n    order: 2;\n  }\n  .order-3-m {\n    order: 3;\n  }\n  .order-4-m {\n    order: 4;\n  }\n}\n.flex-wrap {\n  flex-wrap: wrap;\n}\n.flex-nowrap {\n  flex-wrap: nowrap;\n}\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse;\n}\n@media screen and (max-width: 768px) {\n  .flex-wrap-t {\n    flex-wrap: wrap;\n  }\n}\n@media screen and (max-width: 520px) {\n  .flex-wrap-m {\n    flex-wrap: wrap;\n  }\n}\n.content-start {\n  align-content: flex-start;\n}\n.content-end {\n  align-content: flex-end;\n}\n.content-center {\n  align-content: center;\n}\n.content-baseline {\n  align-content: baseline;\n}\n.content-stretch {\n  align-content: stretch;\n}\n.items-start {\n  align-items: flex-start;\n}\n.items-end {\n  align-items: flex-end;\n}\n.items-center {\n  align-items: center;\n}\n.items-baseline {\n  align-items: baseline;\n}\n.items-stretch {\n  align-items: stretch;\n}\n@media screen and (max-width: 768px) {\n  .items-start-t {\n    align-items: flex-start;\n  }\n  .items-end-t {\n    align-items: flex-end;\n  }\n  .items-center-t {\n    align-items: center;\n  }\n  .items-baseline-t {\n    align-items: baseline;\n  }\n  .items-stretch-t {\n    align-items: stretch;\n  }\n}\n@media screen and (max-width: 520px) {\n  .items-start-m {\n    align-items: flex-start;\n  }\n  .items-end-m {\n    align-items: flex-end;\n  }\n  .items-center-m {\n    align-items: center;\n  }\n  .items-baseline-m {\n    align-items: baseline;\n  }\n  .items-stretch-m {\n    align-items: stretch;\n  }\n}\n.self-end {\n  align-self: flex-end;\n}\n.self-start {\n  align-self: flex-start;\n}\n.self-center {\n  align-self: center;\n}\n@media screen and (max-width: 768px) {\n  .self-end-t {\n    align-self: flex-end;\n  }\n  .self-start-t {\n    align-self: flex-start;\n  }\n}\n.justify-start {\n  justify-content: flex-start;\n}\n.justify-end {\n  justify-content: flex-end;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-between {\n  justify-content: space-between;\n}\n.justify-around {\n  justify-content: space-around;\n}\n.justify-evenly {\n  justify-content: space-around;\n  justify-content: space-evenly;\n}\n@media screen and (max-width: 768px) {\n  .justify-start-t {\n    justify-content: flex-start;\n  }\n  .justify-end-t {\n    justify-content: flex-end;\n  }\n  .justify-center-t {\n    justify-content: center;\n  }\n  .justify-between-t {\n    justify-content: space-between;\n  }\n  .justify-evenly-t {\n    justify-content: space-around;\n    justify-content: space-evenly;\n  }\n}\n@media screen and (max-width: 520px) {\n  .justify-start-m {\n    justify-content: flex-start;\n  }\n  .justify-end-m {\n    justify-content: flex-end;\n  }\n  .justify-center-m {\n    justify-content: center;\n  }\n  .justify-between-m {\n    justify-content: space-between;\n  }\n  .justify-evenly-m {\n    justify-content: space-around;\n    justify-content: space-evenly;\n  }\n}\n.valign-top {\n  vertical-align: top;\n}\n.valign-text-top {\n  vertical-align: text-top;\n}\n.valign-middle {\n  vertical-align: middle;\n}\n.valign-bottom {\n  vertical-align: bottom;\n}\n.valign-text-bottom {\n  vertical-align: text-bottom;\n}\n.valign-super {\n  vertical-align: super;\n}\n.valign-sub {\n  vertical-align: sub;\n}\n.basis0 {\n  flex-basis: 0;\n}\n.basis-auto {\n  min-width: 0;\n  min-height: 0;\n  flex-basis: auto;\n}\n.basis-50 {\n  flex-basis: 50%;\n}\n.basis-100 {\n  flex-basis: 100%;\n}\n@media screen and (max-width: 768px) {\n  .basis0-t {\n    flex-basis: 0;\n  }\n  .basis-auto-t {\n    min-width: 0;\n    min-height: 0;\n    flex-basis: auto;\n  }\n  .basis-100-t {\n    flex-basis: 100%;\n  }\n}\n.grow-0 {\n  flex-grow: 0;\n}\n.grow-1 {\n  flex-grow: 1;\n}\n.grow-2 {\n  flex-grow: 2;\n}\n.grow-3 {\n  flex-grow: 3;\n}\n.grow-4 {\n  flex-grow: 4;\n}\n.grow-5 {\n  flex-grow: 5;\n}\n.grow-initial {\n  flex-grow: initial;\n}\n@media screen and (max-width: 768px) {\n  .grow-0-t {\n    flex-grow: 0;\n  }\n  .grow-1-t {\n    flex-grow: 1;\n  }\n  .grow-2-t {\n    flex-grow: 2;\n  }\n  .grow-3-t {\n    flex-grow: 3;\n  }\n  .grow-4-t {\n    flex-grow: 4;\n  }\n  .grow-5-t {\n    flex-grow: 5;\n  }\n  .grow-initial-t {\n    flex-grow: initial;\n  }\n}\n@media screen and (max-width: 520px) {\n  .grow-0-m {\n    flex-grow: 0;\n  }\n  .grow-1-m {\n    flex-grow: 1;\n  }\n  .grow-2-m {\n    flex-grow: 2;\n  }\n  .grow-3-m {\n    flex-grow: 3;\n  }\n  .grow-4-m {\n    flex-grow: 4;\n  }\n  .grow-5-m {\n    flex-grow: 5;\n  }\n}\n.shrink-0 {\n  flex-shrink: 0;\n}\n.shrink-1 {\n  flex-shrink: 1;\n}\n.shrink-2 {\n  flex-shrink: 2;\n}\n@media screen and (max-width: 768px) {\n  .shrink-0-t {\n    flex-shrink: 0;\n  }\n  .shrink-1-t {\n    flex-shrink: 1;\n  }\n}\n@media screen and (max-width: 520px) {\n  .shrink-0-m {\n    flex-shrink: 0;\n  }\n  .shrink-1-m {\n    flex-shrink: 1;\n  }\n}\n.flt-l {\n  float: left;\n}\n.flt-n {\n  float: none;\n}\n.flt-r {\n  float: right;\n}\n.static {\n  position: static;\n}\n.relative {\n  position: relative;\n}\n.absolute {\n  position: absolute;\n}\n.fixed {\n  position: fixed;\n}\n.sticky {\n  position: -webkit-sticky;\n  position: sticky;\n}\n@media screen and (min-width: 1200px) {\n  .sticky-l {\n    position: -webkit-sticky;\n    position: sticky;\n  }\n}\n@media screen and (max-width: 768px) {\n  .static-t {\n    position: static;\n  }\n  .relative-t {\n    position: relative;\n  }\n  .absolute-t {\n    position: absolute;\n  }\n  .fixed-t {\n    position: fixed;\n  }\n  .sticky-t {\n    position: -webkit-sticky;\n    position: sticky;\n  }\n}\n@media screen and (max-width: 520px) {\n  .static-m {\n    position: static;\n  }\n  .relative-m {\n    position: relative;\n  }\n  .absolute-m {\n    position: absolute;\n  }\n  .fixed-m {\n    position: fixed;\n  }\n  .sticky-m {\n    position: -webkit-sticky;\n    position: sticky;\n  }\n}\n.z0 {\n  z-index: 0;\n}\n.z5 {\n  z-index: 5;\n}\n.z10 {\n  z-index: 10;\n}\n.z15 {\n  z-index: 15;\n}\n.z20 {\n  z-index: 20;\n}\n.z25 {\n  z-index: 25;\n}\n.z30 {\n  z-index: 30;\n}\n.z35 {\n  z-index: 35;\n}\n.z40 {\n  z-index: 40;\n}\n.z45 {\n  z-index: 45;\n}\n.z50 {\n  z-index: 50;\n}\n.z55 {\n  z-index: 55;\n}\n.z60 {\n  z-index: 60;\n}\n.z105 {\n  z-index: 105;\n}\n.z1055 {\n  z-index: 1055;\n}\n.right0 {\n  right: 0;\n}\n.right2 {\n  right: 0.25rem;\n}\n.right3 {\n  right: 0.375rem;\n}\n.right4 {\n  right: 0.5rem;\n}\n.right5 {\n  right: 0.75rem;\n}\n.right6 {\n  right: 1rem;\n}\n.right7 {\n  right: 1.5rem;\n}\n.right9 {\n  right: 3rem;\n}\n.right-50 {\n  right: 50%;\n}\n.right-100 {\n  right: 100%;\n}\n.-right3 {\n  right: -0.375rem;\n}\n.left0 {\n  left: 0;\n}\n.left2 {\n  left: 0.25rem;\n}\n.left4 {\n  left: 0.5rem;\n}\n.left5 {\n  left: 0.75rem;\n}\n.left6 {\n  left: 1rem;\n}\n.left7 {\n  left: 1.5rem;\n}\n.left8 {\n  left: 2rem;\n}\n.left-50 {\n  left: 50%;\n}\n.left-100 {\n  left: 100%;\n}\n.-left5 {\n  left: -0.75rem;\n}\n.top0 {\n  top: 0;\n}\n.top1 {\n  top: 0.125rem;\n}\n.top2 {\n  top: 0.25rem;\n}\n.top3 {\n  top: 0.375rem;\n}\n.top4 {\n  top: 0.5rem;\n}\n.top5 {\n  top: 0.75rem;\n}\n.top6 {\n  top: 1rem;\n}\n.top7 {\n  top: 1.5rem;\n}\n.top8 {\n  top: 2rem;\n}\n.top9 {\n  top: 3rem;\n}\n.top10 {\n  top: 4rem;\n}\n.top11 {\n  top: 6rem;\n}\n.top12 {\n  top: 8rem;\n}\n.top-15 {\n  top: 15%;\n}\n.top-25 {\n  top: 25%;\n}\n.top-50 {\n  top: 50%;\n}\n.top-100 {\n  top: 100%;\n}\n.-top9 {\n  top: -3rem;\n}\n.-top10 {\n  top: -4rem;\n}\n@media screen and (max-width: 768px) {\n  .top4-t {\n    top: 0.5rem;\n  }\n}\n.bottom0 {\n  bottom: 0;\n}\n.bottom1 {\n  bottom: 0.125rem;\n}\n.bottom2 {\n  bottom: 0.25rem;\n}\n.bottom3 {\n  bottom: 0.375rem;\n}\n.bottom4 {\n  bottom: 0.5rem;\n}\n.bottom5 {\n  bottom: 0.75rem;\n}\n.bottom6 {\n  bottom: 1rem;\n}\n.bottom7 {\n  bottom: 1.5rem;\n}\n.bottom12 {\n  bottom: 8rem;\n}\n.bottom13 {\n  bottom: 12rem;\n}\n.bottom-50 {\n  bottom: 50%;\n}\n.bottom-100 {\n  bottom: 100%;\n}\n.-bottom5 {\n  bottom: -0.75rem;\n}\n.w0 {\n  width: 0;\n}\n.w1 {\n  width: 0.125rem;\n}\n.w2 {\n  width: 0.25rem;\n}\n.w3 {\n  width: 0.375rem;\n}\n.w4 {\n  width: 0.5rem;\n}\n.w4-half {\n  width: 0.625rem;\n}\n.w5 {\n  width: 0.75rem;\n}\n.w6 {\n  width: 1rem;\n}\n.w7 {\n  width: 1.5rem;\n}\n.w8 {\n  width: 2rem;\n}\n.w8-half {\n  width: 2.5rem;\n}\n.w9 {\n  width: 3rem;\n}\n.w10 {\n  width: 4rem;\n}\n.w11 {\n  width: 6rem;\n}\n.w11-half {\n  width: 7rem;\n}\n.w12 {\n  width: 8rem;\n}\n.w12-half {\n  width: 9.25rem;\n}\n.w13 {\n  width: 12rem;\n}\n.w14 {\n  width: 16rem;\n}\n.w14-half {\n  width: 24rem;\n}\n.w15 {\n  width: 32rem;\n}\n.w16 {\n  width: 48rem;\n}\n.w17 {\n  width: 64rem;\n}\n.w18 {\n  width: 96rem;\n}\n.w-10 {\n  width: 10%;\n}\n.w-20 {\n  width: 20%;\n}\n.w-25 {\n  width: 25%;\n}\n.w-30 {\n  width: 30%;\n}\n.w-33 {\n  width: 33%;\n}\n.w-34 {\n  width: 34%;\n}\n.w-40 {\n  width: 40%;\n}\n.w-50 {\n  width: 50%;\n}\n.w-55 {\n  width: 55%;\n}\n.w-60 {\n  width: 60%;\n}\n.w-65 {\n  width: 65%;\n}\n.w-70 {\n  width: 70%;\n}\n.w-75 {\n  width: 75%;\n}\n.w-80 {\n  width: 80%;\n}\n.w-90 {\n  width: 90%;\n}\n.w-95 {\n  width: 95%;\n}\n.w-100 {\n  width: 100%;\n}\n.w-third {\n  width: calc(100% / 3);\n}\n.w-two-thirds {\n  width: calc(100% / 1.5);\n}\n.w-auto {\n  width: auto;\n}\n.w-max-content {\n  width: max-content;\n}\n.vw-90 {\n  width: 90vw;\n}\n.vw-100 {\n  width: 100vw;\n}\n@media screen and (max-width: 768px) {\n  .w13-t {\n    width: 12rem;\n  }\n  .w-100-t {\n    width: 100%;\n  }\n  .w8-t {\n    width: 2rem;\n  }\n  .w-95-t {\n    width: 95%;\n  }\n  .w-100-t {\n    width: 100%;\n  }\n  .vw-100-t {\n    width: 100vw;\n  }\n}\n@media screen and (max-width: 520px) {\n  .w5-m {\n    width: 0.75rem;\n  }\n  .w6-m {\n    width: 1rem;\n  }\n  .w7-m {\n    width: 1.5rem;\n  }\n  .w8-m {\n    width: 2rem;\n  }\n  .w10-m {\n    width: 4rem;\n  }\n  .w-100-m {\n    width: 100%;\n  }\n  .w-auto-m {\n    width: auto;\n  }\n  .vw-100-m {\n    width: 100vw;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .w16-l {\n    width: 48rem;\n  }\n  .w-50-l {\n    width: 50%;\n  }\n}\n.max-w0 {\n  max-width: 0;\n}\n.max-w1 {\n  max-width: 0.125rem;\n}\n.max-w2 {\n  max-width: 0.25rem;\n}\n.max-w3 {\n  max-width: 0.375rem;\n}\n.max-w4 {\n  max-width: 0.5rem;\n}\n.max-w5 {\n  max-width: 0.75rem;\n}\n.max-w6 {\n  max-width: 1rem;\n}\n.max-w7 {\n  max-width: 1.5rem;\n}\n.max-w8 {\n  max-width: 2rem;\n}\n.max-w9 {\n  max-width: 3rem;\n}\n.max-w10 {\n  max-width: 4rem;\n}\n.max-w11 {\n  max-width: 6rem;\n}\n.max-w12 {\n  max-width: 8rem;\n}\n.max-w13 {\n  max-width: 12rem;\n}\n.max-w14 {\n  max-width: 16rem;\n}\n.max-w14-half {\n  max-width: 24rem;\n}\n.max-w15 {\n  max-width: 32rem;\n}\n.max-w16 {\n  max-width: 48rem;\n}\n.max-w17 {\n  max-width: 64rem;\n}\n.max-w18 {\n  max-width: 96rem;\n}\n.max-w-90 {\n  max-width: 90%;\n}\n.max-w-94 {\n  max-width: 94%;\n}\n.max-w-100 {\n  max-width: 100%;\n}\n.max-w-90vw {\n  max-width: 90vw;\n}\n.max-w-100vw {\n  max-width: 100vw;\n}\n.max-w-none {\n  max-width: none;\n}\n.max-w-inherit {\n  max-width: inherit;\n}\n.max-w-modal-small {\n  max-width: 23.75rem;\n}\n.max-w-modal-medium {\n  max-width: 35rem;\n}\n.max-w-modal-large {\n  max-width: 45rem;\n}\n@media screen and (max-width: 768px) {\n  .max-w-none-t {\n    max-width: none;\n  }\n}\n.min-w0 {\n  min-width: 0;\n}\n.min-w1 {\n  min-width: 0.125rem;\n}\n.min-w2 {\n  min-width: 0.25rem;\n}\n.min-w3 {\n  min-width: 0.375rem;\n}\n.min-w4 {\n  min-width: 0.5rem;\n}\n.min-w5 {\n  min-width: 0.75rem;\n}\n.min-w6 {\n  min-width: 1rem;\n}\n.min-w7 {\n  min-width: 1.5rem;\n}\n.min-w8 {\n  min-width: 2rem;\n}\n.min-w9 {\n  min-width: 3rem;\n}\n.min-w10 {\n  min-width: 4rem;\n}\n.min-w11 {\n  min-width: 6rem;\n}\n.min-w12 {\n  min-width: 8rem;\n}\n.min-w13 {\n  min-width: 12rem;\n}\n.min-w14 {\n  min-width: 16rem;\n}\n.min-w15 {\n  min-width: 32rem;\n}\n.min-w16 {\n  min-width: 48rem;\n}\n.min-w17 {\n  min-width: 64rem;\n}\n.min-w18 {\n  min-width: 96rem;\n}\n.min-w-80 {\n  min-width: 80%;\n}\n.min-w-100 {\n  min-width: 100%;\n}\n.min-w-none {\n  min-width: 0;\n}\n.min-w-button {\n  min-width: var(--button-width);\n}\n@media screen and (max-width: 520px) {\n  .min-w9-m {\n    min-width: 3rem;\n  }\n}\n.h0 {\n  height: 0;\n}\n.h1 {\n  height: 1rem;\n}\n.h2 {\n  height: 2rem;\n}\n.h3 {\n  height: 3rem;\n}\n.h4 {\n  height: 4rem;\n}\n.h5 {\n  height: 5rem;\n}\n.h6 {\n  height: 6rem;\n}\n.h7 {\n  height: 7rem;\n}\n.h8 {\n  height: 8rem;\n}\n.h10 {\n  height: 10rem;\n}\n.h12 {\n  height: 12rem;\n}\n.h14 {\n  height: 14rem;\n}\n.h16 {\n  height: 16rem;\n}\n.h-25 {\n  height: 25%;\n}\n.h-50 {\n  height: 50%;\n}\n.h-75 {\n  height: 75%;\n}\n.h-100 {\n  height: 100%;\n}\n.vh-25 {\n  height: 25vh;\n}\n.vh-50 {\n  height: 50vh;\n}\n.vh-75 {\n  height: 75vh;\n}\n.vh-100 {\n  height: 100vh;\n}\n.h-auto {\n  height: auto;\n}\n.h-inherit {\n  height: inherit;\n}\n.hs0 {\n  height: 0;\n}\n.hs0-half {\n  height: 0.0625;\n}\n.hs1 {\n  height: 0.125rem;\n}\n.hs2 {\n  height: 0.25rem;\n}\n.hs3 {\n  height: 0.375rem;\n}\n.hs4 {\n  height: 0.5rem;\n}\n.hs5 {\n  height: 0.75rem;\n}\n.hs6 {\n  height: 1rem;\n}\n.hs7 {\n  height: 1.5rem;\n}\n.hs8 {\n  height: 2rem;\n}\n.hs8-half {\n  height: 2.5rem;\n}\n.hs9 {\n  height: 3rem;\n}\n.hs10 {\n  height: 4rem;\n}\n.hs11 {\n  height: 6rem;\n}\n.hs12 {\n  height: 8rem;\n}\n.hs13 {\n  height: 12rem;\n}\n.hs14 {\n  height: 16rem;\n}\n@media screen and (max-width: 520px) {\n  .h1-m {\n    height: 1rem;\n  }\n  .h2-m {\n    height: 2rem;\n  }\n  .h3-m {\n    height: 3rem;\n  }\n  .h4-m {\n    height: 4rem;\n  }\n  .h5-m {\n    height: 5rem;\n  }\n  .h6-m {\n    height: 6rem;\n  }\n}\n.min-h-0 {\n  min-height: 0;\n}\n.min-h2 {\n  min-height: 2rem;\n}\n.min-h3 {\n  min-height: 3rem;\n}\n.min-h4 {\n  min-height: 4rem;\n}\n.min-h8 {\n  min-height: 8rem;\n}\n.min-h12 {\n  min-height: 12rem;\n}\n.min-h-spacing-9 {\n  min-height: 3rem;\n}\n.min-h-spacing-14 {\n  min-height: 16rem;\n}\n.min-h-spacing-15 {\n  min-height: 32rem;\n}\n.min-h-100 {\n  min-height: 100%;\n}\n.min-vh-100 {\n  min-height: 100vh;\n}\n.min-h-inherit {\n  min-height: inherit;\n}\n.max-h0 {\n  max-height: 0;\n}\n.max-h3 {\n  max-height: 3rem;\n}\n.max-h4 {\n  max-height: 4rem;\n}\n.max-h7 {\n  max-height: 7rem;\n}\n.max-h8 {\n  max-height: 2rem;\n}\n.max-h16 {\n  max-height: 16rem;\n}\n.max-h24 {\n  max-height: 24rem;\n}\n.max-h-75 {\n  max-height: 75%;\n}\n@media screen and (max-width: 768px) {\n  .max-h8-t {\n    max-height: 2rem;\n  }\n}\n/*\n\n  Spacing\n  -------\n\n  Utility classes for margins and paddings.\n\n*/\n.gap0 {\n  gap: 0;\n}\n.gap1 {\n  gap: 0.125rem;\n}\n.gap2 {\n  gap: 0.25rem;\n}\n.gap3 {\n  gap: 0.375rem;\n}\n.gap4 {\n  gap: 0.5rem;\n}\n.gap4-half {\n  gap: 0.625rem;\n}\n.gap5 {\n  gap: 0.75rem;\n}\n.gap5-half {\n  gap: 0.875rem;\n}\n.gap6 {\n  gap: 1rem;\n}\n.gap7 {\n  gap: 1.5rem;\n}\n.gap8 {\n  gap: 2rem;\n}\n.gap9 {\n  gap: 3rem;\n}\n.gap10 {\n  gap: 4rem;\n}\n.gap11 {\n  gap: 6rem;\n}\n.gap12 {\n  gap: 8rem;\n}\n.gap13 {\n  gap: 12rem;\n}\n.gap14 {\n  gap: 16rem;\n}\n@media screen and (max-width: 520px) {\n  .gap8-m {\n    gap: 2rem;\n  }\n}\n.pa0 {\n  padding: 0;\n}\n.pa1 {\n  padding: 0.125rem;\n}\n.pa2 {\n  padding: 0.25rem;\n}\n.pa3 {\n  padding: 0.375rem;\n}\n.pa4 {\n  padding: 0.5rem;\n}\n.pa5 {\n  padding: 0.75rem;\n}\n.pa6 {\n  padding: 1rem;\n}\n.pa7 {\n  padding: 1.5rem;\n}\n.pa8 {\n  padding: 2rem;\n}\n.pa9 {\n  padding: 3rem;\n}\n.pa10 {\n  padding: 4rem;\n}\n.pa11 {\n  padding: 6rem;\n}\n.pa12 {\n  padding: 8rem;\n}\n.pa13 {\n  padding: 12rem;\n}\n.pa14 {\n  padding: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .pa0-t {\n    padding: 0;\n  }\n  .pa1-t {\n    padding: 0.125rem;\n  }\n  .pa2-t {\n    padding: 0.25rem;\n  }\n  .pa3-t {\n    padding: 0.375rem;\n  }\n  .pa4-t {\n    padding: 0.5rem;\n  }\n  .pa5-t {\n    padding: 0.75rem;\n  }\n  .pa6-t {\n    padding: 1rem;\n  }\n  .pa7-t {\n    padding: 1.5rem;\n  }\n  .pa8-t {\n    padding: 2rem;\n  }\n  .pa9-t {\n    padding: 3rem;\n  }\n  .pa11-t {\n    padding: 4rem;\n  }\n  .pa10-t {\n    padding: 6rem;\n  }\n  .pa12-t {\n    padding: 8rem;\n  }\n  .pa13-t {\n    padding: 12rem;\n  }\n  .pa14-t {\n    padding: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pa0-m {\n    padding: 0;\n  }\n  .pa1-m {\n    padding: 0.125rem;\n  }\n  .pa2-m {\n    padding: 0.25rem;\n  }\n  .pa3-m {\n    padding: 0.375rem;\n  }\n  .pa4-m {\n    padding: 0.5rem;\n  }\n  .pa5-m {\n    padding: 0.75rem;\n  }\n  .pa6-m {\n    padding: 1rem;\n  }\n  .pa7-m {\n    padding: 1.5rem;\n  }\n  .pa8-m {\n    padding: 2rem;\n  }\n  .pa9-m {\n    padding: 3rem;\n  }\n  .pa11-m {\n    padding: 4rem;\n  }\n  .pa10-m {\n    padding: 6rem;\n  }\n  .pa12-m {\n    padding: 8rem;\n  }\n  .pa13-m {\n    padding: 12rem;\n  }\n  .pa14-m {\n    padding: 16rem;\n  }\n}\n.pl0 {\n  padding-left: 0;\n}\n.pl1 {\n  padding-left: 0.125rem;\n}\n.pl2 {\n  padding-left: 0.25rem;\n}\n.pl3 {\n  padding-left: 0.375rem;\n}\n.pl4 {\n  padding-left: 0.5rem;\n}\n.pl5 {\n  padding-left: 0.75rem;\n}\n.pl6 {\n  padding-left: 1rem;\n}\n.pl7 {\n  padding-left: 1.5rem;\n}\n.pl8 {\n  padding-left: 2rem;\n}\n.pl9 {\n  padding-left: 3rem;\n}\n.pl10 {\n  padding-left: 4rem;\n}\n.pl11 {\n  padding-left: 6rem;\n}\n.pl12 {\n  padding-left: 8rem;\n}\n.pl13 {\n  padding-left: 12rem;\n}\n.pl14 {\n  padding-left: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .pl0-t {\n    padding-left: 0;\n  }\n  .pl1-t {\n    padding-left: 0.125rem;\n  }\n  .pl2-t {\n    padding-left: 0.25rem;\n  }\n  .pl3-t {\n    padding-left: 0.375rem;\n  }\n  .pl4-t {\n    padding-left: 0.5rem;\n  }\n  .pl5-t {\n    padding-left: 0.75rem;\n  }\n  .pl6-t {\n    padding-left: 1rem;\n  }\n  .pl7-t {\n    padding-left: 1.5rem;\n  }\n  .pl8-t {\n    padding-left: 2rem;\n  }\n  .pl9-t {\n    padding-left: 3rem;\n  }\n  .pl11-t {\n    padding-left: 4rem;\n  }\n  .pl10-t {\n    padding-left: 6rem;\n  }\n  .pl12-t {\n    padding-left: 8rem;\n  }\n  .pl13-t {\n    padding-left: 12rem;\n  }\n  .pl14-t {\n    padding-left: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pl0-m {\n    padding-left: 0;\n  }\n  .pl1-m {\n    padding-left: 0.125rem;\n  }\n  .pl2-m {\n    padding-left: 0.25rem;\n  }\n  .pl3-m {\n    padding-left: 0.375rem;\n  }\n  .pl4-m {\n    padding-left: 0.5rem;\n  }\n  .pl5-m {\n    padding-left: 0.75rem;\n  }\n  .pl6-m {\n    padding-left: 1rem;\n  }\n  .pl7-m {\n    padding-left: 1.5rem;\n  }\n  .pl8-m {\n    padding-left: 2rem;\n  }\n  .pl9-m {\n    padding-left: 3rem;\n  }\n  .pl11-m {\n    padding-left: 4rem;\n  }\n  .pl10-m {\n    padding-left: 6rem;\n  }\n  .pl12-m {\n    padding-left: 8rem;\n  }\n  .pl13-m {\n    padding-left: 12rem;\n  }\n  .pl14-m {\n    padding-left: 16rem;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .pl5-l {\n    padding-left: 0.75rem;\n  }\n}\n.pr0 {\n  padding-right: 0;\n}\n.pr1 {\n  padding-right: 0.125rem;\n}\n.pr2 {\n  padding-right: 0.25rem;\n}\n.pr3 {\n  padding-right: 0.375rem;\n}\n.pr4 {\n  padding-right: 0.5rem;\n}\n.pr5 {\n  padding-right: 0.75rem;\n}\n.pr6 {\n  padding-right: 1rem;\n}\n.pr7 {\n  padding-right: 1.5rem;\n}\n.pr8 {\n  padding-right: 2rem;\n}\n.pr9 {\n  padding-right: 3rem;\n}\n.pr10 {\n  padding-right: 4rem;\n}\n.pr11 {\n  padding-right: 6rem;\n}\n.pr12 {\n  padding-right: 8rem;\n}\n.pr13 {\n  padding-right: 12rem;\n}\n.pr14 {\n  padding-right: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .pr0-t {\n    padding-right: 0;\n  }\n  .pr1-t {\n    padding-right: 0.125rem;\n  }\n  .pr2-t {\n    padding-right: 0.25rem;\n  }\n  .pr3-t {\n    padding-right: 0.375rem;\n  }\n  .pr4-t {\n    padding-right: 0.5rem;\n  }\n  .pr5-t {\n    padding-right: 0.75rem;\n  }\n  .pr6-t {\n    padding-right: 1rem;\n  }\n  .pr7-t {\n    padding-right: 1.5rem;\n  }\n  .pr8-t {\n    padding-right: 2rem;\n  }\n  .pr9-t {\n    padding-right: 3rem;\n  }\n  .pr11-t {\n    padding-right: 4rem;\n  }\n  .pr10-t {\n    padding-right: 6rem;\n  }\n  .pr12-t {\n    padding-right: 8rem;\n  }\n  .pr13-t {\n    padding-right: 12rem;\n  }\n  .pr14-t {\n    padding-right: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pr0-m {\n    padding-right: 0;\n  }\n  .pr1-m {\n    padding-right: 0.125rem;\n  }\n  .pr2-m {\n    padding-right: 0.25rem;\n  }\n  .pr3-m {\n    padding-right: 0.375rem;\n  }\n  .pr4-m {\n    padding-right: 0.5rem;\n  }\n  .pr5-m {\n    padding-right: 0.75rem;\n  }\n  .pr6-m {\n    padding-right: 1rem;\n  }\n  .pr7-m {\n    padding-right: 1.5rem;\n  }\n  .pr8-m {\n    padding-right: 2rem;\n  }\n  .pr9-m {\n    padding-right: 3rem;\n  }\n  .pr11-m {\n    padding-right: 4rem;\n  }\n  .pr10-m {\n    padding-right: 6rem;\n  }\n  .pr12-m {\n    padding-right: 8rem;\n  }\n  .pr13-m {\n    padding-right: 12rem;\n  }\n  .pr14-m {\n    padding-right: 16rem;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .pr5-l {\n    padding-right: 0.75rem;\n  }\n}\n.pb0 {\n  padding-bottom: 0;\n}\n.pb1 {\n  padding-bottom: 0.125rem;\n}\n.pb2 {\n  padding-bottom: 0.25rem;\n}\n.pb3 {\n  padding-bottom: 0.375rem;\n}\n.pb4 {\n  padding-bottom: 0.5rem;\n}\n.pb5 {\n  padding-bottom: 0.75rem;\n}\n.pb6 {\n  padding-bottom: 1rem;\n}\n.pb7 {\n  padding-bottom: 1.5rem;\n}\n.pb8 {\n  padding-bottom: 2rem;\n}\n.pb9 {\n  padding-bottom: 3rem;\n}\n.pb10 {\n  padding-bottom: 4rem;\n}\n.pb11 {\n  padding-bottom: 6rem;\n}\n.pb12 {\n  padding-bottom: 8rem;\n}\n.pb13 {\n  padding-bottom: 12rem;\n}\n.pb14 {\n  padding-bottom: 16rem;\n}\n.pb-80 {\n  padding-bottom: 80%;\n}\n@media screen and (max-width: 768px) {\n  .pb0-t {\n    padding-bottom: 0;\n  }\n  .pb1-t {\n    padding-bottom: 0.125rem;\n  }\n  .pb2-t {\n    padding-bottom: 0.25rem;\n  }\n  .pb3-t {\n    padding-bottom: 0.375rem;\n  }\n  .pb4-t {\n    padding-bottom: 0.5rem;\n  }\n  .pb5-t {\n    padding-bottom: 0.75rem;\n  }\n  .pb6-t {\n    padding-bottom: 1rem;\n  }\n  .pb7-t {\n    padding-bottom: 1.5rem;\n  }\n  .pb8-t {\n    padding-bottom: 2rem;\n  }\n  .pb9-t {\n    padding-bottom: 3rem;\n  }\n  .pb10-t {\n    padding-bottom: 4rem;\n  }\n  .pb11-t {\n    padding-bottom: 6rem;\n  }\n  .pb12-t {\n    padding-bottom: 8rem;\n  }\n  .pb13-t {\n    padding-bottom: 12rem;\n  }\n  .pb14-t {\n    padding-bottom: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pb0-m {\n    padding-bottom: 0;\n  }\n  .pb1-m {\n    padding-bottom: 0.125rem;\n  }\n  .pb2-m {\n    padding-bottom: 0.25rem;\n  }\n  .pb3-m {\n    padding-bottom: 0.375rem;\n  }\n  .pb4-m {\n    padding-bottom: 0.5rem;\n  }\n  .pb5-m {\n    padding-bottom: 0.75rem;\n  }\n  .pb6-m {\n    padding-bottom: 1rem;\n  }\n  .pb7-m {\n    padding-bottom: 1.5rem;\n  }\n  .pb8-m {\n    padding-bottom: 2rem;\n  }\n  .pb9-m {\n    padding-bottom: 3rem;\n  }\n  .pb11-m {\n    padding-bottom: 4rem;\n  }\n  .pb10-m {\n    padding-bottom: 6rem;\n  }\n  .pb12-m {\n    padding-bottom: 8rem;\n  }\n  .pb13-m {\n    padding-bottom: 12rem;\n  }\n  .pb14-m {\n    padding-bottom: 16rem;\n  }\n  .pb-80-m {\n    padding-bottom: 80%;\n  }\n}\n.pt0 {\n  padding-top: 0;\n}\n.pt1 {\n  padding-top: 0.125rem;\n}\n.pt2 {\n  padding-top: 0.25rem;\n}\n.pt3 {\n  padding-top: 0.375rem;\n}\n.pt4 {\n  padding-top: 0.5rem;\n}\n.pt5 {\n  padding-top: 0.75rem;\n}\n.pt6 {\n  padding-top: 1rem;\n}\n.pt7 {\n  padding-top: 1.5rem;\n}\n.pt8 {\n  padding-top: 2rem;\n}\n.pt9 {\n  padding-top: 3rem;\n}\n.pt10 {\n  padding-top: 4rem;\n}\n.pt11 {\n  padding-top: 6rem;\n}\n.pt12 {\n  padding-top: 8rem;\n}\n.pt13 {\n  padding-top: 12rem;\n}\n.pt14 {\n  padding-top: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .pt0-t {\n    padding-top: 0;\n  }\n  .pt1-t {\n    padding-top: 0.125rem;\n  }\n  .pt2-t {\n    padding-top: 0.25rem;\n  }\n  .pt3-t {\n    padding-top: 0.375rem;\n  }\n  .pt4-t {\n    padding-top: 0.5rem;\n  }\n  .pt5-t {\n    padding-top: 0.75rem;\n  }\n  .pt6-t {\n    padding-top: 1rem;\n  }\n  .pt7-t {\n    padding-top: 1.5rem;\n  }\n  .pt8-t {\n    padding-top: 2rem;\n  }\n  .pt9-t {\n    padding-top: 3rem;\n  }\n  .pt11-t {\n    padding-top: 4rem;\n  }\n  .pt10-t {\n    padding-top: 6rem;\n  }\n  .pt12-t {\n    padding-top: 8rem;\n  }\n  .pt13-t {\n    padding-top: 12rem;\n  }\n  .pt14-t {\n    padding-top: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pt0-m {\n    padding-top: 0;\n  }\n  .pt1-m {\n    padding-top: 0.125rem;\n  }\n  .pt2-m {\n    padding-top: 0.25rem;\n  }\n  .pt3-m {\n    padding-top: 0.375rem;\n  }\n  .pt4-m {\n    padding-top: 0.5rem;\n  }\n  .pt5-m {\n    padding-top: 0.75rem;\n  }\n  .pt6-m {\n    padding-top: 1rem;\n  }\n  .pt7-m {\n    padding-top: 1.5rem;\n  }\n  .pt8-m {\n    padding-top: 2rem;\n  }\n  .pt9-m {\n    padding-top: 3rem;\n  }\n  .pt11-m {\n    padding-top: 4rem;\n  }\n  .pt10-m {\n    padding-top: 6rem;\n  }\n  .pt12-m {\n    padding-top: 8rem;\n  }\n  .pt13-m {\n    padding-top: 12rem;\n  }\n  .pt14-m {\n    padding-top: 16rem;\n  }\n}\n.pv0 {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.pv0-half {\n  padding-top: 0.0625;\n  padding-bottom: 0.0625;\n}\n.pv1 {\n  padding-top: 0.125rem;\n  padding-bottom: 0.125rem;\n}\n.pv2 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n.pv3 {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n}\n.pv4 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.pv4-half {\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n}\n.pv5 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n.pv6 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.pv7 {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n.pv8 {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n.pv9 {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n.pv10 {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n.pv11 {\n  padding-top: 6rem;\n  padding-bottom: 6rem;\n}\n.pv12 {\n  padding-top: 8rem;\n  padding-bottom: 8rem;\n}\n.pv13 {\n  padding-top: 12rem;\n  padding-bottom: 12rem;\n}\n.pv14 {\n  padding-top: 16rem;\n  padding-bottom: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .pv0-t {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .pv1-t {\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n  }\n  .pv2-t {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .pv3-t {\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n  }\n  .pv4-t {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .pv5-t {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .pv6-t {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .pv7-t {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .pv8-t {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .pv9-t {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n  .pv11-t {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  .pv10-t {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n  .pv12-t {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n  .pv13-t {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n  .pv14-t {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .pv0-m {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .pv1-m {\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n  }\n  .pv2-m {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .pv3-m {\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n  }\n  .pv4-m {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .pv5-m {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .pv6-m {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .pv7-m {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .pv8-m {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .pv9-m {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n  .pv11-m {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  .pv10-m {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n  .pv12-m {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n  .pv13-m {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n  .pv14-m {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n}\n.ph0 {\n  padding-left: 0;\n  padding-right: 0;\n}\n.ph1 {\n  padding-left: 0.125rem;\n  padding-right: 0.125rem;\n}\n.ph2 {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n.ph3 {\n  padding-left: 0.375rem;\n  padding-right: 0.375rem;\n}\n.ph4 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.ph5 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n.ph6 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.ph7 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.ph8 {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n.ph9 {\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n.ph10 {\n  padding-left: 4rem;\n  padding-right: 4rem;\n}\n.ph11 {\n  padding-left: 6rem;\n  padding-right: 6rem;\n}\n.ph12 {\n  padding-left: 8rem;\n  padding-right: 8rem;\n}\n.ph13 {\n  padding-left: 12rem;\n  padding-right: 12rem;\n}\n.ph14 {\n  padding-left: 16rem;\n  padding-right: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .ph0-t {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .ph1-t {\n    padding-left: 0.125rem;\n    padding-right: 0.125rem;\n  }\n  .ph2-t {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .ph3-t {\n    padding-left: 0.375rem;\n    padding-right: 0.375rem;\n  }\n  .ph4-t {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .ph5-t {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .ph6-t {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .ph7-t {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .ph8-t {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .ph9-t {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n  .ph11-t {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n  .ph10-t {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n  .ph12-t {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n  .ph13-t {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n  .ph14-t {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .ph0-m {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .ph1-m {\n    padding-left: 0.125rem;\n    padding-right: 0.125rem;\n  }\n  .ph2-m {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .ph3-m {\n    padding-left: 0.375rem;\n    padding-right: 0.375rem;\n  }\n  .ph4-m {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .ph5-m {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .ph6-m {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .ph7-m {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .ph8-m {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .ph9-m {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n  .ph11-m {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n  .ph10-m {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n  .ph12-m {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n  .ph13-m {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n  .ph14-m {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n}\n.ma0 {\n  margin: 0;\n}\n.ma1 {\n  margin: 0.125rem;\n}\n.ma2 {\n  margin: 0.25rem;\n}\n.ma3 {\n  margin: 0.375rem;\n}\n.ma4 {\n  margin: 0.5rem;\n}\n.ma5 {\n  margin: 0.75rem;\n}\n.ma6 {\n  margin: 1rem;\n}\n.ma7 {\n  margin: 1.5rem;\n}\n.ma8 {\n  margin: 2rem;\n}\n.ma9 {\n  margin: 3rem;\n}\n.ma10 {\n  margin: 4rem;\n}\n.ma10-half {\n  margin: 5rem;\n}\n.ma11 {\n  margin: 6rem;\n}\n.ma11-half {\n  margin: 7rem;\n}\n.ma12 {\n  margin: 8rem;\n}\n.ma13 {\n  margin: 12rem;\n}\n.ma14 {\n  margin: 16rem;\n}\n.maauto {\n  margin: auto;\n}\n@media screen and (max-width: 768px) {\n  .ma0-t {\n    margin: 0;\n  }\n  .ma1-t {\n    margin: 0.125rem;\n  }\n  .ma2-t {\n    margin: 0.25rem;\n  }\n  .ma3-t {\n    margin: 0.375rem;\n  }\n  .ma4-t {\n    margin: 0.5rem;\n  }\n  .ma5-t {\n    margin: 0.75rem;\n  }\n  .ma6-t {\n    margin: 1rem;\n  }\n  .ma7-t {\n    margin: 1.5rem;\n  }\n  .ma8-t {\n    margin: 2rem;\n  }\n  .ma9-t {\n    margin: 3rem;\n  }\n  .ma10-t {\n    margin: 6rem;\n  }\n  .ma10-half-t {\n    margin: 5rem;\n  }\n  .ma11-t {\n    margin: 4rem;\n  }\n  .ma11-half-t {\n    margin: 7rem;\n  }\n  .ma12-t {\n    margin: 8rem;\n  }\n  .ma13-t {\n    margin: 12rem;\n  }\n  .ma14-t {\n    margin: 16rem;\n  }\n  .maauto-t {\n    margin: auto;\n  }\n}\n@media screen and (max-width: 520px) {\n  .ma0-m {\n    margin: 0;\n  }\n  .ma1-m {\n    margin: 0.125rem;\n  }\n  .ma2-m {\n    margin: 0.25rem;\n  }\n  .ma3-m {\n    margin: 0.375rem;\n  }\n  .ma4-m {\n    margin: 0.5rem;\n  }\n  .ma5-m {\n    margin: 0.75rem;\n  }\n  .ma6-m {\n    margin: 1rem;\n  }\n  .ma7-m {\n    margin: 1.5rem;\n  }\n  .ma8-m {\n    margin: 2rem;\n  }\n  .ma9-m {\n    margin: 3rem;\n  }\n  .ma10-m {\n    margin: 4rem;\n  }\n  .ma10-half-m {\n    margin: 5rem;\n  }\n  .ma11-m {\n    margin: 6rem;\n  }\n  .ma11-half-m {\n    margin: 7rem;\n  }\n  .ma12-m {\n    margin: 8rem;\n  }\n  .ma13-m {\n    margin: 12rem;\n  }\n  .ma14-m {\n    margin: 16rem;\n  }\n  .maauto-m {\n    margin: auto;\n  }\n}\n.ml0 {\n  margin-left: 0;\n}\n.ml1 {\n  margin-left: 0.125rem;\n}\n.ml2 {\n  margin-left: 0.25rem;\n}\n.ml3 {\n  margin-left: 0.375rem;\n}\n.ml4 {\n  margin-left: 0.5rem;\n}\n.ml5 {\n  margin-left: 0.75rem;\n}\n.ml6 {\n  margin-left: 1rem;\n}\n.ml7 {\n  margin-left: 1.5rem;\n}\n.ml8 {\n  margin-left: 2rem;\n}\n.ml9 {\n  margin-left: 3rem;\n}\n.ml10 {\n  margin-left: 4rem;\n}\n.ml10-half {\n  margin-left: 5rem;\n}\n.ml11 {\n  margin-left: 6rem;\n}\n.ml11-half {\n  margin-left: 7rem;\n}\n.ml12 {\n  margin-left: 8rem;\n}\n.ml13 {\n  margin-left: 12rem;\n}\n.ml14 {\n  margin-left: 16rem;\n}\n.mlauto {\n  margin-left: auto;\n}\n.ml-22 {\n  margin-left: 22%;\n}\n@media screen and (max-width: 768px) {\n  .ml0-t {\n    margin-left: 0;\n  }\n  .ml1-t {\n    margin-left: 0.125rem;\n  }\n  .ml2-t {\n    margin-left: 0.25rem;\n  }\n  .ml3-t {\n    margin-left: 0.375rem;\n  }\n  .ml4-t {\n    margin-left: 0.5rem;\n  }\n  .ml5-t {\n    margin-left: 0.75rem;\n  }\n  .ml6-t {\n    margin-left: 1rem;\n  }\n  .ml7-t {\n    margin-left: 1.5rem;\n  }\n  .ml8-t {\n    margin-left: 2rem;\n  }\n  .ml9-t {\n    margin-left: 3rem;\n  }\n  .ml10-t {\n    margin-left: 4rem;\n  }\n  .ml10-half-t {\n    margin-left: 5rem;\n  }\n  .ml11-t {\n    margin-left: 6rem;\n  }\n  .ml11-half-t {\n    margin-left: 7rem;\n  }\n  .ml12-t {\n    margin-left: 8rem;\n  }\n  .ml13-t {\n    margin-left: 12rem;\n  }\n  .ml14-t {\n    margin-left: 16rem;\n  }\n  .mlauto-t {\n    margin-left: auto;\n  }\n}\n@media screen and (max-width: 520px) {\n  .ml0-m {\n    margin-left: 0;\n  }\n  .ml1-m {\n    margin-left: 0.125rem;\n  }\n  .ml2-m {\n    margin-left: 0.25rem;\n  }\n  .ml3-m {\n    margin-left: 0.375rem;\n  }\n  .ml4-m {\n    margin-left: 0.5rem;\n  }\n  .ml5-m {\n    margin-left: 0.75rem;\n  }\n  .ml6-m {\n    margin-left: 1rem;\n  }\n  .ml7-m {\n    margin-left: 1.5rem;\n  }\n  .ml8-m {\n    margin-left: 2rem;\n  }\n  .ml9-m {\n    margin-left: 3rem;\n  }\n  .ml10-m {\n    margin-left: 4rem;\n  }\n  .ml10-half-m {\n    margin-left: 5rem;\n  }\n  .ml11-m {\n    margin-left: 6rem;\n  }\n  .ml11-half-m {\n    margin-left: 7rem;\n  }\n  .ml12-m {\n    margin-left: 8rem;\n  }\n  .ml13-m {\n    margin-left: 12rem;\n  }\n  .ml14-m {\n    margin-left: 16rem;\n  }\n  .mlauto-m {\n    margin-left: auto;\n  }\n}\n.mr0 {\n  margin-right: 0;\n}\n.mr1 {\n  margin-right: 0.125rem;\n}\n.mr2 {\n  margin-right: 0.25rem;\n}\n.mr3 {\n  margin-right: 0.375rem;\n}\n.mr4 {\n  margin-right: 0.5rem;\n}\n.mr5 {\n  margin-right: 0.75rem;\n}\n.mr5-half {\n  margin-right: 0.875rem;\n}\n.mr6 {\n  margin-right: 1rem;\n}\n.mr7 {\n  margin-right: 1.5rem;\n}\n.mr8 {\n  margin-right: 2rem;\n}\n.mr9 {\n  margin-right: 3rem;\n}\n.mr10 {\n  margin-right: 4rem;\n}\n.mr10-half {\n  margin-right: 5rem;\n}\n.mr11 {\n  margin-right: 6rem;\n}\n.mr11-half {\n  margin-right: 7rem;\n}\n.mr12 {\n  margin-right: 8rem;\n}\n.mr13 {\n  margin-right: 12rem;\n}\n.mr14 {\n  margin-right: 16rem;\n}\n.mrauto {\n  margin-right: auto;\n}\n@media screen and (min-width: 769px) {\n  .mr-0-d {\n    margin-right: 0;\n  }\n}\n@media screen and (max-width: 768px) {\n  .mr0-t {\n    margin-right: 0;\n  }\n  .mr1-t {\n    margin-right: 0.125rem;\n  }\n  .mr2-t {\n    margin-right: 0.25rem;\n  }\n  .mr3-t {\n    margin-right: 0.375rem;\n  }\n  .mr4-t {\n    margin-right: 0.5rem;\n  }\n  .mr5-t {\n    margin-right: 0.75rem;\n  }\n  .mr6-t {\n    margin-right: 1rem;\n  }\n  .mr7-t {\n    margin-right: 1.5rem;\n  }\n  .mr8-t {\n    margin-right: 2rem;\n  }\n  .mr9-t {\n    margin-right: 3rem;\n  }\n  .mr10-t {\n    margin-right: 4rem;\n  }\n  .mr10-half-t {\n    margin-right: 5rem;\n  }\n  .mr11-t {\n    margin-right: 6rem;\n  }\n  .mr11-half-t {\n    margin-right: 7rem;\n  }\n  .mr12-t {\n    margin-right: 8rem;\n  }\n  .mr13-t {\n    margin-right: 12rem;\n  }\n  .mr14-t {\n    margin-right: 16rem;\n  }\n  .mrauto-t {\n    margin-right: auto;\n  }\n}\n@media screen and (max-width: 520px) {\n  .mr0-m {\n    margin-right: 0;\n  }\n  .mr1-m {\n    margin-right: 0.125rem;\n  }\n  .mr2-m {\n    margin-right: 0.25rem;\n  }\n  .mr3-m {\n    margin-right: 0.375rem;\n  }\n  .mr4-m {\n    margin-right: 0.5rem;\n  }\n  .mr5-m {\n    margin-right: 0.75rem;\n  }\n  .mr6-m {\n    margin-right: 1rem;\n  }\n  .mr7-m {\n    margin-right: 1.5rem;\n  }\n  .mr8-m {\n    margin-right: 2rem;\n  }\n  .mr9-m {\n    margin-right: 3rem;\n  }\n  .mr10-m {\n    margin-right: 4rem;\n  }\n  .mr10-half-m {\n    margin-right: 5rem;\n  }\n  .mr11-m {\n    margin-right: 6rem;\n  }\n  .mr11-half-m {\n    margin-right: 7rem;\n  }\n  .mr12-m {\n    margin-right: 8rem;\n  }\n  .mr13-m {\n    margin-right: 12rem;\n  }\n  .mr14-m {\n    margin-right: 16rem;\n  }\n  .mrauto-m {\n    margin-right: auto;\n  }\n}\n.mb0 {\n  margin-bottom: 0;\n}\n.mb1 {\n  margin-bottom: 0.125rem;\n}\n.mb2 {\n  margin-bottom: 0.25rem;\n}\n.mb3 {\n  margin-bottom: 0.375rem;\n}\n.mb4 {\n  margin-bottom: 0.5rem;\n}\n.mb5 {\n  margin-bottom: 0.75rem;\n}\n.mb6 {\n  margin-bottom: 1rem;\n}\n.mb7 {\n  margin-bottom: 1.5rem;\n}\n.mb8 {\n  margin-bottom: 2rem;\n}\n.mb9 {\n  margin-bottom: 3rem;\n}\n.mb10 {\n  margin-bottom: 4rem;\n}\n.mb10-half {\n  margin-bottom: 5rem;\n}\n.mb11 {\n  margin-bottom: 6rem;\n}\n.mb11-half {\n  margin-bottom: 7rem;\n}\n.mb12 {\n  margin-bottom: 8rem;\n}\n.mb13 {\n  margin-bottom: 12rem;\n}\n.mb14 {\n  margin-bottom: 16rem;\n}\n.mbauto {\n  margin-bottom: auto;\n}\n.-mb2 {\n  margin-bottom: -0.25rem;\n}\n.-mb4 {\n  margin-bottom: -0.5rem;\n}\n.last-child-mb0:last-child {\n  margin-bottom: 0;\n}\n@media screen and (max-width: 768px) {\n  .mb0-t {\n    margin-bottom: 0;\n  }\n  .mb1-t {\n    margin-bottom: 0.125rem;\n  }\n  .mb2-t {\n    margin-bottom: 0.25rem;\n  }\n  .mb3-t {\n    margin-bottom: 0.375rem;\n  }\n  .mb4-t {\n    margin-bottom: 0.5rem;\n  }\n  .mb5-t {\n    margin-bottom: 0.75rem;\n  }\n  .mb6-t {\n    margin-bottom: 1rem;\n  }\n  .mb7-t {\n    margin-bottom: 1.5rem;\n  }\n  .mb8-t {\n    margin-bottom: 2rem;\n  }\n  .mb9-t {\n    margin-bottom: 3rem;\n  }\n  .mb10-t {\n    margin-bottom: 4rem;\n  }\n  .mb10-half-t {\n    margin-bottom: 5rem;\n  }\n  .mb11-t {\n    margin-bottom: 6rem;\n  }\n  .mb11-half-t {\n    margin-bottom: 7rem;\n  }\n  .mb12-t {\n    margin-bottom: 8rem;\n  }\n  .mb13-t {\n    margin-bottom: 12rem;\n  }\n  .mb14-t {\n    margin-bottom: 16rem;\n  }\n  .mbauto-t {\n    margin-bottom: auto;\n  }\n}\n@media screen and (max-width: 520px) {\n  .mb0-m {\n    margin-bottom: 0;\n  }\n  .mb1-m {\n    margin-bottom: 0.125rem;\n  }\n  .mb2-m {\n    margin-bottom: 0.25rem;\n  }\n  .mb3-m {\n    margin-bottom: 0.375rem;\n  }\n  .mb4-m {\n    margin-bottom: 0.5rem;\n  }\n  .mb5-m {\n    margin-bottom: 0.75rem;\n  }\n  .mb6-m {\n    margin-bottom: 1rem;\n  }\n  .mb7-m {\n    margin-bottom: 1.5rem;\n  }\n  .mb8-m {\n    margin-bottom: 2rem;\n  }\n  .mb9-m {\n    margin-bottom: 3rem;\n  }\n  .mb10-m {\n    margin-bottom: 4rem;\n  }\n  .mb10-half-m {\n    margin-bottom: 5rem;\n  }\n  .mb11-m {\n    margin-bottom: 6rem;\n  }\n  .mb11-half-m {\n    margin-bottom: 7rem;\n  }\n  .mb12-m {\n    margin-bottom: 8rem;\n  }\n  .mb13-m {\n    margin-bottom: 12rem;\n  }\n  .mb14-m {\n    margin-bottom: 16rem;\n  }\n  .mbauto-m {\n    margin-bottom: auto;\n  }\n}\n.mt0 {\n  margin-top: 0;\n}\n.mt1 {\n  margin-top: 0.125rem;\n}\n.mt2 {\n  margin-top: 0.25rem;\n}\n.mt3 {\n  margin-top: 0.375rem;\n}\n.mt4 {\n  margin-top: 0.5rem;\n}\n.mt5 {\n  margin-top: 0.75rem;\n}\n.mt6 {\n  margin-top: 1rem;\n}\n.mt7 {\n  margin-top: 1.5rem;\n}\n.mt8 {\n  margin-top: 2rem;\n}\n.mt9 {\n  margin-top: 3rem;\n}\n.mt10 {\n  margin-top: 4rem;\n}\n.mt10-half {\n  margin-top: 5rem;\n}\n.mt11 {\n  margin-top: 6rem;\n}\n.mt11-half {\n  margin-top: 7rem;\n}\n.mt12 {\n  margin-top: 8rem;\n}\n.mt13 {\n  margin-top: 12rem;\n}\n.mt14 {\n  margin-top: 16rem;\n}\n.-mt1 {\n  margin-top: -0.125rem;\n}\n.-mt2 {\n  margin-top: -0.25rem;\n}\n.-mt3 {\n  margin-top: -0.375rem;\n}\n.-mt4 {\n  margin-top: -0.5rem;\n}\n.-mt5 {\n  margin-top: -0.75rem;\n}\n.-mt6 {\n  margin-top: -1rem;\n}\n.-mt7 {\n  margin-top: -1.5rem;\n}\n.-mt8 {\n  margin-top: -2rem;\n}\n.-mt9 {\n  margin-top: -3rem;\n}\n@media screen and (min-width: 1200px) {\n  .mt0-l {\n    margin-top: 0;\n  }\n}\n@media screen and (max-width: 768px) {\n  .mt0-t {\n    margin-top: 0;\n  }\n  .mt1-t {\n    margin-top: 0.125rem;\n  }\n  .mt2-t {\n    margin-top: 0.25rem;\n  }\n  .mt3-t {\n    margin-top: 0.375rem;\n  }\n  .mt4-t {\n    margin-top: 0.5rem;\n  }\n  .mt5-t {\n    margin-top: 0.75rem;\n  }\n  .mt6-t {\n    margin-top: 1rem;\n  }\n  .mt7-t {\n    margin-top: 1.5rem;\n  }\n  .mt8-t {\n    margin-top: 2rem;\n  }\n  .mt9-t {\n    margin-top: 3rem;\n  }\n  .mt10-t {\n    margin-top: 4rem;\n  }\n  .mt10-half-t {\n    margin-top: 5rem;\n  }\n  .mt11-t {\n    margin-top: 6rem;\n  }\n  .mt11-half-t {\n    margin-top: 7rem;\n  }\n  .mt12-t {\n    margin-top: 8rem;\n  }\n  .mt13-t {\n    margin-top: 12rem;\n  }\n  .mt14-t {\n    margin-top: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .mt0-m {\n    margin-top: 0;\n  }\n  .mt1-m {\n    margin-top: 0.125rem;\n  }\n  .mt2-m {\n    margin-top: 0.25rem;\n  }\n  .mt3-m {\n    margin-top: 0.375rem;\n  }\n  .mt4-m {\n    margin-top: 0.5rem;\n  }\n  .mt5-m {\n    margin-top: 0.75rem;\n  }\n  .mt6-m {\n    margin-top: 1rem;\n  }\n  .mt7-m {\n    margin-top: 1.5rem;\n  }\n  .mt8-m {\n    margin-top: 2rem;\n  }\n  .mt9-m {\n    margin-top: 3rem;\n  }\n  .mt10-m {\n    margin-top: 4rem;\n  }\n  .mt10-half-m {\n    margin-top: 5rem;\n  }\n  .mt11-m {\n    margin-top: 6rem;\n  }\n  .mt11-half-m {\n    margin-top: 7rem;\n  }\n  .mt12-m {\n    margin-top: 8rem;\n  }\n  .mt13-m {\n    margin-top: 12rem;\n  }\n  .mt14-m {\n    margin-top: 16rem;\n  }\n}\n.mv0 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.mv1 {\n  margin-top: 0.125rem;\n  margin-bottom: 0.125rem;\n}\n.mv2 {\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n.mv3 {\n  margin-top: 0.375rem;\n  margin-bottom: 0.375rem;\n}\n.mv4 {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.mv5 {\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n.mv6 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.mv7 {\n  margin-top: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n.mv8 {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n.mv9 {\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n.mv10 {\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n}\n.mv10-half {\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n}\n.mv11 {\n  margin-top: 6rem;\n  margin-bottom: 6rem;\n}\n.mv11-half {\n  margin-top: 7rem;\n  margin-bottom: 7rem;\n}\n.mv12 {\n  margin-top: 8rem;\n  margin-bottom: 8rem;\n}\n.mv13 {\n  margin-top: 12rem;\n  margin-bottom: 12rem;\n}\n.mv14 {\n  margin-top: 16rem;\n  margin-bottom: 16rem;\n}\n@media screen and (max-width: 768px) {\n  .mv0-t {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .mv1-t {\n    margin-top: 0.125rem;\n    margin-bottom: 0.125rem;\n  }\n  .mv2-t {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n  .mv3-t {\n    margin-top: 0.375rem;\n    margin-bottom: 0.375rem;\n  }\n  .mv4-t {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n  .mv5-t {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n  .mv6-t {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .mv7-t {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  .mv8-t {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n  .mv9-t {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n  .mv10-t {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n  .mv10-half-t {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n  .mv11-t {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n  .mv11-half-t {\n    margin-top: 7rem;\n    margin-bottom: 7rem;\n  }\n  .mv12-t {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n  .mv13-t {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n  .mv14-t {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .mv0-m {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .mv1-m {\n    margin-top: 0.125rem;\n    margin-bottom: 0.125rem;\n  }\n  .mv2-m {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n  .mv3-m {\n    margin-top: 0.375rem;\n    margin-bottom: 0.375rem;\n  }\n  .mv4-m {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n  .mv5-m {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n  .mv6-m {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .mv7-m {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  .mv8-m {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n  .mv9-m {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n  .mv10-m {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n  .mv10-half-m {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n  .mv11-m {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n  .mv11-half-m {\n    margin-top: 7rem;\n    margin-bottom: 7rem;\n  }\n  .mv12-m {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n  .mv13-m {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n  .mv14-m {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n}\n.mh0 {\n  margin-left: 0;\n  margin-right: 0;\n}\n.mh1 {\n  margin-left: 0.125rem;\n  margin-right: 0.125rem;\n}\n.mh2 {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n.mh3 {\n  margin-left: 0.375rem;\n  margin-right: 0.375rem;\n}\n.mh4 {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n.mh5 {\n  margin-left: 0.75rem;\n  margin-right: 0.75rem;\n}\n.mh6 {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n.mh7 {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n.mh8 {\n  margin-left: 2rem;\n  margin-right: 2rem;\n}\n.mh9 {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n.mh10 {\n  margin-left: 4rem;\n  margin-right: 4rem;\n}\n.mh10-half {\n  margin-left: 5rem;\n  margin-right: 5rem;\n}\n.mh11 {\n  margin-left: 6rem;\n  margin-right: 6rem;\n}\n.mh11-half {\n  margin-left: 7rem;\n  margin-right: 7rem;\n}\n.mh12 {\n  margin-left: 8rem;\n  margin-right: 8rem;\n}\n.mh13 {\n  margin-left: 12rem;\n  margin-right: 12rem;\n}\n.mh14 {\n  margin-left: 16rem;\n  margin-right: 16rem;\n}\n.mhauto {\n  margin-left: auto;\n  margin-right: auto;\n}\n@media screen and (max-width: 768px) {\n  .mh0-t {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .mh1-t {\n    margin-left: 0.125rem;\n    margin-right: 0.125rem;\n  }\n  .mh2-t {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n  .mh3-t {\n    margin-left: 0.375rem;\n    margin-right: 0.375rem;\n  }\n  .mh4-t {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n  .mh5-t {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n  .mh6-t {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n  .mh7-t {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n  .mh8-t {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n  .mh9-t {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n  .mh11-t {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n  .mh10-t {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n  .mh12-t {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n  .mh13-t {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n  .mh14-t {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n  .mhauto-t {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n@media screen and (max-width: 520px) {\n  .mh0-m {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .mh1-m {\n    margin-left: 0.125rem;\n    margin-right: 0.125rem;\n  }\n  .mh2-m {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n  .mh3-m {\n    margin-left: 0.375rem;\n    margin-right: 0.375rem;\n  }\n  .mh4-m {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n  .mh5-m {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n  .mh6-m {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n  .mh7-m {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n  .mh8-m {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n  .mh9-m {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n  .mh10-m {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n  .mh11-m {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n  .mh12-m {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n  .mh13-m {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n  .mh14-m {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n  .mhauto-m {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n.gap1 {\n  gap: 0.125rem;\n}\n.gap2 {\n  gap: 0.25rem;\n}\n.gap3 {\n  gap: 0.375rem;\n}\n.gap4 {\n  gap: 0.5rem;\n}\n.gap5 {\n  gap: 0.75rem;\n}\n.gap6 {\n  gap: 1rem;\n}\n.gap7 {\n  gap: 1.5rem;\n}\n.gap8 {\n  gap: 2rem;\n}\n.gap9 {\n  gap: 3rem;\n}\n.gap10 {\n  gap: 4rem;\n}\n/*\n\n  Theming\n  -------\n\n  Utility classes for theming.\n\n*/\n.bicubic {\n  -ms-interpolation-mode: bicubic;\n  image-rendering: optimizeQuality;\n}\n.fit-image {\n  object-fit: cover;\n}\n.position-image-50-30 {\n  object-position: 50% 30%;\n}\n.fit-bg-image {\n  width: 100%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n}\n.hidden {\n  visibility: hidden;\n}\n.no-pointer-events {\n  pointer-events: none;\n}\n.pointer-events-auto {\n  pointer-events: auto;\n}\n.list-reset {\n  list-style: none;\n}\n.list-item-reset {\n  list-style-type: none;\n}\n.list-item-initial {\n  list-style-type: initial;\n}\n.transition-all {\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  -o-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n}\n.transition-all-slow {\n  -webkit-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.default-cursor {\n  cursor: default;\n}\n.pointer {\n  cursor: pointer;\n}\n.text {\n  cursor: text;\n}\n.disabled-default-cursor:disabled {\n  cursor: default;\n}\n.not-allowed {\n  cursor: not-allowed;\n}\n.wait {\n  cursor: wait;\n}\n.w-resize {\n  cursor: w-resize;\n}\n.outline-0 {\n  outline: 0;\n  outline: none;\n}\n.focus-outline-0:focus {\n  outline: 0;\n  outline: none;\n}\n.focus-outline-0:focus select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n.disable-text-area-resize {\n  resize: none;\n}\n.filter-o-40 {\n  filter: opacity(40%);\n}\n.filter-blur {\n  filter: blur(2px);\n}\n.hover-filter-o-40:hover {\n  filter: opacity(40%);\n}\n.o-100 {\n  -webkit-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}\n.o-90 {\n  -webkit-opacity: 0.9;\n  -moz-opacity: 0.9;\n  opacity: 0.9;\n}\n.o-80 {\n  -webkit-opacity: 0.8;\n  -moz-opacity: 0.8;\n  opacity: 0.8;\n}\n.o-70 {\n  -webkit-opacity: 0.7;\n  -moz-opacity: 0.7;\n  opacity: 0.7;\n}\n.o-60 {\n  -webkit-opacity: 0.6;\n  -moz-opacity: 0.6;\n  opacity: 0.6;\n}\n.o-50 {\n  -webkit-opacity: 0.5;\n  -moz-opacity: 0.5;\n  opacity: 0.5;\n}\n.o-40 {\n  -webkit-opacity: 0.4;\n  -moz-opacity: 0.4;\n  opacity: 0.4;\n}\n.o-30 {\n  -webkit-opacity: 0.3;\n  -moz-opacity: 0.3;\n  opacity: 0.3;\n}\n.o-20 {\n  -webkit-opacity: 0.2;\n  -moz-opacity: 0.2;\n  opacity: 0.2;\n}\n.o-10 {\n  -webkit-opacity: 0.1;\n  -moz-opacity: 0.1;\n  opacity: 0.1;\n}\n.o-05 {\n  -webkit-opacity: 0.05;\n  -moz-opacity: 0.05;\n  opacity: 0.05;\n}\n.o-025 {\n  -webkit-opacity: 0.025;\n  -moz-opacity: 0.025;\n  opacity: 0.025;\n}\n.o-0 {\n  -webkit-opacity: 0;\n  -moz-opacity: 0;\n  opacity: 0;\n}\n.hover-o-90:hover {\n  -webkit-opacity: 0.9;\n  -moz-opacity: 0.9;\n  opacity: 0.9;\n}\n.hover-o-80:hover {\n  -webkit-opacity: 0.8;\n  -moz-opacity: 0.8;\n  opacity: 0.8;\n}\n.hover-o-100:hover {\n  -webkit-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}\n.hover-reveal:hover .hover-reveal-target {\n  -webkit-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}\n.black {\n  color: #111111;\n}\n.bluish-grey {\n  color: #738897;\n}\n.light-bluish-grey {\n  color: #e8eef4;\n}\n.medium-bluish-grey {\n  color: #a7b5be;\n}\n.cadet-blue {\n  color: #6288A5;\n}\n.charcoal {\n  color: #404040;\n}\n.chocolate {\n  color: #C85C17;\n}\n.crimson {\n  color: #CC0033;\n}\n.dark-cyan {\n  color: #00719F;\n}\n.dark-slate-blue {\n  color: #3A447A;\n}\n.dark-orchid {\n  color: #84619C;\n}\n.dim-grey {\n  color: #565656;\n}\n.slate-grey {\n  color: #4d606e;\n}\n.light-slate-grey {\n  color: #6b8699;\n}\n.gains-boro {\n  color: #d8d8d8;\n}\n.grey {\n  color: #73797A;\n}\n.bright-grey {\n  color: #edeff0;\n}\n.ghost-grey {\n  color: #F7F9FA;\n}\n.indian-red {\n  color: #D95741;\n}\n.light-coral {\n  color: #F1617D;\n}\n.lite-grey {\n  color: #979797;\n}\n.dark-coral {\n  color: #DB3668;\n}\n.dark-sea-green {\n  color: #5CBE75;\n}\n.dark-sea-green-2 {\n  color: #128a93;\n}\n.dark-sea-green-3 {\n  color: #008C9F;\n}\n.light-sea-green-1 {\n  color: #3FC599;\n}\n.light-sea-green-2 {\n  color: #0bb9b5;\n}\n.light-turquoise {\n  color: #81cbd3;\n}\n.medium-turquoise {\n  color: #35b8d3;\n}\n.medium-aquamarine {\n  color: #6ac498;\n}\n.navy {\n  color: #011279;\n}\n.pale-green {\n  color: #a0f6aa;\n}\n.pale-violet-red {\n  color: #e25c8f;\n}\n.phantom-grey {\n  color: #e8e8e8;\n}\n.precedents-blue {\n  color: #004b7a;\n}\n.phantom-grey {\n  color: #e8e8e8;\n}\n.royal-blue {\n  color: #1460D1;\n}\n.sienna {\n  color: #825F48;\n}\n.teal {\n  color: #004b7a;\n}\n.tomato {\n  color: #F87531;\n}\n.tangerine-dream {\n  color: #FFCA28;\n}\n.white {\n  color: #FFFFFF;\n}\n.dark-cerulean {\n  color: #255c83;\n}\n.slate-blue-grey {\n  color: #4d616e;\n}\n.star-yellow {\n  color: #f7d757;\n}\n.suez-canal {\n  color: #255d85;\n}\n.placeholder-cadet-blue::placeholder {\n  color: #6288A5;\n}\n.hover-black:hover {\n  color: #111111;\n}\n.hover-cadet-blue:hover {\n  color: #6288A5;\n}\n.hover-dark-sea-green-2:hover {\n  color: #128a93;\n}\n.hover-dark-slate-blue:hover {\n  color: #3A447A;\n}\n.hover-slate-grey:hover {\n  color: #4d606e;\n}\n.hover-dark-sea-green-2:hover {\n  color: #128a93;\n}\n.hover-dark-sea-green-3:hover {\n  color: #008C9F;\n}\n.hover-gains-boro:hover {\n  color: #d8d8d8;\n}\n.hover-white:hover {\n  color: #FFFFFF;\n}\n.hover-slate-grey:hover {\n  color: #4d606e;\n}\n.hover-light-slate-grey:hover {\n  color: #6b8699;\n}\n.focus-light-sea-green-2:focus {\n  color: #0bb9b5;\n}\n.focus-white:focus {\n  color: #FFFFFF;\n}\n.focus-grey:focus {\n  color: #73797A;\n}\n.focus-slate-grey:focus {\n  color: #4d606e;\n}\n.focus-light-slate-grey:focus {\n  color: #6b8699;\n}\n.active-slate-grey:active {\n  color: #4d606e;\n}\n.active-light-slate-grey:active {\n  color: #6b8699;\n}\n.color-inherit {\n  color: inherit;\n}\n.link-children-color-inherit a {\n  color: inherit;\n}\n.bg-black {\n  background-color: #111111;\n}\n.soft-black {\n  background-color: #0d0d0d;\n}\n.bg-cadet-blue {\n  background-color: #6288A5;\n}\n.bg-chocolate {\n  background-color: #C85C17;\n}\n.bg-dark-bluish-grey {\n  background-color: #5d6d7b;\n}\n.bg-light-bluish-grey {\n  background-color: #e8eef4;\n}\n.bg-light-grayish-blue {\n  background-color: #e8eef4;\n}\n.bg-dark-coral {\n  background-color: #DB3668;\n}\n.bg-dark-cyan {\n  background-color: #00719F;\n}\n.bg-dark-sea-green {\n  background-color: #5CBE75;\n}\n.bg-dark-sea-green-2 {\n  background-color: #128a93;\n}\n.bg-dark-sea-green-3 {\n  background-color: #008C9F;\n}\n.bg-dark-slate-blue {\n  background-color: #3A447A;\n}\n.bg-dark-orchid {\n  background-color: #84619C;\n}\n.bg-dim-grey {\n  background-color: #565656;\n}\n.bg-faf-grey {\n  background-color: #FAFAFF;\n}\n.bg-gains-boro {\n  background-color: #d8d8d8;\n}\n.bg-grey {\n  background-color: #73797A;\n}\n.bg-ice-blue {\n  background-color: #D5ECFF;\n}\n.bg-ghost-grey {\n  background-color: #F7F9FA;\n}\n.bg-indian-red {\n  background-color: #D95741;\n}\n.bg-ice-blue {\n  background-color: #D5ECFF;\n}\n.bg-light-coral {\n  background-color: #F1617D;\n}\n.bg-light-yellow {\n  background-color: #FCF8E3;\n}\n.bg-light-sea-green-1 {\n  background-color: #3FC599;\n}\n.bg-light-sea-green-2 {\n  background-color: #0bb9b5;\n}\n.bg-light-turquoise {\n  background-color: #81cbd3;\n}\n.bg-medium-aquamarine {\n  background-color: #6ac498;\n}\n.bg-medium-purple {\n  background-color: #9c7fb0;\n}\n.bg-medium-turquoise {\n  background-color: #35b8d3;\n}\n.bg-navy {\n  background-color: #011279;\n}\n.bg-precedents-blue {\n  background-color: #004b7a;\n}\n.bg-pale-green {\n  background-color: #a0f6aa;\n}\n.bg-pale-violet-red {\n  background-color: #e25c8f;\n}\n.bg-pearl-lusta {\n  background-color: #fbf2d1;\n}\n.bg-phantom-grey {\n  background-color: #e8e8e8;\n}\n.bg-royal-blue {\n  background-color: #1460D1;\n}\n.bg-sienna {\n  background-color: #825F48;\n}\n.bg-slate-grey {\n  background-color: #3A447A;\n}\n.bg-teal {\n  background-color: #004b7a;\n}\n.bg-tomato {\n  background-color: #F87531;\n}\n.bg-white {\n  background-color: #FFFFFF;\n}\n.bg-tangerine-dream {\n  background-color: #FFCA28;\n}\n.bg-transparent {\n  background-color: transparent;\n}\n.bg-twilight-grey {\n  background-color: #EDEDED;\n}\n.bg-void-grey {\n  background-color: #EBF0F4;\n}\n.bg-inherit {\n  background-color: inherit;\n}\n.bg-transparent {\n  background: transparent;\n}\n.bg-casper-white {\n  background-color: #e7eef3;\n}\n.bg-ghost-white {\n  background-color: #f0f4f7;\n}\n.bg-slate-blue-grey {\n  background-color: #4d616e;\n}\n.bg-page-background {\n  background-color: #f0f4f7;\n}\n.bg-dark-cerulean {\n  background-color: #255c83;\n}\n.bg-suez-canal {\n  background-color: #255d85;\n}\n.bg-powder-white {\n  background-color: #ebf0f7;\n}\n.bg-star-yellow {\n  background-color: #f7d757;\n}\n.bg-text-fragment-highlight {\n  background-color: rgba(128, 0, 255, 0.2);\n}\n.hover-bg-transparent:hover {\n  background-color: transparent;\n  background: transparent;\n}\n.hover-bg-cadet-blue:hover {\n  background-color: #6288A5;\n}\n.hover-bg-dark-slate-blue:hover {\n  background-color: #3A447A;\n}\n.hover-bg-dark-sea-green:hover {\n  background-color: #5CBE75;\n}\n.hover-bg-dark-sea-green-2:hover {\n  background-color: #128a93;\n}\n.hover-bg-dark-sea-green-3:hover {\n  background-color: #008C9F;\n}\n.hover-bg-light-bluish-grey:hover {\n  background-color: #e8eef4;\n}\n.hover-bg-dim-grey:hover {\n  background-color: #565656;\n}\n.hover-bg-gains-boro:hover {\n  background-color: #d8d8d8;\n}\n.hover-bg-ghost-grey:hover {\n  background-color: #F7F9FA;\n}\n.hover-bg-grey:hover {\n  background-color: #73797A;\n}\n.hover-bg-light-turquoise:hover {\n  background-color: #81cbd3;\n}\n.hover-bg-teal:hover {\n  background-color: #004b7a;\n}\n.hover-bg-phantom-grey:hover {\n  background-color: #e8e8e8;\n}\n.hover-bg-twilight-grey:hover {\n  background-color: #EDEDED;\n}\n.hover-bg-white:hover {\n  background-color: #FFFFFF;\n}\n.hover-bg-light-bluish-grey:hover {\n  background-color: #e8eef4;\n}\n.hover-bg-casper-white:hover {\n  background-color: #e7eef3;\n}\n.hover-bg-ghost-white:hover {\n  background-color: #f0f4f7;\n}\n.hover-bg-slate-blue-grey:hover {\n  background-color: #4d616e;\n}\n.hover-bg-suez-canal:hover {\n  background-color: #255d85;\n}\n.focus-bg-ghost-white:focus {\n  background-color: #f0f4f7;\n}\n.focus-bg-casper-white:focus {\n  background-color: #e7eef3;\n}\n.focus-bg-star-yellow:focus {\n  background-color: #f7d757;\n}\n.focus-bg-slate-blue-grey:focus {\n  background-color: #4d616e;\n}\n.active-bg-ghost-white:active {\n  background-color: #f0f4f7;\n}\n.active-bg-casper-white:active {\n  background-color: #e7eef3;\n}\n.fill-star-yellow {\n  fill: #f7d757;\n}\n.fill-medium-bluish-grey {\n  fill: #a7b5be;\n}\n.fill-light-slate-grey {\n  fill: #6b8699;\n}\n.hover-fill-light-slate-grey:hover {\n  fill: #6b8699;\n}\n.stroke-suez-canal {\n  stroke: #255d85;\n}\n.bg-contain {\n  background-size: contain;\n}\n.bg-center {\n  background-position: center;\n}\n.bg-x-center {\n  background-position-x: center;\n}\n.bg-y-center {\n  background-position-y: center;\n}\n.border-collapse {\n  border-collapse: collapse;\n}\n.bg-no-repeat {\n  background-repeat: no-repeat;\n}\n.ba {\n  border-style: solid;\n  border-width: 1px;\n}\n.ba2 {\n  border-style: solid;\n  border-width: 2px;\n}\n.bn {\n  border-style: none;\n  border-width: 0;\n}\n.bb {\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n}\n.bl {\n  border-left-style: solid;\n  border-left-width: 1px;\n}\n.bt {\n  border-top-style: solid;\n  border-top-width: 1px;\n}\n.br {\n  border-right-style: solid;\n  border-right-width: 1px;\n}\n.bb-thin {\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n}\n.bb-medium {\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n}\n.bb-thick {\n  border-bottom-style: solid;\n  border-bottom-width: 4px;\n}\n.bb-extra-thick {\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.bt-medium {\n  border-top-style: solid;\n  border-top-width: 2px;\n}\n.bt-thick {\n  border-top-style: solid;\n  border-top-width: 4px;\n}\n.bt-xl {\n  border-top-style: solid;\n  border-top-width: 8px;\n}\n.bl-thick {\n  border-left-style: solid;\n  border-left-width: 4px;\n}\n@media screen and (max-width: 520px) {\n  .bn-m {\n    border-style: none;\n    border-width: 0;\n  }\n  .ba-m {\n    border-style: solid;\n    border-width: 1px;\n  }\n}\n.hover-bb-thick:hover {\n  border-bottom-style: solid;\n  border-bottom-width: 4px;\n}\n.hover-bb-medium:hover {\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n}\n.hover-bt-thick:hover {\n  border-top-style: solid;\n  border-top-width: 4px;\n}\n.last-child-bn:last-child {\n  border-style: none;\n  border-width: 0;\n}\n.last-of-type-bn:last-of-type {\n  border-style: none;\n  border-width: 0;\n}\n@media screen and (max-width: 768px) {\n  .bb-t {\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n  }\n  .bn-t {\n    border-style: none;\n    border-width: 0;\n  }\n  .bt-t {\n    border-top-style: solid;\n    border-top-width: 1px;\n  }\n}\n.b--dashed {\n  border-style: dashed;\n}\n.b--dotted {\n  border-style: dotted;\n}\n.b--none {\n  border-style: none;\n}\n.b--solid {\n  border-style: solid;\n}\n.bt--dashed {\n  border-top-style: dashed;\n}\n.bt--dotted {\n  border-top-style: dotted;\n}\n.bt--none {\n  border-top-style: none;\n}\n.bt--solid {\n  border-top-style: solid;\n}\n.br--dashed {\n  border-right-style: dashed;\n}\n.br--dotted {\n  border-right-style: dotted;\n}\n.br--none {\n  border-right-style: none;\n}\n.br--solid {\n  border-right-style: solid;\n}\n.bb--dashed {\n  border-bottom-style: dashed;\n}\n.bb--dotted {\n  border-bottom-style: dotted;\n}\n.bb--none {\n  border-bottom-style: none;\n}\n.bb--solid {\n  border-bottom-style: solid;\n}\n.bl--dashed {\n  border-left-style: dashed;\n}\n.bl--dotted {\n  border-left-style: dotted;\n}\n.bl--none {\n  border-left-style: none;\n}\n.bl--solid {\n  border-left-style: solid;\n}\n.hover-ba:hover {\n  border-style: solid;\n  border-width: 1px;\n}\n.hover-ba2:hover {\n  border-style: solid;\n  border-width: 2px;\n}\n.b--black {\n  border-color: #111111;\n}\n.b--cadet-blue {\n  border-color: #6288A5;\n}\n.b--chocolate {\n  border-color: #C85C17;\n}\n.b--dark-cyan {\n  border-color: #00719F;\n}\n.b--dark-slate-blue {\n  border-color: #3A447A;\n}\n.b--dark-orchid {\n  border-color: #84619C;\n}\n.b--dark-sea-green-2 {\n  border-color: #128a93;\n}\n.b--dark-sea-green-3 {\n  border-color: #008C9F;\n}\n.b--dim-grey {\n  border-color: #565656;\n}\n.b--gains-boro {\n  border-color: #d8d8d8;\n}\n.b--grey {\n  border-color: #73797A;\n}\n.b--bright-grey {\n  border-color: #edeff0;\n}\n.b--ghost-grey {\n  border-color: #F7F9FA;\n}\n.b--ghost-white {\n  border-color: #f0f4f7;\n}\n.b--indian-red {\n  border-color: #D95741;\n}\n.b--light-coral {\n  border-color: #F1617D;\n}\n.b--light-grey {\n  border-color: #979797;\n}\n.b--light-sea-green-1 {\n  border-color: #3FC599;\n}\n.b--light-sea-green-2 {\n  border-color: #0bb9b5;\n}\n.b--lite-grey {\n  border-color: #979797;\n}\n.b--medium-aquamarine {\n  border-color: #6ac498;\n}\n.b--medium-purple {\n  border-color: #9c7fb0;\n}\n.b--medium-turquoise {\n  border-color: #35b8d3;\n}\n.b--navy {\n  border-color: #011279;\n}\n.b--pale-green {\n  border-color: #a0f6aa;\n}\n.b--pale-violet-red {\n  border-color: #e25c8f;\n}\n.b--precedents-blue {\n  border-color: #004b7a;\n}\n.b--royal-blue {\n  border-color: #1460D1;\n}\n.b--sienna {\n  border-color: #825F48;\n}\n.b--tomato {\n  border-color: #F87531;\n}\n.b--phantom-grey {\n  border-color: #e8e8e8;\n}\n.b--white {\n  border-color: #FFFFFF;\n}\n.b-light-bluish-grey {\n  border-color: #e8eef4;\n}\n.b--transparent {\n  border-color: transparent;\n}\n.b--inherit {\n  border-color: inherit;\n}\n.b--slate-blue-grey {\n  border-color: #4d616e;\n}\n.b--light-bluish-grey {\n  border-color: #e8eef4;\n}\n.b--suez-canal {\n  border-color: #255d85;\n}\n.b--eastern-breeze {\n  border-color: #dae1e5;\n}\n.b--dark-cerulean {\n  border-color: #255c83;\n}\n.bt--transparent {\n  border-top-color: transparent;\n}\n.bt--dark-orchid {\n  border-top-color: #84619C;\n}\n.bt--dark-cyan {\n  border-top-color: #00719F;\n}\n.bt--light-grey {\n  border-top-color: #979797;\n}\n.bt--phantom-grey {\n  border-top-color: #e8e8e8;\n}\n.bt--light-sea-green-2 {\n  border-top-color: #0bb9b5;\n}\n.bt--dark-sea-green-3 {\n  border-top-color: #008C9F;\n}\n.bt--medium-aquamarine {\n  border-top-color: #6ac498;\n}\n.bt--medium-purple {\n  border-top-color: #9c7fb0;\n}\n.bt--eastern-breeze {\n  border-color: #dae1e5;\n}\n.bt--dark-cerulean {\n  border-top-color: #255c83;\n}\n.bb--chocolate {\n  border-bottom-color: #C85C17;\n}\n.bb--dark-cerulean {\n  border-bottom-color: #255c83;\n}\n.bb-light-bluish-grey {\n  border-bottom-color: #e8eef4;\n}\n.hover-b--black:hover {\n  border-color: #111111;\n}\n.hover-b--inherit:hover {\n  border-color: inherit;\n}\n.hover-b--dark-sea-green-2:hover {\n  border-color: #128a93;\n}\n.hover-b--slate-blue-grey:hover {\n  border-color: #4d616e;\n}\n.focus-b--light-sea-green-2:focus {\n  border-color: #0bb9b5;\n}\n.focus-b--cadet-blue:focus {\n  border-color: #6288A5;\n}\n.focus-b--slate-blue-grey:focus {\n  border-color: #4d616e;\n}\n.placeholder-light-slate-grey::placeholder {\n  color: #6b8699;\n}\n.br0 {\n  border-radius: 0;\n}\n.br1 {\n  border-radius: 0.125rem;\n}\n.br2 {\n  border-radius: 0.25rem;\n}\n.br3 {\n  border-radius: 0.5rem;\n}\n.br4 {\n  border-radius: 1rem;\n}\n.br-50 {\n  border-radius: 50%;\n}\n.br-100 {\n  border-radius: 100%;\n}\n.br-pill {\n  border-radius: 9999px;\n}\n.br--bottom {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.br--left {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.br--right {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.br--top {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n/**\n * Box Shadow\n * offset-x | offset-y | blur-radius | spread-radius | color\n * NOTE: This naming convention is too verbose so I'm open to better\n * suggestions!\n */\n.shadow-none {\n  box-shadow: none;\n}\n.shadow-8-04 {\n  box-shadow: 0 0 8px 0 rgba(17, 17, 17, 0.4);\n}\n.shadow-black-1 {\n  -webkit-box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 10px 15px 0px rgba(0, 0, 0, 0.2);\n}\n.shadow-black-2 {\n  -webkit-box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);\n  -moz-box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);\n  box-shadow: 0 5px 5px -5px rgba(17, 17, 17, 0.5);\n}\n.shadow-black-3 {\n  -webkit-box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);\n  -moz-box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);\n  box-shadow: 2px 1px 8px rgba(17, 17, 17, 0.4);\n}\n.shadow-black-4 {\n  -webkit-box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);\n  -moz-box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);\n  box-shadow: 0px 0px 1px rgba(17, 17, 17, 0.2);\n}\n.shadow-black-16 {\n  -webkit-box-shadow: 0 2px 16px 0 rgba(77, 96, 110, 0.05);\n  -moz-box-shadow: 0 2px 16px 0 rgba(77, 96, 110, 0.05);\n  box-shadow: 0 2px 16px 0 rgba(77, 96, 110, 0.05);\n}\n.shadow-faint-black {\n  -webkit-box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);\n}\n@media screen and (max-width: 520px) {\n  .shadow-none-m {\n    box-shadow: none;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .shadow-none-l {\n    box-shadow: none;\n  }\n}\n.x--50-y-50 {\n  -webkit-transform: translateX(-50%) translateY(50%);\n  -moz-transform: translateX(-50%) translateY(50%);\n  -o-transform: translateX(-50%) translateY(50%);\n  -ms-transform: translateX(-50%) translateY(50%);\n  transform: translateX(-50%) translateY(50%);\n}\n.x--50-y-100 {\n  -webkit-transform: translateX(-50%) translateY(100%);\n  -moz-transform: translateX(-50%) translateY(100%);\n  -o-transform: translateX(-50%) translateY(100%);\n  -ms-transform: translateX(-50%) translateY(100%);\n  transform: translateX(-50%) translateY(100%);\n}\n.x--50-y--50 {\n  -webkit-transform: translateX(-50%) translateY(-50%);\n  -moz-transform: translateX(-50%) translateY(-50%);\n  -o-transform: translateX(-50%) translateY(-50%);\n  -ms-transform: translateX(-50%) translateY(-50%);\n  transform: translateX(-50%) translateY(-50%);\n}\n.x--50-y--100 {\n  -webkit-transform: translateX(-50%) translateY(-100%);\n  -moz-transform: translateX(-50%) translateY(-100%);\n  -o-transform: translateX(-50%) translateY(-100%);\n  -ms-transform: translateX(-50%) translateY(-100%);\n  transform: translateX(-50%) translateY(-100%);\n}\n.x-50 {\n  -webkit-transform: translateX(50%);\n  -moz-transform: translateX(50%);\n  -o-transform: translateX(50%);\n  -ms-transform: translateX(50%);\n  transform: translateX(50%);\n}\n.x-100-y--50 {\n  -webkit-transform: translateX(100%) translateY(-50%);\n  -moz-transform: translateX(100%) translateY(-50%);\n  -o-transform: translateX(100%) translateY(-50%);\n  -ms-transform: translateX(100%) translateY(-50%);\n  transform: translateX(100%) translateY(-50%);\n}\n.x-100 {\n  -webkit-transform: translateX(100%);\n  -moz-transform: translateX(100%);\n  -o-transform: translateX(100%);\n  -ms-transform: translateX(100%);\n  transform: translateX(100%);\n}\n.x--50 {\n  -webkit-transform: translateX(-50%);\n  -moz-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n.x--100 {\n  -webkit-transform: translateX(-100%);\n  -moz-transform: translateX(-100%);\n  -o-transform: translateX(-100%);\n  -ms-transform: translateX(-100%);\n  transform: translateX(-100%);\n}\n.x0 {\n  -webkit-transform: translateX(0);\n  -moz-transform: translateX(0);\n  -o-transform: translateX(0);\n  -ms-transform: translateX(0);\n  transform: translateX(0);\n}\n.y--50 {\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.y--100 {\n  -webkit-transform: translateY(-100%);\n  -moz-transform: translateY(-100%);\n  -o-transform: translateY(-100%);\n  -ms-transform: translateY(-100%);\n  transform: translateY(-100%);\n}\n.y-100 {\n  -webkit-transform: translateY(100%);\n  -moz-transform: translateY(100%);\n  -o-transform: translateY(100%);\n  -ms-transform: translateY(100%);\n  transform: translateY(100%);\n}\n.y0 {\n  -webkit-transform: translateY(0);\n  -moz-transform: translateY(0);\n  -o-transform: translateY(0);\n  -ms-transform: translateY(0);\n  transform: translateY(0);\n}\n.x-10 {\n  -webkit-transform: translateX(10px);\n  -moz-transform: translateX(10px);\n  -o-transform: translateX(10px);\n  -ms-transform: translateX(10px);\n  transform: translateX(10px);\n}\n.x-vw-100 {\n  -webkit-transform: translateX(100vw);\n  -moz-transform: translateX(100vw);\n  -o-transform: translateX(100vw);\n  -ms-transform: translateX(100vw);\n  transform: translateX(100vw);\n}\n.y-vh--100 {\n  -webkit-transform: translateY(-100vh);\n  -moz-transform: translateY(-100vh);\n  -o-transform: translateY(-100vh);\n  -ms-transform: translateY(-100vh);\n  transform: translateY(-100vh);\n}\n@media screen and (max-width: 520px) {\n  .x--100-m {\n    -webkit-transform: translateX(-100%);\n    -moz-transform: translateX(-100%);\n    -o-transform: translateX(-100%);\n    -ms-transform: translateX(-100%);\n    transform: translateX(-100%);\n  }\n}\n@media screen and (min-width: 1200px) {\n  .x-0-l {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -o-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n.rotate-90 {\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.rotate-180 {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rotate--90 {\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -o-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n.aspect-ratio {\n  height: 0;\n  position: relative;\n}\n.aspect-ratio--16x9 {\n  padding-bottom: 56.25%;\n}\n.aspect-ratio--9x16 {\n  padding-bottom: 177.77%;\n}\n.aspect-ratio--4x3 {\n  padding-bottom: 75%;\n}\n.aspect-ratio--3x4 {\n  padding-bottom: 133.33%;\n}\n.aspect-ratio--6x4 {\n  padding-bottom: 66.6%;\n}\n.aspect-ratio--4x6 {\n  padding-bottom: 150%;\n}\n.aspect-ratio--8x5 {\n  padding-bottom: 62.5%;\n}\n.aspect-ratio--5x8 {\n  padding-bottom: 160%;\n}\n.aspect-ratio--7x5 {\n  padding-bottom: 71.42%;\n}\n.aspect-ratio--5x7 {\n  padding-bottom: 140%;\n}\n.aspect-ratio--1x1 {\n  padding-bottom: 100%;\n}\n.scroll-touch {\n  -webkit-overflow-scrolling: touch;\n}\n.scroll-auto {\n  -webkit-overflow-scrolling: auto;\n}\n.no-select {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.aol-corporate {\n  color: #35B8D3;\n}\n.bg-aol-corporate {\n  background-color: #35B8D3;\n}\n.bg-aol-corporate-light {\n  background-color: #ddf3f7;\n}\n.b--aol-corporate {\n  border-color: #35B8D3;\n}\n.bb-aol-corporate {\n  border-bottom-color: #35B8D3;\n}\n.aol-employment {\n  color: #5CCCAE;\n}\n.bg-aol-employment {\n  background-color: #5CCCAE;\n}\n.bg-aol-employment-light {\n  background-color: #f7fdfb;\n}\n.b--aol-employment {\n  border-color: #5CCCAE;\n}\n.bb-aol-employment {\n  border-bottom-color: #5CCCAE;\n}\n.aol-ri {\n  color: #FF8657;\n}\n.bg-aol-ri {\n  background-color: #FF8657;\n}\n.bg-aol-ri-light {\n  background-color: #ffffff;\n}\n.b--aol-ri {\n  border-color: #FF8657;\n}\n.bb-aol-ri {\n  border-bottom-color: #FF8657;\n}\n@keyframes fade-in-animation {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fade-out-animation {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.fade-in-animate {\n  opacity: 1;\n  animation: fade-in-animation 250ms linear 1;\n}\n.fade-out-animate {\n  opacity: 1;\n  animation: fade-out-animation 250ms linear 1;\n}\n.fade-headless {\n  opacity: 1;\n  transition: opacity 250ms linear;\n}\n.fade-headless[data-closed] {\n  opacity: 0;\n}\n/*\n\n  Typography\n  ----------\n\n  Utility classes for typography.\n\n*/\n.font-default {\n  font-family: \"Source Sans Pro\", \"Arial\", sans-serif;\n}\n.f1 {\n  font-size: 3rem;\n}\n.f2 {\n  font-size: 2.25rem;\n}\n.f3 {\n  font-size: 1.5rem;\n}\n.f4 {\n  font-size: 1.25rem;\n}\n.f5 {\n  font-size: 1rem;\n}\n.f6 {\n  font-size: 0.875rem;\n}\n.f7 {\n  font-size: 0.75rem;\n}\n.f8 {\n  font-size: 0.625rem;\n}\n.fht {\n  font-size: 1.75rem;\n}\n@media screen and (max-width: 768px) {\n  .f1-t {\n    font-size: 3rem;\n  }\n  .f2-t {\n    font-size: 2.25rem;\n  }\n  .f3-t {\n    font-size: 1.5rem;\n  }\n  .f4-t {\n    font-size: 1.25rem;\n  }\n  .f5-t {\n    font-size: 1rem;\n  }\n  .f6-t {\n    font-size: 0.875rem;\n  }\n  .f7-t {\n    font-size: 0.75rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .f1-m {\n    font-size: 3rem;\n  }\n  .f2-m {\n    font-size: 2.25rem;\n  }\n  .f3-m {\n    font-size: 1.5rem;\n  }\n  .f4-m {\n    font-size: 1.25rem;\n  }\n  .f5-m {\n    font-size: 1rem;\n  }\n  .f6-m {\n    font-size: 0.875rem;\n  }\n  .f7-m {\n    font-size: 0.75rem;\n  }\n}\n.untracked {\n  letter-spacing: normal;\n}\n.tracked {\n  letter-spacing: 0.1rem;\n}\n.tracked-cosy {\n  letter-spacing: -0.005rem;\n}\n.tracked-tight {\n  letter-spacing: -0.05rem;\n}\n.tracked-mega {\n  letter-spacing: 0.25rem;\n}\n.normal {\n  font-weight: normal;\n}\n.b {\n  font-weight: bold;\n}\n.lighter {\n  font-weight: lighter;\n}\n.fw2 {\n  font-weight: 200;\n}\n.fw3 {\n  font-weight: 300;\n}\n.fw4 {\n  font-weight: 400;\n}\n.fw5 {\n  font-weight: 500;\n}\n.fw6 {\n  font-weight: 600;\n}\n.fw7 {\n  font-weight: 700;\n}\n.fw8 {\n  font-weight: 800;\n}\n.i {\n  font-style: italic;\n}\n.fs-normal {\n  font-style: normal;\n}\n.lh-solid {\n  line-height: 1;\n}\n.lh-headline {\n  line-height: 1.17;\n}\n.lh-title {\n  line-height: 1.25;\n}\n.lh-copy-variant {\n  line-height: 1.44;\n}\n.lh-copy {\n  line-height: 1.5;\n}\n.lh-pagination {\n  line-height: 1.75;\n}\n.lh-copy--spaced {\n  line-height: 2.25;\n}\n.tc {\n  text-align: center;\n}\n.tr {\n  text-align: right;\n}\n.tl {\n  text-align: left;\n}\n@media screen and (max-width: 520px) {\n  .tc-m {\n    text-align: center;\n  }\n  .tr-m {\n    text-align: right;\n  }\n  .tl-m {\n    text-align: left;\n  }\n}\n.vt {\n  vertical-align: top;\n}\n.vm {\n  vertical-align: middle;\n}\n.vbs {\n  vertical-align: baseline;\n}\n.no-underline {\n  text-decoration: none;\n}\n.underline {\n  text-decoration: underline;\n}\n.decoration-inherit {\n  text-decoration: inherit;\n}\n.hover-underline:hover {\n  text-decoration: underline;\n}\n.hover-no-underline:hover {\n  text-decoration: none;\n}\n.hover-b:hover {\n  font-weight: bold;\n}\n.ws-normal {\n  white-space: normal;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.pre {\n  white-space: pre;\n}\n@media screen and (max-width: 520px) {\n  .ws-normal-m {\n    white-space: normal;\n  }\n}\n@media screen and (max-width: 768px) {\n  .ws-normal-t {\n    white-space: normal;\n  }\n  .nowrap-t {\n    white-space: nowrap;\n  }\n}\n.o-auto {\n  overflow: auto;\n}\n.o-hidden {\n  overflow: hidden;\n}\n.truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ttc {\n  text-transform: capitalize;\n}\n.ttl {\n  text-transform: lowercase;\n}\n.ttn {\n  text-transform: none;\n}\n.ttu {\n  text-transform: uppercase;\n}\n.measure {\n  max-width: 30em;\n}\n.measure-wide {\n  max-width: 34em;\n}\n.measure-narrow {\n  max-width: 20em;\n}\n@media screen and (min-width: 769px) {\n  .measure-d {\n    max-width: 30em;\n  }\n  .measure-wide-d {\n    max-width: 34em;\n  }\n  .measure-narrow-d {\n    max-width: 20em;\n  }\n}\n.indent {\n  text-indent: 1rem;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.disable-select {\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer */\n  -webkit-user-select: none;\n  /* Chrome, Safari, and Opera */\n  user-select: none;\n}\n.ds {\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer */\n  -webkit-user-select: none;\n  /* Chrome, Safari, and Opera */\n  user-select: none;\n}\n.wb-all {\n  word-break: break-all;\n}\n.wb-word {\n  word-break: break-word;\n}\n.wb-keep {\n  word-break: keep-all;\n}\n@media screen and (max-width: 768px) {\n  .wb-all-t {\n    word-break: break-all;\n  }\n}\n@media screen and (max-width: 520px) {\n  .wb-word-m {\n    word-break: break-word;\n  }\n}\n.ca-grid-card {\n  height: 26.25rem;\n}\n.ca-grid-card a {\n  color: #0bb9b5;\n  text-decoration: none;\n}\n.ca-grid-card a:hover {\n  text-decoration: underline;\n}\n.arrow-link {\n  text-decoration: none !important;\n}\n.arrow-link a {\n  color: #6288A5 !important;\n}\n.arrow-link svg {\n  color: #111111 !important;\n}\n.arrow-link:hover * {\n  color: #128a93 !important;\n  text-decoration: underline !important;\n}\n.ca-content a {\n  color: #0bb9b5;\n  text-decoration: none;\n}\n.ca-content > ul {\n  list-style-type: initial;\n  padding-left: 1rem;\n}\n.ca-tile-title p {\n  margin: 0 !important;\n}\n.ca-article-headline-title {\n  line-height: 1.17;\n  margin-top: 1.5rem;\n  margin-bottom: 0.375rem;\n}\n.announcements-content div:first-child > h3:first-child {\n  margin-top: 0;\n}\n.announcements-content div:not(:first-child) > h3 {\n  margin-top: 3rem;\n}\n.announcements-content h3 {\n  font-size: 1.25rem;\n  font-weight: 800;\n  margin: 1.25rem 0 0.4rem;\n  color: #111111;\n}\n.announcements-content strong {\n  color: #111111;\n  letter-spacing: 0.1px;\n}\n.announcements-content p,\n.announcements-content li {\n  font-size: 0.9375rem;\n  color: #404040;\n  line-height: 1.17;\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n.announcements-content li {\n  letter-spacing: 0.1px;\n}\n.announcements-content a {\n  text-decoration: none;\n}\n.announcements-content a:hover {\n  text-decoration: underline;\n}\n.announcements-content ul,\n.announcements-content ol {\n  padding-left: 1.5rem;\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n.announcements-content div:first-child > p:first-child {\n  margin-top: 0.5rem;\n}\n.announcements-content div:first-child > ul:first-child {\n  margin-top: 0.5rem;\n}\n.announcements-content div:first-child > ul:first-child > li:first-child {\n  margin-top: 0.25rem;\n}\n.article-page-icons .svg-base {\n  margin-left: 0.375rem;\n  margin-right: 0.375rem;\n  height: 24px !important;\n  width: 24px !important;\n}\n.article-page-icons .MuiIconButton-root {\n  color: #6288A5;\n  outline: 0;\n  padding: 0;\n  height: 2.5rem;\n  width: 2.5rem;\n  font-size: inherit;\n}\n.article-page-icons .MuiIconButton-root:hover {\n  color: #128a93;\n}\n.share-buttons-container .MuiIconButton-root {\n  color: #6288A5 !important;\n  outline: 0;\n  font-size: inherit;\n  padding: 4px;\n}\n.share-buttons-container .MuiIconButton-root:hover {\n  color: #128a93;\n}\n.submit-form-button .MuiButton-root {\n  padding: 1rem 2rem;\n  color: #FFFFFF;\n  background-color: #0bb9b5;\n}\n.submit-form-button .MuiButton-root:hover {\n  background-color: #128a93;\n}\n.submit-form-button .MuiButton-root:disabled {\n  background-color: #73797A;\n}\n.article-grid a {\n  outline: 0 !important;\n}\n.article-section {\n  min-height: 60rem;\n}\n@media screen and (max-width: 632px) {\n  .article-section {\n    height: 64rem;\n  }\n}\n@media screen and (max-width: 566px) {\n  .article-section {\n    height: 66rem;\n  }\n}\n@media screen and (max-width: 430px) {\n  .article-section {\n    height: 70rem;\n  }\n}\n@media screen and (max-width: 420px) {\n  .article-section {\n    height: 72rem;\n  }\n}\n@media screen and (max-width: 382px) {\n  .article-section {\n    height: 76rem;\n  }\n}\n@media screen and (max-width: 382px) {\n  .article-section {\n    height: 80rem;\n  }\n}\n.Toastify__progress-bar--default {\n  background: #3FC599;\n}\n.icon-clipboard-container,\n.icon-preview-toggle-container {\n  width: 32px;\n  height: 32px;\n}\n.icon-clipboard-container .MuiSvgIcon-root,\n.icon-preview-toggle-container .MuiSvgIcon-root {\n  width: 32px;\n  height: 32px;\n}\n.icon-clipboard-container:hover,\n.icon-preview-toggle-container:hover {\n  color: #128a93 !important;\n}\n.expand-more-button {\n  width: 100%;\n  height: 0;\n  text-align: center;\n}\n.expand-more-button-container {\n  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);\n  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);\n  background: -ms-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);\n  background: -o-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);\n  background: linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ededed 75%);\n}\n.tile-frosted-bottom {\n  background: #ffffff;\n  background: linear-gradient(0deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);\n  /*.linear-gradient(top, rgba(255, 255, 255, 0), 0%, rgb(255, 255, 255), 100%);*/\n}\n.tooltip-wrapper::before {\n  position: absolute;\n  left: 0;\n  width: 1.5rem;\n  top: 0;\n  bottom: 0;\n  content: '';\n  z-index: 5;\n  background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ededed 100%);\n}\n.tooltip-wrapper::after {\n  position: absolute;\n  right: 0;\n  width: 1.5rem;\n  top: 0;\n  bottom: 0;\n  content: '';\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ededed 100%);\n}\n.hover-bg-ghost-grey:hover {\n  background-color: #F7F9FA;\n}\n.bg-precedents-blue-30 {\n  background-color: rgba(0, 75, 122, 0.3);\n}\n.bg-precedents-blue-20 {\n  background-color: rgba(0, 75, 122, 0.2);\n}\n.bg-precedents-blue-10 {\n  background-color: rgba(0, 75, 122, 0.1);\n}\n.bg-precedents-blue-5 {\n  background-color: rgba(0, 75, 122, 0.05);\n}\n.hover-bg-precedents-blue-10:hover {\n  background-color: rgba(0, 75, 122, 0.1);\n}\n.hover-bg-precedents-blue-20:hover {\n  background-color: rgba(0, 75, 122, 0.2);\n}\n.precedents-tile .MuiButton-root:hover {\n  background-color: rgba(0, 75, 122, 0.1);\n}\n.precedents-description p {\n  margin: 0 0 10px;\n}\n.bg-precedents-blue-exp {\n  background-color: #004b7a !important;\n}\n.action-buttons button {\n  cursor: pointer;\n  background-color: #FFFFFF;\n}\n.menu-list-button {\n  -moz-appearance: menulist-button;\n  -webkit-appearance: menulist-button;\n}\n.texteditor .DraftEditor-root {\n  padding: 0.5em;\n  margin: 0;\n  background: rgba(255, 255, 255, 0.5);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  min-height: 17rem;\n  position: relative;\n}\n.texteditor .side-toolbar {\n  position: absolute;\n  top: 25px;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 2em;\n  transition: top 0.2s;\n}\n.texteditor .side-toolbar .svg-icon {\n  color: rgba(0, 0, 0, 0.2);\n  fill: rgba(0, 0, 0, 0.2);\n  font-size: 1.4em;\n  cursor: pointer;\n  vertical-align: middle;\n}\n.texteditor .side-toolbar .svg-icon.a-menu {\n  font-size: 1.4em;\n}\n.texteditor .public-DraftEditorPlaceholder-root {\n  position: absolute;\n}\n.texteditor .paragraph,\n.public-DraftStyleDefault-ul,\n.public-DraftStyleDefault-ol {\n  margin-bottom: 0;\n}\n.public-DraftStyleDefault-ul,\n.public-DraftStyleDefault-ol {\n  margin-top: 0;\n}\n.texteditor {\n  position: relative;\n  padding-left: 2em;\n}\n.texteditor .paragraph {\n  margin-bottom: 0.5em;\n}\n.texteditor blockquote {\n  padding: 10px 20px;\n  margin: 0 0 20px;\n  border-left: 5px solid #eee;\n}\n.texteditor img {\n  max-width: 100%;\n}\n.texteditor .toolbar {\n  position: absolute;\n  z-index: 9999;\n  height: 2em;\n  cursor: default;\n  pointer-events: none;\n  transition: opacity 0.2s;\n  opacity: 0;\n}\n.texteditor .toolbar.side {\n  top: 0;\n  left: -1px;\n}\n.texteditor .toolbar.active {\n  opacity: 1;\n  pointer-events: all;\n}\n.texteditor .toolbar.inline {\n  font-size: 1.1em;\n}\n.texteditor .toolbar .toolbar-icons {\n  position: relative;\n  z-index: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  list-style: none;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  background: #f5f5f5;\n  border: 1px solid #ddd;\n  font-size: 1em;\n}\n.texteditor .toolbar .toolbar-icons .toolbar-static {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  background: #ddd;\n  width: 2.1em;\n  max-width: 2.1em;\n}\n.texteditor .toolbar .toolbar-icons .toolbar-static .svg-icon {\n  fill: #000;\n  width: auto;\n  height: auto;\n  margin: 0;\n}\n.texteditor .toolbar .toolbar-icons .toolbar-icon {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: baseline;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  height: 100%;\n  width: 2.4em;\n  line-height: 2.5em;\n  max-width: 2.4em;\n  font-size: 0.8em;\n  color: #aaa;\n  transition: all 0.15s linear;\n  cursor: pointer;\n}\n.texteditor .toolbar .toolbar-icons .toolbar-icon.active,\n.texteditor .toolbar .toolbar-icons .toolbar-icon:hover {\n  color: #222;\n}\n.texteditor .toolbar .toolbar-icons .toolbar-icon.active .svg-icon,\n.texteditor .toolbar .toolbar-icons .toolbar-icon:hover .svg-icon {\n  fill: #222;\n  color: #222;\n}\n.texteditor .toolbar-icon:hover .toolbar .toolbar-icons .toolbar-icon i {\n  margin: 0;\n  padding: 0;\n  color: #444;\n  font-size: 1.8em;\n}\n.link-editor {\n  display: block;\n  max-width: 800px;\n  margin: auto;\n  width: 96%;\n  background: #ffffff;\n  padding: 5px 20px 20px;\n  font-size: 1.3em;\n}\n.link-editor .form-actions {\n  text-align: right;\n  margin-top: 1em;\n}\n.link-editor .form-actions a {\n  display: inline-block;\n  font-size: 1em;\n  width: 10em;\n  margin: 0 0.5em;\n}\n@media screen and (max-width: 520px) {\n  .link-editor .form-actions {\n    text-align: center;\n    margin: 1em 0;\n  }\n  .link-editor .form-actions a {\n    width: 60%;\n    margin: 0.2em 0;\n  }\n}\n.link-editor .input-container {\n  padding: 1em 2em;\n}\n.link-editor .input-container input {\n  width: 100%;\n  font-size: 1.1em;\n  padding: 0.4em;\n  outline: none;\n  border: 2px solid #eee;\n  border-radius: 2px;\n}\n.group .texteditor {\n  padding: 18px 64px 18px 64px;\n  font-size: 1.5rem;\n  display: block;\n  font-weight: 400;\n}\n.group .toggle-texteditor {\n  margin: 0 1em 1em 1em;\n}\n.group .toggle-texteditor svg {\n  fill: #fff;\n}\n.placeholder-cadet-blue-important input::placeholder {\n  color: #6288A5 !important;\n  opacity: 1;\n}\n.date-picker input::placeholder {\n  color: #6288A5 !important;\n  opacity: 1;\n}\n.date-picker input {\n  background: transparent;\n  border: 1px solid;\n  width: 11rem;\n}\n.date-picker .react-datepicker-popper {\n  left: -2.25rem !important;\n  top: 0 !important;\n  z-index: 2;\n}\n.filter-checkbox-icon {\n  width: 1rem;\n}\n.filter-checkbox-icon svg g {\n  stroke: none;\n}\n.drawer-svg-icon svg {\n  top: 0;\n}\n.header-action-button.MuiButtonBase-root {\n  background-color: rgba(255, 202, 40, 0.3);\n}\n.header-action-button.MuiButtonBase-root:hover {\n  background-color: #FFCA28;\n}\n.header-action-button-disabled.MuiButton-root.Mui-disabled {\n  color: #6288A5;\n}\n.svg-stroke-white svg path,\n.svg-stroke-white svg polyline {\n  stroke: #FFFFFF;\n}\n.svg-stroke-cadet-blue svg path,\n.svg-stroke-cadet-blue svg polyline {\n  stroke: #6288A5;\n}\n.svg-fill-cadet-blue svg {\n  fill: #6288A5;\n}\n.svg-fill-white svg {\n  fill: #FFFFFF;\n}\n/*\n\n  Fix\n  ---\n\n  Fixes! Add a comment explaining what bug it fixes and if you found the\n  solution on e.g. StackOverflow then include the link.\n\n*/\n.chrome-nested-flex-column-fix {\n  min-width: 0;\n  min-height: 0;\n}\n.clearfix:before,\n.clearfix:after {\n  content: \" \";\n  display: table;\n}\n.clearfix:after {\n  clear: both;\n}\n@media screen and (min-width: 769px) {\n  .firefox-flex-grow-fix {\n    flex-basis: 0;\n  }\n}\n.ie-fix-justify-evenly {\n  justify-content: space-around;\n}\n@supports (-ms-ime-align: auto) {\n  .justify-evenly {\n    justify-content: space-around;\n  }\n}\n.ie-hide-default-select-chevron::-ms-expand {\n  display: none;\n}\n.margin-collapse-fix:after {\n  content: '';\n  overflow: auto;\n  display: block;\n}\n.no-csspositionsticky .ie-sticky-fix {\n  position: fixed;\n}\n.safari-border-image-fix {\n  border-right: 0 solid transparent;\n}\n.muiButtonHoverLinesFix.muiButtonHoverLinesFix:hover {\n  text-decoration: none;\n}\nselect::-ms-expand {\n  display: none;\n}\n.ie-min-height-flex-items-center-fix {\n  padding-top: 0.875rem !important;\n  padding-bottom: 0.875rem !important;\n}\n.ie-min-height-flex-items-center-fix .ie-prefix-hack {\n  top: 0.875rem;\n}\n.popover.bottom > .arrow::after {\n  border-bottom-color: #004b7a !important;\n}\n.ie-layout-fix {\n  max-width: 100%;\n}\n.ie-layout-fix > div {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1400px;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n@media screen and (max-width: 768px) {\n  .ie-layout-fix > div {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .ie-layout-fix > div {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n}\n.ie-side {\n  display: block;\n}\n.items-center-ie-fix {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.outline-0 select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n@media screen and (max-width: 520px) {\n  .header-icon-mobile-width {\n    width: 2.25rem;\n  }\n}\n/* Stops table wrapping onto new line - see FC-1436*/\n@media only screen and (min-width: 1200px) {\n  /* Duplicating class selector to increase specificity of rule to overwrite layout-width-constraints max-width */\n  .deal-watch-width-constraint {\n    width: 72vw !important;\n  }\n}\n.deal-watch-width-constraint {\n  width: 96vw;\n}\n.popover-content a {\n  color: #FFFFFF;\n}\n.new-ticker div p {\n  margin: 0;\n}\n.icon-button-bg-color-active {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n.rich-text-editor .public-DraftEditor-content {\n  min-height: 12rem;\n}\n.ie-basis0-fix {\n  flex-basis: auto;\n}\n/*\n\n  Grid\n  ----\n\n  You can use the .grid-with-gutters(@n, @gw) mixin to create a grid structure\n  with n items per row and gutter width gw.\n\n  Note that the styles inside the media queries don't apply to smaller screen\n  widths!\n  i.e. if you want a grid that has 4 items per row on desktop and tablet and 1\n  on mobile you would need grid-4-gutter-4-d, grid-4-gutter-4-t and\n  grid-1-gutter-4-d.\n\n  This is because the margins on the nth children (which are the outermost items\n  in the grid) can't be reliably overridden.\n\n*/\n.grid-1-gutter-4 {\n  display: flex;\n  flex-wrap: wrap;\n}\n.grid-1-gutter-4 > * {\n  width: calc((100% / 1) - 0rem);\n  margin: 0.25rem;\n}\n.grid-1-gutter-4 > *:nth-child(1n - 0) {\n  margin-left: 0;\n}\n.grid-1-gutter-4 > *:nth-child(1n) {\n  margin-right: 0;\n}\n.grid-1-gutter-4 > *:nth-child(-n + 1) {\n  margin-top: 0;\n}\n.grid-1-gutter-4 > *:nth-last-child(-n + 1) {\n  margin-bottom: 0;\n}\n.grid-2-gutter-4 {\n  display: flex;\n  flex-wrap: wrap;\n}\n.grid-2-gutter-4 > * {\n  width: calc((100% / 2) - 1rem);\n  margin: 0.25rem;\n}\n.grid-2-gutter-4 > *:nth-child(2n - 1) {\n  margin-left: 0;\n}\n.grid-2-gutter-4 > *:nth-child(2n) {\n  margin-right: 0;\n}\n.grid-2-gutter-4 > *:nth-child(-n + 2) {\n  margin-top: 0;\n}\n.grid-2-gutter-4 > *:nth-last-child(-n + 2) {\n  margin-bottom: 0;\n}\n.grid-3-gutter-4 {\n  display: flex;\n  flex-wrap: wrap;\n}\n.grid-3-gutter-4 > * {\n  width: calc((100% / 3) - 1rem);\n  margin: 0.25rem;\n}\n.grid-3-gutter-4 > *:nth-child(3n - 2) {\n  margin-left: 0;\n}\n.grid-3-gutter-4 > *:nth-child(3n) {\n  margin-right: 0;\n}\n.grid-3-gutter-4 > *:nth-child(-n + 3) {\n  margin-top: 0;\n}\n.grid-3-gutter-4 > *:nth-last-child(-n + 3) {\n  margin-bottom: 0;\n}\n.grid-4-gutter-4 {\n  display: flex;\n  flex-wrap: wrap;\n}\n.grid-4-gutter-4 > * {\n  width: calc((100% / 4) - 1rem);\n  margin: 0.25rem;\n}\n.grid-4-gutter-4 > *:nth-child(4n - 3) {\n  margin-left: 0;\n}\n.grid-4-gutter-4 > *:nth-child(4n) {\n  margin-right: 0;\n}\n.grid-4-gutter-4 > *:nth-child(-n + 4) {\n  margin-top: 0;\n}\n.grid-4-gutter-4 > *:nth-last-child(-n + 4) {\n  margin-bottom: 0;\n}\n.grid-5-gutter-4 {\n  display: flex;\n  flex-wrap: wrap;\n}\n.grid-5-gutter-4 > * {\n  width: calc((100% / 5) - 1rem);\n  margin: 0.25rem;\n}\n.grid-5-gutter-4 > *:nth-child(5n - 4) {\n  margin-left: 0;\n}\n.grid-5-gutter-4 > *:nth-child(5n) {\n  margin-right: 0;\n}\n.grid-5-gutter-4 > *:nth-child(-n + 5) {\n  margin-top: 0;\n}\n.grid-5-gutter-4 > *:nth-last-child(-n + 5) {\n  margin-bottom: 0;\n}\n@media screen and (min-width: 769px) {\n  .grid-1-gutter-4-d {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-1-gutter-4-d > * {\n    width: calc((100% / 1) - 0rem);\n    margin: 0.25rem;\n  }\n  .grid-1-gutter-4-d > *:nth-child(1n - 0) {\n    margin-left: 0;\n  }\n  .grid-1-gutter-4-d > *:nth-child(1n) {\n    margin-right: 0;\n  }\n  .grid-1-gutter-4-d > *:nth-child(-n + 1) {\n    margin-top: 0;\n  }\n  .grid-1-gutter-4-d > *:nth-last-child(-n + 1) {\n    margin-bottom: 0;\n  }\n  .grid-2-gutter-4-d {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-2-gutter-4-d > * {\n    width: calc((100% / 2) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-2-gutter-4-d > *:nth-child(2n - 1) {\n    margin-left: 0;\n  }\n  .grid-2-gutter-4-d > *:nth-child(2n) {\n    margin-right: 0;\n  }\n  .grid-2-gutter-4-d > *:nth-child(-n + 2) {\n    margin-top: 0;\n  }\n  .grid-2-gutter-4-d > *:nth-last-child(-n + 2) {\n    margin-bottom: 0;\n  }\n  .grid-3-gutter-4-d {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-3-gutter-4-d > * {\n    width: calc((100% / 3) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-3-gutter-4-d > *:nth-child(3n - 2) {\n    margin-left: 0;\n  }\n  .grid-3-gutter-4-d > *:nth-child(3n) {\n    margin-right: 0;\n  }\n  .grid-3-gutter-4-d > *:nth-child(-n + 3) {\n    margin-top: 0;\n  }\n  .grid-3-gutter-4-d > *:nth-last-child(-n + 3) {\n    margin-bottom: 0;\n  }\n  .grid-4-gutter-4-d {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-4-gutter-4-d > * {\n    width: calc((100% / 4) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-4-gutter-4-d > *:nth-child(4n - 3) {\n    margin-left: 0;\n  }\n  .grid-4-gutter-4-d > *:nth-child(4n) {\n    margin-right: 0;\n  }\n  .grid-4-gutter-4-d > *:nth-child(-n + 4) {\n    margin-top: 0;\n  }\n  .grid-4-gutter-4-d > *:nth-last-child(-n + 4) {\n    margin-bottom: 0;\n  }\n  .grid-5-gutter-4-d {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-5-gutter-4-d > * {\n    width: calc((100% / 5) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-5-gutter-4-d > *:nth-child(5n - 4) {\n    margin-left: 0;\n  }\n  .grid-5-gutter-4-d > *:nth-child(5n) {\n    margin-right: 0;\n  }\n  .grid-5-gutter-4-d > *:nth-child(-n + 5) {\n    margin-top: 0;\n  }\n  .grid-5-gutter-4-d > *:nth-last-child(-n + 5) {\n    margin-bottom: 0;\n  }\n}\n@media screen and (min-width: 520px) and (max-width: 768px) {\n  .grid-1-gutter-4-t {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-1-gutter-4-t > * {\n    width: calc((100% / 1) - 0rem);\n    margin: 0.25rem;\n  }\n  .grid-1-gutter-4-t > *:nth-child(1n - 0) {\n    margin-left: 0;\n  }\n  .grid-1-gutter-4-t > *:nth-child(1n) {\n    margin-right: 0;\n  }\n  .grid-1-gutter-4-t > *:nth-child(-n + 1) {\n    margin-top: 0;\n  }\n  .grid-1-gutter-4-t > *:nth-last-child(-n + 1) {\n    margin-bottom: 0;\n  }\n  .grid-2-gutter-4-t {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-2-gutter-4-t > * {\n    width: calc((100% / 2) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-2-gutter-4-t > *:nth-child(2n - 1) {\n    margin-left: 0;\n  }\n  .grid-2-gutter-4-t > *:nth-child(2n) {\n    margin-right: 0;\n  }\n  .grid-2-gutter-4-t > *:nth-child(-n + 2) {\n    margin-top: 0;\n  }\n  .grid-2-gutter-4-t > *:nth-last-child(-n + 2) {\n    margin-bottom: 0;\n  }\n  .grid-3-gutter-4-t {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-3-gutter-4-t > * {\n    width: calc((100% / 3) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-3-gutter-4-t > *:nth-child(3n - 2) {\n    margin-left: 0;\n  }\n  .grid-3-gutter-4-t > *:nth-child(3n) {\n    margin-right: 0;\n  }\n  .grid-3-gutter-4-t > *:nth-child(-n + 3) {\n    margin-top: 0;\n  }\n  .grid-3-gutter-4-t > *:nth-last-child(-n + 3) {\n    margin-bottom: 0;\n  }\n  .grid-4-gutter-4-t {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-4-gutter-4-t > * {\n    width: calc((100% / 4) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-4-gutter-4-t > *:nth-child(4n - 3) {\n    margin-left: 0;\n  }\n  .grid-4-gutter-4-t > *:nth-child(4n) {\n    margin-right: 0;\n  }\n  .grid-4-gutter-4-t > *:nth-child(-n + 4) {\n    margin-top: 0;\n  }\n  .grid-4-gutter-4-t > *:nth-last-child(-n + 4) {\n    margin-bottom: 0;\n  }\n  .grid-5-gutter-4-t {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-5-gutter-4-t > * {\n    width: calc((100% / 5) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-5-gutter-4-t > *:nth-child(5n - 4) {\n    margin-left: 0;\n  }\n  .grid-5-gutter-4-t > *:nth-child(5n) {\n    margin-right: 0;\n  }\n  .grid-5-gutter-4-t > *:nth-child(-n + 5) {\n    margin-top: 0;\n  }\n  .grid-5-gutter-4-t > *:nth-last-child(-n + 5) {\n    margin-bottom: 0;\n  }\n}\n@media screen and (max-width: 520px) {\n  .grid-1-gutter-4-m {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-1-gutter-4-m > * {\n    width: calc((100% / 1) - 0rem);\n    margin: 0.25rem;\n  }\n  .grid-1-gutter-4-m > *:nth-child(1n - 0) {\n    margin-left: 0;\n  }\n  .grid-1-gutter-4-m > *:nth-child(1n) {\n    margin-right: 0;\n  }\n  .grid-1-gutter-4-m > *:nth-child(-n + 1) {\n    margin-top: 0;\n  }\n  .grid-1-gutter-4-m > *:nth-last-child(-n + 1) {\n    margin-bottom: 0;\n  }\n  .grid-2-gutter-4-m {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-2-gutter-4-m > * {\n    width: calc((100% / 2) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-2-gutter-4-m > *:nth-child(2n - 1) {\n    margin-left: 0;\n  }\n  .grid-2-gutter-4-m > *:nth-child(2n) {\n    margin-right: 0;\n  }\n  .grid-2-gutter-4-m > *:nth-child(-n + 2) {\n    margin-top: 0;\n  }\n  .grid-2-gutter-4-m > *:nth-last-child(-n + 2) {\n    margin-bottom: 0;\n  }\n  .grid-3-gutter-4-m {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-3-gutter-4-m > * {\n    width: calc((100% / 3) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-3-gutter-4-m > *:nth-child(3n - 2) {\n    margin-left: 0;\n  }\n  .grid-3-gutter-4-m > *:nth-child(3n) {\n    margin-right: 0;\n  }\n  .grid-3-gutter-4-m > *:nth-child(-n + 3) {\n    margin-top: 0;\n  }\n  .grid-3-gutter-4-m > *:nth-last-child(-n + 3) {\n    margin-bottom: 0;\n  }\n  .grid-4-gutter-4-m {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-4-gutter-4-m > * {\n    width: calc((100% / 4) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-4-gutter-4-m > *:nth-child(4n - 3) {\n    margin-left: 0;\n  }\n  .grid-4-gutter-4-m > *:nth-child(4n) {\n    margin-right: 0;\n  }\n  .grid-4-gutter-4-m > *:nth-child(-n + 4) {\n    margin-top: 0;\n  }\n  .grid-4-gutter-4-m > *:nth-last-child(-n + 4) {\n    margin-bottom: 0;\n  }\n  .grid-5-gutter-4-m {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .grid-5-gutter-4-m > * {\n    width: calc((100% / 5) - 1rem);\n    margin: 0.25rem;\n  }\n  .grid-5-gutter-4-m > *:nth-child(5n - 4) {\n    margin-left: 0;\n  }\n  .grid-5-gutter-4-m > *:nth-child(5n) {\n    margin-right: 0;\n  }\n  .grid-5-gutter-4-m > *:nth-child(-n + 5) {\n    margin-top: 0;\n  }\n  .grid-5-gutter-4-m > *:nth-last-child(-n + 5) {\n    margin-bottom: 0;\n  }\n}\n/*\n\n  Helpers\n  -------\n\n  This file is for mixins and helpful generic classes that aren't simple enough\n  to be considered a utility class. Should be used sparingly!\n\n*/\n.screen-reader-text {\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute !important;\n  width: 1px;\n  word-wrap: normal !important;\n}\n.center {\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n.center-h {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -moz-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n.center-v {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n/*\n * Hamburgers\n * @description Tasty CSS-animated hamburgers\n * @author Jonathan Suh @jonsuh\n * @site https://jonsuh.com/hamburgers\n * @link https://github.com/jonsuh/hamburgers\n */\n.hamburger {\n  padding: 0;\n  display: inline-block;\n  cursor: pointer;\n  transition-property: opacity, filter;\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.hamburger:hover {\n  opacity: 0.7;\n}\n.hamburger-box {\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n.hamburger-inner {\n  display: block;\n  width: 100%;\n  height: 2px;\n  border-radius: 4px;\n  position: absolute;\n  background-color: #111111;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.hamburger-inner-1 {\n  top: 0;\n}\n.hamburger-inner-2 {\n  top: 50%;\n}\n.hamburger-inner-3 {\n  top: 100%;\n}\n/*\n\n  Custom\n  ------\n\n  Add any styling that can't be constructed from the generic styles to this\n  file. Include a comment explaining what the styling does.\n\n  This file should be used as a last resort.\n\n*/\n.logo-width {\n  width: 12rem;\n}\n@media screen and (max-width: 768px) {\n  .logo-width {\n    width: 3rem;\n  }\n}\n@media screen and (max-width: 520px) {\n  .logo-width {\n    width: 2rem;\n  }\n}\n.nav-full-right {\n  width: 16rem;\n  -webkit-transform: translate(16rem, 0);\n  -moz-transform: translate(16rem, 0);\n  -o-transform: translate(16rem, 0);\n  -ms-transform: translate(16rem, 0);\n  transform: translate(16rem, 0);\n}\n.application-header,\n.application-content,\n.nav-full-right {\n  -webkit-transition: transform 0.3s;\n  -moz-transition: transform 0.3s;\n  -ms-transition: transform 0.3s;\n  -o-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.show-navigation .application-header,\n.show-navigation .application-content {\n  -webkit-transform: translate(-16rem, 0);\n  -moz-transform: translate(-16rem, 0);\n  -o-transform: translate(-16rem, 0);\n  -ms-transform: translate(-16rem, 0);\n  transform: translate(-16rem, 0);\n}\n.show-navigation .nav-full-right {\n  -webkit-transform: translate(0.0001px, 0);\n  -moz-transform: translate(0.0001px, 0);\n  -o-transform: translate(0.0001px, 0);\n  -ms-transform: translate(0.0001px, 0);\n  transform: translate(0.0001px, 0);\n}\n.accordion-header-center {\n  line-height: 3rem;\n}\n.pop-faqs-icon svg {\n  margin-top: 4px;\n}\n.o-50-hover:hover {\n  -webkit-opacity: 0.5;\n  -moz-opacity: 0.5;\n  opacity: 0.5;\n}\n.feedback-container {\n  position: relative;\n  min-height: 8rem;\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  -o-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n  width: 32rem;\n}\n@media screen and (max-width: 555px) {\n  .feedback-container {\n    max-width: 390px;\n  }\n}\n@media screen and (max-width: 425px) {\n  .feedback-container {\n    max-width: 380px;\n  }\n}\n@media screen and (max-width: 375px) {\n  .feedback-container {\n    max-width: 330px;\n  }\n}\n@media screen and (max-width: 320px) {\n  .feedback-container {\n    max-width: 280px;\n  }\n}\n.feedback-button {\n  left: 0;\n  transform: rotate(270deg) translateY(-5rem) translateX(-2.95rem);\n}\n.fade-out-overlay::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(rgba(255, 255, 255, 0), #F7F9FA);\n}\n.account-item-rows > a,\n.account-item-rows > div,\n.account-item-rows > li {\n  text-decoration: none;\n}\n.account-item-rows > a:nth-child(even),\n.account-item-rows > div:nth-child(even),\n.account-item-rows > li:nth-child(even) {\n  background-color: #FFFFFF;\n}\n.account-overlay {\n  max-width: 800px;\n  margin: auto;\n  width: 96%;\n  background: #FFFFFF;\n  padding: 5px 20px 20px;\n  flex-direction: column;\n}\n.careerText p {\n  margin-bottom: 1rem;\n}\n@media screen and (max-width: 520px) {\n  .mob-team-img-position {\n    background-position: 50% 30%;\n  }\n}\n.legislation-tile .MuiButton-root:hover {\n  background-color: rgba(132, 97, 156, 0.1);\n}\n.hover-default-tab-button-bg:hover {\n  background-color: rgba(0, 140, 159, 0.15);\n}\n.qa-tile-full .MuiButton-root:hover {\n  background-color: rgba(53, 184, 211, 0.1);\n}\n.qa-tile-semi .MuiButton-root:hover {\n  background-color: rgba(63, 197, 153, 0.1);\n}\n.qa-tile-skimmed .MuiButton-root:hover {\n  background-color: rgba(241, 97, 125, 0.1);\n}\n.MuiIconButton-colorSecondary.Mui-checked {\n  color: inherit;\n}\n.MuiIconButton-colorSecondary:hover {\n  background-color: inherit;\n}\n.news-ticker-toggle-button.Mui-disabled {\n  color: #fff;\n}\n.bg-news-publication {\n  background-color: #eaf7f0 !important;\n}\n.bg-news-publication:hover {\n  background-color: #c5e8d7 !important;\n}\n.bg-news-publication.darker {\n  background-color: #b3e1cb !important;\n}\n.bg-flavour-full {\n  background-color: #ddf3f7 !important;\n}\n.bg-flavour-full.darker,\n.bg-flavour-full:hover {\n  background-color: #b3e4ee !important;\n}\n.bg-flavour-full .MuiCheckbox-colorSecondary {\n  color: #35b8d3 !important;\n}\n.bg-flavour-full .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(53, 184, 211, 0.1) !important;\n}\n.bg-flavour-full .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #35b8d3 !important;\n}\n.full .MuiCheckbox-colorSecondary {\n  color: #35b8d3 !important;\n}\n.full .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(53, 184, 211, 0.1) !important;\n}\n.full .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #35b8d3 !important;\n}\n.bg-flavour-semi {\n  background-color: #dcf4ec !important;\n}\n.bg-flavour-semi.darker,\n.bg-flavour-semi:hover {\n  background-color: #b5e8d7 !important;\n}\n.bg-flavour-semi .MuiCheckbox-colorSecondary {\n  color: #3FC599 !important;\n}\n.bg-flavour-semi .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(63, 197, 153, 0.1) !important;\n}\n.bg-flavour-semi .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #3FC599 !important;\n}\n.semi .MuiCheckbox-colorSecondary {\n  color: #3FC599 !important;\n}\n.semi .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(63, 197, 153, 0.1) !important;\n}\n.semi .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #3FC599 !important;\n}\n.bg-flavour-skimmed {\n  background-color: #fdeef1 !important;\n}\n.bg-flavour-skimmed.darker,\n.bg-flavour-skimmed:hover {\n  background-color: #f9bfca !important;\n}\n.bg-flavour-skimmed .MuiCheckbox-colorSecondary {\n  color: #F1617D !important;\n}\n.bg-flavour-skimmed .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(241, 97, 125, 0.1) !important;\n}\n.bg-flavour-skimmed .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #F1617D !important;\n}\n.skimmed .MuiCheckbox-colorSecondary {\n  color: #F1617D !important;\n}\n.skimmed .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(241, 97, 125, 0.1) !important;\n}\n.skimmed .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #F1617D !important;\n}\n.b--flavour-full {\n  border-color: #35b8d3;\n}\n.b--flavour-semi {\n  border-color: #3FC599;\n}\n.b--flavour-skimmed {\n  border-color: #F1617D;\n}\n.hover-bg-flavour-full:hover {\n  background-color: #ddf3f7 !important;\n}\n.hover-bg-flavour-full:hover.darker,\n.hover-bg-flavour-full:hover:hover {\n  background-color: #b3e4ee !important;\n}\n.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary {\n  color: #35b8d3 !important;\n}\n.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(53, 184, 211, 0.1) !important;\n}\n.hover-bg-flavour-full:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #35b8d3 !important;\n}\n.hover-bg-flavour-semi:hover {\n  background-color: #dcf4ec !important;\n}\n.hover-bg-flavour-semi:hover.darker,\n.hover-bg-flavour-semi:hover:hover {\n  background-color: #b5e8d7 !important;\n}\n.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary {\n  color: #3FC599 !important;\n}\n.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(63, 197, 153, 0.1) !important;\n}\n.hover-bg-flavour-semi:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #3FC599 !important;\n}\n.hover-bg-flavour-skimmed:hover {\n  background-color: #fdeef1 !important;\n}\n.hover-bg-flavour-skimmed:hover.darker,\n.hover-bg-flavour-skimmed:hover:hover {\n  background-color: #f9bfca !important;\n}\n.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary {\n  color: #F1617D !important;\n}\n.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary:hover {\n  background-color: rgba(241, 97, 125, 0.1) !important;\n}\n.hover-bg-flavour-skimmed:hover .MuiCheckbox-colorSecondary .MuiIconButton-colorSecondary:hover {\n  color: #F1617D !important;\n}\n.btc--flavour-full {\n  border-top-color: #35b8d3;\n}\n.btc--flavour-semi {\n  border-top-color: #3FC599;\n}\n.btc--flavour-skimmed {\n  border-top-color: #F1617D;\n}\n.highlight-yellow {\n  background-color: #FCF8E3 !important;\n}\n.flavour-tabs {\n  font-size: 0.65rem;\n}\n.h1-5 {\n  height: 1.5rem;\n}\nmark {\n  background-color: #fcf8e3;\n  color: inherit;\n}\n.pseudo-arrows > li::after {\n  content: ' > ';\n  margin: 0 0.25rem;\n}\n.pseudo-arrows > li:last-child::after {\n  content: '';\n}\n.w-date {\n  width: 14.28571429%;\n}\n.bg-teal-darken-10 {\n  background-color: #002c47;\n}\n.bg-teal-darken-5 {\n  background-color: #003b61;\n}\n.hover-bg-teal-darken-5:hover {\n  background-color: #003b61;\n}\n.hover-bg-teal-darken-10:hover {\n  background-color: #002c47;\n}\n.MuiSpeedDial-actions.comment-menu-speed-dial-actions {\n  margin-top: -1.5rem;\n  padding-top: 2rem;\n}\n.side-width,\n.ca-left-width {\n  width: 20rem;\n}\n.marketplace-search-button,\n.marketplace-search-button.Mui-disabled,\n.account-nav-button.Mui-disabled {\n  background-color: #255c83;\n}\nbutton.qa-search-button,\nbutton.qa-search-button.Mui-disabled,\n.qa-search-button,\n.qa-search-button.Mui-disabled {\n  background-color: #35b8d3 !important;\n}\n.search-drop-down-menu.qa-search-button.MuiButton-contained:hover,\n.search-drop-down-menu.marketplace-search-button.MuiButton-contained:hover {\n  background-color: #2698af;\n}\n.faq-header-expanded {\n  background-color: #c7fcfa;\n}\n.faq-header-expanded-content {\n  background-color: #088986;\n}\n.legislation-search-button,\n.legislation-search-button.Mui-disabled {\n  background-color: #84619C;\n}\n.search-drop-down-menu.legislation-search-button.MuiButton-contained:hover {\n  background-color: #694d7d;\n}\n.news-search-button,\n.news-search-button.Mui-disabled {\n  background-color: #0bb9b5;\n}\nbutton.qa-search-button,\nbutton.qa-search-button.Mui-disabled,\n.qa-search-button,\n.qa-search-button.Mui-disabled {\n  background-color: #35b8d3 !important;\n}\n.search-drop-down-menu.news-search-button.MuiButton-contained:hover {\n  background-color: #088986;\n}\nbutton.precedents-search-button,\nbutton.precedents-search-button.Mui-disabled,\n.precedents-search-button,\n.precedents-search-button.Mui-disabled {\n  background-color: #004b7a !important;\n}\n.search-drop-down-menu.precedents-search-button.MuiButton-contained:hover {\n  background-color: #002c47;\n}\n.markets-search-button,\n.markets-search-button.Mui-disabled {\n  background-color: #008C9F;\n}\n.search-drop-down-menu.markets-search-button.MuiButton-contained:hover {\n  background-color: #005f6c;\n}\n.news-date-picker-search-button.MuiButton-root:hover {\n  background-color: #5CBE75;\n}\n.search-drop-down-menu.news-date-picker-search-button.MuiButton-contained:hover {\n  background-color: #42a55b;\n}\n.bg-qa-tab::before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  width: 100%;\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  -o-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n}\n.bg-qa-tab.selected::before {\n  height: 100%;\n}\n.bg-qa-tab.full:hover::before,\n.bg-qa-tab.full.selected::before {\n  background-color: #35b8d3;\n}\n.bg-qa-tab.semi:hover::before,\n.bg-qa-tab.semi.selected::before {\n  background-color: #3FC599;\n}\n.bg-qa-tab.skimmed:hover::before,\n.bg-qa-tab.skimmed.selected::before {\n  background-color: #F1617D;\n}\n.bg-qa-tab.archive:hover::before,\n.bg-qa-tab.archive.selected::before {\n  background-color: #73797A;\n}\n.bg-qa-tab.legislation:hover::before,\n.bg-qa-tab.legislation.selected::before {\n  background-color: #83619C;\n}\n.popover.bottom > .arrow {\n  position: absolute;\n  top: -11px;\n}\n.popover.bottom > .arrow::after {\n  content: ' ';\n  top: 1px;\n  margin-left: -10px;\n  border-width: 10px;\n  border-top-width: 0;\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-color: transparent;\n}\n.ca-filter-link:hover {\n  color: #6288A5;\n}\n.privacy-filter-link:hover svg g {\n  stroke: #004b7a;\n}\n.filter-link:hover svg g {\n  stroke: #008C9F;\n}\n.account-input-label:hover svg g {\n  stroke: #004b7a;\n}\n.account-input-label:hover svg {\n  fill: #004b7a;\n}\n.account-input-checked svg {\n  color: #004b7a;\n}\n.teal-save-button.MuiButton-root:hover {\n  background-color: #002c47;\n}\n.white-cancel-button.MuiButton-root:hover {\n  background-color: #e6e6e6;\n}\n.react-datepicker__navigation {\n  border: 0.45rem solid transparent;\n}\n.react-datepicker__navigation--next {\n  border-left-color: #ccc;\n}\n.react-datepicker__navigation--previous {\n  border-right-color: #ccc;\n}\n.ca-homepage ol li,\n.ca-homepage ul li {\n  margin: 0.5rem 0;\n}\n.folder-badge {\n  min-width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 0.75rem;\n}\n.form-submit-button:hover {\n  background-color: #0bb9b5;\n}\n.form-cancel-button:hover:hover {\n  background-color: #D5ECFF;\n}\n.trial-select-organisation-button:hover {\n  background-color: #008C9F;\n}\n.trial-select-individual-button:hover {\n  background-color: #008C9F;\n}\n.trial-thank-you-finish-button:hover {\n  background-color: #5CBE75;\n}\n.ca-search-date-submit-button:hover {\n  background-color: #5CBE75;\n}\n.dealwatch-search-date-submit-button:hover {\n  background-color: #128a93;\n}\n@media screen and (max-width: 346px) {\n  .MuiPickersBasePicker-pickerView {\n    padding-right: 1.25rem;\n  }\n}\n.markdown-content p {\n  margin-top: 0;\n}\n.speech-bubble {\n  background-color: #ebf0f4;\n  padding: 10px 16px;\n  position: relative;\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  border-radius: 12px;\n}\n.speech-bubble:after {\n  content: \"\";\n  position: absolute;\n  bottom: -2.25rem;\n  /* value = - border-top-width - border-bottom-width */\n  left: 5.25rem;\n  /* controls horizontal position */\n  border-width: 2.25rem 3rem 0 0;\n  /* vary these values to change the angle of the vertex */\n  border-style: solid;\n  border-color: #ebf0f3 transparent;\n  /* reduce the damage in FF3.0 */\n  display: block;\n  width: 0;\n}\n.markets-overview-tile {\n  font-size: 18px;\n}\n.markets-overview-tile:hover {\n  background: #d3fdff;\n}\n.overlay-parameter-header:before {\n  content: ' ';\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background: #979797;\n}\n.overlay-parameter-header-enabled:before {\n  background: #73797A;\n}\n.deal-increase {\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #5CBE75;\n}\n.deal-decrease {\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid #CC0033;\n}\n.comment-controls .mini-speed-dial {\n  min-height: 2rem;\n  height: 2rem;\n  width: 2rem;\n}\n.comment-controls .MuiSpeedDial-directionDown .MuiSpeedDial-actions {\n  padding-top: 42px;\n}\n.transition-fade-out-slow {\n  animation: fadeOut 500ms forwards;\n  animation-delay: 0s;\n}\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    display: none;\n  }\n}\n.indented-section {\n  display: block;\n  padding-left: 2rem;\n}\n.esv-interview-label > p {\n  margin: 0;\n  word-wrap: break-word;\n}\n.esv-interview-hide-break > br {\n  display: none;\n}\n.esv-interview-toolbar-width {\n  width: 100%;\n}\n@media screen and (min-width: 1200px) {\n  .esv-interview-toolbar-width {\n    width: calc(100% - 20rem);\n  }\n}\n@media screen and (min-width: 1500px) {\n  .esv-interview-toolbar-spacing,\n  .esv-footer-spacing {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n@media screen and (min-width: 1450px) {\n  .esv-interview-db-l {\n    display: block;\n  }\n  .esv-interview-dn-l {\n    display: none;\n  }\n  .esv-interview-preview-width-l {\n    width: 50rem;\n  }\n}\n.compact-switch-label {\n  text-align: left;\n  font-size: 0.875rem;\n  color: #73797A;\n}\n.account-menu-dropdown {\n  min-width: 128px;\n}\n.tile-border {\n  position: relative;\n  padding-bottom: 6px;\n  border: 1px solid transparent;\n}\n.tile-border::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  width: 100%;\n  height: 6px;\n  background: #255c83;\n}\n.tile-border:hover,\n.tile-border:focus-within {\n  border-color: #255c83;\n}\n.tile-border:hover::after,\n.tile-border:focus-within::after {\n  background: #255c83;\n}\n.tile-border.aol-corporate:hover,\n.tile-border.aol-corporate:focus-within {\n  border-color: #35B8D3;\n}\n.tile-border.aol-corporate:hover::after,\n.tile-border.aol-corporate:focus-within::after {\n  background: #35B8D3;\n}\n.tile-border.aol-employment:hover,\n.tile-border.aol-employment:focus-within {\n  border-color: #5CCCAE;\n}\n.tile-border.aol-employment:hover::after,\n.tile-border.aol-employment:focus-within::after {\n  background: #5CCCAE;\n}\n.tile-border.aol-ri:hover,\n.tile-border.aol-ri:focus-within {\n  border-color: #FF8657;\n}\n.tile-border.aol-ri:hover::after,\n.tile-border.aol-ri:focus-within::after {\n  background: #FF8657;\n}\n.tile-unavailable {\n  position: relative;\n  padding-bottom: 6px;\n  border: 1px solid transparent;\n}\n.tile-unavailable::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  width: 100%;\n  height: 6px;\n  background: #d8d8d8;\n}\n.tile-unavailable:hover,\n.tile-unavailable:focus-within {\n  border-color: #d8d8d8;\n}\n.tile-unavailable:hover::after,\n.tile-unavailable:focus-within::after {\n  background: #d8d8d8;\n}\n.smartsearch-switch {\n  transform: translateX(0.5rem);\n}\n.description-line-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n/* pdfjs-dist/web/pdf_viewer.css covers textLayer, annotationLayer, and pdfViewer page styles */\n.pdf-viewer-wrapper {\n  height: calc(100vh - 13rem);\n  max-width: 1000px;\n}\n#pdfViewer .page {\n  box-sizing: content-box;\n}\n#pdfViewer .textLayer {\n  text-rendering: auto;\n  -webkit-font-smoothing: auto;\n}\n.navigation-item-title .archived-label {\n  display: none;\n}\n.archived-label {\n  font-style: normal;\n  font-size: 0.9rem;\n  background: #83619C;\n  padding: 5px;\n  padding-right: 5px;\n  padding-left: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border-radius: 9999px;\n  margin-left: 15px;\n  margin-top: -2px;\n  color: #fff;\n}\n.cd-accordion-menu {\n  /*background: @color-accordion-base;*/\n  list-style: none;\n  margin: 0 auto 1.2em auto;\n  padding: 0;\n}\n.cd-accordion-menu a {\n  text-decoration: none;\n}\n.cd-accordion-menu ul.group {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  z-index: 2;\n}\n.cd-accordion-menu .sticky,\n.cd-accordion-menu .toggle {\n  position: relative;\n  z-index: 2;\n}\n.cd-accordion-menu .toggle {\n  background: #FFFFFF;\n}\n.cd-accordion-menu li {\n  padding: 0;\n  margin: 0;\n  position: relative;\n  top: 0;\n  left: 0;\n}\n.cd-accordion-menu input[type=checkbox] {\n  /* hide native checkbox */\n  position: absolute;\n  opacity: 0;\n}\n.cd-accordion-menu .prefix {\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 1.4em;\n  height: 100%;\n  width: 64px;\n  min-width: 10px;\n  padding: 19px 0 0 0;\n  text-transform: uppercase;\n  text-align: center;\n  font-weight: bold;\n  z-index: 20;\n  color: #000;\n  text-decoration: none;\n  line-height: 1.8em;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-menu .prefix {\n    width: 28px;\n    font-size: 1.2em;\n    line-height: 1em;\n  }\n}\n.cd-accordion-menu .comment,\n.cd-accordion-menu .selector {\n  cursor: pointer;\n  font-size: 1.4em;\n  width: 2em;\n  height: 4.5em;\n  text-align: center;\n  position: absolute;\n  z-index: 20;\n  box-shadow: none;\n  background: transparent;\n  color: inherit;\n  padding: 0;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-menu .comment,\n  .cd-accordion-menu .selector {\n    height: 3.4em;\n  }\n}\n.cd-accordion-menu .comment {\n  right: 3em;\n}\n.cd-accordion-menu .comment i {\n  font-size: 1.2em;\n  margin-top: 1px;\n  position: absolute;\n  display: block;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  letter-spacing: -1px;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.cd-accordion-menu .no-title .comment {\n  right: 1em;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-menu .no-title .comment {\n    display: none;\n  }\n}\n.cd-accordion-menu .selector {\n  right: 1em;\n}\n.cd-accordion-menu .selector .indicator {\n  position: absolute;\n  display: block;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  letter-spacing: -1px;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.cd-accordion-menu .selector .indicator .svg-icon {\n  position: relative;\n  font-size: 1.2em;\n}\n.cd-accordion-menu .group-prefix {\n  display: inline-block;\n  font-weight: lighter;\n  vertical-align: middle;\n  font-size: 0.8em;\n  text-transform: uppercase;\n  margin-right: 1em;\n}\n.cd-accordion-menu .sticky-bottom {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: block;\n  z-index: 1;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-1 {\n  z-index: 34;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-2 {\n  z-index: 35;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-3 {\n  z-index: 36;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-4 {\n  z-index: 37;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-5 {\n  z-index: 38;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-6 {\n  z-index: 39;\n}\n.cd-accordion-menu .sticky-bottom.show.depth-7 {\n  z-index: 40;\n}\n.cd-accordion-menu .highlight.content,\n.cd-accordion-menu .highlight.group,\n.cd-accordion-menu .highlight.content label.content {\n  background: #fcf8e3 !important;\n}\n.cd-accordion-menu label .before {\n  /* icons */\n  content: '';\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  margin: -0.1em 0 0 -0.1em;\n}\n.cd-accordion-menu label {\n  cursor: pointer;\n}\n.cd-accordion-menu label.group .before {\n  background-image: none;\n  color: inherit;\n  line-height: 1em;\n  font-size: 1em;\n  /* arrow icon */\n  left: 18px;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.cd-accordion-menu label .suffix {\n  float: right;\n  font-size: 0.8em;\n  line-height: 1.8em;\n  font-weight: lighter;\n}\n.cd-accordion-menu label.group-header-archived {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.cd-accordion-menu .is-loading label::before {\n  content: ' ';\n  animation: accordion-loader 1.2s infinite linear;\n  border: 2px solid;\n  border-right-color: transparent;\n  border-radius: 50%;\n}\n.cd-accordion-menu .is-loading label .before {\n  display: none;\n}\n@-moz-keyframes accordion-loader {\n  0% {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  100% {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n@-webkit-keyframes accordion-loader {\n  0% {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  100% {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n@keyframes accordion-loader {\n  0% {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  100% {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n.cd-accordion-menu input[type=checkbox]:checked + label .before {\n  /* rotate arrow */\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.cd-accordion-menu input[type=checkbox]:checked + label::after {\n  /* show open folder icon if item is checked */\n  background-position: -32px 0;\n}\n.cd-accordion-menu input[type=checkbox]:checked + label + ul,\n.cd-accordion-menu input[type=checkbox]:checked + label:nth-of-type(n) + ul {\n  /* use label:nth-of-type(n) to fix a bug on safari (<= 8.0.8) with multiple adjacent-sibling selectors*/\n  /* show children when item is checked */\n  display: block;\n}\n.no-touch .cd-accordion-menu ul.group label:hover {\n  background: #ededed;\n}\n.cd-accordion-menu li.depth-1 {\n  margin-bottom: 2px;\n}\n.cd-accordion-menu li.depth-1.group {\n  margin-bottom: 0;\n}\n.cd-accordion-menu label.depth-1.group {\n  color: #222;\n  fill: #222;\n  background: #FFF;\n  box-shadow: 0 0 0 1px rgba(127, 127, 127, 0.2) inset;\n  padding-left: 38px;\n}\n.cd-accordion-menu label.depth-1.group .before {\n  left: 16px;\n}\n.cd-accordion-menu label.depth-1.group.expanded {\n  background: #555;\n}\n.cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #4f4f4f;\n}\n.cd-accordion-menu label.depth-2.group.expanded {\n  background: #767676;\n}\n.cd-accordion-menu label.depth-2.group.expanded:hover {\n  background: #707070;\n}\n.cd-accordion-menu .disabled label.depth-1.group,\n.cd-accordion-menu .disabled label.depth-2.group {\n  color: #666;\n  fill: #666;\n}\n.cd-accordion-menu label.depth-1.group.expanded,\n.cd-accordion-menu label.depth-2.group.expanded {\n  color: #FFF !important;\n  fill: #FFF !important;\n  box-shadow: none !important;\n}\n.cd-accordion-menu .selector.expanded .indicator,\n.cd-accordion-menu .depth-1.pinned .selector .indicator,\n.cd-accordion-menu .depth-2.pinned .selector .indicator {\n  color: #FFF;\n  fill: #FFF;\n}\n.cd-accordion-menu .depth-3 .selector.expanded .indicator {\n  color: inherit;\n  fill: inherit;\n}\n.cd-accordion-menu label.depth-2.group,\n.cd-accordion-menu label.depth-3.group,\n.cd-accordion-menu label.depth-4.group,\n.cd-accordion-menu label.depth-5.group,\n.cd-accordion-menu label.depth-6.group {\n  color: #222;\n  fill: #222;\n  box-shadow: 0 -1px 0 0 rgba(127, 127, 127, 0.2) inset, -1px 0 0 0 rgba(127, 127, 127, 0.2) inset, 1px 0 0 0 rgba(127, 127, 127, 0.2) inset, 0 -1px 0 0 rgba(127, 127, 127, 0.2) inset;\n}\n.cd-accordion-menu label.depth-2.group {\n  background: #e6e6e6;\n  padding-left: 56px;\n}\n.cd-accordion-menu label.depth-2.group .before {\n  left: 34px;\n}\n.cd-accordion-menu label.depth-2.group:hover {\n  background: #dfdfdf;\n}\n.cd-accordion-menu label.depth-3.group {\n  background: #ececec;\n  padding-left: 74px;\n}\n.cd-accordion-menu label.depth-3.group .before {\n  left: 52px;\n}\n.cd-accordion-menu label.depth-3.group:hover {\n  background: #e6e6e6;\n}\n.cd-accordion-menu label.depth-4.group {\n  background: #f2f2f2;\n  padding-left: 92px;\n}\n.cd-accordion-menu label.depth-4.group .before {\n  left: 70px;\n}\n.cd-accordion-menu label.depth-4.group:hover {\n  background: #ececec;\n}\n.cd-accordion-menu label.depth-5.group {\n  background: #f9f9f9;\n  padding-left: 110px;\n}\n.cd-accordion-menu label.depth-5.group .before {\n  left: 88px;\n}\n.cd-accordion-menu label.depth-5.group:hover {\n  background: #f2f2f2;\n}\n.cd-accordion-menu label.depth-6.group {\n  background: #ffffff;\n  padding-left: 128px;\n}\n.cd-accordion-menu label.depth-6.group .before {\n  left: 106px;\n}\n.cd-accordion-menu label.depth-6.group:hover {\n  background: #f9f9f9;\n}\n.cd-accordion-menu label.content {\n  padding-left: 64px;\n}\n.cd-accordion-menu .selectable label.content,\n.cd-accordion-menu .selectable label.group {\n  padding-right: 4em;\n}\n.cd-accordion-menu .content,\n.cd-accordion-menu .content label.content {\n  background: #FFFFFF !important;\n  color: #222222;\n  fill: #222222;\n}\n.cd-accordion-menu .content .selector .indicator,\n.cd-accordion-menu .content label.content .selector .indicator {\n  color: #222222;\n  fill: #222222;\n}\n.cd-accordion-menu .highlight-yellow .content,\n.cd-accordion-menu .highlight-yellow .content label.content {\n  background-color: #FCF8E3 !important;\n}\n.cd-accordion-menu .content label .before,\n.cd-accordion-menu .content label::after {\n  display: none;\n}\n.cd-accordion-menu .content label .prefix {\n  left: 6px;\n  width: 54px;\n  text-align: center;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  letter-spacing: -0.8px;\n}\n.cd-accordion-menu .content .content-text {\n  padding: 18px 64px 18px 0;\n  font-size: 1.2em;\n  display: block;\n  font-weight: 400;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-menu .content .content-text {\n    padding: 0 0.5rem 0 0;\n  }\n}\n.cd-accordion-menu .content .content-text p,\n.cd-accordion-menu .content .content-text ul li {\n  margin: 0.5em 0;\n}\n.cd-accordion-menu label::before {\n  /* this class is used if you're using jquery to animate the accordion */\n  -webkit-transition: transform 0.1s;\n  -moz-transition: transform 0.1s;\n  -ms-transition: transform 0.1s;\n  -o-transition: transform 0.1s;\n  transition: transform 0.1s;\n}\n.precedents .cd-accordion-menu label.depth-1.group.expanded {\n  background: #011aac;\n}\n.precedents .cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #01189f;\n}\n.precedents .cd-accordion-menu label.depth-2.group.expanded {\n  background: #0928e6;\n}\n.precedents .cd-accordion-menu label.depth-2.group.expanded:hover {\n  background: #0926da;\n}\n.precedents .cd-accordion-menu .disabled label.depth-1.group,\n.precedents .cd-accordion-menu .disabled label.depth-2.group {\n  color: #666;\n  fill: #666;\n}\n.content-review .cd-accordion-menu label .before {\n  display: none !important;\n}\n.content-review .cd-accordion-menu label {\n  cursor: default !important;\n}\n.ca .cd-accordion-menu label.depth-1,\n.ca .cd-accordion-menu label.depth-1.group.expanded {\n  background: #FFF;\n  color: #F87531 !important;\n  padding-left: 0;\n  font-size: 1.7em;\n  box-shadow: inset 0 -1px #fdd8c5 !important;\n}\n.ca .cd-accordion-menu label.depth-1:hover,\n.ca .cd-accordion-menu label.depth-1.group.expanded:hover {\n  background: #FFF;\n}\n.ca .cd-accordion-menu label.group .before {\n  display: none;\n}\n.ca .cd-accordion-menu label.selector {\n  color: #222;\n  fill: #222;\n}\n.cd-accordion-header {\n  /*position: absolute;\n  width: 96%;\n  left: 50%;\n  height: 0;\n  margin: 0;\n  max-width: @page-max-width;\n  margin-left: auto;\n  margin-right: auto;*/\n  background: transparent;\n  bottom: -3px;\n  /*.transform(translate(-50%, 0));*/\n}\n.cd-accordion-header .prefix.selectable .indicator {\n  border-bottom: 3px solid #EEE;\n  width: auto;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n.cd-accordion-header .prefix.selectable .indicator::after {\n  display: none;\n}\n.cd-accordion-header .prefix.selectable.selected .indicator {\n  border-bottom: 3px solid;\n}\n.cd-accordion-header .selectable .selector {\n  height: 2.7em;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-header .selectable .selector {\n    height: 2.1em;\n  }\n}\n.cd-accordion-header .prefix {\n  pointer-events: none;\n}\n.cd-accordion-header .cd-accordion-menu {\n  width: 100%;\n  margin: 0;\n}\n.cd-accordion-header .cd-accordion-menu .content label {\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);\n}\n.cd-accordion-header .cd-list-container {\n  width: 100%;\n  /*margin: 0;\n    max-width: @page-max-width;\n    .transform(translate(0,0));\n    -webkit-transition: -webkit-transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;\n    -moz-transition: -moz-transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;\n    transition: transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;*/\n  position: relative;\n  /*    top: 0;\n    left: 0;*/\n}\n.cd-accordion-header .fadeout {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #FFFFFF;\n  opacity: 0.6;\n  z-index: 2;\n}\n.cd-accordion-header.view-right {\n  /*max-width: @page-max-width !important;*/\n}\n.cd-accordion-header.view-right .cd-list-container {\n  /*width: 96%;\n      margin: auto;*/\n  -webkit-transform: translate(-700px, 0);\n  -moz-transform: translate(-700px, 0);\n  -o-transform: translate(-700px, 0);\n  -ms-transform: translate(-700px, 0);\n  transform: translate(-700px, 0);\n  pointer-events: none;\n}\n.cd-accordion-header.view-right .cd-list-container .fadeout {\n  display: block;\n}\n@media screen and (min-width: 1270px) {\n  .cd-accordion-header.view-right .cd-list-container {\n    -webkit-transform: translate(-550px, 0);\n    -moz-transform: translate(-550px, 0);\n    -o-transform: translate(-550px, 0);\n    -ms-transform: translate(-550px, 0);\n    transform: translate(-550px, 0);\n  }\n}\n@media screen and (min-width: 1570px) {\n  .cd-accordion-header.view-right .cd-list-container {\n    pointer-events: all;\n    -webkit-transform: translate(-300px, 0);\n    -moz-transform: translate(-300px, 0);\n    -o-transform: translate(-300px, 0);\n    -ms-transform: translate(-300px, 0);\n    transform: translate(-300px, 0);\n  }\n  .cd-accordion-header.view-right .cd-list-container .fadeout {\n    display: none;\n  }\n}\n@media screen and (max-width: 768px) {\n  .cd-accordion-header.view-right .cd-list-container {\n    -webkit-transform: translate(-520px, 0);\n    -moz-transform: translate(-520px, 0);\n    -o-transform: translate(-520px, 0);\n    -ms-transform: translate(-520px, 0);\n    transform: translate(-520px, 0);\n  }\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-header.view-right .cd-list-container {\n    -webkit-transform: translate(-325px, 0);\n    -moz-transform: translate(-325px, 0);\n    -o-transform: translate(-325px, 0);\n    -ms-transform: translate(-325px, 0);\n    transform: translate(-325px, 0);\n  }\n}\n.cd-accordion-header.view-left {\n  max-width: 970px !important;\n  pointer-events: none;\n}\n.cd-accordion-header.view-left .cd-list-container {\n  width: 100%;\n  margin: auto;\n  -webkit-transform: translate(300px, 0);\n  -moz-transform: translate(300px, 0);\n  -o-transform: translate(300px, 0);\n  -ms-transform: translate(300px, 0);\n  transform: translate(300px, 0);\n}\n.cd-accordion-header li label {\n  -webkit-transition: padding 0.1s;\n  -moz-transition: padding 0.1s;\n  -ms-transition: padding 0.1s;\n  -o-transition: padding 0.1s;\n  transition: padding 0.1s;\n}\n.cd-accordion-header li {\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 2;\n}\n.cd-accordion-header li label {\n  padding-top: 7px;\n  padding-bottom: 7px;\n}\n@media screen and (max-width: 520px) {\n  .cd-accordion-header li label {\n    padding-top: 4px;\n    padding-bottom: 4px;\n  }\n}\n.cd-accordion-header .prefix {\n  padding-top: 7px;\n}\n.cd-accordion-header li:last-child {\n  z-index: 1;\n}\n@media screen and (min-width: 1270px) {\n  .has-left .cd-accordion-header.view-left,\n  .has-left .cd-accordion-header.view-main {\n    max-width: 970px !important;\n  }\n  .has-left .cd-accordion-header.view-left .cd-list-container,\n  .has-left .cd-accordion-header.view-main .cd-list-container {\n    width: 96%;\n    margin: auto;\n    -webkit-transform: translate(150px, 0);\n    -moz-transform: translate(150px, 0);\n    -o-transform: translate(150px, 0);\n    -ms-transform: translate(150px, 0);\n    transform: translate(150px, 0);\n  }\n}\n.browser-ie .cd-list-container {\n  -ms-transition: none !important;\n  transition: none !important;\n}\n.accordion-comments {\n  padding: 18px 64px 18px 64px;\n  font-size: 1.8em;\n  display: block;\n  font-weight: 400;\n}\n@media screen and (max-width: 520px) {\n  .accordion-comments {\n    font-size: 1.5em;\n    padding: 18px 0 18px 18px;\n  }\n}\n.accordion-navigator {\n  font-size: 1.4em;\n  line-height: 1.3;\n  margin: 0.6em 0 0 1em;\n}\n.accordion-navigator .navigation-group {\n  margin: 0;\n}\n.accordion-navigator .navigation-group.depth-1 {\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n.accordion-navigator .navigation-group.depth-1 > .navigation-item {\n  border-left: none;\n  padding-left: 0;\n}\n.accordion-navigator .navigation-group.depth-1 > .navigation-item:before,\n.accordion-navigator .navigation-group.depth-1 > .navigation-item:after {\n  display: none;\n}\n.accordion-navigator .navigation-item {\n  padding: 0.5em 0 0em 0.7em;\n  border-left: 2px solid #FAFAFA;\n  position: relative;\n  margin-left: 3px;\n  transition: border-color 0.2s;\n}\n.accordion-navigator a {\n  color: inherit;\n  margin: 0;\n}\n.accordion-navigator .navigation-item-title {\n  display: block;\n  white-space: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-bottom: 0.5em;\n  color: #AAA;\n  fill: #AAA;\n}\n.accordion-navigator .navigation-item-title .prefix {\n  text-transform: uppercase;\n  font-size: 0.8em;\n  font-weight: lighter;\n  margin-right: 0.6em;\n}\n.accordion-navigator .navigation-item-title a {\n  cursor: pointer;\n  transition: color 0.2s;\n}\n.accordion-navigator .navigation-item-title a:hover {\n  text-decoration: none;\n  color: #000;\n  fill: #000;\n}\n.accordion-navigator .active > .navigation-item-title {\n  color: #000;\n  fill: #000;\n}\n.accordion-navigator .active-after.navigation-item {\n  border-color: #000;\n}\n.accordion-navigator .navigation-item:before {\n  content: \" \";\n  display: block;\n  position: absolute;\n  height: 1.3em;\n  width: 0;\n  top: 0;\n  border-left: 2px solid transparent;\n  left: -2px;\n  transition: border-color 0.2s;\n}\n.accordion-navigator .navigation-item.active:before {\n  border-left: 2px solid #000 !important;\n}\n.accordion-navigator .navigation-item:last-child {\n  border-left: 2px solid transparent;\n}\n.accordion-navigator .navigation-item:last-child:before {\n  border-left: 2px solid #FAFAFA;\n}\n.accordion-navigator .navigation-item:after {\n  content: \" \";\n  display: block;\n  position: absolute;\n  top: 1.2em;\n  height: 0;\n  width: 0.3em;\n  border-bottom: 0.2em solid transparent;\n  left: -2px;\n  transition: border-color 0.2s;\n}\n.accordion-navigator .navigation-item.active:after {\n  border-bottom-color: #000;\n}\n.key-picks.row::before {\n  content: '';\n  display: table;\n}\n.key-picks.row::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.content-view {\n  /* === Sections / Targetted Styles === */\n  /* Smaller Section styles */\n  /* Level 2 heading */\n  /* Level 3 heading */\n  /* === Typography/Headings Styles === */\n  /* Questions - Collapsable */\n  /* === Section / Level Specific Styles === */\n  /* Mobile Devices */\n}\n.content-view.table-of-contents {\n  font-size: 1.2em;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n.content-view.table-of-contents ul {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  list-style: none;\n  padding-left: 0;\n  -webkit-transition: top ease-in-out 250ms;\n  -moz-transition: top ease-in-out 250ms;\n  -ms-transition: top ease-in-out 250ms;\n  -o-transition: top ease-in-out 250ms;\n  transition: top ease-in-out 250ms;\n}\n.content-view.table-of-contents ul li {\n  padding: 0.5em 1em 0.5em 0.5em;\n  color: #aaa;\n}\n.content-view.table-of-contents ul li a {\n  display: block;\n  text-decoration: none !important;\n  color: inherit;\n}\n.content-view.table-of-contents ul li.highlight {\n  color: #000000;\n}\n.content-view.table-of-contents ul .depth-1 {\n  padding-left: 1.5em;\n  font-weight: bold;\n}\n.content-view.table-of-contents ul .depth-2 {\n  padding-left: 1.5em;\n}\n.content-view.table-of-contents ul .depth-3 {\n  padding-left: 2.5em;\n}\n.content-view.table-of-contents ul .depth-4 {\n  padding-left: 3.5em;\n}\n.content-view.table-of-contents ul .depth-5 {\n  padding-left: 4.5em;\n}\n.content-view.table-of-contents ul .depth-6 {\n  padding-left: 5.5em;\n}\n.content-view.table-of-contents ul li:last-child {\n  margin-bottom: 1em;\n}\n.content-view .lr-treeheader {\n  display: block;\n  font-size: 1.8em;\n  padding: 0.5em;\n}\n.content-view .lr-treeheader a {\n  color: #000;\n  font-weight: 600;\n}\n.content-view .lr-treeheader.lr-container {\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);\n}\n.content-view .lr-treeheader.lr-container.depth-1 {\n  padding-left: 1em;\n  background: #dfdfdf;\n}\n.content-view .lr-treeheader.lr-container.depth-2 {\n  padding-left: 2em;\n  background: #e6e6e6;\n}\n.content-view .lr-treeheader.lr-container.depth-3 {\n  padding-left: 3em;\n  background: #ececec;\n}\n.content-view .lr-treeheader.lr-container.depth-4 {\n  padding-left: 4em;\n  background: #f2f2f2;\n}\n.content-view .lr-treeheader.lr-container.depth-5 {\n  padding-left: 5em;\n  background: #f9f9f9;\n}\n.content-view .lr-treeheader.lr-container.depth-6 {\n  padding-left: 6em;\n  background: #ffffff;\n}\n.content-view .lr-treeheader a.fc-question {\n  font-size: 1em;\n}\n.content-view .lr-treeheader a:hover {\n  text-decoration: underline !important;\n}\n.content-view .lr-treeheader .lr-breadcrumbs {\n  display: block;\n  font-size: 0.7em;\n  margin-top: 0.2em;\n}\n.content-view .lr-treeheader .lr-breadcrumbs a {\n  color: #006621;\n}\n.content-view .lr-treeheader .lr-breadcrumbs span + span::before {\n  content: \" > \";\n  color: #006621;\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n.content-view .lr-treeheader.lr-leaf.depth-1 {\n  margin-top: 1em;\n}\n.content-view .lr-treenode .fc-qa {\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.2);\n}\n.content-view .ca-heading-heading {\n  display: flex;\n  flex-direction: column;\n}\n.content-view .section-heading {\n  font-weight: 700;\n  font-size: 2.4em;\n  line-height: 1.4;\n  z-index: 2;\n  position: relative;\n  background-color: #ffffff;\n}\n.content-view .section-heading a {\n  color: inherit;\n}\n.content-view .section-heading a:hover {\n  text-decoration: none;\n}\n@media screen and (max-width: 768px) {\n  .content-view .section-heading {\n    font-size: 2.4em;\n  }\n}\n@media screen and (max-width: 520px) {\n  .content-view .section-heading {\n    font-size: 2.2em;\n  }\n}\n.content-view .section-heading .right-align {\n  font-size: 0.6em;\n  font-weight: normal;\n  float: right;\n  color: #999;\n  fill: #999;\n  line-height: 2.6em;\n}\n.content-view .section-heading .right-align i {\n  font-size: 2em;\n  vertical-align: middle;\n}\n.content-view .section-heading .right-align a,\n.content-view .section-heading .right-align a:hover {\n  text-decoration: none;\n  display: inline;\n}\n.content-view .section-heading .right-align .svg-icon {\n  font-size: 1.4em;\n  position: relative;\n  top: 0.1em;\n  margin: 0 0.3em;\n}\n.content-view .section-heading .right-align a:hover {\n  color: #666;\n  fill: #666;\n}\n.content-view .section-heading .right-align .spacer {\n  margin: 0 1em 0 2em;\n}\n.content-view .section-heading .right-align .spacer::before {\n  content: \"|\";\n}\n.content-view .section-heading .right-align .flavoured {\n  font-weight: bold;\n}\n.content-view table:not(.tinymce-generated-content) {\n  width: 100%;\n}\n.content-view table:not(.tinymce-generated-content) td {\n  vertical-align: top;\n}\n.content-view table:not(.tinymce-generated-content) td.button {\n  width: 1em;\n  font-weight: normal;\n}\n.content-view table:not(.tinymce-generated-content) td.button a {\n  color: inherit;\n}\n.content-view table:not(.tinymce-generated-content) .align-middle {\n  vertical-align: middle;\n}\n.content-view .ca-content table {\n  width: unset;\n}\n.content-view .ca-content table td {\n  vertical-align: unset;\n}\n.content-view .checkbox-widget {\n  margin: 0;\n  font-size: 18px;\n}\n.content-view.header {\n  width: 100%;\n  background-color: #e5e5e5;\n}\n.content-view.header .container {\n  max-width: 970px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0;\n}\n@media screen and (max-width: 970px) {\n  .content-view.header .container {\n    width: 96%;\n  }\n}\n.content-view.header .container .fc-section-header {\n  padding-left: 0;\n  padding-right: 0;\n}\n.content-view.header .fc-section-checkbox {\n  display: block;\n  background-color: #e5e5e5;\n  font-size: 1.8em;\n  line-height: 1.1em;\n  color: #000000;\n  font-weight: 400;\n  padding: 0.5em 5px;\n}\n@media screen and (max-width: 520px) {\n  .content-view.header .fc-section-checkbox {\n    font-size: 1.5em;\n    padding: 0.5em 0;\n  }\n  .content-view.header .fc-section-checkbox table tr td.button {\n    padding: 0 5px;\n  }\n  .content-view.header .fc-section-checkbox table tr td.button.big {\n    padding: 0 5px 0 0;\n  }\n}\n.content-view.header .fc-section-checkbox table td {\n  vertical-align: middle;\n  height: inherit;\n}\n.content-view.header .fc-section-checkbox table td.button {\n  padding: 0 10px 0 5px;\n}\n.content-view.header .fc-section-checkbox table td.button.big {\n  padding: 0 5px;\n  font-size: 1.1em;\n}\n.content-view.header .fc-section-checkbox input {\n  height: 1.7em;\n  border: 1px solid #000000;\n  padding: 0 10px;\n  font-size: 0.8em;\n  margin-left: 5%;\n  width: 94%;\n  outline: none;\n  display: inline-block;\n  vertical-align: top;\n}\n.content-view .excerpt {\n  font-size: 1.8em;\n  font-weight: 200;\n  margin: 0 0 2em;\n}\n@media screen and (max-width: 520px) {\n  .content-view .excerpt {\n    padding: 0 18px;\n    font-size: 1.3em;\n  }\n}\n.content-view .navigation {\n  font-size: 1.9em;\n}\n.content-view .navigation a {\n  display: block;\n  padding: 0.3em 0.5em;\n  background: #666;\n  color: #fff;\n  text-decoration: none;\n}\n.content-view .navigation a:focus {\n  text-decoration: none;\n}\n@media screen and (max-width: 520px) {\n  .content-view .navigation {\n    font-size: 1.4em;\n  }\n}\n.content-view .indented {\n  font-size: 7px;\n}\n.content-view .indented .node-crossheading {\n  margin-left: 2em;\n}\n.content-view .indented a {\n  color: inherit;\n  display: block;\n  text-decoration: underline;\n}\n.content-view .indented .fc-section-header {\n  padding-right: 15px;\n}\n.content-view .indented .header-depth-1 {\n  padding-left: 10px;\n}\n.content-view .indented .header-depth-2 {\n  padding-left: 20px;\n}\n.content-view .indented .header-depth-3 {\n  padding-left: 30px;\n}\n.content-view .indented .header-depth-4 {\n  padding-left: 40px;\n}\n.content-view .indented .header-depth-5 {\n  padding-left: 50px;\n}\n.content-view .indented .header-depth-6 {\n  padding-left: 60px;\n}\n@media screen and (max-width: 520px) {\n  .content-view .indented .header-depth-1 {\n    padding-left: 1em;\n  }\n  .content-view .indented .header-depth-2 {\n    padding-left: 2em;\n  }\n  .content-view .indented .header-depth-3 {\n    padding-left: 2.5em;\n    font-size: 1.5em;\n  }\n  .content-view .indented .header-depth-4 {\n    padding-left: 3em;\n  }\n  .content-view .indented .header-depth-5 {\n    padding-left: 3.5em;\n  }\n  .content-view .indented .header-depth-6 {\n    padding-left: 4em;\n  }\n}\n.content-view .padded .fc-section-header,\n.content-view .padded .fc-qa {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.content-view .fc-section-header {\n  border: none;\n  background-color: #000000;\n  margin: 0px 0;\n  line-height: 1.2em;\n  padding: 0.5em 0;\n  width: 100%;\n  margin: 0;\n}\n.content-view .fc-section-header .number {\n  display: inline-block;\n  margin-right: 1em;\n  font-size: 0.7em;\n  line-height: 1.8em;\n  vertical-align: top;\n  text-transform: uppercase;\n}\n.content-view .fc-section-header.header-depth-1 {\n  border-bottom: none;\n  font-size: 3em;\n  color: #ffffff;\n}\n.content-view .fc-section-header.header-depth-1 table td.button {\n  color: #ffffff;\n}\n.content-view .fc-section-header.header-depth-2 {\n  background-color: #e5e5e5;\n  border-bottom: none;\n  font-weight: 500;\n  font-size: 2.6em;\n}\n.content-view .fc-section-header.header-depth-3 {\n  background-color: #fff;\n  color: #002a5b;\n  border-bottom: 1px solid #e5e5e5;\n  font-size: 2.4em;\n}\n.content-view .fc-section-header.header-depth-4 {\n  background-color: #fff;\n  color: #002a5b;\n  border-bottom: 1px solid #e5e5e5;\n  font-size: 2.2em;\n}\n.content-view .fc-section-header.header-depth-5 {\n  background-color: #fff;\n  color: #002a5b;\n  font-size: 2em;\n}\n.content-view .fc-section-header.header-depth-6 {\n  background-color: #fff;\n  color: #002a5b;\n  font-size: 2em;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-section-header.header-depth-1 {\n    font-size: 2em;\n  }\n  .content-view .fc-section-header.header-depth-2 {\n    font-size: 1.8em;\n  }\n  .content-view .fc-section-header.header-depth-3 {\n    font-size: 1.7em;\n  }\n  .content-view .fc-section-header.header-depth-4 {\n    font-size: 1.6em;\n  }\n  .content-view .fc-section-header.header-depth-5 {\n    font-size: 1.5em;\n  }\n  .content-view .fc-section-header.header-depth-6 {\n    font-size: 1.4em;\n  }\n}\n.content-view .space-maker {\n  opacity: 0;\n}\n.content-view > .fc-section-tree {\n  margin-top: 9px;\n}\n.content-view .small-sections .fc-section-header h1,\n.content-view .small-sections .fc-section-header h2,\n.content-view .small-sections .fc-section-header h3 {\n  line-height: 55px;\n  font-size: 30px;\n}\n.content-view .small-sections .fc-section-header h3,\n.content-view .small-sections .fc-section-header h4,\n.content-view .small-sections .fc-section-header h5 {\n  padding: 0px;\n}\n.content-view .small-sections .pull-right {\n  height: 55px;\n}\n.content-view .fc-section-body .fc-section-header,\n.content-view .panel {\n  background-color: #e5e5e5;\n}\n.content-view .fc-section-tree .fc-section-children .fc-section-body .fc-section-header {\n  background-color: #fff;\n  color: #002a5b;\n}\n.content-view h3,\n.content-view h4,\n.content-view h5,\n.content-view h6 {\n  color: #2c2e83;\n}\n.content-view h1 {\n  font-size: 3.6em;\n  line-height: 40px;\n  padding: 19px 0px 21px 0;\n}\n.content-view h2 {\n  font-size: 3.4em;\n  line-height: 41px;\n}\n.content-view h3 {\n  font-size: 2.8em;\n  line-height: 33px;\n}\n.content-view h4 {\n  font-size: 2.4em;\n  line-height: 28px;\n}\n.content-view h5 {\n  font-size: 2.2em;\n  line-height: 26px;\n}\n.content-view h6 {\n  font-size: 2em;\n  line-height: 24px;\n}\n.content-view section h1 {\n  font-size: 3em;\n}\n.content-view ol:not(.tinymce-generated-content) {\n  counter-reset: li;\n}\n.content-view ol:not(.tinymce-generated-content) > li {\n  position: relative;\n  list-style: none;\n  margin-bottom: 0.2em;\n}\n.content-view ol:not(.tinymce-generated-content) > li::before {\n  content: \"(\" counter(li, lower-alpha) \")\";\n  counter-increment: li;\n  position: absolute;\n  left: -2em;\n  font-size: 0.9em;\n  line-height: 1.7em;\n  color: #444;\n}\n.content-view ol:not(.tinymce-generated-content) ol li::before {\n  content: \"(\" counter(li, lower-roman) \")\";\n}\n.content-view .ca-content ol:not(.tinymce-generated-content) > li {\n  list-style: inherit;\n}\n.content-view .ca-content ol:not(.tinymce-generated-content) > li::before {\n  content: none;\n}\n.content-view .ca-content ol:not(.tinymce-generated-content) ol li::before {\n  content: none;\n}\n.content-view .capitalize::first-letter {\n  text-transform: uppercase;\n}\n.content-view .no-border {\n  border: none !important;\n}\n.content-view .fc-qa {\n  padding: 0.7em 2em 0.8em 0;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-qa {\n    padding: 0.7em 0.5em 0.8em 0;\n  }\n}\n.content-view .fc-qa.expanded {\n  border-bottom: 1px solid #e5e5e5;\n}\n.content-view .fc-qa:last-child {\n  padding-bottom: 2em;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-qa:last-child {\n    padding-bottom: 0;\n  }\n}\n.content-view .fc-qa:last-child .fc-answer {\n  border-bottom: none;\n  margin-bottom: 0px;\n}\n.content-view .fc-qa:first-child {\n  padding-top: 1.5em;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-qa:first-child {\n    padding-top: 1em;\n  }\n}\n.content-view .fc-qa.selected:last-child {\n  border-bottom: none;\n}\n.content-view .fc-qa.selected + .fc-qa {\n  margin-top: 8px;\n}\n.content-view .fc-qa.selected.highlight {\n  margin: 8px 0;\n  border-left: 8px solid #e5e5e5;\n  padding-left: 10px;\n}\n.content-view .fc-qa table td.button,\n.content-view .fc-section-header table td.button {\n  font-size: 18px;\n  color: #000000;\n  padding: 0 11px;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-qa table td.button,\n  .content-view .fc-section-header table td.button {\n    padding: 0 5px;\n  }\n}\n.content-view .fc-answer.section-content {\n  font-size: 1.6em;\n}\n.content-view .fc-em {\n  font-style: italic;\n}\n.content-view .fc-p,\n.content-view .fc-indent {\n  padding-left: 2.2em;\n  display: block;\n  position: relative;\n  top: 0;\n  left: 0;\n  margin: 0.5em 0;\n}\n.content-view .fc-p .reference,\n.content-view .fc-indent .reference,\n.content-view .fc-p .fc-reference,\n.content-view .fc-indent .fc-reference {\n  position: absolute;\n  top: 0;\n  left: 0.2em;\n  color: inherit;\n  display: block;\n  font-size: 0.9em;\n  line-height: 1.7em;\n  font-weight: normal;\n}\n.content-view .fc-p .reference .fc-stacked-reference-2,\n.content-view .fc-indent .reference .fc-stacked-reference-2,\n.content-view .fc-p .fc-reference .fc-stacked-reference-2,\n.content-view .fc-indent .fc-reference .fc-stacked-reference-2 {\n  position: absolute;\n  left: -2.6em;\n}\n.content-view .fc-p .reference .fc-stacked-reference-3,\n.content-view .fc-indent .reference .fc-stacked-reference-3,\n.content-view .fc-p .fc-reference .fc-stacked-reference-3,\n.content-view .fc-indent .fc-reference .fc-stacked-reference-3 {\n  position: absolute;\n  left: -5.2em;\n}\n.content-view .fc-p .reference .fc-stacked-reference-4,\n.content-view .fc-indent .reference .fc-stacked-reference-4,\n.content-view .fc-p .fc-reference .fc-stacked-reference-4,\n.content-view .fc-indent .fc-reference .fc-stacked-reference-4 {\n  position: absolute;\n  left: -7.8em;\n}\n.content-view .fc-p.mark,\n.content-view .fc-indent.mark {\n  background-color: #FCF8E3;\n  padding: 0 0 0 2.2em;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-p,\n  .content-view .fc-indent {\n    padding-left: 1.3em;\n  }\n  .content-view .fc-p .reference,\n  .content-view .fc-indent .reference,\n  .content-view .fc-p .fc-reference,\n  .content-view .fc-indent .fc-reference {\n    left: 0;\n  }\n  .content-view .fc-p .reference .fc-stacked-reference-2,\n  .content-view .fc-indent .reference .fc-stacked-reference-2,\n  .content-view .fc-p .fc-reference .fc-stacked-reference-2,\n  .content-view .fc-indent .fc-reference .fc-stacked-reference-2 {\n    position: absolute;\n    left: -1.6em;\n  }\n  .content-view .fc-p .reference .fc-stacked-reference-3,\n  .content-view .fc-indent .reference .fc-stacked-reference-3,\n  .content-view .fc-p .fc-reference .fc-stacked-reference-3,\n  .content-view .fc-indent .fc-reference .fc-stacked-reference-3 {\n    position: absolute;\n    left: -3.2em;\n  }\n  .content-view .fc-p .reference .fc-stacked-reference-4,\n  .content-view .fc-indent .reference .fc-stacked-reference-4,\n  .content-view .fc-p .fc-reference .fc-stacked-reference-4,\n  .content-view .fc-indent .fc-reference .fc-stacked-reference-4 {\n    position: absolute;\n    left: -4.8em;\n  }\n}\n.content-view .fc-indent {\n  margin-left: 2.2em;\n}\n.content-view .fc-indent .fc-indent {\n  margin-left: 0;\n}\n.content-view .fc-amend {\n  display: block;\n  position: relative;\n  margin: 2em 0;\n  padding-left: 1em;\n  border-left: 3px solid #eeeeee;\n}\n.content-view .fc-amend .fc-crossheading > .fc-title {\n  font-weight: bold;\n  margin: 0 0 1em -1em;\n}\n.content-view .fc-amend .fc-schedule {\n  padding-left: 2.2em;\n  position: relative;\n}\n.content-view .fc-amend .fc-schedule .fc-title {\n  margin: 0 0 0 1em;\n}\n.content-view .fc-amend .fc-schedule .fc-part {\n  display: block;\n}\n.content-view .fc-amend .fc-schedule > .reference {\n  left: -1em;\n  font-weight: bold;\n  font-size: 0.8em;\n  line-height: 1.7em;\n}\n.content-view .fc-amend .fc-crossheading,\n.content-view .fc-amend .fc-section,\n.content-view .fc-amend .fc-part,\n.content-view .fc-amend .fc-chapter {\n  padding-left: 2.2em;\n  position: relative;\n}\n.content-view .fc-amend .fc-crossheading > .reference,\n.content-view .fc-amend .fc-section > .reference,\n.content-view .fc-amend .fc-part > .reference,\n.content-view .fc-amend .fc-chapter > .reference {\n  left: -1em;\n  font-weight: bold;\n  font-size: 0.8em;\n  line-height: 1.7em;\n}\n.content-view .fc-amend .fc-section {\n  display: block;\n}\n.content-view .fc-title {\n  font-weight: bold;\n  position: relative;\n}\n.content-view .fc-title .reference {\n  display: inline-block;\n  position: relative;\n  margin-left: -2em;\n  margin-right: 0.5em;\n  font-size: 1em;\n  font-weight: bold;\n}\n.content-view .fc-table {\n  display: table;\n  padding: 0 2em;\n  margin: 1em 0 3em;\n  width: 100%;\n}\n.content-view .fc-table .fc-tr {\n  display: table-row;\n}\n.content-view .fc-table .fc-td {\n  display: table-cell;\n  padding: 0.2em 1em;\n}\n.content-view .fc-table .fc-td > .fc-p {\n  padding-left: 0;\n}\n.content-view .fc-section-qas {\n  border-bottom: 1px solid #e5e5e5;\n}\n.content-view .fc-question {\n  display: table-row;\n  color: #1460d1;\n  font-size: 1.8em;\n  padding: 11px 0px 0px 0px;\n  line-height: 1.3em;\n  margin-bottom: 0px;\n  /*25*/\n  font-weight: 700;\n  text-decoration: none !important;\n}\n.content-view .fc-question .fc-question-number {\n  vertical-align: top;\n  display: table-cell;\n  white-space: nowrap;\n  padding-right: 0.4em;\n}\n.content-view .fc-question .fc-question {\n  vertical-align: top;\n  display: table-cell;\n  font-size: 1em;\n  padding: 0;\n}\n.content-view .fc-question .fc-question-number,\n.content-view .fc-question .fc-question {\n  padding-top: 0.1em;\n}\n@media screen and (max-width: 768px) {\n  .content-view .fc-question .fc-question-number,\n  .content-view .fc-question .fc-question {\n    padding-top: 0.3em;\n  }\n}\n.content-view .fc-question .path {\n  font-weight: normal;\n  font-size: 0.75em;\n  color: #006621;\n  margin: 0.5em 0 0;\n}\n.content-view .fc-question .path span + span:before {\n  content: \" > \";\n  color: #006621;\n}\n.content-view .row .col-fluid {\n  display: table-cell;\n  vertical-align: top;\n  width: 100%;\n  padding: 0 17px;\n}\n.content-view .row .col-checkbox {\n  display: table-cell;\n  vertical-align: top;\n}\n.content-view .row .col-checkbox:first-child {\n  padding: 0 0 0 17px;\n}\n.content-view .row .col-checkbox:last-child {\n  padding: 0 17px 0 0;\n}\n@media screen and (max-width: 768px) {\n  .content-view .row .col-checkbox:last-child {\n    padding-right: 8px;\n  }\n  .content-view .row .col-checkbox:first-child {\n    padding-left: 8px;\n  }\n  .content-view .row .col-fluid {\n    padding: 0 8px;\n  }\n}\n.content-view .fc-qa.review,\n.content-view .fc-section-header.review {\n  padding-left: 18px;\n}\n.content-view .fc-answer.collapse.in {\n  margin-bottom: 8px;\n}\n.content-view .fc-answer {\n  display: block;\n  padding-bottom: 0.8em;\n}\n.content-view .fc-answer p {\n  margin: 0.5em 0;\n}\n.content-view .fc-answer p:last-child {\n  margin-bottom: 0;\n}\n.content-view .fc-answer ol {\n  list-style-type: lower-alpha;\n  padding-left: 2em;\n  margin-bottom: 0px;\n}\n.content-view .fc-answer ol ol {\n  list-style-type: lower-roman;\n}\n.content-view .fc-answer a {\n  overflow: hidden;\n  display: inline;\n  vertical-align: top;\n}\n.content-view .fc-answer-wrap p,\n.content-view .fc-glossary,\n.content-view .fc-legislation {\n  font-weight: 400;\n  color: #231f20;\n  font-size: 1em;\n}\n.content-view .fc-legislation {\n  border-bottom: 1px dashed #a6a6a6;\n  top: 0;\n  left: 0;\n  outline: none;\n  cursor: pointer;\n}\n.content-view .fc-legislation .fc-reference,\n.content-view .fc-legislation .fc-labels {\n  display: none;\n}\n.content-view .fc-legislation .fc-glossary {\n  border-bottom: none;\n}\n.content-view .legislation-reference-title {\n  width: 100%;\n}\n.content-view .legislation-reference-title td.title {\n  max-width: 0;\n  padding-bottom: 0.4em;\n}\n.content-view .legislation-reference-title a {\n  text-overflow: ellipsis;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.content-view .legislation-reference-body {\n  position: absolute;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  bottom: 0;\n  top: 6em;\n  z-index: 1;\n  padding-right: 10px;\n  right: 0;\n  left: 15px;\n}\n.content-view .legislation-reference-body .fc-section-body .fc-section-header {\n  background: none;\n  border-bottom: none;\n}\n.content-view .legislation-reference-body .fc-section-body .header-depth-2 {\n  font-size: 1.8em;\n  font-weight: bold;\n}\n.content-view .legislation-reference-body .fc-section-body .header-depth-3 {\n  font-size: 1.8em;\n  font-weight: bold;\n}\n.content-view .legislation-reference-body .fc-section-body .header-depth-4 {\n  font-size: 1.8em;\n  margin-left: 1em;\n}\n.content-view .legislation-reference-body .fc-section-qas {\n  border-bottom: none;\n}\n.content-view .legislation-reference-body .fc-section-qas .fc-qa {\n  border-bottom: none;\n  padding: 0 !important;\n}\n@media screen and (max-width: 768px) {\n  .content-view .legislation-reference-body {\n    top: 6em;\n  }\n}\n.content-view .fc-answer-wrap ul,\n.content-view .fc-answer-wrap ol {\n  font-weight: 400;\n}\n.content-view .fc-glossary {\n  white-space: nowrap;\n  border-bottom: 1px dashed #a6a6a6;\n  top: 0;\n  left: 0;\n  outline: none;\n  cursor: pointer;\n}\n.content-view .fc-glossary.focus {\n  position: relative;\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-glossary.focus {\n    background: #DDDDDD;\n  }\n}\n.content-view a.fc-cross-reference,\n.content-view a.fc-news-reference,\n.content-view a.fc-document-reference {\n  color: #1460D1;\n  display: inline;\n}\n.content-view a.fc-cross-reference:hover,\n.content-view a.fc-news-reference:hover,\n.content-view a.fc-document-reference:hover {\n  text-decoration: underline;\n}\n.content-view li p {\n  margin-bottom: 0px;\n}\n.content-view p {\n  margin-bottom: 9px;\n}\n.content-view p a {\n  color: #1460D1;\n}\n.content-view .fc-legislation-reference,\n.content-view .fc-legislation-reference-range,\n.content-view .fc-canonical-case-reference {\n  display: none;\n  visibility: hidden;\n}\n.content-view .fc-case-reference {\n  font-weight: bold;\n}\n.content-view .popover {\n  max-width: 300px;\n}\n.content-view .fc-partialnote,\n.content-view .fc-jurisdictionnote {\n  font-size: 0.8em;\n  font-style: italic;\n  color: #555;\n  display: inline-block;\n  font-weight: normal;\n  padding: 0.4em 1em;\n  background: #eee;\n}\n@media screen and (max-width: 768px) {\n  .content-view {\n    /* Targetted */\n  }\n  .content-view h1,\n  .content-view .fc-section-header h1 {\n    font-size: 1.7em;\n  }\n  .content-view .fc-section-header h2 {\n    font-size: 1.8em;\n  }\n  .content-view .fc-section-header h3 {\n    font-size: 1.7em;\n  }\n  .content-view .fc-section-header h4 {\n    font-size: 1.6em;\n  }\n  .content-view .fc-section-header h5 {\n    font-size: 1.6em;\n  }\n  .content-view .fc-section-header h6 {\n    font-size: 1.6em;\n  }\n  .content-view .fc-question {\n    padding-left: 0px;\n    padding-right: 20px;\n    font-size: 1.4em;\n  }\n  .content-view .fc-answer > p {\n    padding-left: 0px;\n    padding-right: 20px;\n  }\n  .content-view .fc-answer ol {\n    padding-left: 1.5em;\n    padding-right: 1.5em;\n    margin-bottom: 1em;\n  }\n  .content-view > section > .fc-section-body > .fc-section-children > section > .fc-section-body > .fc-section-children > section > .fc-section-header h3 {\n    padding: 12px 1px 12px 0px;\n  }\n}\n.content-view .reference-range {\n  font-size: 14px;\n}\n@media screen and (max-width: 520px) {\n  .content-view .reference-range {\n    font-size: 11px;\n  }\n}\n@media screen and (max-width: 520px) {\n  .content-view .fc-answer ol {\n    padding-left: 18px;\n  }\n  .content-view .fc-qa:last-child {\n    margin-bottom: 16px;\n  }\n  .content-view .fc-qa:last-child .fc-answer-wrap {\n    padding-bottom: 0px;\n  }\n}\n.content-view.content-review .fc-answer-wrap {\n  font-size: 1.8em;\n  margin: 1.4em 0 0;\n  display: block;\n}\n.content-view .copyright-footer {\n  font-size: 1.4em;\n  line-height: 1.3;\n  padding: 1.5em 2em;\n  color: #888;\n}\n.content-view .large {\n  font-size: 1.8em;\n}\n.content-view .content-text > :not(.ca-content) table:not(.tinymce-generated-content),\n.content-view .content-text > table:not(.tinymce-generated-content) {\n  border-spacing: 1.5em;\n  border-collapse: separate;\n  margin: 0 -1.5em;\n}\n.content-view .content-text [class^=\"icon-bottle\"] {\n  font-size: 1.5em;\n  vertical-align: sub;\n}\n.content-view .bottle-icon {\n  display: inline-block;\n  vertical-align: middle;\n  width: 2.4em;\n  height: 2.4em;\n  background-size: 2.4em !important;\n}\n.content-view .nowrap {\n  white-space: nowrap;\n}\nspan.wj {\n  font-size: 0 !important;\n}\n.flavour-full .section-heading .right-align .flavoured,\n.color-full {\n  color: #35b8d3;\n  fill: #35b8d3;\n}\n.flavour-full .section-heading .right-align .flavoured.active,\n.color-full.active {\n  color: #FFFFFF;\n  fill: #FFFFFF;\n}\n.flavour-semi .section-heading .right-align .flavoured,\n.color-semi {\n  color: #3fc599;\n  fill: #3fc599;\n}\n.flavour-semi .section-heading .right-align .flavoured.active,\n.color-semi.active {\n  color: #FFFFFF;\n  fill: #FFFFFF;\n}\n.flavour-skimmed .section-heading .right-align .flavoured,\n.color-skimmed {\n  color: #f1617d;\n  fill: #f1617d;\n}\n.flavour-skimmed .section-heading .right-align .flavoured.active,\n.color-skimmed.active {\n  color: #FFFFFF;\n  fill: #FFFFFF;\n}\n.flavour-archive .section-heading .right-align .flavoured,\n.color-archive {\n  color: #73797a;\n  fill: #73797a;\n}\n.flavour-archive .section-heading .right-align .flavoured.active,\n.color-archive.active {\n  color: #FFFFFF;\n  fill: #FFFFFF;\n}\n.color-legislation {\n  color: #83619C;\n  fill: #83619C;\n}\n.color-legislation.active {\n  color: #FFFFFF;\n  fill: #FFFFFF;\n}\n.content-depth {\n  font-size: 1em;\n  color: #fff;\n  margin-right: 0.2em;\n  margin-left: 1em;\n}\n.content-depth .content-depth-text {\n  display: inline-block;\n  vertical-align: middle;\n}\n.content-depth .desc {\n  color: #666;\n}\n.content-depth i {\n  font-size: 1.7em !important;\n  vertical-align: sub;\n}\n.content-depth.full {\n  color: #35b8d3;\n}\n.content-depth.semi {\n  color: #3fc599;\n}\n.content-depth.skimmed {\n  color: #f1617d;\n}\n.popover-container {\n  font-size: 1.6em;\n}\n.popover-container .popover {\n  margin-top: 10px;\n  max-width: 450px;\n  font-size: 0.8em;\n  -webkit-transition: opacity 0.2s;\n  -moz-transition: opacity 0.2s;\n  -ms-transition: opacity 0.2s;\n  -o-transition: opacity 0.2s;\n  transition: opacity 0.2s;\n}\n.popover-container .popover p {\n  margin: 0;\n}\n.popover-container .popover p + p {\n  margin: 1em 0 0;\n}\n@media screen and (max-width: 520px) {\n  .popover-container .popover {\n    font-size: 1em;\n    max-width: calc(100vw - 1.5rem);\n  }\n}\n.popover-container .popover.show {\n  opacity: 1;\n}\n.popover-container .popover.show.fade-leave-active {\n  opacity: 0;\n}\n.comment-body .public-DraftEditor-content h1,\n.comment-body .content-view h1 {\n  font-size: 1.4em;\n  font-weight: normal;\n  margin: 0 0 0.3em;\n  padding: 0;\n  line-height: normal;\n}\n.comment-body .public-DraftEditor-content h2,\n.comment-body .content-view h2,\n.comment-body .public-DraftEditor-content h3,\n.comment-body .content-view h3,\n.comment-body .public-DraftEditor-content h4,\n.comment-body .content-view h4,\n.comment-body .public-DraftEditor-content h5,\n.comment-body .content-view h5,\n.comment-body .public-DraftEditor-content h6,\n.comment-body .content-view h6 {\n  font-size: 1.2em;\n  font-weight: normal;\n  margin: 0 0 0.4em 0.8em;\n  padding: 0;\n  line-height: normal;\n}\n.comment-body .public-DraftEditor-content p,\n.comment-body .content-view p,\n.comment-body .public-DraftEditor-content .paragraph,\n.comment-body .content-view .paragraph {\n  margin: 0 0 0.5em 1em;\n}\n.comment-body .public-DraftEditor-content ol,\n.comment-body .content-view ol,\n.comment-body .public-DraftEditor-content ul,\n.comment-body .content-view ul {\n  margin-left: 0.5em;\n}\n.comment-body .public-DraftEditor-content ol li::before,\n.comment-body .content-view ol li::before {\n  content: \"(\" counter(li) \")\";\n}\n.comment-body .public-DraftEditor-content .paragraph {\n  margin: 0 0 0.5rem 0;\n}\n.svg-base {\n  display: inline-block;\n  line-height: 1;\n}\n.svg-base svg {\n  fill: currentColor;\n  vertical-align: middle;\n  width: 100%;\n  height: 100%;\n}\n.svg-base svg g {\n  stroke: currentColor;\n}\n.svg-base svg path {\n  fill: inherit;\n}\n.icon-base {\n  position: relative;\n  height: auto;\n}\n.icon-base svg {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n}\n.icon-base:after {\n  content: \"\";\n  display: block;\n  padding-bottom: 100%;\n}\n/*# sourceMappingURL=index.css.map */","/*\n\n  Base\n  ----\n\n  This file contains the site's base styles.\n  It also contains styling for markup that's generated server side as it's too\n  convoluted to add classes directly to it.\n\n*/\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  max-height: 100vh;\n  min-width: 320px;\n  .mobile({\n    height: auto;\n    max-height: none;\n    overflow-y: auto;\n  })\n}\n\nbody {\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: subpixel-antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: @font-default;\n  line-height: 1.5;\n  font-size: 16px;\n  color: @black;\n  .bg-white();\n}\n\n#app {\n  position: relative;\n  width: 100vw;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n.layout-width-constraint {\n  .pv0();\n  .mv0();\n  .mhauto();\n  max-width: @LAYOUT_MAX_WIDTH;\n  padding-left: @LAYOUT_PADDING;\n  padding-right: @LAYOUT_PADDING;\n  .tablet({\n    padding-left: @LAYOUT_PADDING_TABLET;\n    padding-right: @LAYOUT_PADDING_TABLET;\n  });\n  .mobile({\n    padding-left: @LAYOUT_PADDING_MOBILE;\n    padding-right: @LAYOUT_PADDING_MOBILE;\n  });\n}\n\n\nbutton,\ninput,\ntextarea,\nselect {\n  color: inherit;\n  background-color: transparent;\n}\n\n// Reset iOS Safari's default control chrome (rounded corners, background\n// gradient) which otherwise overrides custom styling. Checkboxes/radios are\n// excluded as they rely on native appearance for their checked state.\nbutton,\ninput:not([type=checkbox]):not([type=radio]),\ntextarea,\nselect {\n  border-radius: 0;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n\nbutton {\n  border: none;\n  outline: none;\n}\n\ntd {\n  -webkit-margin-before: 0;\n  -webkit-margin-after: 0;\n}\n\na {\n  color: @dark-cyan;\n}\n\nspan {\n  &.wj {\n    font-size: 0 !important;\n  }\n  &.fc-em {\n    font-style: italic;\n  }\n}\n\n.loading {\n  animation: big-loader 2s infinite linear;\n  width: 1em;\n  height: 1em;\n  border: 0.1em solid;\n  border-right-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.keyframes(big-loader, {\n  0%  { transform: rotate(0deg); }\n  100%  { transform: rotate(360deg); }\n});\n\nsummary {\n  /* Standard property for most browsers (Firefox, Chrome, Edge) */\n  list-style: none;\n}\n\n/* Specific vendor prefix for WebKit-based browsers (Safari, older Chrome/Edge) */\nsummary::-webkit-details-marker {\n  display: none;\n}\n\n.spin-to-win {\n  animation: big-loader 2s infinite linear;\n}","/*\n\n  Media\n  -----\n\n  Define media queries.\n\n*/\n\n.responsive(@width, @rules) {\n  @media screen and (max-width: @width) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  .responsive(@TABLET_MAX_WIDTH, @rules);\n}\n\n.tablet-only(@rules) {\n  @media screen and (min-width: @MOBILE_MAX_WIDTH) and (max-width: @TABLET_MAX_WIDTH) {\n    @rules();\n  }\n}\n\n.mobile(@rules) {\n  .responsive(@MOBILE_MAX_WIDTH, @rules);\n}\n\n// NOTE: Used for calculating height of beta ribbon as the text runs over three\n// lines on very narrow screens.\n.xs-mobile(@rules) {\n  .responsive(367px, @rules);\n}\n\n.desktop(@rules) {\n  @media screen and (min-width: @DESKTOP_MIN_WIDTH) {\n    @rules();\n  }\n}\n\n.desktop-only(@rules) {\n  @media screen and (min-width: @DESKTOP_MIN_WIDTH) {\n    @rules();\n  }\n}\n\n.large-desktop(@rules) {\n  @media screen and (min-width: @LARGE_DESKTOP_MIN_WIDTH) {\n    @rules();\n  }\n}\n\n.desktop-fullscreen(@rules) {\n  @media screen and (min-width: @PAGE_MAX_WIDTH) {\n    @rules();\n  }\n}\n\n.desktop-left-expanded(@rules) {\n  @media screen and (min-width: (@PAGE_MAX_WIDTH + @page-left-width)) {\n    @rules();\n  }\n}\n.desktop-right-expanded(@rules) {\n  @media screen and (min-width: (@PAGE_MAX_WIDTH + @page-right-width-desktop-wide)) {\n    @rules();\n  }\n}\n\n.fullscreen(@rules) {\n  @media screen and (max-width: @PAGE_MAX_WIDTH) {\n    @rules();\n  }\n}\n","/*\n\n  Theming\n  -------\n\n  Utility classes for theming.\n\n*/\n\n\n// Image Rendering\n.bicubic { -ms-interpolation-mode: bicubic; image-rendering: optimizeQuality; }\n.fit-image { object-fit: cover; }; // makes image keep ratio while filling container\n.position-image-50-30 { object-position: 50% 30%; }\n.fit-bg-image {\n  width: 100%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n}\n\n// Visibility\n.hidden { visibility: hidden; }\n\n\n// Pointer Events\n.no-pointer-events { pointer-events: none; }\n.pointer-events-auto { pointer-events: auto; }\n\n\n// List Style\n.list-reset { list-style: none; }\n.list-item-reset {list-style-type: none; }\n.list-item-initial {list-style-type: initial; }\n\n// Transition\n.transition-all {\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  -o-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n}\n\n.transition-all-slow {\n  -webkit-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\n// Cursor\n.default-cursor { cursor: default; }\n.pointer        { cursor: pointer; }\n.text           { cursor: text;    }\n.disabled-default-cursor:disabled { .default-cursor(); }\n.not-allowed    { cursor: not-allowed; }\n.wait           { cursor: wait; }\n.w-resize       { cursor: w-resize;}\n\n\n// Outline\n.outline-0 { outline: 0; outline: none; }\n\n.focus-outline-0:focus { .outline-0(); }\n\n// Text area rezise\n.disable-text-area-resize { resize: none; }\n\n// Filter\n.filter-o-40 { filter: opacity(40%); }\n.filter-blur { filter: blur(2px); }\n\n.hover-filter-o-40:hover { .filter-o-40(); }\n\n\n// Opacity\n.o-100 { .opacity(1); }\n.o-90  { .opacity(0.9); }\n.o-80  { .opacity(0.8); }\n.o-70  { .opacity(0.7); }\n.o-60  { .opacity(0.6); }\n.o-50  { .opacity(0.5); }\n.o-40  { .opacity(0.4); }\n.o-30  { .opacity(0.3); }\n.o-20  { .opacity(0.2); }\n.o-10  { .opacity(0.1); }\n.o-05  { .opacity(0.05); }\n.o-025 { .opacity(0.025); }\n.o-0   { .opacity(0); }\n\n.hover-o-90:hover { .o-90(); }\n.hover-o-80:hover { .o-80(); }\n.hover-o-100:hover { .o-100() }\n\n// Reveal a descendant on hover, e.g. an icon that only appears when its container is hovered.\n.hover-reveal:hover .hover-reveal-target { .o-100; }\n\n\n// Color\n.black             { color: @black; }\n.bluish-grey       { color: @bluish-grey; }\n.light-bluish-grey { color: @light-bluish-grey; }\n.medium-bluish-grey{ color: @medium-bluish-grey; }\n.cadet-blue        { color: @cadet-blue; }\n.charcoal          { color: @charcoal }\n.chocolate         { color: @chocolate; }\n.crimson           { color: @crimson; }\n.dark-cyan         { color: @dark-cyan; }\n.dark-slate-blue   { color: @dark-slate-blue; }\n.dark-orchid       { color: @dark-orchid; }\n.dim-grey          { color: @dim-grey; }\n.slate-grey        { color: @slate-grey; }\n.light-slate-grey  { color: @light-slate-grey; }\n.gains-boro        { color: @gains-boro; }\n.grey              { color: @grey; }\n.bright-grey       { color: @bright-grey; }\n.ghost-grey        { color: @ghost-grey; }\n.indian-red        { color: @indian-red; }\n.light-coral       { color: @light-coral; }\n.lite-grey         { color: @lite-grey; }\n.dark-coral        { color: @dark-coral; }\n.dark-sea-green    { color: @dark-sea-green; }\n.dark-sea-green-2  { color: @dark-sea-green-2; }\n.dark-sea-green-3  { color: @dark-sea-green-3; }\n.light-sea-green-1 { color: @light-sea-green-1; }\n.light-sea-green-2 { color: @light-sea-green-2; }\n.light-turquoise   { color: @light-turquoise; }\n.medium-turquoise  { color: @medium-turquoise; }\n.medium-aquamarine { color: @medium-aquamarine; }\n.navy              { color: @navy; }\n.pale-green        { color: @pale-green; }\n.pale-violet-red   { color: @pale-violet-red; }\n.phantom-grey      { color: @phantom-grey; }\n.precedents-blue   { color: @precedents-blue; }\n.phantom-grey      { color: @phantom-grey; }\n.royal-blue        { color: @royal-blue; }\n.sienna            { color: @sienna; }\n.teal              { color: @teal; }\n.tomato            { color: @tomato; }\n.tangerine-dream   { color: @tangerine-dream; }\n.white             { color: @white; }\n.dark-cerulean     { color: @dark-cerulean; }\n.slate-blue-grey   { color: @slate-blue-grey; }\n.star-yellow       { color: @star-yellow; }\n.suez-canal        { color: @suez-canal; }\n\n.placeholder-cadet-blue::placeholder { .cadet-blue(); }\n\n.hover-black:hover { color: @black; }\n.hover-cadet-blue:hover { .cadet-blue(); }\n.hover-dark-sea-green-2:hover { color: @dark-sea-green-2; }\n.hover-dark-slate-blue:hover { color: @dark-slate-blue; }\n.hover-slate-grey:hover { color: @slate-grey; }\n.hover-dark-sea-green-2:hover { color: @dark-sea-green-2; }\n.hover-dark-sea-green-3:hover { color: @dark-sea-green-3; }\n.hover-gains-boro:hover { .gains-boro(); }\n.hover-white:hover { .white(); }\n.hover-slate-grey:hover { .slate-grey(); }\n.hover-light-slate-grey:hover { .light-slate-grey(); }\n\n.focus-light-sea-green-2:focus { .light-sea-green-2(); }\n.focus-white:focus { .white(); }\n.focus-grey:focus { .grey(); }\n.focus-slate-grey:focus { .slate-grey(); }\n.focus-light-slate-grey:focus { .light-slate-grey(); }\n\n.active-slate-grey:active { .slate-grey(); }\n.active-light-slate-grey:active { .light-slate-grey(); }\n\n.color-inherit { color: inherit; }\n.link-children-color-inherit a { .color-inherit(); }\n\n// Background Color\n.bg-black             { background-color: @black; }\n.soft-black           { background-color: @soft-black; }\n.bg-cadet-blue        { background-color: @cadet-blue; }\n.bg-chocolate         { background-color: @chocolate; }\n.bg-dark-bluish-grey  { background-color: @dark-bluish-grey; }\n.bg-light-bluish-grey { background-color: @light-bluish-grey; }\n.bg-light-grayish-blue { background-color: @light-bluish-grey; }\n.bg-dark-coral        { background-color: @dark-coral; }\n.bg-dark-cyan         { background-color: @dark-cyan; }\n.bg-dark-sea-green    { background-color: @dark-sea-green; }\n.bg-dark-sea-green-2  { background-color: @dark-sea-green-2; }\n.bg-dark-sea-green-3  { background-color: @dark-sea-green-3; }\n.bg-dark-slate-blue   { background-color: @dark-slate-blue; }\n.bg-dark-orchid       { background-color: @dark-orchid; }\n.bg-dim-grey          { background-color: @dim-grey; }\n.bg-faf-grey          { background-color: @faf-grey; }\n.bg-gains-boro        { background-color: @gains-boro; }\n.bg-grey              { background-color: @grey; }\n.bg-ice-blue          { background-color: @ice-blue; }\n.bg-ghost-grey        { background-color: @ghost-grey; }\n.bg-indian-red        { background-color: @indian-red; }\n.bg-ice-blue          { background-color: @ice-blue; }\n.bg-light-coral       { background-color: @light-coral; }\n.bg-light-yellow      { background-color: @light-yellow; }\n.bg-light-sea-green-1 { background-color: @light-sea-green-1; }\n.bg-light-sea-green-2 { background-color: @light-sea-green-2; }\n.bg-light-turquoise   { background-color: @light-turquoise; }\n.bg-medium-aquamarine { background-color: @medium-aquamarine; }\n.bg-medium-purple     { background-color: @medium-purple; }\n.bg-medium-turquoise  { background-color: @medium-turquoise; }\n.bg-navy              { background-color: @navy; }\n.bg-precedents-blue   { background-color: @precedents-blue; }\n.bg-pale-green        { background-color: @pale-green; }\n.bg-pale-violet-red   { background-color: @pale-violet-red; }\n.bg-pearl-lusta       { background-color: @pearl-lusta; }\n.bg-phantom-grey      { background-color: @phantom-grey; }\n.bg-royal-blue        { background-color: @royal-blue; }\n.bg-sienna            { background-color: @sienna; }\n.bg-slate-grey        { background-color: @dark-slate-blue; }\n.bg-teal              { background-color: @teal; }\n.bg-tomato            { background-color: @tomato; }\n.bg-white             { background-color: @white; }\n.bg-tangerine-dream   { background-color: @tangerine-dream; }\n.bg-transparent       { background-color: transparent; }\n.bg-twilight-grey     { background-color: @twilight-grey; }\n.bg-void-grey         { background-color: @void-grey; }\n.bg-inherit           { background-color: inherit; }\n.bg-transparent       { background: transparent; }\n.bg-casper-white       { background-color: @casper-white; }\n.bg-ghost-white       { background-color: @ghost-white; }\n.bg-slate-blue-grey   { background-color: @slate-blue-grey; }\n.bg-page-background   { background-color: @ghost-white; } // Change variable to update all main page backgrounds colour\n.bg-dark-cerulean     { background-color: @dark-cerulean; }\n.bg-suez-canal        { background-color: @suez-canal; }\n.bg-powder-white      { background-color: @powder-white; }\n.bg-star-yellow       { background-color: @star-yellow; }\n.bg-text-fragment-highlight { background-color: fade(@text-fragment-highlight, 20%); }\n\n.hover-bg-transparent:hover       { .bg-transparent(); }\n.hover-bg-cadet-blue:hover        { .bg-cadet-blue(); }\n.hover-bg-dark-slate-blue:hover   { .bg-dark-slate-blue(); }\n.hover-bg-dark-sea-green:hover    { .bg-dark-sea-green(); }\n.hover-bg-dark-sea-green-2:hover  { .bg-dark-sea-green-2(); }\n.hover-bg-dark-sea-green-3:hover  { .bg-dark-sea-green-3(); }\n.hover-bg-light-bluish-grey:hover { .bg-light-bluish-grey(); }\n.hover-bg-dim-grey:hover          { .bg-dim-grey(); }\n.hover-bg-gains-boro:hover        { .bg-gains-boro(); }\n.hover-bg-ghost-grey:hover        { .bg-ghost-grey(); }\n.hover-bg-grey:hover              { .bg-grey(); }\n.hover-bg-light-turquoise:hover   { .bg-light-turquoise(); }\n.hover-bg-teal:hover              { .bg-teal(); }\n.hover-bg-phantom-grey:hover      { .bg-phantom-grey(); }\n.hover-bg-twilight-grey:hover     { .bg-twilight-grey(); }\n.hover-bg-white:hover             { .bg-white(); }\n.hover-bg-light-bluish-grey:hover { .bg-light-bluish-grey(); }\n.hover-bg-casper-white:hover      { .bg-casper-white(); }\n.hover-bg-ghost-white:hover       { .bg-ghost-white(); }\n.hover-bg-slate-blue-grey:hover   { .bg-slate-blue-grey(); }\n.hover-bg-suez-canal:hover        { .bg-suez-canal(); }\n\n.focus-bg-ghost-white:focus      { .bg-ghost-white(); }\n.focus-bg-casper-white:focus     { .bg-casper-white(); }\n.focus-bg-star-yellow:focus      { .bg-star-yellow(); }\n.focus-bg-slate-blue-grey:focus  { .bg-slate-blue-grey(); }\n\n.active-bg-ghost-white:active       { .bg-ghost-white(); }\n.active-bg-casper-white:active      { .bg-casper-white(); }\n\n// Fill\n.fill-star-yellow        { fill: @star-yellow; }\n.fill-medium-bluish-grey { fill: @medium-bluish-grey; }\n.fill-light-slate-grey   { fill: @light-slate-grey; }\n\n// Hover fill\n.hover-fill-light-slate-grey:hover { .fill-light-slate-grey(); }\n\n// Stroke\n.stroke-suez-canal { stroke: @suez-canal; }\n\n// Background Size\n.bg-contain { background-size: contain; }\n\n// Background Position\n.bg-center   { background-position: center; }\n.bg-x-center { background-position-x: center; }\n.bg-y-center { background-position-y: center; }\n\n\n// Border Collapse\n.border-collapse { border-collapse: collapse }\n\n// Background Repeat\n.bg-no-repeat { background-repeat: no-repeat; }\n\n// Border Width\n.ba        { border-style: solid; border-width: 1px; }\n.ba2       { border-style: solid; border-width: 2px; }\n.bn        { border-style: none; border-width: 0; }\n.bb        { border-bottom-style: solid; border-bottom-width: 1px; }\n.bl        { border-left-style: solid; border-left-width: 1px; }\n.bt        { border-top-style: solid; border-top-width: 1px; }\n.br        { border-right-style: solid; border-right-width: 1px; }\n.bb-thin   { border-bottom-style: solid; border-bottom-width: 1px; }\n.bb-medium { border-bottom-style: solid; border-bottom-width: 2px; }\n.bb-thick  { border-bottom-style: solid; border-bottom-width: 4px; }\n.bb-extra-thick  { border-bottom-style: solid; border-bottom-width: 6px; }\n.bt-medium { border-top-style: solid; border-top-width: 2px; }\n.bt-thick  { border-top-style: solid; border-top-width: 4px; }\n.bt-xl     { border-top-style: solid; border-top-width: 8px; }\n.bl-thick  { border-left-style: solid; border-left-width: 4px; }\n\n.mobile({\n  .bn-m { .bn(); }\n  .ba-m { .ba(); }\n});\n\n.hover-bb-thick:hover           { .bb-thick(); }\n.hover-bb-medium:hover          { .bb-medium(); }\n.hover-bt-thick:hover           { .bt-thick(); }\n.last-child-bn:last-child       { .bn(); }\n.last-of-type-bn:last-of-type   { .bn(); }\n\n.tablet({\n  .bb-t { .bb(); }\n  .bn-t { .bn(); }\n  .bt-t { .bt(); }\n});\n\n\n// Border Style\n.b--dashed  { border-style: dashed; }\n.b--dotted  { border-style: dotted; }\n.b--none    { border-style: none; }\n.b--solid   { border-style: solid; }\n.bt--dashed { border-top-style: dashed; }\n.bt--dotted { border-top-style: dotted; }\n.bt--none   { border-top-style: none; }\n.bt--solid  { border-top-style: solid; }\n.br--dashed { border-right-style: dashed; }\n.br--dotted { border-right-style: dotted; }\n.br--none   { border-right-style: none; }\n.br--solid  { border-right-style: solid; }\n.bb--dashed { border-bottom-style: dashed; }\n.bb--dotted { border-bottom-style: dotted; }\n.bb--none   { border-bottom-style: none; }\n.bb--solid  { border-bottom-style: solid; }\n.bl--dashed { border-left-style: dashed; }\n.bl--dotted { border-left-style: dotted; }\n.bl--none   { border-left-style: none; }\n.bl--solid  { border-left-style: solid; }\n\n.hover-ba:hover  { .ba();}\n.hover-ba2:hover { .ba2(); }\n\n\n// Border Color\n.b--black             { border-color: @black; }\n.b--cadet-blue        { border-color: @cadet-blue; }\n.b--chocolate         { border-color: @chocolate; }\n.b--dark-cyan         { border-color: @dark-cyan; }\n.b--dark-slate-blue   { border-color: @dark-slate-blue; }\n.b--dark-orchid       { border-color: @dark-orchid; }\n.b--dark-sea-green-2  { border-color: @dark-sea-green-2; }\n.b--dark-sea-green-3  { border-color: @dark-sea-green-3; }\n.b--dim-grey          { border-color: @dim-grey; }\n.b--gains-boro        { border-color: @gains-boro; }\n.b--grey              { border-color: @grey; }\n.b--bright-grey       { border-color: @bright-grey; }\n.b--ghost-grey        { border-color: @ghost-grey; }\n.b--ghost-white       { border-color: @ghost-white; }\n.b--indian-red        { border-color: @indian-red; }\n.b--light-coral       { border-color: @light-coral; }\n.b--light-grey        { border-color: @lite-grey; }\n.b--light-sea-green-1 { border-color: @light-sea-green-1; }\n.b--light-sea-green-2 { border-color: @light-sea-green-2; }\n.b--lite-grey         { border-color: @lite-grey; }\n.b--medium-aquamarine { border-color: @medium-aquamarine; }\n.b--medium-purple     { border-color: @medium-purple; }\n.b--medium-turquoise  { border-color: @medium-turquoise; }\n.b--navy              { border-color: @navy; }\n.b--pale-green        { border-color: @pale-green; }\n.b--pale-violet-red   { border-color: @pale-violet-red; }\n.b--precedents-blue   { border-color: @precedents-blue; }\n.b--royal-blue        { border-color: @royal-blue; }\n.b--sienna            { border-color: @sienna; }\n.b--tomato            { border-color: @tomato; }\n.b--phantom-grey      { border-color: @phantom-grey; }\n.b--white             { border-color: @white; }\n.b-light-bluish-grey  { border-color: @light-bluish-grey;}\n.b--transparent       { border-color: transparent; }\n.b--inherit           { border-color: inherit; }\n.b--slate-blue-grey   { border-color: @slate-blue-grey; }\n.b--light-bluish-grey { border-color: @light-bluish-grey; }\n.b--suez-canal        { border-color: @suez-canal; }\n.b--eastern-breeze    { border-color: @eastern-breeze; }\n.b--dark-cerulean     { border-color: @dark-cerulean; }\n\n.bt--transparent        { border-top-color: transparent; }\n.bt--dark-orchid        { border-top-color: @dark-orchid; }\n.bt--dark-cyan          { border-top-color: @dark-cyan; }\n.bt--light-grey         { border-top-color: @lite-grey; }\n.bt--phantom-grey       { border-top-color: @phantom-grey; }\n.bt--light-sea-green-2  { border-top-color: @light-sea-green-2; }\n.bt--dark-sea-green-3   { border-top-color: @dark-sea-green-3; }\n.bt--medium-aquamarine  { border-top-color: @medium-aquamarine; }\n.bt--medium-purple      { border-top-color: @medium-purple; }\n.bt--eastern-breeze     { border-color: @eastern-breeze; }\n.bt--dark-cerulean      { border-top-color: @dark-cerulean; }\n\n.bb--chocolate          { border-bottom-color: @chocolate; }\n.bb--dark-cerulean      { border-bottom-color: @dark-cerulean; }\n.bb-light-bluish-grey   { border-bottom-color: @light-bluish-grey; }\n\n.hover-b--black:hover   { .b--black(); }\n.hover-b--inherit:hover { .b--inherit(); }\n.hover-b--dark-sea-green-2:hover { .b--dark-sea-green-2(); }\n.hover-b--slate-blue-grey:hover { .b--slate-blue-grey(); }\n\n.focus-b--light-sea-green-2:focus { .b--light-sea-green-2(); }\n.focus-b--cadet-blue:focus { .b--cadet-blue(); }\n.focus-b--slate-blue-grey:focus { .b--slate-blue-grey(); }\n\n//Placeholder color\n.placeholder-light-slate-grey::placeholder { .light-slate-grey(); }\n\n// Border Radius\n.br0     { border-radius: 0; }\n.br1     { border-radius: 0.125rem; }\n.br2     { border-radius: 0.25rem; }\n.br3     { border-radius: 0.5rem; }\n.br4     { border-radius: 1rem; }\n.br-50   { border-radius: 50%; }\n.br-100  { border-radius: 100%; }\n.br-pill { border-radius: 9999px; }\n\n.br--bottom { border-top-left-radius: 0; border-top-right-radius: 0; }\n.br--left   { border-top-right-radius: 0; border-bottom-right-radius: 0; }\n.br--right  { border-top-left-radius: 0; border-bottom-left-radius: 0; }\n.br--top    { border-bottom-left-radius: 0; border-bottom-right-radius: 0; }\n\n\n/**\n * Box Shadow\n * offset-x | offset-y | blur-radius | spread-radius | color\n * NOTE: This naming convention is too verbose so I'm open to better\n * suggestions!\n */\n\n.shadow-none { box-shadow: none; }\n\n.shadow-8-04 { box-shadow: 0 0 8px 0 rgba(17, 17, 17, 0.4);}\n.shadow-black-1 { .box-shadow(0 10px 15px 0px rgba(0, 0, 0, 0.2)); }\n.shadow-black-2 { .box-shadow(0 5px 5px -5px rgba(17, 17, 17, 0.5)); }\n.shadow-black-3 { .box-shadow(2px 1px 8px rgba(17, 17, 17, 0.4)); }\n.shadow-black-4 { .box-shadow(0px 0px 1px rgba(17, 17, 17, 0.2)); }\n.shadow-black-16 { .box-shadow(0 2px 16px 0 rgba(77, 96, 110, 0.05);) }\n\n.shadow-faint-black { .box-shadow(0 4px 16px 0 rgba(0, 0, 0, 0.1);) }\n\n.mobile({\n  .shadow-none-m { .shadow-none(); }\n});\n\n.large-desktop({\n  .shadow-none-l { .shadow-none(); }\n});\n\n\n// Transform\n.x--50-y-50   { .transform(translateX(-50%) translateY(50%)); }\n.x--50-y-100  { .transform(translateX(-50%) translateY(100%)); }\n.x--50-y--50  { .transform(translateX(-50%) translateY(-50%)); }\n.x--50-y--100 { .transform(translateX(-50%) translateY(-100%));}\n.x-50         { .transform(translateX(50%)); }\n.x-100-y--50  { .transform(translateX(100%) translateY(-50%)); }\n.x-100        { .transform(translateX(100%)); }\n.x--50        { .transform(translateX(-50%)); }\n.x--100       { .transform(translateX(-100%)); }\n.x0           { .transform(translateX(0)); }\n.y--50        { .transform(translateY(-50%)); }\n.y--100       { .transform(translateY(-100%)); }\n.y-100        { .transform(translateY(100%)); }\n.y0           { .transform(translateY(0)); }\n\n.x-10         { .transform(translateX(10px)); }\n\n.x-vw-100     { .transform(translateX(100vw)); }\n\n.y-vh--100    { .transform(translateY(-100vh)); }\n\n.mobile({\n  .x--100-m    { .x--100(); }\n});\n\n.large-desktop({\n  .x-0-l       { .x0(); }\n});\n\n.rotate-90    { .transform(rotate(90deg)); }\n.rotate-180   { .transform(rotate(180deg)); }\n.rotate--90   { .transform(rotate(-90deg)); }\n\n// Aspect Ratio\n.aspect-ratio       { height: 0; position: relative; }\n.aspect-ratio--16x9 { padding-bottom: 56.25%; }\n.aspect-ratio--9x16 { padding-bottom: 177.77%; }\n.aspect-ratio--4x3  { padding-bottom: 75%; }\n.aspect-ratio--3x4  { padding-bottom: 133.33%; }\n.aspect-ratio--6x4  { padding-bottom: 66.6%; }\n.aspect-ratio--4x6  { padding-bottom: 150%; }\n.aspect-ratio--8x5  { padding-bottom: 62.5%; }\n.aspect-ratio--5x8  { padding-bottom: 160%; }\n.aspect-ratio--7x5  { padding-bottom: 71.42%; }\n.aspect-ratio--5x7  { padding-bottom: 140%; }\n.aspect-ratio--1x1  { padding-bottom: 100%; }\n\n// Overflow Scrolling\n.scroll-touch { -webkit-overflow-scrolling: touch; } // Momentum scrolling\n.scroll-auto  { -webkit-overflow-scrolling: auto; }\n\n.no-select {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.aol-color-classes(@name, @color) {\n  .aol-@{name}        { color: @color; }\n  .bg-aol-@{name}     { background-color: @color; }\n  .bg-aol-@{name}-light { background-color: lighten(@color, 40%); }\n  .b--aol-@{name}     { border-color: @color; }\n  .bb-aol-@{name}    { border-bottom-color: @color; }\n}\n\n.aol-color-classes(corporate, @aol-corporate);\n.aol-color-classes(employment, @aol-employment);\n.aol-color-classes(ri, @aol-ri);\n\n@keyframes fade-in-animation {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n@keyframes fade-out-animation {\n  0% { opacity: 1; }\n  100% { opacity: 0; }\n}\n\n.fade-in-animate {\n  opacity: 1;\n  animation: fade-in-animation 250ms linear 1;\n}\n\n.fade-out-animate {\n  opacity: 1;\n  animation: fade-out-animation 250ms linear 1;\n}\n\n.fade-headless {\n  opacity: 1;\n  transition: opacity 250ms linear;\n  \n  &[data-closed] {\n    opacity: 0;\n  }\n}\n","/*\n\n  Spacing\n  -------\n\n  Utility classes for margins and paddings.\n\n*/\n\n  // Gaps\n.gap0  { gap: @spacing-0; }\n.gap1  { gap: @spacing-1; }\n.gap2  { gap: @spacing-2; }\n.gap3  { gap: @spacing-3; }\n.gap4  { gap: @spacing-4; }\n.gap4-half  { gap: @spacing-4-half; }\n.gap5  { gap: @spacing-5; }\n.gap5-half  { gap: @spacing-5-half; }\n.gap6  { gap: @spacing-6; }\n.gap7  { gap: @spacing-7; }\n.gap8  { gap: @spacing-8; }\n.gap9  { gap: @spacing-9; }\n.gap10 { gap: @spacing-10; }\n.gap11 { gap: @spacing-11; }\n.gap12 { gap: @spacing-12; }\n.gap13 { gap: @spacing-13; }\n.gap14 { gap: @spacing-14; }\n\n.mobile({\n  .gap8-m { gap: @spacing-8; }\n});\n\n // Padding All\n.pa0  { padding: @spacing-0; }\n.pa1  { padding: @spacing-1; }\n.pa2  { padding: @spacing-2; }\n.pa3  { padding: @spacing-3; }\n.pa4  { padding: @spacing-4; }\n.pa5  { padding: @spacing-5; }\n.pa6  { padding: @spacing-6; }\n.pa7  { padding: @spacing-7; }\n.pa8  { padding: @spacing-8; }\n.pa9  { padding: @spacing-9; }\n.pa10 { padding: @spacing-10; }\n.pa11 { padding: @spacing-11; }\n.pa12 { padding: @spacing-12; }\n.pa13 { padding: @spacing-13; }\n.pa14 { padding: @spacing-14; }\n\n.tablet({\n  .pa0-t  { .pa0(); }\n  .pa1-t  { .pa1(); }\n  .pa2-t  { .pa2(); }\n  .pa3-t  { .pa3(); }\n  .pa4-t  { .pa4(); }\n  .pa5-t  { .pa5(); }\n  .pa6-t  { .pa6(); }\n  .pa7-t  { .pa7(); }\n  .pa8-t  { .pa8(); }\n  .pa9-t  { .pa9(); }\n  .pa11-t { .pa10(); }\n  .pa10-t { .pa11(); }\n  .pa12-t { .pa12(); }\n  .pa13-t { .pa13(); }\n  .pa14-t { .pa14(); }\n});\n\n.mobile({\n  .pa0-m  { .pa0(); }\n  .pa1-m  { .pa1(); }\n  .pa2-m  { .pa2(); }\n  .pa3-m  { .pa3(); }\n  .pa4-m  { .pa4(); }\n  .pa5-m  { .pa5(); }\n  .pa6-m  { .pa6(); }\n  .pa7-m  { .pa7(); }\n  .pa8-m  { .pa8(); }\n  .pa9-m  { .pa9(); }\n  .pa11-m { .pa10(); }\n  .pa10-m { .pa11(); }\n  .pa12-m { .pa12(); }\n  .pa13-m { .pa13(); }\n  .pa14-m { .pa14(); }\n});\n\n\n // Padding Left\n.pl0  { padding-left: @spacing-0; }\n.pl1  { padding-left: @spacing-1; }\n.pl2  { padding-left: @spacing-2; }\n.pl3  { padding-left: @spacing-3; }\n.pl4  { padding-left: @spacing-4; }\n.pl5  { padding-left: @spacing-5; }\n.pl6  { padding-left: @spacing-6; }\n.pl7  { padding-left: @spacing-7; }\n.pl8  { padding-left: @spacing-8; }\n.pl9  { padding-left: @spacing-9; }\n.pl10 { padding-left: @spacing-10; }\n.pl11 { padding-left: @spacing-11; }\n.pl12 { padding-left: @spacing-12; }\n.pl13 { padding-left: @spacing-13; }\n.pl14 { padding-left: @spacing-14; }\n\n.tablet({\n  .pl0-t  { .pl0(); }\n  .pl1-t  { .pl1(); }\n  .pl2-t  { .pl2(); }\n  .pl3-t  { .pl3(); }\n  .pl4-t  { .pl4(); }\n  .pl5-t  { .pl5(); }\n  .pl6-t  { .pl6(); }\n  .pl7-t  { .pl7(); }\n  .pl8-t  { .pl8(); }\n  .pl9-t  { .pl9(); }\n  .pl11-t { .pl10(); }\n  .pl10-t { .pl11(); }\n  .pl12-t { .pl12(); }\n  .pl13-t { .pl13(); }\n  .pl14-t { .pl14(); }\n});\n\n.mobile({\n  .pl0-m  { .pl0(); }\n  .pl1-m  { .pl1(); }\n  .pl2-m  { .pl2(); }\n  .pl3-m  { .pl3(); }\n  .pl4-m  { .pl4(); }\n  .pl5-m  { .pl5(); }\n  .pl6-m  { .pl6(); }\n  .pl7-m  { .pl7(); }\n  .pl8-m  { .pl8(); }\n  .pl9-m  { .pl9(); }\n  .pl11-m { .pl10(); }\n  .pl10-m { .pl11(); }\n  .pl12-m { .pl12(); }\n  .pl13-m { .pl13(); }\n  .pl14-m { .pl14(); }\n});\n\n.large-desktop({\n  .pl5-l  { .pl5(); }\n});\n\n // Padding Right\n.pr0  { padding-right: @spacing-0; }\n.pr1  { padding-right: @spacing-1; }\n.pr2  { padding-right: @spacing-2; }\n.pr3  { padding-right: @spacing-3; }\n.pr4  { padding-right: @spacing-4; }\n.pr5  { padding-right: @spacing-5; }\n.pr6  { padding-right: @spacing-6; }\n.pr7  { padding-right: @spacing-7; }\n.pr8  { padding-right: @spacing-8; }\n.pr9  { padding-right: @spacing-9; }\n.pr10 { padding-right: @spacing-10; }\n.pr11 { padding-right: @spacing-11; }\n.pr12 { padding-right: @spacing-12; }\n.pr13 { padding-right: @spacing-13; }\n.pr14 { padding-right: @spacing-14; }\n\n.tablet({\n  .pr0-t  { .pr0(); }\n  .pr1-t  { .pr1(); }\n  .pr2-t  { .pr2(); }\n  .pr3-t  { .pr3(); }\n  .pr4-t  { .pr4(); }\n  .pr5-t  { .pr5(); }\n  .pr6-t  { .pr6(); }\n  .pr7-t  { .pr7(); }\n  .pr8-t  { .pr8(); }\n  .pr9-t  { .pr9(); }\n  .pr11-t { .pr10(); }\n  .pr10-t { .pr11(); }\n  .pr12-t { .pr12(); }\n  .pr13-t { .pr13(); }\n  .pr14-t { .pr14(); }\n});\n\n.mobile({\n  .pr0-m  { .pr0(); }\n  .pr1-m  { .pr1(); }\n  .pr2-m  { .pr2(); }\n  .pr3-m  { .pr3(); }\n  .pr4-m  { .pr4(); }\n  .pr5-m  { .pr5(); }\n  .pr6-m  { .pr6(); }\n  .pr7-m  { .pr7(); }\n  .pr8-m  { .pr8(); }\n  .pr9-m  { .pr9(); }\n  .pr11-m { .pr10(); }\n  .pr10-m { .pr11(); }\n  .pr12-m { .pr12(); }\n  .pr13-m { .pr13(); }\n  .pr14-m { .pr14(); }\n});\n\n.large-desktop({\n  .pr5-l  { .pr5(); }\n});\n\n // Padding Bottom\n.pb0  { padding-bottom: @spacing-0; }\n.pb1  { padding-bottom: @spacing-1; }\n.pb2  { padding-bottom: @spacing-2; }\n.pb3  { padding-bottom: @spacing-3; }\n.pb4  { padding-bottom: @spacing-4; }\n.pb5  { padding-bottom: @spacing-5; }\n.pb6  { padding-bottom: @spacing-6; }\n.pb7  { padding-bottom: @spacing-7; }\n.pb8  { padding-bottom: @spacing-8; }\n.pb9  { padding-bottom: @spacing-9; }\n.pb10 { padding-bottom: @spacing-10; }\n.pb11 { padding-bottom: @spacing-11; }\n.pb12 { padding-bottom: @spacing-12; }\n.pb13 { padding-bottom: @spacing-13; }\n.pb14 { padding-bottom: @spacing-14; }\n\n.pb-80 { padding-bottom: 80%; }\n\n.tablet({\n  .pb0-t   { .pb0(); }\n  .pb1-t   { .pb1(); }\n  .pb2-t   { .pb2(); }\n  .pb3-t   { .pb3(); }\n  .pb4-t   { .pb4(); }\n  .pb5-t   { .pb5(); }\n  .pb6-t   { .pb6(); }\n  .pb7-t   { .pb7(); }\n  .pb8-t   { .pb8(); }\n  .pb9-t   { .pb9(); }\n  .pb10-t  { .pb10(); }\n  .pb11-t  { .pb11(); }\n  .pb12-t  { .pb12(); }\n  .pb13-t  { .pb13(); }\n  .pb14-t  { .pb14(); }\n});\n\n.mobile({\n  .pb0-m  { .pb0(); }\n  .pb1-m  { .pb1(); }\n  .pb2-m  { .pb2(); }\n  .pb3-m  { .pb3(); }\n  .pb4-m  { .pb4(); }\n  .pb5-m  { .pb5(); }\n  .pb6-m  { .pb6(); }\n  .pb7-m  { .pb7(); }\n  .pb8-m  { .pb8(); }\n  .pb9-m  { .pb9(); }\n  .pb11-m { .pb10(); }\n  .pb10-m { .pb11(); }\n  .pb12-m { .pb12(); }\n  .pb13-m { .pb13(); }\n  .pb14-m { .pb14(); }\n  .pb-80-m { .pb-80(); }\n});\n\n\n // Padding Top\n.pt0  { padding-top: @spacing-0; }\n.pt1  { padding-top: @spacing-1; }\n.pt2  { padding-top: @spacing-2; }\n.pt3  { padding-top: @spacing-3; }\n.pt4  { padding-top: @spacing-4; }\n.pt5  { padding-top: @spacing-5; }\n.pt6  { padding-top: @spacing-6; }\n.pt7  { padding-top: @spacing-7; }\n.pt8  { padding-top: @spacing-8; }\n.pt9  { padding-top: @spacing-9; }\n.pt10 { padding-top: @spacing-10; }\n.pt11 { padding-top: @spacing-11; }\n.pt12 { padding-top: @spacing-12; }\n.pt13 { padding-top: @spacing-13; }\n.pt14 { padding-top: @spacing-14; }\n\n.tablet({\n  .pt0-t  { .pt0(); }\n  .pt1-t  { .pt1(); }\n  .pt2-t  { .pt2(); }\n  .pt3-t  { .pt3(); }\n  .pt4-t  { .pt4(); }\n  .pt5-t  { .pt5(); }\n  .pt6-t  { .pt6(); }\n  .pt7-t  { .pt7(); }\n  .pt8-t  { .pt8(); }\n  .pt9-t  { .pt9(); }\n  .pt11-t { .pt10(); }\n  .pt10-t { .pt11(); }\n  .pt12-t { .pt12(); }\n  .pt13-t { .pt13(); }\n  .pt14-t { .pt14(); }\n});\n\n.mobile({\n  .pt0-m  { .pt0(); }\n  .pt1-m  { .pt1(); }\n  .pt2-m  { .pt2(); }\n  .pt3-m  { .pt3(); }\n  .pt4-m  { .pt4(); }\n  .pt5-m  { .pt5(); }\n  .pt6-m  { .pt6(); }\n  .pt7-m  { .pt7(); }\n  .pt8-m  { .pt8(); }\n  .pt9-m  { .pt9(); }\n  .pt11-m { .pt10(); }\n  .pt10-m { .pt11(); }\n  .pt12-m { .pt12(); }\n  .pt13-m { .pt13(); }\n  .pt14-m { .pt14(); }\n});\n\n\n // Padding Vertical\n.pv0      { padding-top: @spacing-0; padding-bottom: @spacing-0;           }\n.pv0-half { padding-top: @spacing-0-half; padding-bottom: @spacing-0-half; }\n.pv1      { padding-top: @spacing-1; padding-bottom: @spacing-1;           }\n.pv2      { padding-top: @spacing-2; padding-bottom: @spacing-2;           }\n.pv3      { padding-top: @spacing-3; padding-bottom: @spacing-3;           }\n.pv4      { padding-top: @spacing-4; padding-bottom: @spacing-4;           }\n.pv4-half { padding-top: @spacing-4-half; padding-bottom: @spacing-4-half; }\n.pv5      { padding-top: @spacing-5; padding-bottom: @spacing-5;           }\n.pv6      { padding-top: @spacing-6; padding-bottom: @spacing-6;           }\n.pv7      { padding-top: @spacing-7; padding-bottom: @spacing-7;           }\n.pv8      { padding-top: @spacing-8; padding-bottom: @spacing-8;           }\n.pv9      { padding-top: @spacing-9; padding-bottom: @spacing-9;           }\n.pv10     { padding-top: @spacing-10; padding-bottom: @spacing-10;         }\n.pv11     { padding-top: @spacing-11; padding-bottom: @spacing-11;         }\n.pv12     { padding-top: @spacing-12; padding-bottom: @spacing-12;         }\n.pv13     { padding-top: @spacing-13; padding-bottom: @spacing-13;         }\n.pv14     { padding-top: @spacing-14; padding-bottom: @spacing-14;         }\n\n.tablet({\n  .pv0-t  { .pv0(); }\n  .pv1-t  { .pv1(); }\n  .pv2-t  { .pv2(); }\n  .pv3-t  { .pv3(); }\n  .pv4-t  { .pv4(); }\n  .pv5-t  { .pv5(); }\n  .pv6-t  { .pv6(); }\n  .pv7-t  { .pv7(); }\n  .pv8-t  { .pv8(); }\n  .pv9-t  { .pv9(); }\n  .pv11-t { .pv10(); }\n  .pv10-t { .pv11(); }\n  .pv12-t { .pv12(); }\n  .pv13-t { .pv13(); }\n  .pv14-t { .pv14(); }\n});\n\n.mobile({\n  .pv0-m  { .pv0(); }\n  .pv1-m  { .pv1(); }\n  .pv2-m  { .pv2(); }\n  .pv3-m  { .pv3(); }\n  .pv4-m  { .pv4(); }\n  .pv5-m  { .pv5(); }\n  .pv6-m  { .pv6(); }\n  .pv7-m  { .pv7(); }\n  .pv8-m  { .pv8(); }\n  .pv9-m  { .pv9(); }\n  .pv11-m { .pv10(); }\n  .pv10-m { .pv11(); }\n  .pv12-m { .pv12(); }\n  .pv13-m { .pv13(); }\n  .pv14-m { .pv14(); }\n});\n\n\n // Padding Horizontal\n.ph0  { padding-left: @spacing-0; padding-right: @spacing-0; }\n.ph1  { padding-left: @spacing-1; padding-right: @spacing-1; }\n.ph2  { padding-left: @spacing-2; padding-right: @spacing-2; }\n.ph3  { padding-left: @spacing-3; padding-right: @spacing-3; }\n.ph4  { padding-left: @spacing-4; padding-right: @spacing-4; }\n.ph5  { padding-left: @spacing-5; padding-right: @spacing-5; }\n.ph6  { padding-left: @spacing-6; padding-right: @spacing-6; }\n.ph7  { padding-left: @spacing-7; padding-right: @spacing-7; }\n.ph8  { padding-left: @spacing-8; padding-right: @spacing-8; }\n.ph9  { padding-left: @spacing-9; padding-right: @spacing-9; }\n.ph10 { padding-left: @spacing-10; padding-right: @spacing-10; }\n.ph11 { padding-left: @spacing-11; padding-right: @spacing-11; }\n.ph12 { padding-left: @spacing-12; padding-right: @spacing-12; }\n.ph13 { padding-left: @spacing-13; padding-right: @spacing-13; }\n.ph14 { padding-left: @spacing-14; padding-right: @spacing-14; }\n\n.tablet({\n  .ph0-t  { .ph0(); }\n  .ph1-t  { .ph1(); }\n  .ph2-t  { .ph2(); }\n  .ph3-t  { .ph3(); }\n  .ph4-t  { .ph4(); }\n  .ph5-t  { .ph5(); }\n  .ph6-t  { .ph6(); }\n  .ph7-t  { .ph7(); }\n  .ph8-t  { .ph8(); }\n  .ph9-t  { .ph9(); }\n  .ph11-t { .ph10(); }\n  .ph10-t { .ph11(); }\n  .ph12-t { .ph12(); }\n  .ph13-t { .ph13(); }\n  .ph14-t { .ph14(); }\n});\n\n.mobile({\n  .ph0-m  { .ph0(); }\n  .ph1-m  { .ph1(); }\n  .ph2-m  { .ph2(); }\n  .ph3-m  { .ph3(); }\n  .ph4-m  { .ph4(); }\n  .ph5-m  { .ph5(); }\n  .ph6-m  { .ph6(); }\n  .ph7-m  { .ph7(); }\n  .ph8-m  { .ph8(); }\n  .ph9-m  { .ph9(); }\n  .ph11-m { .ph10(); }\n  .ph10-m { .ph11(); }\n  .ph12-m { .ph12(); }\n  .ph13-m { .ph13(); }\n  .ph14-m { .ph14(); }\n});\n\n\n\n\n // Margin All\n.ma0         { margin: @spacing-0; }\n.ma1         { margin: @spacing-1; }\n.ma2         { margin: @spacing-2; }\n.ma3         { margin: @spacing-3; }\n.ma4         { margin: @spacing-4; }\n.ma5         { margin: @spacing-5; }\n.ma6         { margin: @spacing-6; }\n.ma7         { margin: @spacing-7; }\n.ma8         { margin: @spacing-8; }\n.ma9         { margin: @spacing-9; }\n.ma10        { margin: @spacing-10; }\n.ma10-half   { margin: @spacing-10-half; }\n.ma11        { margin: @spacing-11; }\n.ma11-half   { margin: @spacing-11-half; }\n.ma12        { margin: @spacing-12; }\n.ma13        { margin: @spacing-13; }\n.ma14        { margin: @spacing-14; }\n.maauto      { margin: auto; }\n\n.tablet({\n  .ma0-t         { .ma0(); }\n  .ma1-t         { .ma1(); }\n  .ma2-t         { .ma2(); }\n  .ma3-t         { .ma3(); }\n  .ma4-t         { .ma4(); }\n  .ma5-t         { .ma5(); }\n  .ma6-t         { .ma6(); }\n  .ma7-t         { .ma7(); }\n  .ma8-t         { .ma8(); }\n  .ma9-t         { .ma9(); }\n  .ma10-t        { .ma11(); }\n  .ma10-half-t   { .ma10-half(); }\n  .ma11-t        { .ma10(); }\n  .ma11-half-t   { .ma11-half(); }\n  .ma12-t        { .ma12(); }\n  .ma13-t        { .ma13(); }\n  .ma14-t        { .ma14(); }\n  .maauto-t      { .maauto(); }\n});\n\n.mobile({\n  .ma0-m         { .ma0(); }\n  .ma1-m         { .ma1(); }\n  .ma2-m         { .ma2(); }\n  .ma3-m         { .ma3(); }\n  .ma4-m         { .ma4(); }\n  .ma5-m         { .ma5(); }\n  .ma6-m         { .ma6(); }\n  .ma7-m         { .ma7(); }\n  .ma8-m         { .ma8(); }\n  .ma9-m         { .ma9(); }\n  .ma10-m        { .ma10(); }\n  .ma10-half-m   { .ma10-half(); }\n  .ma11-m        { .ma11(); }\n  .ma11-half-m   { .ma11-half(); }\n  .ma12-m        { .ma12(); }\n  .ma13-m        { .ma13(); }\n  .ma14-m        { .ma14(); }\n  .maauto-m      { .maauto(); }\n});\n\n\n // Margin Left\n.ml0         { margin-left: @spacing-0; }\n.ml1         { margin-left: @spacing-1; }\n.ml2         { margin-left: @spacing-2; }\n.ml3         { margin-left: @spacing-3; }\n.ml4         { margin-left: @spacing-4; }\n.ml5         { margin-left: @spacing-5; }\n.ml6         { margin-left: @spacing-6; }\n.ml7         { margin-left: @spacing-7; }\n.ml8         { margin-left: @spacing-8; }\n.ml9         { margin-left: @spacing-9; }\n.ml10        { margin-left: @spacing-10; }\n.ml10-half   { margin-left: @spacing-10-half; }\n.ml11        { margin-left: @spacing-11; }\n.ml11-half   { margin-left: @spacing-11-half; }\n.ml12        { margin-left: @spacing-12; }\n.ml13        { margin-left: @spacing-13; }\n.ml14        { margin-left: @spacing-14; }\n.mlauto      { margin-left: auto; }\n\n.ml-22 { margin-left: 22%; }\n\n.tablet({\n  .ml0-t          { .ml0(); }\n  .ml1-t          { .ml1(); }\n  .ml2-t          { .ml2(); }\n  .ml3-t          { .ml3(); }\n  .ml4-t          { .ml4(); }\n  .ml5-t          { .ml5(); }\n  .ml6-t          { .ml6(); }\n  .ml7-t          { .ml7(); }\n  .ml8-t          { .ml8(); }\n  .ml9-t          { .ml9(); }\n  .ml10-t         { .ml10(); }\n  .ml10-half-t    { .ml10-half(); }\n  .ml11-t         { .ml11(); }\n  .ml11-half-t    { .ml11-half(); }\n  .ml12-t         { .ml12(); }\n  .ml13-t         { .ml13(); }\n  .ml14-t         { .ml14(); }\n  .mlauto-t       { .mlauto(); }\n});\n\n.mobile({\n  .ml0-m         { .ml0(); }\n  .ml1-m         { .ml1(); }\n  .ml2-m         { .ml2(); }\n  .ml3-m         { .ml3(); }\n  .ml4-m         { .ml4(); }\n  .ml5-m         { .ml5(); }\n  .ml6-m         { .ml6(); }\n  .ml7-m         { .ml7(); }\n  .ml8-m         { .ml8(); }\n  .ml9-m         { .ml9(); }\n  .ml10-m        { .ml10(); }\n  .ml10-half-m   { .ml10-half(); }\n  .ml11-m        { .ml11(); }\n  .ml11-half-m   { .ml11-half(); }\n  .ml12-m        { .ml12(); }\n  .ml13-m        { .ml13(); }\n  .ml14-m        { .ml14(); }\n  .mlauto-m      { .mlauto(); }\n});\n\n\n // Margin Right\n.mr0         { margin-right: @spacing-0; }\n.mr1         { margin-right: @spacing-1; }\n.mr2         { margin-right: @spacing-2; }\n.mr3         { margin-right: @spacing-3; }\n.mr4         { margin-right: @spacing-4; }\n.mr5         { margin-right: @spacing-5; }\n.mr5-half    { margin-right: @spacing-5-half; }\n.mr6         { margin-right: @spacing-6; }\n.mr7         { margin-right: @spacing-7; }\n.mr8         { margin-right: @spacing-8; }\n.mr9         { margin-right: @spacing-9; }\n.mr10        { margin-right: @spacing-10; }\n.mr10-half   { margin-right: @spacing-10-half; }\n.mr11        { margin-right: @spacing-11; }\n.mr11-half   { margin-right: @spacing-11-half; }\n.mr12        { margin-right: @spacing-12; }\n.mr13        { margin-right: @spacing-13; }\n.mr14        { margin-right: @spacing-14; }\n.mrauto      { margin-right: auto; }\n\n.desktop({\n  .mr-0-d { .mr0(); }\n});\n\n.tablet({\n  .mr0-t         { .mr0(); }\n  .mr1-t         { .mr1(); }\n  .mr2-t         { .mr2(); }\n  .mr3-t         { .mr3(); }\n  .mr4-t         { .mr4(); }\n  .mr5-t         { .mr5(); }\n  .mr6-t         { .mr6(); }\n  .mr7-t         { .mr7(); }\n  .mr8-t         { .mr8(); }\n  .mr9-t         { .mr9(); }\n  .mr10-t        { .mr10(); }\n  .mr10-half-t   { .mr10-half(); }\n  .mr11-t        { .mr11(); }\n  .mr11-half-t   { .mr11-half(); }\n  .mr12-t        { .mr12(); }\n  .mr13-t        { .mr13(); }\n  .mr14-t        { .mr14(); }\n  .mrauto-t      { .mrauto(); }\n});\n\n.mobile({\n  .mr0-m         { .mr0(); }\n  .mr1-m         { .mr1(); }\n  .mr2-m         { .mr2(); }\n  .mr3-m         { .mr3(); }\n  .mr4-m         { .mr4(); }\n  .mr5-m         { .mr5(); }\n  .mr6-m         { .mr6(); }\n  .mr7-m         { .mr7(); }\n  .mr8-m         { .mr8(); }\n  .mr9-m         { .mr9(); }\n  .mr10-m        { .mr10(); }\n  .mr10-half-m   { .mr10-half(); }\n  .mr11-m        { .mr11(); }\n  .mr11-half-m   { .mr11-half(); }\n  .mr12-m        { .mr12(); }\n  .mr13-m        { .mr13(); }\n  .mr14-m        { .mr14(); }\n  .mrauto-m      { .mrauto(); }\n});\n\n\n // Margin Bottom\n.mb0         { margin-bottom: @spacing-0; }\n.mb1         { margin-bottom: @spacing-1; }\n.mb2         { margin-bottom: @spacing-2; }\n.mb3         { margin-bottom: @spacing-3; }\n.mb4         { margin-bottom: @spacing-4; }\n.mb5         { margin-bottom: @spacing-5; }\n.mb6         { margin-bottom: @spacing-6; }\n.mb7         { margin-bottom: @spacing-7; }\n.mb8         { margin-bottom: @spacing-8; }\n.mb9         { margin-bottom: @spacing-9; }\n.mb10        { margin-bottom: @spacing-10; }\n.mb10-half   { margin-bottom: @spacing-10-half; }\n.mb11        { margin-bottom: @spacing-11; }\n.mb11-half   { margin-bottom: @spacing-11-half; }\n.mb12        { margin-bottom: @spacing-12; }\n.mb13        { margin-bottom: @spacing-13; }\n.mb14        { margin-bottom: @spacing-14; }\n.mbauto      { margin-bottom: auto; }\n\n.-mb2   { margin-bottom: -@spacing-2; }\n.-mb4   { margin-bottom: -@spacing-4; }\n\n.last-child-mb0:last-child { .mb0(); }\n\n.tablet({\n  .mb0-t         { .mb0(); }\n  .mb1-t         { .mb1(); }\n  .mb2-t         { .mb2(); }\n  .mb3-t         { .mb3(); }\n  .mb4-t         { .mb4(); }\n  .mb5-t         { .mb5(); }\n  .mb6-t         { .mb6(); }\n  .mb7-t         { .mb7(); }\n  .mb8-t         { .mb8(); }\n  .mb9-t         { .mb9(); }\n  .mb10-t        { .mb10(); }\n  .mb10-half-t   { .mb10-half(); }\n  .mb11-t        { .mb11(); }\n  .mb11-half-t   { .mb11-half(); }\n  .mb12-t        { .mb12(); }\n  .mb13-t        { .mb13(); }\n  .mb14-t        { .mb14(); }\n  .mbauto-t { .mbauto(); }\n});\n\n.mobile({\n  .mb0-m         { .mb0(); }\n  .mb1-m         { .mb1(); }\n  .mb2-m         { .mb2(); }\n  .mb3-m         { .mb3(); }\n  .mb4-m         { .mb4(); }\n  .mb5-m         { .mb5(); }\n  .mb6-m         { .mb6(); }\n  .mb7-m         { .mb7(); }\n  .mb8-m         { .mb8(); }\n  .mb9-m         { .mb9(); }\n  .mb10-m        { .mb10(); }\n  .mb10-half-m   { .mb10-half(); }\n  .mb11-m        { .mb11(); }\n  .mb11-half-m   { .mb11-half(); }\n  .mb12-m        { .mb12(); }\n  .mb13-m        { .mb13(); }\n  .mb14-m        { .mb14(); }\n  .mbauto-m      { .mbauto(); }\n});\n\n\n // Margin Top\n.mt0       {  margin-top: @spacing-0; }\n.mt1       {  margin-top: @spacing-1; }\n.mt2       {  margin-top: @spacing-2; }\n.mt3       {  margin-top: @spacing-3; }\n.mt4       {  margin-top: @spacing-4; }\n.mt5       {  margin-top: @spacing-5; }\n.mt6       {  margin-top: @spacing-6; }\n.mt7       {  margin-top: @spacing-7; }\n.mt8       {  margin-top: @spacing-8; }\n.mt9       {  margin-top: @spacing-9; }\n.mt10      {  margin-top: @spacing-10; }\n.mt10-half {  margin-top: @spacing-10-half; }\n.mt11      {  margin-top: @spacing-11; }\n.mt11-half {  margin-top: @spacing-11-half; }\n.mt12      {  margin-top: @spacing-12; }\n.mt13      {  margin-top: @spacing-13; }\n.mt14      {  margin-top: @spacing-14; }\n\n.-mt1 {  margin-top: -@spacing-1; }\n.-mt2 {  margin-top: -@spacing-2; }\n.-mt3 {  margin-top: -@spacing-3; }\n.-mt4 {  margin-top: -@spacing-4; }\n.-mt5 {  margin-top: -@spacing-5; }\n.-mt6 {  margin-top: -@spacing-6; }\n.-mt7 {  margin-top: -@spacing-7; }\n.-mt8 {  margin-top: -@spacing-8; }\n.-mt9 {  margin-top: -@spacing-9; }\n\n.large-desktop({\n  .mt0-l { .mt0(); }\n});\n\n.tablet({\n  .mt0-t       { .mt0(); }\n  .mt1-t       { .mt1(); }\n  .mt2-t       { .mt2(); }\n  .mt3-t       { .mt3(); }\n  .mt4-t       { .mt4(); }\n  .mt5-t       { .mt5(); }\n  .mt6-t       { .mt6(); }\n  .mt7-t       { .mt7(); }\n  .mt8-t       { .mt8(); }\n  .mt9-t       { .mt9(); }\n  .mt10-t      { .mt10(); }\n  .mt10-half-t { .mt10-half(); }\n  .mt11-t      { .mt11(); }\n  .mt11-half-t { .mt11-half(); }\n  .mt12-t      { .mt12(); }\n  .mt13-t      { .mt13(); }\n  .mt14-t      { .mt14(); }\n});\n\n.mobile({\n  .mt0-m  { .mt0(); }\n  .mt1-m  { .mt1(); }\n  .mt2-m  { .mt2(); }\n  .mt3-m  { .mt3(); }\n  .mt4-m  { .mt4(); }\n  .mt5-m  { .mt5(); }\n  .mt6-m  { .mt6(); }\n  .mt7-m  { .mt7(); }\n  .mt8-m  { .mt8(); }\n  .mt9-m  { .mt9(); }\n  .mt10-m { .mt10(); }\n  .mt10-half-m { .mt10-half(); }\n  .mt11-m { .mt11(); }\n  .mt11-half-m { .mt11-half(); }\n  .mt12-m { .mt12(); }\n  .mt13-m { .mt13(); }\n  .mt14-m { .mt14(); }\n});\n\n\n // Margin Vertical\n.mv0       { margin-top: @spacing-0; margin-bottom: @spacing-0; }\n.mv1       { margin-top: @spacing-1; margin-bottom: @spacing-1; }\n.mv2       { margin-top: @spacing-2; margin-bottom: @spacing-2; }\n.mv3       { margin-top: @spacing-3; margin-bottom: @spacing-3; }\n.mv4       { margin-top: @spacing-4; margin-bottom: @spacing-4; }\n.mv5       { margin-top: @spacing-5; margin-bottom: @spacing-5; }\n.mv6       { margin-top: @spacing-6; margin-bottom: @spacing-6; }\n.mv7       { margin-top: @spacing-7; margin-bottom: @spacing-7; }\n.mv8       { margin-top: @spacing-8; margin-bottom: @spacing-8; }\n.mv9       { margin-top: @spacing-9; margin-bottom: @spacing-9; }\n.mv10      { margin-top: @spacing-10; margin-bottom: @spacing-10; }\n.mv10-half { margin-top: @spacing-10-half; margin-bottom: @spacing-10-half; }\n.mv11      { margin-top: @spacing-11; margin-bottom: @spacing-11; }\n.mv11-half { margin-top: @spacing-11-half; margin-bottom: @spacing-11-half; }\n.mv12      { margin-top: @spacing-12; margin-bottom: @spacing-12; }\n.mv13      { margin-top: @spacing-13; margin-bottom: @spacing-13; }\n.mv14      { margin-top: @spacing-14; margin-bottom: @spacing-14; }\n\n.tablet({\n  .mv0-t  { .mv0(); }\n  .mv1-t  { .mv1(); }\n  .mv2-t  { .mv2(); }\n  .mv3-t  { .mv3(); }\n  .mv4-t  { .mv4(); }\n  .mv5-t  { .mv5(); }\n  .mv6-t  { .mv6(); }\n  .mv7-t  { .mv7(); }\n  .mv8-t  { .mv8(); }\n  .mv9-t  { .mv9(); }\n  .mv10-t { .mv10(); }\n  .mv10-half-t { .mv10-half(); }\n  .mv11-t { .mv11(); }\n  .mv11-half-t { .mv11-half(); }\n  .mv12-t { .mv12(); }\n  .mv13-t { .mv13(); }\n  .mv14-t { .mv14(); }\n});\n\n.mobile({\n  .mv0-m       { .mv0(); }\n  .mv1-m       { .mv1(); }\n  .mv2-m       { .mv2(); }\n  .mv3-m       { .mv3(); }\n  .mv4-m       { .mv4(); }\n  .mv5-m       { .mv5(); }\n  .mv6-m       { .mv6(); }\n  .mv7-m       { .mv7(); }\n  .mv8-m       { .mv8(); }\n  .mv9-m       { .mv9(); }\n  .mv10-m      { .mv10(); }\n  .mv10-half-m { .mv10-half(); }\n  .mv11-m      { .mv11(); }\n  .mv11-half-m { .mv11-half(); }\n  .mv12-m      { .mv12(); }\n  .mv13-m      { .mv13(); }\n  .mv14-m      { .mv14(); }\n});\n\n\n // Margin Horizontal\n.mh0         { margin-left: @spacing-0; margin-right: @spacing-0; }\n.mh1         { margin-left: @spacing-1; margin-right: @spacing-1; }\n.mh2         { margin-left: @spacing-2; margin-right: @spacing-2; }\n.mh3         { margin-left: @spacing-3; margin-right: @spacing-3; }\n.mh4         { margin-left: @spacing-4; margin-right: @spacing-4; }\n.mh5         { margin-left: @spacing-5; margin-right: @spacing-5; }\n.mh6         { margin-left: @spacing-6; margin-right: @spacing-6; }\n.mh7         { margin-left: @spacing-7; margin-right: @spacing-7; }\n.mh8         { margin-left: @spacing-8; margin-right: @spacing-8; }\n.mh9         { margin-left: @spacing-9; margin-right: @spacing-9; }\n.mh10        { margin-left: @spacing-10; margin-right: @spacing-10; }\n.mh10-half   { margin-left: @spacing-10-half; margin-right: @spacing-10-half; }\n.mh11        { margin-left: @spacing-11; margin-right: @spacing-11; }\n.mh11-half    { margin-left: @spacing-11-half; margin-right: @spacing-11-half; }\n.mh12        { margin-left: @spacing-12; margin-right: @spacing-12; }\n.mh13        { margin-left: @spacing-13; margin-right: @spacing-13; }\n.mh14        { margin-left: @spacing-14; margin-right: @spacing-14; }\n.mhauto      { margin-left: auto; margin-right: auto; }\n\n.tablet({\n  .mh0-t    { .mh0(); }\n  .mh1-t    { .mh1(); }\n  .mh2-t    { .mh2(); }\n  .mh3-t    { .mh3(); }\n  .mh4-t    { .mh4(); }\n  .mh5-t    { .mh5(); }\n  .mh6-t    { .mh6(); }\n  .mh7-t    { .mh7(); }\n  .mh8-t    { .mh8(); }\n  .mh9-t    { .mh9(); }\n  .mh11-t   { .mh10(); }\n  .mh10-t   { .mh11(); }\n  .mh12-t   { .mh12(); }\n  .mh13-t   { .mh13(); }\n  .mh14-t   { .mh14(); }\n  .mhauto-t { .mhauto(); }\n});\n\n.mobile({\n  .mh0-m    { .mh0(); }\n  .mh1-m    { .mh1(); }\n  .mh2-m    { .mh2(); }\n  .mh3-m    { .mh3(); }\n  .mh4-m    { .mh4(); }\n  .mh5-m    { .mh5(); }\n  .mh6-m    { .mh6(); }\n  .mh7-m    { .mh7(); }\n  .mh8-m    { .mh8(); }\n  .mh9-m    { .mh9(); }\n  .mh10-m   { .mh10(); }\n  .mh11-m   { .mh11(); }\n  .mh12-m   { .mh12(); }\n  .mh13-m   { .mh13(); }\n  .mh14-m   { .mh14(); }\n  .mhauto-m { .mhauto(); }\n});\n\n.gap1 { gap: @spacing-1; }\n.gap2 { gap: @spacing-2; }\n.gap3 { gap: @spacing-3; }\n.gap4 { gap: @spacing-4; }\n.gap5 { gap: @spacing-5; }\n.gap6 { gap: @spacing-6; }\n.gap7 { gap: @spacing-7; }\n.gap8 { gap: @spacing-8; }\n.gap9 { gap: @spacing-9; }\n.gap10 { gap: @spacing-10; }","@zero-px: 0.0001px;\n\n@animation-length: 250ms;\n@skimmedSearch: rgb(241, 97, 125); //#F1617D;\n@semiSearch: rgb(63, 197, 153); //#3FC599;\n@fullSearch: rgb(53, 184, 211); // #35B8D3;\n@archive: rgb(115, 121, 122); // #73797A;\n@legislation: #83619C;\n@currentAwareness: #F87531;\n@precedents: #011279;\n@about: #825F48;\n@faq: #3A447A;\n@termsOfUse: #C85C17;\n@privacyPolicy: #D95741;\n@dealwatch: #00719F;\n\n@desktop-navbar-height: 80px;\n@mobile-navbar-height: 50px;\n\n@desktop-searchbar-height: 70px;\n@mobile-searchbar-height: 60px;\n\n@desktop-search-height: 45px;\n@mobile-search-height: 40px;\n\n@page-max-width: 970px;\n@page-left-width: 300px;\n@page-right-width-desktop-wide: 600px;\n@page-right-width-desktop: 700px;\n@page-right-width-tablet: 520px;\n@page-right-width-mobile: 325px;\n\n@color-accordion-base: #ffffff; // Abbey\n\n@color-accordion-top-level: #FFF;\n@color-accordion-top-level-expanded: #555;\n\n@color-accordion-shadow: #a0f6aa; // Gossip\n@color-accordion-text: #000; // White\n@accordion-darken-step: 2.5%;\n@color-header-menu: #565656;\n@color-header-menu-secondary: #d8d8d8;\n@color-link: #1460D1;\n@color-error: #FC645F; // TODO: replace - going to use the other tomato for now\n\n@color-dragged-item-background: #555; // TODO - replace - going to use existing dim grey\n\n.keyframes(@name; @arguments) {\n  @-moz-keyframes @name { @arguments(); }\n  @-webkit-keyframes @name { @arguments(); }\n  @keyframes @name { @arguments(); }\n}\n","/*\n\n  Layout\n  ------\n\n  Utility classes for layout.\n\n*/\n\n// Overflow\n.overflow-auto    { overflow: auto; }\n.overflow-hidden  { overflow: hidden; }\n.overflow-y-auto  { overflow-y: auto; }\n.overflow-visible { overflow: visible; }\n.overflow-x-hidden { overflow: hidden;}\n.overflow-fade { \n  overflow: hidden; \n  position: relative;\n}\n\n.overflow-fade::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: @height-4;\n  background: linear-gradient(to bottom, transparent, rgb(255, 255, 255));\n}\n\n\n\n// Border Collapse\n.collapse { border-collapse: collapse; border-spacing: 0; }\n\n\n// Display\n.db          { display: block; }\n.dib         { display: inline-block; }\n.di          { display: inline; }\n.dn          { display: none; }\n.flex        { display: flex; }\n.inline-flex { display: inline-flex; }\n\n.tablet({\n  .db-t          { .db(); }\n  .dib-t         { .dib(); }\n  .di-t          { .di(); }\n  .dn-t          { .dn(); }\n  .flex-t        { .flex(); }\n  .inline-flex-t { .inline-flex(); }\n});\n\n.mobile({\n  .db-m          { .db(); }\n  .dib-m         { .dib(); }\n  .di-m          { .di(); }\n  .dn-m          { .dn(); }\n  .flex-m        { .flex(); }\n  .inline-flex-m { .inline-flex(); }\n  .contents-m    { display: contents; }\n});\n\n.desktop({\n  .dn-d { .dn(); }\n  .db-d { .db(); }\n});\n\n.large-desktop({\n  .db-l { .db(); }\n  .dn-l { .dn(); }\n  .flex-l { .flex(); }\n});\n\n// Flex shorthand\n.flexy  { flex: 1 1 auto; }\n.flex-1 { flex: 1 1 0%; }\n\n.mobile({ \n  .flexy-m { .flexy(); }\n});\n\n\n// Flex Direction\n.flex-column         { flex-direction: column; }\n.flex-row            { flex-direction: row; }\n.flex-column-reverse { flex-direction: column-reverse; }\n.flex-row-reverse    { flex-direction: row-reverse; }\n\n.tablet({\n  .flex-column-t         { .flex-column(); }\n  .flex-row-t            { .flex-row(); }\n  .flex-column-reverse-t { .flex-column-reverse(); }\n  .flex-row-reverse-t    { .flex-row-reverse(); }\n});\n\n.mobile({\n  .flex-column-m         { .flex-column(); }\n  .flex-row-m            { .flex-row(); }\n  .flex-column-reverse-m { .flex-column-reverse(); }\n  .flex-row-reverse-m    { .flex-row-reverse(); }\n});\n\n// Flex order\n.order-1 { order: 1;}\n.order-2 { order: 2;}\n.order-3 { order: 3;}\n\n.mobile({\n  .order-1-m { order: 1; }\n  .order-2-m { order: 2; }\n  .order-3-m { order: 3; }\n  .order-4-m { order: 4; }\n});\n\n// Flex Wrap\n.flex-wrap           { flex-wrap: wrap; }\n.flex-nowrap         { flex-wrap: nowrap; }\n.flex-wrap-reverse   { flex-wrap: wrap-reverse; }\n\n.tablet({\n  .flex-wrap-t { .flex-wrap(); }\n});\n\n.mobile({\n  .flex-wrap-m { .flex-wrap(); }\n});\n\n// Align Content\n.content-start    { align-content: flex-start; }\n.content-end      { align-content: flex-end; }\n.content-center   { align-content: center; }\n.content-baseline { align-content: baseline; }\n.content-stretch  { align-content: stretch; }\n\n\n// Align Items\n.items-start    { align-items: flex-start; }\n.items-end      { align-items: flex-end; }\n.items-center   { align-items: center; }\n.items-baseline { align-items: baseline; }\n.items-stretch  { align-items: stretch; }\n\n.tablet({\n  .items-start-t    { .items-start(); }\n  .items-end-t      { .items-end(); }\n  .items-center-t   { .items-center(); }\n  .items-baseline-t { .items-baseline(); }\n  .items-stretch-t  { .items-stretch(); }\n});\n\n.mobile({\n  .items-start-m    { .items-start(); }\n  .items-end-m      { .items-end(); }\n  .items-center-m   { .items-center(); }\n  .items-baseline-m { .items-baseline(); }\n  .items-stretch-m  { .items-stretch(); }\n});\n\n\n// Align Self\n.self-end   { align-self: flex-end; }\n.self-start { align-self: flex-start; }\n.self-center { align-self: center; }\n\n.tablet({\n  .self-end-t   { .self-end(); }\n  .self-start-t { .self-start(); }\n});\n\n\n// Justify Content\n.justify-start   { justify-content: flex-start; }\n.justify-end     { justify-content: flex-end; }\n.justify-center  { justify-content: center; }\n.justify-between { justify-content: space-between; }\n.justify-around  { justify-content: space-around; }\n.justify-evenly  { .ie-fix-justify-evenly(); justify-content: space-evenly; }\n\n.tablet({\n  .justify-start-t   { .justify-start(); }\n  .justify-end-t     { .justify-end(); }\n  .justify-center-t  { .justify-center(); }\n  .justify-between-t { .justify-between(); }\n  .justify-evenly-t  { .justify-evenly(); }\n});\n\n.mobile({\n  .justify-start-m   { .justify-start(); }\n  .justify-end-m     { .justify-end(); }\n  .justify-center-m  { .justify-center(); }\n  .justify-between-m { .justify-between(); }\n  .justify-evenly-m  { .justify-evenly(); }\n});\n\n\n// Vertical Align\n.valign-top         { vertical-align: top; }\n.valign-text-top    { vertical-align: text-top; }\n.valign-middle      { vertical-align: middle; }\n.valign-bottom      { vertical-align: bottom; }\n.valign-text-bottom { vertical-align: text-bottom; }\n.valign-super       { vertical-align: super; }\n.valign-sub         { vertical-align: sub; }\n\n\n// Flex Basis\n.basis0     { flex-basis: 0; }\n.basis-auto { .chrome-nested-flex-column-fix(); flex-basis: auto; }\n.basis-50   { flex-basis: 50%; } \n.basis-100  { flex-basis: 100%; }     \n\n.tablet({\n  .basis0-t     { .basis0(); }\n  .basis-auto-t { .basis-auto(); }\n  .basis-100-t  { .basis-100(); }     \n});\n\n\n// Flex Grow\n.grow-0 { flex-grow: 0; }\n.grow-1 { flex-grow: 1; }\n.grow-2 { flex-grow: 2; }\n.grow-3 { flex-grow: 3; }\n.grow-4 { flex-grow: 4; }\n.grow-5 { flex-grow: 5; }\n\n.grow-initial { flex-grow: initial; }\n\n.tablet({\n  .grow-0-t { .grow-0(); }\n  .grow-1-t { .grow-1(); }\n  .grow-2-t { .grow-2(); }\n  .grow-3-t { .grow-3(); }\n  .grow-4-t { .grow-4(); }\n  .grow-5-t { .grow-5(); }\n\n  .grow-initial-t { .grow-initial(); }\n});\n\n.mobile({\n  .grow-0-m { .grow-0(); }\n  .grow-1-m { .grow-1(); }\n  .grow-2-m { .grow-2(); }\n  .grow-3-m { .grow-3(); }\n  .grow-4-m { .grow-4(); }\n  .grow-5-m { .grow-5(); }\n});\n\n\n// Flex Shrink\n.shrink-0 { flex-shrink: 0; }\n.shrink-1 { flex-shrink: 1; }\n.shrink-2 { flex-shrink: 2; }\n\n.tablet({\n  .shrink-0-t { .shrink-0(); }\n  .shrink-1-t { .shrink-1(); }\n});\n\n.mobile({\n  .shrink-0-m { .shrink-0(); }\n  .shrink-1-m { .shrink-1(); }\n});\n\n\n// Float\n.flt-l { float: left; }\n.flt-n { float: none; }\n.flt-r { float: right; }\n\n\n// Position\n.static   { position: static; }\n.relative { position: relative; }\n.absolute { position: absolute; }\n.fixed    { position: fixed; }\n.sticky   {\n  position: -webkit-sticky;\n  position: sticky;\n}\n\n.large-desktop({\n  .sticky-l { .sticky(); }\n});\n\n.tablet({\n  .static-t   { .static(); }\n  .relative-t { .relative(); }\n  .absolute-t { .absolute(); }\n  .fixed-t    { .fixed(); }\n  .sticky-t   { .sticky(); }\n});\n\n.mobile({\n  .static-m   { .static(); }\n  .relative-m { .relative(); }\n  .absolute-m { .absolute(); }\n  .fixed-m    { .fixed(); }\n  .sticky-m   { .sticky(); }\n});\n\n\n// Z Index\n.z0   { z-index: 0; }\n.z5   { z-index: 5; }\n.z10  { z-index: 10; }\n.z15  { z-index: 15; }\n.z20  { z-index: 20; }\n.z25  { z-index: 25; }\n.z30  { z-index: 30; }\n.z35  { z-index: 35; }\n.z40  { z-index: 40; }\n.z45  { z-index: 45; }\n.z50  { z-index: 50; }\n.z55  { z-index: 55; }\n.z60  { z-index: 60; }\n.z105 { z-index: 105; }\n.z1055 { z-index: 1055; }\n\n// Right\n.right0    { right: @spacing-0;  }\n.right2    { right: @spacing-2;  }\n.right3    { right: @spacing-3;  }\n.right4    { right: @spacing-4;  }\n.right5    { right: @spacing-5;  }\n.right6    { right: @spacing-6;  }\n.right7    { right: @spacing-7;  }\n.right9    { right: @spacing-9;  }\n.right-50  { right: 50%; }\n.right-100 { right: 100%; }\n\n.-right3   { right: -@spacing-3;  }\n\n// Left\n.left0    { left: @spacing-0; }\n.left2    { left: @spacing-2; }\n.left4    { left: @spacing-4; }\n.left5    { left: @spacing-5; }\n.left6    { left: @spacing-6; }\n.left7    { left: @spacing-7; }\n.left8    { left: @spacing-8; }\n.left-50  { left: 50%; }\n.left-100 { left: 100%; }\n\n.-left5   { left: -@spacing-5;  }\n\n// Top\n.top0    { top: @spacing-0; }\n.top1    { top: @spacing-1; }\n.top2    { top: @spacing-2; }\n.top3    { top: @spacing-3; }\n.top4    { top: @spacing-4; }\n.top5    { top: @spacing-5; }\n.top6    { top: @spacing-6; }\n.top7    { top: @spacing-7; }\n.top8    { top: @spacing-8; }\n.top9    { top: @spacing-9; }\n.top10   { top: @spacing-10; }\n.top11   { top: @spacing-11; }\n.top12   { top: @spacing-12; }\n\n.top-15  { top: 15%; }\n.top-25  { top: 25%; }\n.top-50  { top: 50%; }\n.top-100 { top: 100%; }\n\n.-top9   { top: -@spacing-9; }\n.-top10  { top: -@spacing-10; }\n\n.tablet({\n  .top4-t   { .top4(); }\n});\n\n// Bottom\n.bottom0    { bottom: @spacing-0; }\n.bottom1    { bottom: @spacing-1; }\n.bottom2    { bottom: @spacing-2; }\n.bottom3    { bottom: @spacing-3; }\n.bottom4    { bottom: @spacing-4; }\n.bottom5    { bottom: @spacing-5; }\n.bottom6    { bottom: @spacing-6; }\n.bottom7    { bottom: @spacing-7; }\n.bottom12    { bottom: @spacing-12; }\n.bottom13    { bottom: @spacing-13; }\n.bottom-50  { bottom: 50%; }\n.bottom-100 { bottom: 100%; }\n\n.-bottom5   { bottom: -@spacing-5; }\n\n// Width\n.w0       { width: 0; }\n.w1       { width: @spacing-1; }\n.w2       { width: @spacing-2; }\n.w3       { width: @spacing-3; }\n.w4       { width: @spacing-4; }\n.w4-half  { width: @spacing-4-half;}\n.w5       { width: @spacing-5; }\n.w6       { width: @spacing-6; }\n.w7       { width: @spacing-7; }\n.w8       { width: @spacing-8; }\n.w8-half  { width: @spacing-8-half; }\n.w9       { width: @spacing-9; }\n.w10      { width: @spacing-10; }\n.w11      { width: @spacing-11; }\n.w11-half { width: @spacing-11-half;}\n.w12      { width: @spacing-12; }\n.w12-half { width: @spacing-12-half;}\n.w13      { width: @spacing-13; }\n.w14      { width: @spacing-14; }\n.w14-half {width: @spacing-14-half;}\n.w15      { width: @spacing-15; }\n.w16      { width: @spacing-16; }\n.w17      { width: @spacing-17; }\n.w18      { width: @spacing-18; }\n\n.w-10  { width: 10%; }\n.w-20  { width: 20%; }\n.w-25  { width: 25%; }\n.w-30  { width: 30%; }\n.w-33  { width: 33%; }\n.w-34  { width: 34%; }\n.w-40  { width: 40%; }\n.w-50  { width: 50%; }\n.w-55  { width: 55%; }\n.w-60  { width: 60%; }\n.w-65  { width: 65%; }\n.w-70  { width: 70%; }\n.w-75  { width: 75%; }\n.w-80  { width: 80%; }\n.w-90  { width: 90%; }\n.w-95  { width: 95%; }\n.w-100 { width: 100%; }\n\n.w-third        { width: calc(100% / 3); }\n.w-two-thirds   { width: calc(100% / 1.5); }\n.w-auto         { width: auto; }\n.w-max-content  { width: max-content; }\n\n.vw-90  { width: 90vw; }\n.vw-100 { width: 100vw; }\n\n.tablet({\n  .w13-t   { .w13(); }\n  .w-100-t { .w-100(); }\n  .w8-t    { .w8(); }\n  .w-95-t  { .w-95(); }\n  .w-100-t { .w-100(); }\n  .vw-100-t { .vw-100(); }\n});\n\n.mobile({\n  .w5-m { .w5(); }\n  .w6-m { .w6(); }\n  .w7-m { .w7(); }\n  .w8-m { .w8(); }\n  .w10-m { .w10(); }\n  .w-100-m { .w-100(); }\n  .w-auto-m { .w-auto(); }\n  .vw-100-m { .vw-100(); }\n});\n\n.large-desktop({\n  .w16-l  { .w16(); }\n  .w-50-l { .w-50(); }\n});\n\n// Max Width\n.max-w0  { max-width: 0; }\n.max-w1  { max-width: @spacing-1; }\n.max-w2  { max-width: @spacing-2; }\n.max-w3  { max-width: @spacing-3; }\n.max-w4  { max-width: @spacing-4; }\n.max-w5  { max-width: @spacing-5; }\n.max-w6  { max-width: @spacing-6; }\n.max-w7  { max-width: @spacing-7; }\n.max-w8  { max-width: @spacing-8; }\n.max-w9  { max-width: @spacing-9; }\n.max-w10 { max-width: @spacing-10; }\n.max-w11 { max-width: @spacing-11; }\n.max-w12 { max-width: @spacing-12; }\n.max-w13 { max-width: @spacing-13; }\n.max-w14 { max-width: @spacing-14; }\n.max-w14-half { max-width: @spacing-14-half; }\n.max-w15 { max-width: @spacing-15; }\n.max-w16 { max-width: @spacing-16; }\n.max-w17 { max-width: @spacing-17; }\n.max-w18 { max-width: @spacing-18; }\n\n.max-w-90  { max-width: 90%; }\n.max-w-94  { max-width: 94%; }\n.max-w-100 { max-width: 100%; }\n\n.max-w-90vw  { max-width: 90vw; }\n.max-w-100vw { max-width: 100vw; }\n\n.max-w-none { max-width: none; }\n.max-w-inherit { max-width: inherit; }\n\n.max-w-modal-small  { max-width: @modal-width-small; }\n.max-w-modal-medium { max-width: @modal-width-medium; }\n.max-w-modal-large  { max-width: @modal-width-large; }\n\n.tablet({\n  .max-w-none-t { .max-w-none(); }\n});\n\n// Min Width\n.min-w0  { min-width: 0; }\n.min-w1  { min-width: @spacing-1; }\n.min-w2  { min-width: @spacing-2; }\n.min-w3  { min-width: @spacing-3; }\n.min-w4  { min-width: @spacing-4; }\n.min-w5  { min-width: @spacing-5; }\n.min-w6  { min-width: @spacing-6; }\n.min-w7  { min-width: @spacing-7; }\n.min-w8  { min-width: @spacing-8; }\n.min-w9  { min-width: @spacing-9; }\n.min-w10 { min-width: @spacing-10; }\n.min-w11 { min-width: @spacing-11; }\n.min-w12 { min-width: @spacing-12; }\n.min-w13 { min-width: @spacing-13; }\n.min-w14 { min-width: @spacing-14; }\n.min-w15 { min-width: @spacing-15; }\n.min-w16 { min-width: @spacing-16; }\n.min-w17 { min-width: @spacing-17; }\n.min-w18 { min-width: @spacing-18; }\n\n.min-w-80  { min-width: 80%;  }\n.min-w-100 { min-width: 100%; }\n\n.min-w-none { min-width: 0; }\n\n// Matches the trigger element's width via the Headless UI `--button-width` custom property\n.min-w-button { min-width: var(--button-width); }\n\n.mobile({\n  .min-w9-m { .min-w9(); }\n});\n\n// Height\n.h0  { height: 0;         }\n.h1  { height: @height-1; }\n.h2  { height: @height-2; }\n.h3  { height: @height-3; }\n.h4  { height: @height-4; }\n.h5  { height: @height-5; }\n.h6  { height: @height-6; }\n.h7  { height: @height-7; }\n.h8  { height: @height-8; }\n.h10  { height: @height-10; }\n.h12 { height: @height-12; }\n.h14 { height: @height-14; }\n.h16 { height: @height-16; }\n\n.h-25  { height: 25%; }\n.h-50  { height: 50%; }\n.h-75  { height: 75%; }\n.h-100 { height: 100%; }\n\n.vh-25  { height: 25vh; }\n.vh-50  { height: 50vh; }\n.vh-75  { height: 75vh; }\n.vh-100 { height: 100vh; }\n\n.h-auto    { height: auto; }\n.h-inherit { height: inherit; }\n\n// heights using spacing variables (used for width and everything else)\n.hs0       { height: @spacing-0       }\n.hs0-half  { height: @spacing-0-half  }\n.hs1       { height: @spacing-1       }\n.hs2       { height: @spacing-2       }\n.hs3       { height: @spacing-3       }\n.hs4       { height: @spacing-4       }\n.hs5       { height: @spacing-5       }\n.hs6       { height: @spacing-6       }\n.hs7       { height: @spacing-7       }\n.hs8       { height: @spacing-8       }\n.hs8-half  { height: @spacing-8-half  }\n.hs9       { height: @spacing-9       }\n.hs10      { height: @spacing-10      }\n.hs11      { height: @spacing-11      }\n.hs12      { height: @spacing-12      }\n.hs13      { height: @spacing-13      }\n.hs14      { height: @spacing-14      }\n\n.mobile({\n  .h1-m { .h1(); }\n  .h2-m { .h2(); }\n  .h3-m { .h3(); }\n  .h4-m { .h4(); }\n  .h5-m { .h5(); }\n  .h6-m { .h6(); }\n});\n\n\n// Min Height\n.min-h-0    { min-height: 0; }\n.min-h2    { min-height: @height-2; }\n.min-h3     { min-height: @height-3; }\n.min-h4     { min-height: @height-4; }\n.min-h8     { min-height: @height-8; }\n.min-h12    { min-height: @height-12;  }\n\n.min-h-spacing-9     { min-height: @spacing-9; }\n.min-h-spacing-14    { min-height: @spacing-14; }\n.min-h-spacing-15    { min-height: @spacing-15; }\n\n.min-h-100      { min-height: 100%; }\n.min-vh-100     { min-height: 100vh; }\n.min-h-inherit  { min-height: inherit }\n\n// Max height\n.max-h0     { max-height: 0; }\n.max-h3     { max-height: @height-3; }\n.max-h4     { max-height: @height-4; }\n.max-h7     { max-height: @height-7}\n.max-h8     { max-height: @spacing-8; }\n.max-h16    { max-height: @height-16; }\n.max-h24    { max-height: @height-24; }\n.max-h-75   { max-height: 75%; }\n\n.tablet({\n  .max-h8-t { .max-h8(); }\n});","/*\n\n  Fix\n  ---\n\n  Fixes! Add a comment explaining what bug it fixes and if you found the\n  solution on e.g. StackOverflow then include the link.\n\n*/\n\n// Fixes a problem on Chrome with scrolling on nested flex columns.\n// https://code.google.com/p/chromium/issues/detail?id=506893\n.chrome-nested-flex-column-fix {\n  min-width: 0;\n  min-height: 0;\n}\n\n// Common clearfix for floats.\n// http://nicolasgallagher.com/micro-clearfix-hack/\n.clearfix {\n  &:before,\n  &:after {\n    content: \" \";\n    display: table;\n  }\n  &:after {\n    clear: both;\n  }\n}\n\n.firefox-flex-grow-fix {\n  .desktop({\n    flex-basis: 0;\n  });\n}\n\n// Fallback to justify-content: space-around for IE.\n// https://caniuse.com/#search=space-evenly\n.ie-fix-justify-evenly {\n  justify-content: space-around;\n}\n\n// fix for edge browser\n@supports (-ms-ime-align: auto) {\n  .justify-evenly {\n    justify-content: space-around;\n  }\n}\n\n// Hide default chevron on select elements.\n// https://developer.mozilla.org/en-US/docs/Learn/HTML/Forms/Advanced_styling_for_HTML_forms#Dealing_with_the_select_nightmare\n.ie-hide-default-select-chevron::-ms-expand {\n  display: none;\n}\n\n// Fixes margin collapse problems on e.g. Contact page without having to\n// set overflow: auto directly on this div (which messes up the topics content\n// page). https://stackoverflow.com/a/48872483\n.margin-collapse-fix {\n  &:after {\n    content: '';\n    overflow: auto;\n    display: block;\n  }\n}\n\n// TODO: Can Delete ?\n// Fallback to position: fixed for IE.\n.no-csspositionsticky .ie-sticky-fix {\n  position: fixed;\n}\n\n// Fixes a problem with border images on Safari. If you set a border image\n// on an element that has border-style-left set on it, the border will also\n// appear on the right\n.safari-border-image-fix {\n  border-right: 0 solid transparent;\n}\n\n// Disabled input elements on Safari appear lighter by default, which\n// makes them difficult to read.\n// https://stackoverflow.com/questions/262158/disabled-input-text-color\n.safari-disabled-input-fix(@color) {\n  -webkit-text-fill-color: @color;\n  -webkit-opacity: 1;\n}\n// can't find another easy way to remove the default underlines and they're annoying\n.muiButtonHoverLinesFix.muiButtonHoverLinesFix:hover {\n  .no-underline();\n}\n\n// stupid ie select styling\nselect::-ms-expand {\n  display: none;\n}\n\n// fix ie for when a div is a flex-box and we need items centered vertically\n.ie-min-height-flex-items-center-fix {\n  padding-top: 0.875rem !important; // urrrrgh\n  padding-bottom: 0.875rem !important;\n  .ie-prefix-hack {\n    top: 0.875rem;\n  }\n}\n\n.popover.bottom > .arrow::after {\n    border-bottom-color: @teal !important;\n}\n\n//  IE specific fixes for the layout\n.ie-layout-fix {\n  .max-w-100();\n  > div {\n    .layout-width-constraint();\n  }\n}\n.ie-side {\n  .db();\n}\n\n// IE has issues with items-center and needs container with this class\n.items-center-ie-fix {\n  .h-100();\n  .flex();\n  .flex-column();\n}\n\n// Remove outline from select box in FF\n.outline-0 {\n  select:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n  }\n}\n\n// FC-Logo needs to be same height as search bar on mobile\n.mobile({\n  .header-icon-mobile-width {\n    width: 2.25rem;\n  }\n});\n\n/* Stops table wrapping onto new line - see FC-1436*/\n@media only screen and (min-width: 1200px) {\n  /* Duplicating class selector to increase specificity of rule to overwrite layout-width-constraints max-width */\n  .deal-watch-width-constraint {\n    width: 72vw !important;\n  }\n}\n.deal-watch-width-constraint {\n  width: 96vw;\n}\n\n// glossary content is imported from the back end so we have to target differently\n.popover-content a {\n  .white();\n}\n\n.new-ticker {\n  div {\n    p {\n      .ma0();\n    }\n  }\n}\n\n.icon-button-bg-color-active {\n  background-color: rgba(0,0,0,0.04);\n}\n\n// fixes rte-editor onClick focus\n.rich-text-editor .public-DraftEditor-content {\n  min-height: 12rem;\n}\n\n// IE specific fix for flex when basis 0 misbehaves\n// I'm not applying this site wide as that may have unexpected behaviour\n.ie-basis0-fix {\n  flex-basis: auto;\n}\n","/*\n\n  Helpers\n  -------\n\n  This file is for mixins and helpful generic classes that aren't simple enough\n  to be considered a utility class. Should be used sparingly!\n\n*/\n\n// Visually hide text for screen readers.\n.screen-reader-text {\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute !important;\n  width: 1px;\n  word-wrap: normal !important;\n}\n\n// Add vendor prefixes to transform property.\n.transform(...) {\n  -webkit-transform: @arguments;\n  -moz-transform: @arguments;\n  -o-transform: @arguments;\n  -ms-transform: @arguments;\n  transform: @arguments;\n}\n\n// Add vendor prefixes to transition property.\n.transition (@transition) {\n  -webkit-transition: @transition;\n  -moz-transition: @transition;\n  -ms-transition: @transition;\n  -o-transition: @transition;\n  transition: @transition;\n}\n\n// Add vendor prefixes to transition property.\n.opacity (@opacity: 0.5) {\n  -webkit-opacity: @opacity;\n  -moz-opacity: @opacity;\n  opacity: @opacity;\n}\n\n.box-shadow (@box-shadow) {\n  -webkit-box-shadow: @box-shadow;\n  -moz-box-shadow: @box-shadow;\n  box-shadow: @box-shadow;\n}\n\n// Linear Gradient\n//============================================================\n// @see http://dev.w3.org/csswg/css3-images/#linear-gradients\n//\n// @param dir                 :  top, left, 90deg\n// @param start-color         :  #000, rgba(255,255,255,0.5)\n// @param end-color           :  #000, rgba(255,255,255,0.5)\n// @param start-percent       :  0%, 50%, 100%\n\n// @example .linear-gradient(50deg, #eee, 0%, #aaa, 50%);\n\n.linear-gradient( @dir: top, @start-color: #eee, @start-percent: 0%, @end-color: #aaa, @end-percent: 50%) {\n  background: -webkit-linear-gradient(@dir, @start-color @start-percent, @end-color @end-percent);\n  background: -moz-linear-gradient(@dir, @start-color @start-percent, @end-color @end-percent);\n  background: -ms-linear-gradient(@dir, @start-color @start-percent, @end-color @end-percent);\n  background: -o-linear-gradient(@dir, @start-color @start-percent, @end-color @end-percent);\n  background: linear-gradient(@dir, @start-color @start-percent, @end-color @end-percent);\n}\n\n// Vertically and horizontally centres an element.\n// NOTE: Still have to add absolute and relative positions on the relevant\n// elements.\n.center {\n  top: 50%;\n  left: 50%;\n  .transform(translate(-50%, -50%));\n}\n\n// Horizontally centres an element.\n.center-h {\n  left: 50%;\n  .transform(translateX(-50%));\n}\n\n // Vertically centres an element.\n.center-v {\n  top: 50%;\n  .transform(translateY(-50%));\n}","/*\n\n  Typography\n  ----------\n\n  Utility classes for typography.\n\n*/\n\n@font-default: \"Source Sans Pro\", \"Arial\", sans-serif;\n\n.font-default { font-family: @font-default}\n\n// Font Size\n.f1 { font-size: 3rem; } // 48px\n.f2 { font-size: 2.25rem; } // 36px\n.f3 { font-size: 1.5rem; } // 24px \n.f4 { font-size: 1.25rem; } // 20px\n.f5 { font-size: 1rem; } // 16px\n.f6 { font-size: .875rem; } // 14px \n.f7 { font-size: .75rem; } // 12px\n.f8 { font-size: 0.625rem; } // 10px\n.fht { font-size: 1.75rem; } // header page title\n\n.tablet({\n  .f1-t { .f1(); }\n  .f2-t { .f2(); }\n  .f3-t { .f3(); }\n  .f4-t { .f4(); }\n  .f5-t { .f5(); }\n  .f6-t { .f6(); }\n  .f7-t { .f7(); }\n});\n\n.mobile({\n  .f1-m { .f1(); }\n  .f2-m { .f2(); }\n  .f3-m { .f3(); }\n  .f4-m { .f4(); }\n  .f5-m { .f5(); }\n  .f6-m { .f6(); }\n  .f7-m { .f7(); }\n});\n\n// Letter Spacing\n.untracked     { letter-spacing: normal;    }\n.tracked       { letter-spacing: 0.1rem;     }\n.tracked-cosy  { letter-spacing: -0.005rem;  }\n.tracked-tight { letter-spacing: -0.05rem;   }\n.tracked-mega  { letter-spacing: 0.25rem;    }\n\n// Font Weight\n.normal  { font-weight: normal;  }\n.b       { font-weight: bold;    }\n.lighter { font-weight: lighter; }\n.fw2     { font-weight: 200;     }\n.fw3     { font-weight: 300;     }\n.fw4     { font-weight: 400;     }\n.fw5     { font-weight: 500;     }\n.fw6     { font-weight: 600;     }\n.fw7     { font-weight: 700;     }\n.fw8     { font-weight: 800;     }\n\n// Font Style\n.i         { font-style: italic; }\n.fs-normal { font-style: normal; }\n\n// Line Height\n.lh-solid        { line-height: 1;    }\n.lh-headline     { line-height: 1.17; }\n.lh-title        { line-height: 1.25; }\n.lh-copy-variant { line-height: 1.44; }\n.lh-copy         { line-height: 1.5;  }\n.lh-pagination   { line-height: 1.75; }\n.lh-copy--spaced { line-height: 2.25; }\n\n// Text Align\n.tc { text-align: center; }\n.tr { text-align: right;  }\n.tl { text-align: left;   }\n\n.mobile({\n  .tc-m { text-align: center; }\n  .tr-m { text-align: right;  }\n  .tl-m { text-align: left;   }\n});\n\n// Vertical Algin\n.vt  { vertical-align: top; }\n.vm  { vertical-align: middle;}\n.vbs { vertical-align: baseline; }\n\n// Text Decoration\n.no-underline { text-decoration: none;      }\n.underline    { text-decoration: underline; }\n.decoration-inherit { text-decoration: inherit; }\n\n.hover-underline:hover { .underline(); }\n.hover-no-underline:hover { .no-underline(); }\n.hover-b:hover { .b(); }\n\n// White Space\n.ws-normal { white-space: normal; }\n.nowrap    { white-space: nowrap; }\n.pre       { white-space: pre;    }\n\n.mobile({\n  .ws-normal-m { .ws-normal() };\n});\n\n.tablet({\n  .ws-normal-t { .ws-normal() };\n  .nowrap-t { .nowrap() };\n});\n\n.o-auto   { overflow: auto; }\n.o-hidden { overflow: hidden; }\n\n// Text Overflow\n.truncate {\n  .nowrap();\n  .o-hidden();\n  text-overflow: ellipsis;\n}\n\n// Text Transform\n.ttc { text-transform: capitalize; }\n.ttl { text-transform: lowercase; }\n.ttn { text-transform: none; }\n.ttu { text-transform: uppercase; }\n\n// Measure\n.measure        { max-width: 30em; } // Measure is limited to ~66 characters\n.measure-wide   { max-width: 34em; } // Measure is limited to ~80 characters\n.measure-narrow { max-width: 20em; } // Measure is limited to ~45 characters\n\n.desktop({\n  .measure-d        { .measure(); }  \n  .measure-wide-d   { .measure-wide(); }\n  .measure-narrow-d { .measure-narrow(); }\n});\n\n// Indentation\n// Book paragraph style - paragraphs are indented with no vertical spacing.\n.indent {\n  text-indent: 1rem;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.disable-select {\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer */\n  -webkit-user-select: none; /* Chrome, Safari, and Opera */\n  user-select: none;\n}\n\n.ds { .disable-select(); }\n\n// Word break\n.wb-all   { word-break: break-all; }\n.wb-word  { word-break: break-word; }  \n.wb-keep  { word-break: keep-all; }\n\n.tablet({\n  .wb-all-t { .wb-all(); }\n});\n\n.mobile({\n  .wb-word-m { .wb-word() };\n});\n","\n.ca-grid-card {\n  height: 26.25rem;\n  a {\n    color: @light-sea-green-2;\n    text-decoration: none;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n}\n\n.arrow-link {\n  text-decoration: none !important;\n  & a {\n    color: @cadet-blue !important;\n  }\n  & svg {\n    color: @black !important;\n  }\n  &:hover * {\n    color: @dark-sea-green-2 !important;\n    text-decoration: underline !important;\n  }\n}\n\n.ca-content {\n  a {\n    color: @light-sea-green-2;\n    text-decoration: none;\n  }\n  & > ul {\n    .list-item-initial();\n    padding-left: 1rem;\n  }\n}\n\n.ca-tile-title {\n    p {\n      margin: 0 !important;\n  }\n}\n\n.ca-article-headline-title {\n  .lh-headline();\n  .mt7();\n  .mb3();\n}\n\n.announcements-content {\n  div:first-child > h3:first-child {\n    margin-top: 0;\n  }\n  div:not(:first-child) > h3 {\n    margin-top: 3rem;\n  }\n  h3 {\n    font-size: 1.25rem;\n    font-weight: 800;\n    margin: 1.25rem 0 0.4rem;\n    color: @black;\n  }\n  strong {\n    color: @black;\n    letter-spacing: 0.1px;\n  }\n  p, li {\n    font-size: 0.9375rem;\n    color: @charcoal;\n    .lh-headline();\n    .mv5();\n  }\n  li {\n    letter-spacing: 0.1px;\n  }\n  a {\n    text-decoration: none;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n  ul, ol {\n    padding-left: 1.5rem;\n    .mv5();\n  }\n  div:first-child {\n    > p:first-child {\n      .mt4();\n    }\n    > ul:first-child {\n      .mt4();\n      > li:first-child{\n        .mt2();\n      }\n    }\n  }\n}\n\n.article-page-icons {\n  .svg-base {\n    .mh3();\n    height: 24px !important;\n    width: 24px !important;\n  }\n  .MuiIconButton-root {\n    color: @cadet-blue;\n    outline: 0;\n    padding: 0;\n    height: 2.5rem;\n    width: 2.5rem;\n    font-size: inherit;\n    &:hover {\n      color: @dark-sea-green-2;\n    }\n  }\n}\n\n.share-buttons-container {\n  .MuiIconButton-root {\n    color: @cadet-blue !important;\n    outline: 0;\n    font-size: inherit;\n    padding:4px;\n    &:hover {\n      color: @dark-sea-green-2;\n    }\n  }\n}\n\n.submit-form-button{\n  .MuiButton-root {\n    padding: 1rem 2rem;\n    color: @white;\n    background-color: @light-sea-green-2;\n    &:hover {\n      background-color: @dark-sea-green-2;\n    }\n    &:disabled {\n      background-color: @grey;\n    }\n  }\n}\n\n.article-grid {\n  a {\n    outline: 0 !important;\n  }\n}\n\n// TODO look into refactoring article-section, possibly by using a Grid container with direction column\n.article-section {\n  min-height: 60rem;\n  @media screen and (max-width: 632px) {\n    height: 64rem;\n  }\n  @media screen and (max-width: 566px) {\n    height: 66rem;\n  }\n  @media screen and (max-width: 430px) {\n    height: 70rem;\n  }\n  @media screen and (max-width: 420px) {\n    height: 72rem;\n  }\n  @media screen and (max-width: 382px) {\n    height: 76rem;\n  }\n  @media screen and (max-width: 382px) {\n    height: 80rem;\n  }\n}\n// override toastify progress-bar default styles\n.Toastify__progress-bar--default {\n  background: @light-sea-green-1;\n}\n.icon-clipboard-container, .icon-preview-toggle-container {\n  width: 32px;\n  height: 32px;\n  .MuiSvgIcon-root {\n    width: 32px;\n    height: 32px;\n  }\n  &:hover {\n    color: @dark-sea-green-2 !important;\n  }\n}\n\n.expand-more-button {\n  width: 100%;\n  height: 0;\n  text-align: center;\n}\n.expand-more-button-container {\n  .linear-gradient(top, rgba(255,255,255,0), 0%, rgba(237,237,237,1), 75%);\n}\n.tile-frosted-bottom {\n  background: rgb(255,255,255);\n  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);\n  /*.linear-gradient(top, rgba(255, 255, 255, 0), 0%, rgb(255, 255, 255), 100%);*/\n}\n\n.tooltip-wrapper {\n  &::before {\n    .absolute();\n    .left0();\n    .w7();\n    .top0();\n    .bottom0();\n    content: '';\n    .z5();\n    background: linear-gradient(270deg, rgba(255,255,255,0) 0%, rgba(237,237,237,1) 100%);\n  }\n  &::after {\n    .absolute();\n    .right0();\n    .w7();\n    .top0();\n    .bottom0();\n    content: '';\n    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(237,237,237,1) 100%);\n  }\n}\n",".hover-bg-ghost-grey:hover { .bg-ghost-grey(); }\n.bg-precedents-blue-30 { background-color: fade(@precedents-blue, 30%) } ///\n.bg-precedents-blue-20 { background-color: fade(@precedents-blue, 20%) }\n.bg-precedents-blue-10 { background-color: fade(@precedents-blue, 10%) }\n.bg-precedents-blue-5 { background-color: fade(@precedents-blue, 5%) }\n.hover-bg-precedents-blue-10:hover { .bg-precedents-blue-10(); }\n.hover-bg-precedents-blue-20:hover { .bg-precedents-blue-20(); }\n.precedents-tile {\n  .MuiButton-root {\n    &:hover {\n      background-color: fade(@precedents-blue, 10%);\n    }\n  }\n}\n.precedents-description {\n  p {\n    margin: 0 0 10px;\n  }\n}\n.bg-precedents-blue-exp {\n  background-color: @precedents-blue !important;\n}\n.action-buttons {\n  button {\n    .pointer();\n    .bg-white();\n  }\n}\n\n.menu-list-button {\n  -moz-appearance: menulist-button;\n  -webkit-appearance: menulist-button;\n}\n",".texteditor {\n  .DraftEditor-root {\n    padding: 0.5em;\n    margin: 0;\n    background: rgba(255, 255, 255, 0.5);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    min-height: 17rem;\n    position: relative;\n  }\n\n  .side-toolbar {\n    position: absolute;\n    top: 25px;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 2em;\n    transition: top 0.2s;\n\n    .svg-icon {\n      color: rgba(0, 0, 0, 0.2);\n      fill: rgba(0, 0, 0, 0.2);\n      font-size: 1.4em;\n      cursor: pointer;\n      vertical-align: middle;\n    }\n\n    .svg-icon.a-menu {\n      font-size: 1.4em;\n    }\n  }\n\n  .public-DraftEditorPlaceholder-root {\n    position: absolute;\n  }\n}\n\n@texteditor-color: #ddd;\n\n.texteditor .paragraph, .public-DraftStyleDefault-ul, .public-DraftStyleDefault-ol {\n  margin-bottom: 0;\n}\n\n.public-DraftStyleDefault-ul, .public-DraftStyleDefault-ol {\n  margin-top: 0;\n}\n\n.texteditor {\n  position: relative;\n  padding-left: 2em;\n\n  .paragraph {\n    margin-bottom: 0.5em;\n  }\n\n  blockquote {\n    padding: 10px 20px;\n    margin: 0 0 20px;\n    border-left: 5px solid #eee;\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  .toolbar {\n    position: absolute;\n    z-index: 9999;\n    height: 2em;\n    cursor: default;\n    pointer-events: none;\n    transition: opacity 0.2s;\n    opacity: 0;\n\n    &.side {\n      top: 0;\n      left: -1px;\n    }\n\n    &.active {\n      opacity: 1;\n      pointer-events: all;\n    }\n\n    &.inline {\n      font-size: 1.1em;\n    }\n\n    .toolbar-icons {\n      position: relative;\n      z-index: 1;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-align-items: center;\n      -ms-flex-align: center;\n      align-items: center;\n      -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n      justify-content: space-between;\n      list-style: none;\n      height: 100%;\n      margin: 0;\n      padding: 0;\n      background: #f5f5f5;\n      border: 1px solid @texteditor-color;\n      font-size: 1em;\n\n      .toolbar-static {\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-align-items: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        background: @texteditor-color;\n        width: 2.1em;\n        max-width: 2.1em;\n\n        .svg-icon {\n          fill: #000;\n          width: auto;\n          height: auto;\n          margin: 0;\n        }\n      }\n\n      .toolbar-icon {\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-align-items: center;\n        -ms-flex-align: center;\n        align-items: baseline;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        height: 100%;\n        width: 2.4em;\n        line-height: 2.5em;\n        max-width: 2.4em;\n        font-size: 0.8em;\n        color: #aaa;\n        transition: all 0.15s linear;\n        cursor: pointer;\n      }\n\n      .toolbar-icon.active,\n      .toolbar-icon:hover {\n        color: #222;\n\n        .svg-icon {\n          fill: #222;\n          color: #222;\n        }\n      }\n    }\n  }\n\n  .toolbar-icon:hover .toolbar .toolbar-icons .toolbar-icon i {\n    margin: 0;\n    padding: 0;\n    color: #444;\n    font-size: 1.8em;\n  }\n}\n\n.link-editor {\n  display: block;\n  max-width: 800px;\n  margin: auto;\n  width: 96%;\n  background: #ffffff;\n  padding: 5px 20px 20px;\n  font-size: 1.3em;\n\n  .form-actions {\n    text-align: right;\n    margin-top: 1em;\n\n    a {\n      display: inline-block;\n      font-size: 1em;\n      width: 10em;\n      margin: 0 0.5em;\n    }\n\n    .mobile({\n      text-align: center;\n      margin: 1em 0;\n\n      a {\n        width: 60%;\n        margin: 0.2em 0;\n      }\n    });\n  }\n\n  .input-container {\n    padding: 1em 2em;\n\n    input {\n      width: 100%;\n      font-size: 1.1em;\n      padding: 0.4em;\n      outline: none;\n      border: 2px solid #eee;\n      border-radius: 2px;\n    }\n  }\n}\n\n.group .texteditor {\n  padding: 18px 64px 18px 64px;\n  .f3();\n  display: block;\n  font-weight: 400;\n}\n\n.group .toggle-texteditor {\n  margin: 0 1em 1em 1em;\n}\n\n.group .toggle-texteditor svg {\n  fill: #fff;\n}\n",".placeholder-cadet-blue-important {\n  input::placeholder {\n    color: @cadet-blue !important;\n    opacity: 1;\n  }\n}\n\n.date-picker {\n  .placeholder-cadet-blue-important();\n  input {\n    background: transparent;\n    border: 1px solid;\n    width: 11rem;\n  }\n  .react-datepicker-popper {\n    left: -2.25rem !important;\n    top: 0 !important;\n    z-index: 2;\n  }\n}\n\n.filter-checkbox-icon {\n  width: 1rem;\n  svg g {\n    stroke: none;\n  }\n}\n\n.drawer-svg-icon {\n  svg {\n    top: 0;\n  }\n}\n\n.header-action-button.MuiButtonBase-root {\n  background-color: fade(@tangerine-dream, 30%);\n  &:hover {\n    background-color: @tangerine-dream;\n  }\n}\n\n.header-action-button-disabled.MuiButton-root.Mui-disabled {\n  color: @cadet-blue;\n}\n",".svg-stroke-white {\n  svg {\n    path, polyline {\n      stroke: @white;\n    }\n  }\n}\n\n.svg-stroke-cadet-blue {\n  svg {\n    path, polyline {\n      stroke: @cadet-blue;\n    }\n  }\n}\n\n.svg-fill-cadet-blue {\n  svg {\n    fill: @cadet-blue;\n  }\n}\n\n.svg-fill-white {\n  svg {\n    fill: @white;\n  }\n}\n","/*\n\n  Grid\n  ----\n\n  You can use the .grid-with-gutters(@n, @gw) mixin to create a grid structure\n  with n items per row and gutter width gw.\n\n  Note that the styles inside the media queries don't apply to smaller screen\n  widths!\n  i.e. if you want a grid that has 4 items per row on desktop and tablet and 1\n  on mobile you would need grid-4-gutter-4-d, grid-4-gutter-4-t and\n  grid-1-gutter-4-d.\n\n  This is because the margins on the nth children (which are the outermost items\n  in the grid) can't be reliably overridden.\n\n*/\n\n.grid-with-gutters(@n, @gw) {\n  @n-1: @n - 1;\n  .flex();\n  .flex-wrap();\n  // Select any immediate child.\n  > * {\n    // (100% / number of items) - (number of gutters * gutter width) / number of items\n    width: calc((100% / @n) - ceil((((@n - 1) * @gw) / @n)));\n    margin: (@gw / 2);\n    // Item at start of row.\n    &:nth-child(@{n}n - @{n-1}) {\n      .ml0();\n    }\n    // Item at end of row.\n    &:nth-child(@{n}n) {\n      .mr0();\n    }\n    // Item in first row.\n    &:nth-child(-n + @{n}) {\n      .mt0();\n    }\n    // Item in last row.\n    &:nth-last-child(-n + @{n}) {\n      .mb0();\n    }\n  }\n}\n\n.grid-1-gutter-4 { .grid-with-gutters(1, @spacing-4); }\n.grid-2-gutter-4 { .grid-with-gutters(2, @spacing-4); }\n.grid-3-gutter-4 { .grid-with-gutters(3, @spacing-4); }\n.grid-4-gutter-4 { .grid-with-gutters(4, @spacing-4); }\n.grid-5-gutter-4 { .grid-with-gutters(5, @spacing-4); }\n\n.desktop({\n  .grid-1-gutter-4-d { .grid-1-gutter-4(); }\n  .grid-2-gutter-4-d { .grid-2-gutter-4(); }\n  .grid-3-gutter-4-d { .grid-3-gutter-4(); }\n  .grid-4-gutter-4-d { .grid-4-gutter-4(); }\n  .grid-5-gutter-4-d { .grid-5-gutter-4(); }\n});\n\n.tablet-only({\n  .grid-1-gutter-4-t { .grid-1-gutter-4(); }\n  .grid-2-gutter-4-t { .grid-2-gutter-4(); }\n  .grid-3-gutter-4-t { .grid-3-gutter-4(); }\n  .grid-4-gutter-4-t { .grid-4-gutter-4(); }\n  .grid-5-gutter-4-t { .grid-5-gutter-4(); }\n});\n\n.mobile({\n  .grid-1-gutter-4-m { .grid-1-gutter-4(); }\n  .grid-2-gutter-4-m { .grid-2-gutter-4(); }\n  .grid-3-gutter-4-m { .grid-3-gutter-4(); }\n  .grid-4-gutter-4-m { .grid-4-gutter-4(); }\n  .grid-5-gutter-4-m { .grid-5-gutter-4(); }\n});\n","/*\n * Hamburgers\n * @description Tasty CSS-animated hamburgers\n * @author Jonathan Suh @jonsuh\n * @site https://jonsuh.com/hamburgers\n * @link https://github.com/jonsuh/hamburgers\n */\n@burger-scale: 0.625;\n.hamburger {\n  padding: 0;\n  display: inline-block;\n  cursor: pointer;\n  transition-property: opacity, filter;\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n  position: relative;\n  // width: floor(40px * @burger-scale);\n  width: 100%;\n  // height: floor(24px * @burger-scale);\n  height: 100%;\n}\n.hamburger:hover {\n  opacity: 0.7;\n}\n\n.hamburger-box {\n  // width: floor(40px * @burger-scale);\n  width: 100%;\n  // height: floor(24px * @burger-scale);\n  height: 100%;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  .transform(translate(-50%, -50%));\n}\n\n.hamburger-inner {\n  display: block;\n  width: 100%;\n  height: 2px;\n  border-radius: 4px;\n  position: absolute;\n  background-color: @black;\n  .transform(translateY(-50%));\n}\n.hamburger-inner-1 {\n  top: 0;\n}\n.hamburger-inner-2 {\n  top: 50%;\n\n}\n.hamburger-inner-3 {\n  top: 100%;\n}\n","/*\n\n  Custom\n  ------\n\n  Add any styling that can't be constructed from the generic styles to this\n  file. Include a comment explaining what the styling does.\n\n  This file should be used as a last resort.\n\n*/\n\n// Specify exact width for desktop mobile.\n.logo-width {\n  width: @logo-width-d;\n  .tablet({\n    .w9();\n  });\n  .mobile({\n    .w8();\n  });\n}\n\n// The navigation menu that appears when you click the hamburger on mobile.\n.nav-full-right {\n  .w14();\n  .transform(translate(@spacing-14, 0));\n}\n.application-header, .application-content, .nav-full-right {\n  .transition(transform 0.3s);\n}\n.show-navigation {\n  .application-header, .application-content {\n    .transform(translate(-@spacing-14, 0));\n  }\n  .nav-full-right {\n    .transform(translate(@zero-px, 0));\n  }\n}\n\n// have to set line height to same height as the accordion box height to make it look centered\n.accordion-header-center {\n  line-height: @height-3;\n}\n\n// SVG icon not lining up right for some reason\n.pop-faqs-icon svg {\n  margin-top: 4px;\n}\n\n.o-50-hover:hover {\n  .o-50();\n}\n\n// Don't squish feedback on mobile\n.feedback-container {\n  .relative();\n  .min-h8();\n  .transition-all();\n  .w15();\n  @media screen and (max-width: 555px) {\n    max-width: 390px;\n  }\n  @media screen and (max-width: 425px) {\n    max-width: 380px;\n  }\n  @media screen and (max-width: 375px) {\n    max-width: 330px;\n  }\n  @media screen and (max-width: 320px) {\n    max-width: 280px;\n  }\n  // @media screen and (max-width: 426px) {\n  //   .w15();\n  // }\n}\n\n// to shunt the feedback to window side\n.feedback-button {\n  .left0();\n  transform: rotate(270deg) translateY(-5rem) translateX(-2.95rem);\n}\n\n// pseudo element\n.fade-out-overlay::after {\n  content: '';\n  .absolute();\n  .top0();\n  .left0();\n  .right0();\n  .bottom0();\n  // TIL: https://stackoverflow.com/questions/38391457/linear-gradient-to-transparent-bug-in-latest-safari\n  background: linear-gradient(rgba(255,255,255,0), @ghost-grey);\n}\n\n.account-item-rows > a, .account-item-rows > div, .account-item-rows > li {\n  .no-underline();\n  &:nth-child(even) {\n    .bg-white();\n  }\n}\n\n.account-overlay {\n  max-width: 800px;\n  margin: auto;\n  width: 96%;\n  background: #FFFFFF;\n  padding: 5px 20px 20px;\n  flex-direction: column;\n}\n// handle the text we get for the career opportunities page which is for some reason in raw html\n.careerText {\n  p {\n    margin-bottom: @spacing-6;\n  }\n}\n\n// team images need positioning on mobile\n.mobile({\n  .mob-team-img-position {\n    background-position: 50% 30%;\n  }\n});\n\n// Grid stuff for leg tile menu\n.legislation-tile {\n  .MuiButton-root {\n    &:hover {\n      background-color: fade(@dark-orchid, 10%);\n    }\n  }\n}\n\n.hover-default-tab-button-bg:hover {\n  background-color: rgba(0,140,159,0.15)\n}\n\n// Hover background colour for qa menu tiles needs to be overridden.\n.qa-tile-full {\n  .MuiButton-root {\n    &:hover {\n      background-color: fade(@medium-turquoise, 10%);\n    }\n  }\n}\n.qa-tile-semi {\n  .MuiButton-root {\n    &:hover {\n      background-color: fade(@light-sea-green-1, 10%);\n    }\n  }\n}\n.qa-tile-skimmed {\n  .MuiButton-root {\n    &:hover {\n      background-color: fade(@light-coral, 10%);\n    }\n  }\n}\n\n.MuiIconButton-colorSecondary {\n  &.Mui-checked {\n    color: inherit;\n  }\n  &:hover {\n    background-color: inherit;\n  }\n}\n\n// MUI sets its own low-contrast text colour on disabled buttons, which\n// overrides the `white` utility class. This button (NewsTickerControlButton)\n// must stay readable regardless of its disabled state.\n.news-ticker-toggle-button.Mui-disabled {\n  color: #fff;\n}\n\n.bg-news-publication {\n  background-color: lighten(@medium-aquamarine, 35%) !important;\n  &:hover {\n    background-color: lighten(@medium-aquamarine, 25%) !important;\n  }\n  &.darker{\n    background-color: lighten(@medium-aquamarine, 20%) !important;\n  }\n}\n\n.bg-flavour-full {\n  background-color: lighten(@medium-turquoise, 40%) !important;\n  &.darker, &:hover {\n    background-color: lighten(@medium-turquoise, 30%) !important;\n  }\n  .MuiCheckbox-colorSecondary {\n    color: @medium-turquoise !important;\n    &:hover {\n      background-color: fade(@medium-turquoise, 10%) !important;\n    }\n    .MuiIconButton-colorSecondary:hover {\n      color: @medium-turquoise !important;\n    }\n  }\n}\n.full {\n  .MuiCheckbox-colorSecondary {\n    color: @medium-turquoise !important;\n    &:hover {\n      background-color: fade(@medium-turquoise, 10%) !important;\n    }\n    .MuiIconButton-colorSecondary:hover {\n      color: @medium-turquoise !important;\n    }\n  }\n}\n\n.bg-flavour-semi {\n  background-color: lighten(@light-sea-green-1, 40%) !important;\n  &.darker, &:hover {\n    background-color: lighten(@light-sea-green-1, 30%) !important;\n  }\n  .MuiCheckbox-colorSecondary {\n    color: @light-sea-green-1 !important;\n    &:hover {\n      background-color: fade(@light-sea-green-1, 10%) !important;\n    }\n    .MuiIconButton-colorSecondary:hover {\n      color: @light-sea-green-1 !important;\n    }\n  }\n}\n.semi {\n  .MuiCheckbox-colorSecondary {\n    color: @light-sea-green-1 !important;\n    &:hover {\n      background-color: fade(@light-sea-green-1, 10%) !important;\n    }\n    .MuiIconButton-colorSecondary:hover {\n      color: @light-sea-green-1 !important;\n    }\n  }\n}\n\n.bg-flavour-skimmed {\n  background-color: lighten(@light-coral, 30%) !important;\n  &.darker, &:hover {\n    background-color: lighten(@light-coral, 20%) !important;\n  }\n  .MuiCheckbox-colorSecondary {\n    color: @light-coral !important;\n    &:hover {\n      background-color: fade(@light-coral, 10%) !important;\n    }\n    .MuiIconButton-colorSecondary:hover {\n      color: @light-coral !important;\n    }\n  }\n}\n.skimmed {\n  .MuiCheckbox-colorSecondary {\n    color: @light-coral !important;\n    &:hover {\n      background-color: fade(@light-coral, 10%) !important;\n    }\n    .MuiIconButton-colorSecondary:hover {\n      color: @light-coral !important;\n    }\n  }\n}\n\n.b--flavour- {\n  &full {\n    border-color: @medium-turquoise;\n  }\n  &semi {\n    border-color: @light-sea-green-1;\n  }\n  &skimmed {\n    border-color: @light-coral;\n  }\n}\n\n//.bg-flavour-full:hover { background-color: lighten(@medium-turquoise, 30%) !important; }\n\n.hover-bg-flavour-full:hover { .bg-flavour-full(); }\n.hover-bg-flavour-semi:hover { .bg-flavour-semi(); }\n.hover-bg-flavour-skimmed:hover { .bg-flavour-skimmed(); }\n\n.btc--flavour-full { border-top-color: @medium-turquoise; }\n.btc--flavour-semi { border-top-color: @light-sea-green-1; }\n.btc--flavour-skimmed { border-top-color: @light-coral; }\n\n.highlight-yellow {\n  background-color : @light-yellow !important;\n}\n// TODO: temporary...?\n.flavour-tabs {\n  font-size: 0.65rem;\n}\n\n// needed an unusual height, if this comes up again maybe we add it to the 'real' heights\n.h1-5 {\n  height: 1.5rem;\n}\n\n// need some new styling for mark elements from elastic search\nmark {\n  background-color: #fcf8e3; // nicked from old styles\n  color: inherit;\n}\n\n// doing pseudos with breadcrumbs\n.pseudo-arrows > li {\n  &::after {\n    content: ' > ';\n    margin: 0 @spacing-2;\n  }\n  &:last-child::after {\n    content: ''\n  }\n}\n\n// Date picker width\n.w-date {\n  width: (100/7%);\n}\n\n.bg-teal-darken-10 { background-color: darken(@teal, 10%)}\n.bg-teal-darken-5 { background-color: darken(@teal, 5%)}\n.hover-bg-teal-darken-5:hover { .bg-teal-darken-5() }\n.hover-bg-teal-darken-10:hover { .bg-teal-darken-10() }\n\n.MuiSpeedDial-actions.comment-menu-speed-dial-actions {\n  .-mt7();\n  .pt8();\n}\n\n.side-width,\n.ca-left-width {\n  width: 20rem;\n}\n\n// active search buttons are disabled\n\n.marketplace-search-button,\n.marketplace-search-button.Mui-disabled,\n.account-nav-button.Mui-disabled {\n  .bg-dark-cerulean();\n}\n\n\nbutton.qa-search-button,\nbutton.qa-search-button.Mui-disabled,\n.qa-search-button,\n.qa-search-button.Mui-disabled {\n  background-color: @medium-turquoise !important;\n}\n\n.search-drop-down-menu.qa-search-button.MuiButton-contained,\n.search-drop-down-menu.marketplace-search-button.MuiButton-contained {\n  &:hover {\n    background-color: darken(@medium-turquoise, 10%);\n  }\n}\n\n\n\n.faq-header-expanded {\n  background-color: lighten(@light-sea-green-2, 50%);\n}\n\n.faq-header-expanded-content {\n  background-color: darken(@light-sea-green-2, 10%);\n}\n\n.legislation-search-button, .legislation-search-button.Mui-disabled {\n  .bg-dark-orchid();\n}\n\n.search-drop-down-menu.legislation-search-button.MuiButton-contained {\n  &:hover {\n    background-color: darken(@dark-orchid, 10%);\n  }\n}\n\n.news-search-button, .news-search-button.Mui-disabled {\n  .bg-light-sea-green-2();\n}\n\n// Ensure search button theming overrides Material-UI\nbutton.qa-search-button,\nbutton.qa-search-button.Mui-disabled,\n.qa-search-button,\n.qa-search-button.Mui-disabled {\n  background-color: @medium-turquoise !important;\n}\n.search-drop-down-menu.news-search-button.MuiButton-contained {\n  &:hover {\n    background-color: darken(@light-sea-green-2, 10%);\n  }\n}\n\nbutton.precedents-search-button,\nbutton.precedents-search-button.Mui-disabled,\n.precedents-search-button,\n.precedents-search-button.Mui-disabled {\n  background-color: @teal !important;\n}\n\n.search-drop-down-menu.precedents-search-button.MuiButton-contained {\n  &:hover {\n    background-color: darken(@teal, 10%);\n  }\n}\n\n.markets-search-button, .markets-search-button.Mui-disabled {\n  .bg-dark-sea-green-3();\n}\n\n.search-drop-down-menu.markets-search-button.MuiButton-contained {\n  &:hover {\n    background-color: darken(@dark-sea-green-3, 10%);\n  }\n}\n\n.news-date-picker-search-button.MuiButton-root:hover {\n  .bg-dark-sea-green();\n}\n\n.search-drop-down-menu.news-date-picker-search-button.MuiButton-contained {\n  &:hover {\n    background-color: darken(@dark-sea-green, 10%);\n  }\n}\n\n\n// Flavour tabs\n.bg-qa-tab {\n  &::before {\n    content: '';\n    .absolute();\n    .bottom0();\n    .left0();\n    height: 3px;\n    .w-100();\n    .transition-all();\n  }\n  &.selected::before {\n    .h-100();\n  }\n  &.full {\n    &:hover::before,\n    &.selected::before {\n      .bg-medium-turquoise();\n    }\n  }\n  &.semi {\n    &:hover::before,\n    &.selected::before {\n      .bg-light-sea-green-1();\n    }\n  }\n  &.skimmed {\n    &:hover::before,\n    &.selected::before {\n      .bg-light-coral();\n    }\n  }\n  &.archive {\n    &:hover::before,\n    &.selected::before {\n      .bg-grey();\n    }\n  }\n  &.legislation {\n    &:hover::before,\n    &.selected::before {\n      background-color: @legislation;\n    }\n  }\n}\n\n.popover.bottom > .arrow {\n  position: absolute;\n  top: -11px;\n  &::after {\n    content: ' ';\n    top: 1px;\n    margin-left: -10px;\n    border-width: 10px;\n    border-top-width: 0;\n    .absolute();\n    .db();\n    .w0();\n    .h0();\n    .b--solid();\n    .b--transparent();\n  }\n}\n\n.ca-filter-link {\n  &:hover {\n    color: @cadet-blue;\n  }\n}\n\n.privacy-filter-link {\n  &:hover {\n    svg g {\n      stroke: @teal;\n    }\n  }\n}\n\n.filter-link {\n  &:hover {\n    svg g {\n      stroke: @dark-sea-green-3;\n    }\n  }\n}\n\n.account-input-label {\n  &:hover {\n    svg g {\n      stroke: @teal;\n    }\n  }\n}\n\n.account-input-label {\n  &:hover {\n    svg {\n      fill: @teal;\n    }\n  }\n}\n\n.account-input-checked {\n  svg {\n    color: @teal;\n  }\n}\n\n.teal-save-button.MuiButton-root {\n  &:hover {\n    background-color: darken(@teal, 10%);\n  }\n}\n\n.white-cancel-button.MuiButton-root {\n  &:hover {\n    background-color: darken(@white, 10%);\n  }\n}\n\n// our base button style overrides react-date-picker\n.react-datepicker__navigation {\n  border: 0.45rem solid transparent;\n}\n.react-datepicker__navigation--next {\n  border-left-color: #ccc;\n}\n.react-datepicker__navigation--previous {\n  border-right-color: #ccc;\n}\n\n// HTML from ca can't be styled, so override here\n.ca-homepage {\n  ol li, ul li {\n    margin: 0.5rem 0;\n  }\n}\n\n.folder-badge {\n  min-width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 0.75rem;\n}\n\n.form-submit-button:hover {\n  .bg-light-sea-green-2();\n}\n\n.form-cancel-button:hover:hover {\n  .bg-ice-blue();\n}\n\n.trial-select-organisation-button:hover {\n  .bg-dark-sea-green-3();\n}\n\n.trial-select-individual-button:hover {\n  .bg-dark-sea-green-3();\n}\n\n.trial-thank-you-finish-button:hover {\n  .bg-dark-sea-green();\n}\n\n.ca-search-date-submit-button:hover {\n  .bg-dark-sea-green();\n}\n\n.dealwatch-search-date-submit-button:hover {\n  .bg-dark-sea-green-2();\n}\n\n// Applies some spacing to the mui datepicker on smaller displays\n// as the last column of dates and the button to go to the next month\n// are very close to the border\n.MuiPickersBasePicker-pickerView {\n  @media screen and (max-width: 346px) {\n    padding-right: 1.25rem;\n  }\n}\n\n// Markdown-rendered commentary — reset browser paragraph spacing\n.markdown-content p {\n  margin-top: 0;\n}\n\n// MW speech bubble\n.speech-bubble {\n  background-color: #ebf0f4;\n  padding: 10px 16px;\n  position: relative;\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  border-radius: 12px;\n}\n\n.speech-bubble:after {\n  content:\"\";\n  position:absolute;\n  bottom:-2.25rem; /* value = - border-top-width - border-bottom-width */\n  left:5.25rem; /* controls horizontal position */\n  border-width:2.25rem 3rem 0 0; /* vary these values to change the angle of the vertex */\n  border-style:solid;\n  border-color:#ebf0f3 transparent;\n  /* reduce the damage in FF3.0 */\n  display:block;\n  width:0;\n}\n\n.markets-overview-tile {\n  font-size: 18px;\n  &:hover {\n    background: #d3fdff;\n  }\n}\n\n.overlay-parameter-header:before {\n  content: ' ';\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background: @lite-grey;\n}\n\n.overlay-parameter-header-enabled:before {\n  background: @grey;\n}\n\n.deal-increase {\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #5CBE75;\n}\n\n.deal-decrease {\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid #CC0033;\n}\n\n.comment-controls {\n  .mini-speed-dial {\n    min-height: 2rem;\n    height: 2rem;\n    width: 2rem;\n  }\n  .MuiSpeedDial-directionDown .MuiSpeedDial-actions {\n    padding-top: 42px;\n  }\n}\n\n.transition-fade-out-slow {\n  animation: fadeOut 500ms forwards;\n  animation-delay: 0s;\n}\n\n@keyframes fadeOut {\n  from {opacity: 1;}\n  to {opacity: 0; display: none;}\n}\n\n// Style to be added by news authors for adding indented sections:\n.indented-section {\n  display: block;\n  .pl8();\n}\n\n.esv-interview-label {\n  & > p {\n    margin: 0;\n    word-wrap: break-word;\n  }\n}\n\n.esv-interview-hide-break {\n  & > br {\n    .dn();\n  }\n}\n\n.esv-interview-toolbar-width {\n  .w-100();\n  .large-desktop({\n    width: calc(100% - 20rem)\n  });\n}\n\n.esv-interview-toolbar-spacing, .esv-footer-spacing {\n  @media screen and (min-width: 1500px) {\n    .mhauto();\n  }\n}\n\n//large desktop for the doc drafter interviews needs to be larger than other large desktop views\n@media screen and (min-width: 1450px) {\n  .esv-interview-db-l {.db(); }\n  .esv-interview-dn-l { .dn(); }\n  .esv-interview-preview-width-l { width: 50rem; }\n}\n\n.compact-switch-label {\n  text-align: left;\n  font-size: 0.875rem;\n  color: @grey;\n}\n\n.account-menu-dropdown {\n  min-width: 128px;\n}\n\n//Tile Styling with AOL specific colours\n// Needed to use pseudo element\n.aol-tile-styling(@type, @color) {\n  &.aol-@{type}:hover, &.aol-@{type}:focus-within {\n    border-color: @color;\n    &::after {\n      background: @color;\n    }\n  }\n}\n\n.tile-base(@border-color: @dark-cerulean) {\n  position: relative;\n  padding-bottom: 6px;\n  border: 1px solid transparent;\n\n  &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: -1px;\n    width: 100%;\n    height: 6px;\n    background: @border-color;\n  }\n\n  &:hover, &:focus-within {\n    border-color: @border-color;\n    &::after {\n      background: @border-color;\n    }\n  }\n}\n\n.tile-border {\n  .tile-base();\n  .aol-tile-styling(corporate, @aol-corporate);\n  .aol-tile-styling(employment, @aol-employment);\n  .aol-tile-styling(ri, @aol-ri);\n}\n\n.tile-unavailable {\n  .tile-base(@gains-boro);\n}\n\n// Allows Smartsearch switch to escape layout-width-constraint right-edge border...\n// ...in Header, to look in line and match design\n.smartsearch-switch {\n  transform: translateX(@spacing-4);\n}\n\n.description-line-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n","/* pdfjs-dist/web/pdf_viewer.css covers textLayer, annotationLayer, and pdfViewer page styles */\n\n.pdf-viewer-wrapper {\n  height: calc(100vh - 13rem);\n  max-width: 1000px;\n}\n\n#pdfViewer .page {\n  box-sizing: content-box;\n}\n\n#pdfViewer .textLayer {\n  text-rendering: auto;\n  -webkit-font-smoothing: auto;\n}\n","// fonts\n\n@item-padding-XS: 15px;\n@item-padding-S: 18px;\n@item-padding-M: 24px;\n@icon-spacing: 18px;\n\n.navigation-item-title .archived-label {\n  display: none;\n}\n\n.archived-label {\n  font-style: normal;\n  font-size: 0.9rem;\n  background: @legislation;\n  padding: 5px;\n  padding-right: 5px;\n  padding-left: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border-radius: 9999px;\n  margin-left: 15px;\n  margin-top: -2px;\n  color: #fff;\n}\n\n.cd-accordion-menu {\n  /*background: @color-accordion-base;*/\n  list-style: none;\n  margin:0 auto 1.2em auto;\n  // box-shadow: 0 4px 40px shade(@color-accordion-shadow, 30%);\n  padding: 0;\n\n  a {\n    text-decoration: none;\n  }\n\n  ul.group {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    position: relative;\n    z-index: 2;\n  }\n\n  .sticky, .toggle {\n    position: relative;\n    z-index: 2;\n  }\n\n  .toggle {\n    background: #FFFFFF;\n  }\n\n  li {\n    // .noselect();\n    padding: 0;\n    margin: 0;\n    position: relative;\n    top: 0;\n    left: 0;\n  }\n\n  input[type=checkbox] {\n    /* hide native checkbox */\n    position: absolute;\n    opacity: 0;\n  }\n\n  .prefix {\n    position: absolute;\n    top: 0;\n    left: 0;\n    font-size: 1.4em;\n    height: 100%;\n    width: (@item-padding-S * 3) + 10px;\n    min-width: 10px;\n    padding: @item-padding-S + 1px 0 0 0;\n    text-transform: uppercase;\n    text-align: center;\n    font-weight: bold;\n    z-index: 20;\n    color: @color-accordion-text;\n    text-decoration: none;\n    line-height: 1.8em;\n\n    .mobile({\n      width: (@item-padding-S) + 10px;\n      font-size: 1.2em;\n      line-height: 1em;\n    });\n  }\n\n  .comment, .selector {\n    cursor: pointer;\n    font-size: 1.4em;\n    width: 2em;\n    height: 4.5em;\n    text-align: center;\n    position: absolute;\n    z-index: 20;\n    box-shadow: none;\n    background: transparent;\n    color: inherit;\n    padding: 0;\n\n    .mobile({\n      height: 3.4em;\n    });\n  }\n\n  .comment {\n    right: 3em;\n\n    i {\n      font-size: 1.2em;\n      margin-top: 1px;\n      position: absolute;\n      display: block;\n      top: 50%;\n      left: 0;\n      width: 100%;\n      letter-spacing: -1px;\n      .transform(translateY(-50%));\n    }\n  }\n\n  .no-title .comment {\n    right: 1em;\n\n    .mobile({\n      display: none;\n    })\n  }\n\n  .selector {\n    right: 1em;\n\n    .indicator {\n      position: absolute;\n      display: block;\n      top: 50%;\n      left: 0;\n      width: 100%;\n      letter-spacing: -1px;\n      .transform(translateY(-50%));\n\n      .svg-icon {\n        position: relative;\n        font-size: 1.2em;\n      }\n\n    }\n\n  }\n\n  .group-prefix {\n    display: inline-block;\n    font-weight: lighter;\n    vertical-align: middle;\n    font-size: 0.8em;\n    text-transform: uppercase;\n    margin-right: 1em;\n  }\n\n  .sticky-bottom {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    display: block;\n    z-index: 1;\n\n    &.show {\n\n      &.depth-1 { z-index: 34 }\n      &.depth-2 { z-index: 35 }\n      &.depth-3 { z-index: 36 }\n      &.depth-4 { z-index: 37 }\n      &.depth-5 { z-index: 38 }\n      &.depth-6 { z-index: 39 }\n      &.depth-7 { z-index: 40 }\n    }\n  }\n\n  .highlight.content, .highlight.group, .highlight.content label.content {\n    background: #fcf8e3 !important;\n  }\n\n  label .before {\n    /* icons */\n    content: '';\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    top: 50%;\n    .transform(translateY(-50%));\n    margin: -0.1em 0 0 -0.1em;\n  }\n\n  label {\n    cursor: pointer;\n\n    &::before { // &::after {\n      // background-image: url(../images/cd-icons.svg);\n      // background-repeat: no-repeat;\n    }\n\n    &.group .before {\n      background-image: none;\n      color: inherit;\n      line-height: 1em;\n      font-size: 1em;\n      /* arrow icon */\n      left: @item-padding-S;\n      // background-position: 0 0;\n      .transform(translateY(-50%));\n    }\n\n    // &::after {\n    //   /* folder icons */\n    //   left: (@item-padding-S * 2) + 5px;\n    //   background-position: -16px 0;\n    // }\n\n    .suffix {\n      float: right;\n      font-size: 0.8em;\n      line-height: 1.8em;\n      font-weight: lighter;\n    }\n\n    &.group-header-archived {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  }\n\n  .is-loading label::before {\n    content: ' ';\n    animation: accordion-loader 1.2s infinite linear;\n    border: 2px solid;\n    border-right-color: transparent;\n    border-radius: 50%;\n  }\n\n  .is-loading label .before {\n    display: none;\n  }\n\n\n  .keyframes(accordion-loader, {\n    0%  { transform: translateY(-50%) rotate(0deg); }\n    100%  { transform: translateY(-50%) rotate(360deg); }\n  });\n\n\n  // a::after {\n  //   /* image icon */\n  //   left: @item-padding-S * 2;\n  //   background: url(../images/cd-icons.svg) no-repeat -48px 0;\n  // }\n\n  input[type=checkbox]:checked + label .before {\n    /* rotate arrow */\n    .transform(translateY(-50%));\n  }\n\n  input[type=checkbox]:checked + label::after {\n    /* show open folder icon if item is checked */\n    background-position: -32px 0;\n  }\n\n  input[type=checkbox]:checked + label + ul,\n  input[type=checkbox]:checked + label:nth-of-type(n) + ul {\n    /* use label:nth-of-type(n) to fix a bug on safari (<= 8.0.8) with multiple adjacent-sibling selectors*/\n    /* show children when item is checked */\n    display: block;\n  }\n\n  ul.group label {\n\n    .no-touch &:hover {\n      background: darken(@color-accordion-base, 7%);\n    }\n\n  }\n\n  // > li:last-of-type > label,\n  // > li:last-of-type > a,\n  // > li > ul > li:last-of-type label,\n  // > li > ul > li:last-of-type a {\n  //   box-shadow: none;\n  // }\n\n  // Add spacing to bottom of each top level (unless expanded)\n  li.depth-1 {\n    margin-bottom: 2px;\n    &.group {\n      margin-bottom: 0;\n    }\n  }\n\n  // Depth 1 (not expanded)\n  label.depth-1.group {\n    color:#222;\n    fill:#222;\n    background: @color-accordion-top-level;\n    box-shadow: 0 0 0 1px rgba(127,127,127,0.2) inset;\n    padding-left:(@item-padding-S + @icon-spacing + 2px);\n    & .before {\n      left:@icon-spacing - 2px;\n    }\n  }\n\n  // Depth 1 and depth 2: expanded & disabled\n  .accordionColour(@color-accordion-top-level-expanded);\n\n  // Expanded: label\n  label.depth-1.group.expanded,\n  label.depth-2.group.expanded {\n    color: #FFF !important;\n    fill: #FFF !important;\n    box-shadow: none !important;\n  }\n\n  // Expanded and pinned: Selector\n  .selector.expanded .indicator,\n  .depth-1.pinned .selector .indicator,\n  .depth-2.pinned .selector .indicator {\n    color: #FFF;\n    fill: #FFF;\n  }\n  .depth-3 .selector.expanded .indicator {\n    color: inherit;\n    fill: inherit;\n  }\n\n  // Depth 2 onwards\n  label.depth-2.group, label.depth-3.group, label.depth-4.group, label.depth-5.group, label.depth-6.group {\n    color:#222;\n    fill:#222;\n    box-shadow: 0 -1px 0 0 rgba(127,127,127,0.2) inset,\n                -1px 0 0 0 rgba(127,127,127,0.2) inset,\n                1px 0 0 0 rgba(127,127,127,0.2) inset,\n                0 -1px 0 0 rgba(127,127,127,0.2) inset;\n  }\n\n  label.depth-2.group {\n    background: darken(@color-accordion-base, @accordion-darken-step * 4);\n    padding-left:(@item-padding-S + (@icon-spacing * 2) + 2px);\n    & .before {\n      left:(@icon-spacing * 2) - 2px;\n    }\n    &:hover {\n      background: darken(@color-accordion-base, @accordion-darken-step * 5);\n    }\n  }\n\n  label.depth-3.group {\n    background: darken(@color-accordion-base, @accordion-darken-step * 3);\n    padding-left:(@item-padding-S + (@icon-spacing * 3) + 2px);\n    & .before {\n      left:(@icon-spacing * 3) - 2px;\n    }\n    &:hover {\n      background: darken(@color-accordion-base, @accordion-darken-step * 4);\n    }\n  }\n\n  label.depth-4.group {\n    background: darken(@color-accordion-base, @accordion-darken-step * 2);\n    padding-left:(@item-padding-S + (@icon-spacing * 4) + 2px);\n    & .before {\n      left:(@icon-spacing * 4) - 2px;\n    }\n    &:hover {\n      background: darken(@color-accordion-base, @accordion-darken-step * 3);\n    }\n  }\n\n  label.depth-5.group {\n    background: darken(@color-accordion-base, @accordion-darken-step * 1);\n    padding-left:(@item-padding-S + (@icon-spacing * 5) + 2px);\n    & .before {\n      left:(@icon-spacing * 5) - 2px;\n    }\n    &:hover {\n      background: darken(@color-accordion-base, @accordion-darken-step * 2);\n    }\n  }\n\n  label.depth-6.group {\n    background: darken(@color-accordion-base, @accordion-darken-step * 0);\n    padding-left:(@item-padding-S + (@icon-spacing * 6) + 2px);\n    & .before {\n      left:(@icon-spacing * 6) - 2px;\n    }\n    &:hover {\n      background: darken(@color-accordion-base, @accordion-darken-step * 1);\n    }\n  }\n\n  label.content {\n    padding-left: (@item-padding-S * 3) + 10px;\n  }\n\n  .selectable { label.content, label.group {\n    padding-right: 4em;\n  }}\n\n  .content, .content label.content {\n    background: #FFFFFF !important;\n    color: #222222;\n    fill: #222222;\n\n    .selector .indicator {\n      color: #222222;\n      fill: #222222;\n    }\n  }\n\n  .highlight-yellow {\n    .content, .content label.content {\n      background-color: #FCF8E3 !important;\n    }\n  }\n\n  .content label {\n    & .before, &::after {\n      display: none;\n    }\n\n    .prefix {\n      left: (@item-padding-S / 3);\n      width: @item-padding-S * 3;\n      text-align: center;\n      display: inline-block;\n      position: absolute;\n      top: 50%;\n      .transform(translateY(-50%));\n      letter-spacing: -0.8px;\n    }\n\n  }\n\n  .content .content-text {\n    padding: @item-padding-S (@item-padding-S * 3) + 10px @item-padding-S 0;\n    font-size: 1.2em;\n    display: block;\n    font-weight: 400;\n\n    .mobile({\n      padding: 0 0.5rem 0 0;\n    });\n\n    p, ul li {\n      margin: 0.5em 0;\n    }\n  }\n\n\n\n  // @include MQ(M) {\n  //   label, a {\n  //     padding: @item-padding-M @item-padding-M @item-padding-M (@item-padding-M * 3) + 10px;\n  //     font-size: 1.9em;\n  //   }\n  //\n  //   label::before {\n  //     left: @item-padding-M;\n  //   }\n  //\n  //   label::after {\n  //     left: (@item-padding-M * 2) + 5px;\n  //   }\n  //\n  //   ul label,\n  //   ul a {\n  //     padding-left: (@item-padding-M * 4) + 10px;\n  //   }\n  //\n  //   ul label::before {\n  //     left: @item-padding-M * 2;\n  //   }\n  //\n  //   ul label::after,\n  //   ul a::after {\n  //     left: (@item-padding-M * 3) + 5px;\n  //   }\n  //\n  //   ul ul label,\n  //   ul ul a {\n  //     padding-left: (@item-padding-M * 5) + 10px;\n  //   }\n  //\n  //   ul ul label::before {\n  //     left: @item-padding-M * 3;\n  //   }\n  //\n  //   ul ul label::after,\n  //   ul ul a::after {\n  //     left: (@item-padding-M * 4) + 5px;\n  //   }\n  //\n  //   ul ul ul label,\n  //   ul ul ul a {\n  //     padding-left: (@item-padding-M * 6) + 10px;\n  //   }\n  //\n  //   ul ul ul label::before {\n  //     left: @item-padding-M * 4;\n  //   }\n  //\n  //   ul ul ul label::after,\n  //   ul ul ul a::after {\n  //     left: (@item-padding-M * 5) + 5px;\n  //   }\n  // }\n\n  label::before {\n    /* this class is used if you're using jquery to animate the accordion */\n    .transition(transform .1s);\n  }\n\n}\n\n@accordion-depth-2-lighten: 13%;\n@accordion-depth-2-desaturate: 6%;\n\n.accordionColour(@colour) {\n\n  label.depth-1.group.expanded {\n    background: @colour;\n    &:hover {\n      background: darken(@colour, @accordion-darken-step * 1);\n    }\n  }\n\n  label.depth-2.group.expanded {\n    background: lighten(desaturate(@colour, @accordion-depth-2-desaturate), @accordion-depth-2-lighten);\n    &:hover {\n      background: darken(lighten(desaturate(@colour, @accordion-depth-2-desaturate), @accordion-depth-2-lighten), @accordion-darken-step * 1);\n    }\n  }\n\n  .disabled label.depth-1.group,\n  .disabled label.depth-2.group {\n    color: #666;\n    fill: #666;\n  }\n\n};\n\n.precedents .cd-accordion-menu {\n  .accordionColour(lighten(@precedents, 10%));\n}\n\n.content-review .cd-accordion-menu {\n  label .before {\n    display: none !important;\n  }\n  label {\n    cursor: default !important;\n    // pointer-events: none;\n  }\n}\n\n.ca .cd-accordion-menu {\n  // .accordionColour(@currentAwareness);\n\n  label.depth-1, label.depth-1.group.expanded {\n    background: #FFF;\n    color: @currentAwareness !important;\n    padding-left: 0;\n    font-size: 1.7em;\n    box-shadow: inset 0 -1px lighten(@currentAwareness, 30%) !important;\n    &:hover {\n      background: #FFF;\n    }\n  }\n\n\n  label.group .before {\n    display: none;\n  }\n\n  label.selector {\n    color: #222;\n    fill: #222;\n  }\n}\n\n.cd-accordion-header {\n  /*position: absolute;\n  width: 96%;\n  left: 50%;\n  height: 0;\n  margin: 0;\n  max-width: @page-max-width;\n  margin-left: auto;\n  margin-right: auto;*/\n  background: transparent;\n  bottom: -3px;\n  /*.transform(translate(-50%, 0));*/\n\n  // pointer-events: none;\n  // touch-action: none;\n\n  label {\n    // pointer-events: all;\n  }\n\n  .prefix.selectable {\n    .indicator {\n      border-bottom: 3px solid #EEE;\n      width: auto;\n      left: 50%;\n      .transform(translate(-50%,-50%));\n    }\n    .indicator::after {\n      display: none;\n    }\n    &.selected .indicator {\n      border-bottom: 3px solid;\n    }\n  }\n\n  .selectable .selector {\n    height: 2.7em;\n\n    .mobile({\n      height: 2.1em;\n    });\n  }\n\n  .prefix {\n    pointer-events: none;\n  }\n\n  .cd-accordion-menu {\n    width: 100%;\n    margin: 0;\n\n    .content label {\n      box-shadow: inset 0 -1px fade(@color-accordion-text, 20%);\n    }\n  }\n\n  .cd-list-container {\n    width: 100%;\n    /*margin: 0;\n    max-width: @page-max-width;\n    .transform(translate(0,0));\n    -webkit-transition: -webkit-transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;\n    -moz-transition: -moz-transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;\n    transition: transform 0.2s cubic-bezier(0.2,0.3,0.25,0.9), opacity 0.2s;*/\n    position: relative;\n/*    top: 0;\n    left: 0;*/\n  }\n\n  .fadeout {\n    display: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: #FFFFFF;\n    opacity: 0.6;\n    z-index: 2;\n  }\n\n  &.view-right {\n    /*max-width: @page-max-width !important;*/\n\n    .cd-list-container {\n      /*width: 96%;\n      margin: auto;*/\n\n      .transform(translate(-@page-right-width-desktop, 0));\n      pointer-events: none;\n\n      .fadeout {\n        display: block;\n      }\n\n      .desktop-left-expanded({\n        .transform(translate(-@page-right-width-desktop + (@page-left-width / 2), 0));\n      });\n\n      .desktop-right-expanded({\n        pointer-events: all;\n        .transform(translate((-@page-right-width-desktop-wide/2), 0));\n\n        .fadeout {\n          display: none;\n        }\n      });\n      .tablet({\n        .transform(translate(-@page-right-width-tablet, 0));\n      });\n      .mobile({\n        .transform(translate(-@page-right-width-mobile, 0));\n      });\n    }\n  }\n\n  &.view-left {\n    max-width: @page-max-width !important;\n    pointer-events: none;\n\n    .cd-list-container {\n      width: 100%;\n      margin: auto;\n\n      .transform(translate(@page-left-width, 0));\n    }\n  }\n\n  li label {\n    .transition(padding 0.1s);\n  }\n\n  li {\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 2;\n\n    label {\n      padding-top: @item-padding-S - 11px;\n      padding-bottom: @item-padding-S - 11px;\n\n      .mobile({\n        padding-top: @item-padding-XS - 11px;\n        padding-bottom: @item-padding-XS - 11px;\n      });\n    }\n  }\n\n  .prefix {\n    padding-top: @item-padding-S - 11px;\n  }\n\n  li:last-child {\n    z-index: 1;\n    // label {\n    //   padding-top: 18px;\n    //   padding-bottom: 18px;\n    // }\n  }\n}\n\n.desktop-left-expanded({\n  .has-left .cd-accordion-header.view-left, .has-left .cd-accordion-header.view-main {\n    max-width: @page-max-width !important;\n\n    .cd-list-container {\n      width: 96%;\n      margin: auto;\n\n      .transform(translate((@page-left-width / 2), 0));\n    }\n  }\n});\n\n\n.browser-ie .cd-list-container {\n  -ms-transition: none !important;\n  transition: none !important;\n}\n\n.accordion-comments {\n  padding: @item-padding-S (@item-padding-S * 3) + 10px @item-padding-S (@item-padding-S * 3) + 10px;\n  font-size: 1.8em;\n  display: block;\n  font-weight: 400;\n\n  .mobile({\n    font-size: 1.5em;\n    padding: @item-padding-S 0 @item-padding-S @item-padding-S;\n  });\n\n\n}\n\n.accordion-navigator {\n  font-size: 1.4em;\n  line-height: 1.3;\n  margin: 0.6em 0 0 1em;\n\n  .navigation-group {\n    margin: 0;\n  }\n\n  .navigation-group.depth-1 {\n    margin: 0;\n    padding: 0;\n    border: none;\n\n    & > .navigation-item {\n      border-left: none;\n      padding-left: 0;\n\n      &:before, &:after {\n        display: none;\n      }\n    }\n  }\n\n  .navigation-item {\n    padding: 0.5em 0 0em 0.7em;\n    border-left: 2px solid #FAFAFA;\n    position: relative;\n    margin-left: 3px;\n    transition: border-color 0.2s;\n  }\n\n  a {\n    color: inherit;\n    margin: 0;\n  }\n\n  .navigation-item-title {\n    display: block;\n    white-space: normal;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding-bottom: 0.5em;\n    color: #AAA;\n    fill: #AAA;\n\n    .prefix {\n      text-transform: uppercase;\n      font-size: 0.8em;\n      font-weight: lighter;\n      margin-right: 0.6em;\n    }\n\n    a {\n      cursor: pointer;\n      transition: color 0.2s;\n    }\n\n    a:hover {\n      text-decoration: none;\n      color: #000;\n      fill: #000;\n    }\n  }\n\n  .active > .navigation-item-title {\n    color: #000;\n    fill: #000;\n  }\n\n  .active-after.navigation-item {\n    border-color: #000;\n  }\n\n  .navigation-item:before {\n    content: \" \";\n    display: block;\n    position: absolute;\n    height: 1.3em;\n    width: 0;\n    top: 0;\n    border-left: 2px solid transparent;\n    left: -2px;\n    transition: border-color 0.2s;\n  }\n\n  .navigation-item.active:before {\n    border-left: 2px solid #000 !important;\n  }\n\n  .navigation-item:last-child {\n    border-left: 2px solid transparent;\n\n    &:before {\n      border-left: 2px solid #FAFAFA;\n    }\n  }\n\n  .navigation-item:after {\n    content: \" \";\n    display: block;\n    position: absolute;\n    top: 1.2em;\n    height: 0;\n    width: 0.3em;\n    border-bottom: 0.2em solid transparent;\n    left: -2px;\n    transition: border-color 0.2s;\n  }\n\n  .navigation-item.active:after {\n    border-bottom-color: #000;\n  }\n}\n\n.key-picks.row {\n  &::before {\n    content: '';\n    display: table;\n  }\n  &::after {\n    content: '';\n    display: table;\n    clear:both;\n  }\n}\n",".content-view {\n  &.table-of-contents {\n    font-size: 1.2em;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    // overflow-y: scroll;\n    // -ms-overflow-style: -ms-autohiding-scrollbar;\n    // -webkit-backface-visibility: hidden;\n    // -webkit-overflow-scrolling: touch;\n\n    ul {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      list-style: none;\n      padding-left: 0;\n      .transition(top ease-in-out @animation-length);\n\n      li {\n        padding: 0.5em 1em 0.5em 0.5em;\n        color: #aaa;\n\n        a {\n          display: block;\n          text-decoration: none !important;\n          color: inherit;\n        }\n\n        &.highlight {\n          color: #000000;\n        }\n      }\n\n      .depth-1 {\n        padding-left: 1.5em;\n        font-weight: bold;\n      }\n      .depth-2 {\n        padding-left: 1.5em;\n      }\n      .depth-3 {\n        padding-left: 2.5em;\n      }\n      .depth-4 {\n        padding-left: 3.5em;\n      }\n      .depth-5 {\n        padding-left: 4.5em;\n      }\n      .depth-6 {\n        padding-left: 5.5em;\n      }\n\n      li:first-child {\n        // margin-top: 1em;\n      }\n\n      li:last-child {\n        margin-bottom: 1em;\n      }\n    }\n  }\n\n  .lr-treeheader {\n    display: block;\n    font-size: 1.8em;\n    padding: 0.5em;\n\n    a {\n      color: @color-accordion-text;\n      font-weight: 600;\n    }\n\n    &.lr-container {\n      box-shadow: inset 0 -1px fade(@color-accordion-text, 20%);\n\n      &.depth-1 {\n        padding-left: 1em;\n        background: darken(@color-accordion-base, @accordion-darken-step * 5);\n      }\n      &.depth-2 {\n        padding-left: 2em;\n        background: darken(@color-accordion-base, @accordion-darken-step * 4);\n      }\n      &.depth-3 {\n        padding-left: 3em;\n        background: darken(@color-accordion-base, @accordion-darken-step * 3);\n      }\n      &.depth-4 {\n        padding-left: 4em;\n        background: darken(@color-accordion-base, @accordion-darken-step * 2);\n      }\n      &.depth-5 {\n        padding-left: 5em;\n        background: darken(@color-accordion-base, @accordion-darken-step * 1);\n      }\n      &.depth-6 {\n        padding-left: 6em;\n        background: darken(@color-accordion-base, @accordion-darken-step * 0);\n      }\n    }\n\n    a.fc-question {\n      font-size: 1em;\n    }\n\n    a:hover {\n      text-decoration: underline !important;\n    }\n\n    .lr-breadcrumbs {\n      display: block;\n      font-size: 0.7em;\n      margin-top: 0.2em;\n\n      a {\n        color: #006621;\n      }\n      span + span::before {\n        content: \" > \";\n        color: #006621;\n        .ph2();\n      }\n    }\n\n    &.lr-leaf.depth-1 {\n      margin-top: 1em;\n    }\n  }\n\n  .lr-treenode .fc-qa {\n    box-shadow: inset 0 -1px fade(@color-accordion-text, 20%);\n  }\n\n  .ca-heading-heading {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .section-heading {\n    font-weight: 700;\n    font-size: 2.4em;\n    line-height: 1.4;\n    z-index: 2;\n    position: relative;\n    background-color: #ffffff;\n\n    a {\n      color: inherit;\n      &:hover {\n        text-decoration: none;\n      }\n    }\n\n    .tablet({\n      font-size: 2.4em;\n    });\n    .mobile({\n      font-size: 2.2em;\n    });\n\n    .right-align {\n      font-size: 0.6em;\n      font-weight: normal;\n      float: right;\n      color: #999;\n      fill: #999;\n      line-height: 2.6em;\n\n      i {\n        font-size: 2em;\n        vertical-align: middle;\n      }\n\n      a,\n      a:hover {\n        text-decoration: none;\n        display: inline;\n      }\n\n      .svg-icon {\n        font-size: 1.4em;\n        position: relative;\n        top: 0.1em;\n        margin: 0 0.3em;\n      }\n\n      a:hover {\n        color: #666;\n        fill: #666;\n      }\n\n      .spacer {\n        margin: 0 1em 0 2em;\n        &::before {\n          content: \"|\";\n        }\n      }\n\n      .flavoured {\n        font-weight: bold;\n      }\n    }\n  }\n\n  table:not(.tinymce-generated-content) {\n    width: 100%;\n\n    td {\n      vertical-align: top;\n      &.button {\n        width: 1em;\n        font-weight: normal;\n\n        a {\n          color: inherit;\n        }\n      }\n    }\n\n    .align-middle {\n      vertical-align: middle;\n    }\n  }\n\n  .ca-content table {\n    width: unset;\n    td {\n      vertical-align: unset;\n    }\n  }\n\n  .checkbox-widget {\n    margin: 0;\n    font-size: 18px;\n  }\n\n  &.header {\n    width: 100%;\n    background-color: #e5e5e5;\n\n    .container {\n      max-width: @page-max-width;\n      width: 100%;\n      margin-left: auto;\n      margin-right: auto;\n      padding: 0;\n\n      .fullscreen({\n        width: 96%;\n      });\n\n      .fc-section-header {\n        padding-left: 0;\n        padding-right: 0;\n      }\n    }\n\n    &.toc {\n      // .desktop-left-expanded({\n      //   .transform(translate(@page-left-width / 2, 0));\n      // });\n    }\n\n    .fc-section-checkbox {\n      display: block;\n      background-color: #e5e5e5;\n      font-size: 1.8em;\n      line-height: 1.1em;\n      color: #000000;\n      font-weight: 400;\n      padding: 0.5em 5px;\n\n      .mobile({\n        font-size: 1.5em;\n        padding: 0.5em 0;\n\n        table tr td.button {\n          padding: 0 5px;\n        }\n        table tr td.button.big {\n          padding: 0 5px 0 0;\n        }\n      });\n\n      table {\n        td {\n          vertical-align: middle;\n          height: inherit;\n\n          &.button {\n            padding: 0 10px 0 5px;\n          }\n\n          &.button.big {\n            padding: 0 5px;\n            font-size: 1.1em;\n          }\n        }\n      }\n\n      input {\n        height: 1.7em;\n        border: 1px solid #000000;\n        padding: 0 10px;\n        font-size: 0.8em;\n        margin-left: 5%;\n        width: 94%;\n        outline: none;\n        display: inline-block;\n        vertical-align: top;\n      }\n    }\n  }\n\n  .excerpt {\n    font-size: 1.8em;\n    font-weight: 200;\n    margin: 0 0 2em;\n\n    .mobile({\n      padding: 0 18px;\n      font-size: 1.3em;\n    });\n  }\n\n  .navigation {\n    font-size: 1.9em;\n\n    a {\n      display: block;\n      padding: 0.3em 0.5em;\n      background: #666;\n      color: #fff;\n      text-decoration: none;\n\n      &:focus {\n        text-decoration: none;\n      }\n    }\n\n    .mobile({\n      font-size: 1.4em;\n    });\n  }\n\n  .indented {\n    font-size: 7px;\n\n    .node-crossheading {\n      margin-left: 2em;\n    }\n\n    a {\n      color: inherit;\n      display: block;\n      text-decoration: underline;\n    }\n\n    .fc-section-header {\n      padding-right: 15px;\n    }\n\n    .header-depth-1 {\n      padding-left: 10px;\n    }\n    .header-depth-2 {\n      padding-left: 20px;\n    }\n    .header-depth-3 {\n      padding-left: 30px;\n    }\n    .header-depth-4 {\n      padding-left: 40px;\n    }\n    .header-depth-5 {\n      padding-left: 50px;\n    }\n    .header-depth-6 {\n      padding-left: 60px;\n    }\n\n    .mobile({\n      .header-depth-1 { padding-left: 1em; }\n      .header-depth-2 { padding-left: 2em; }\n      .header-depth-3 { padding-left: 2.5em; font-size: 1.5em; }\n      .header-depth-4 { padding-left: 3em; }\n      .header-depth-5 { padding-left: 3.5em; }\n      .header-depth-6 { padding-left: 4em; }\n    });\n  }\n\n  .padded {\n    .fc-section-header,\n    .fc-qa {\n      padding-left: 15px;\n      padding-right: 15px;\n    }\n  }\n\n  /* === Sections / Targetted Styles === */\n  .fc-section-header {\n    border: none;\n    background-color: #000000;\n    margin: 0px 0;\n    line-height: 1.2em;\n    padding: 0.5em 0;\n    width: 100%;\n    margin: 0;\n\n    .number {\n      display: inline-block;\n      margin-right: 1em;\n      font-size: 0.7em;\n      line-height: 1.8em;\n      vertical-align: top;\n      text-transform: uppercase;\n    }\n\n    &.header-depth-1 {\n      border-bottom: none;\n      font-size: 3em;\n      color: #ffffff;\n      table td.button {\n        color: #ffffff;\n      }\n    }\n\n    &.header-depth-2 {\n      background-color: #e5e5e5;\n      border-bottom: none;\n      font-weight: 500;\n      font-size: 2.6em;\n    }\n\n    &.header-depth-3 {\n      background-color: #fff;\n      color: #002a5b;\n      border-bottom: 1px solid #e5e5e5;\n      font-size: 2.4em;\n    }\n    &.header-depth-4 {\n      background-color: #fff;\n      color: #002a5b;\n      border-bottom: 1px solid #e5e5e5;\n      font-size: 2.2em;\n    }\n    &.header-depth-5 {\n      background-color: #fff;\n      color: #002a5b;\n      font-size: 2em;\n    }\n    &.header-depth-6 {\n      background-color: #fff;\n      color: #002a5b;\n      font-size: 2em;\n    }\n\n    .mobile({\n      &.header-depth-1 {\n        font-size: 2em;\n      }\n\n      &.header-depth-2 {\n        font-size: 1.8em;\n      }\n\n      &.header-depth-3 {\n        font-size: 1.7em;\n      }\n      &.header-depth-4 {\n        font-size: 1.6em;\n      }\n      &.header-depth-5 {\n        font-size: 1.5em;\n      }\n      &.header-depth-6 {\n        font-size: 1.4em;\n      }\n    });\n  }\n\n  .space-maker {\n    opacity: 0;\n  }\n\n  & > .fc-section-tree {\n    margin-top: 9px;\n  }\n\n  /* Smaller Section styles */\n  .small-sections .fc-section-header {\n    h1,\n    h2,\n    h3 {\n      line-height: 55px;\n      font-size: 30px;\n    }\n    h3,\n    h4,\n    h5 {\n      padding: 0px;\n    }\n  }\n\n  .small-sections .pull-right {\n    height: 55px;\n  }\n\n  /* Level 2 heading */\n  .fc-section-body .fc-section-header,\n  .panel {\n    background-color: #e5e5e5;\n  }\n\n  /* Level 3 heading */\n  .fc-section-tree .fc-section-children .fc-section-body .fc-section-header {\n    background-color: #fff;\n    color: #002a5b;\n  }\n\n  /* === Typography/Headings Styles === */\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: #2c2e83;\n  }\n\n  h1 {\n    font-size: 3.6em;\n    line-height: 40px;\n    padding: 19px 0px 21px 0;\n  }\n\n  h2 {\n    font-size: 3.4em;\n    line-height: 41px;\n  }\n\n  h3 {\n    font-size: 2.8em;\n    line-height: 33px;\n  }\n\n  h4 {\n    font-size: 2.4em;\n    line-height: 28px;\n  }\n\n  h5 {\n    font-size: 2.2em;\n    line-height: 26px;\n  }\n\n  h6 {\n    font-size: 2em;\n    line-height: 24px;\n  }\n\n  section h1 {\n    font-size: 3em;\n  }\n\n  ol:not(.tinymce-generated-content) {\n    counter-reset: li;\n\n    & > li {\n      position: relative;\n      list-style: none;\n      margin-bottom: 0.2em;\n\n      &::before {\n        content: \"(\" counter(li, lower-alpha) \")\";\n        counter-increment: li;\n        position: absolute;\n        left: -2em;\n        font-size: 0.9em;\n        line-height: 1.7em;\n        color: #444;\n      }\n    }\n\n    ol li::before {\n      content: \"(\" counter(li, lower-roman) \")\";\n    }\n  }\n\n  .ca-content {\n    // hacks on hacks on hacks\n    ol:not(.tinymce-generated-content) {\n      & > li {\n        list-style: inherit;\n        &::before {\n          content: none;\n        }\n      }\n\n      ol li::before {\n        content: none;\n      }\n    }\n  }\n\n  .capitalize::first-letter {\n    text-transform: uppercase;\n  }\n\n  .no-border {\n    border: none !important;\n  }\n\n  /* Questions - Collapsable */\n  .fc-qa {\n    padding: 0.7em 2em 0.8em 0;\n\n    .mobile({\n      padding: 0.7em 0.5em 0.8em 0;\n    });\n\n    &.expanded {\n      border-bottom: 1px solid #e5e5e5;\n    }\n\n    &:last-child {\n      padding-bottom: 2em;\n      .mobile({\n        padding-bottom: 0;\n      });\n\n      .fc-answer {\n        border-bottom: none;\n        margin-bottom: 0px;\n      }\n    }\n    &:first-child {\n      padding-top: 1.5em;\n      .mobile({\n        padding-top: 1em;\n      });\n    }\n\n    &.selected:last-child {\n      border-bottom: none;\n    }\n\n    &.selected + .fc-qa {\n      margin-top: 8px;\n    }\n\n    &.selected.highlight {\n      margin: 8px 0;\n      border-left: 8px solid #e5e5e5;\n      padding-left: 10px;\n      // border-right: 10px solid #e5e5e5;\n      // padding-right: 5px;\n    }\n  }\n\n  .fc-qa,\n  .fc-section-header {\n    table td.button {\n      font-size: 18px;\n      color: #000000;\n      padding: 0 11px;\n\n      .mobile({\n        padding: 0 5px;\n      });\n    }\n  }\n\n  .fc-answer.section-content {\n    font-size: 1.6em;\n\n    .mobile({\n      // font-size: 1.2em;\n    });\n  }\n\n  .fc-em {\n    font-style: italic;\n  }\n\n  .fc-p,\n  .fc-indent {\n    padding-left: 2.2em;\n    display: block;\n    position: relative;\n    top: 0;\n    left: 0;\n    margin: 0.5em 0;\n\n    .reference,\n    .fc-reference {\n      position: absolute;\n      top: 0;\n      left: 0.2em;\n      color: inherit;\n      display: block;\n      font-size: 0.9em;\n      line-height: 1.7em;\n      font-weight: normal;\n\n      .fc-stacked-reference-2 {\n        position: absolute;\n        left: -2.6em;\n      }\n      .fc-stacked-reference-3 {\n        position: absolute;\n        left: -5.2em;\n      }\n      .fc-stacked-reference-4 {\n        position: absolute;\n        left: -7.8em;\n      }\n    }\n\n    &.mark {\n      .bg-light-yellow();\n      padding: 0 0 0 2.2em;\n    }\n\n    .mobile({\n      padding-left: 1.3em;\n\n      .reference, .fc-reference {\n        left: 0;\n\n        .fc-stacked-reference-2 {\n          position: absolute;\n          left: -1.6em;\n        }\n        .fc-stacked-reference-3 {\n          position: absolute;\n          left: -3.2em;\n        }\n        .fc-stacked-reference-4 {\n          position: absolute;\n          left: -4.8em;\n        }\n\n      }\n    });\n  }\n\n  .fc-indent {\n    margin-left: 2.2em;\n    .fc-indent {\n      margin-left: 0;\n    }\n  }\n\n  .fc-amend {\n    display: block;\n    position: relative;\n    margin: 2em 0;\n    padding-left: 1em;\n\n    border-left: 3px solid #eeeeee;\n\n    .fc-crossheading > .fc-title {\n      font-weight: bold;\n      margin: 0 0 1em -1em;\n    }\n    .fc-schedule {\n      padding-left: 2.2em;\n      position: relative;\n\n      .fc-title {\n        margin: 0 0 0 1em;\n      }\n      .fc-part {\n        display: block;\n      }\n      & > .reference {\n        left: -1em;\n        font-weight: bold;\n        font-size: 0.8em;\n        line-height: 1.7em;\n      }\n    }\n\n    .fc-crossheading,\n    .fc-section,\n    .fc-part,\n    .fc-chapter {\n      padding-left: 2.2em;\n      position: relative;\n\n      & > .reference {\n        left: -1em;\n        font-weight: bold;\n        font-size: 0.8em;\n        line-height: 1.7em;\n      }\n    }\n\n    .fc-section {\n      display: block;\n    }\n  }\n\n  .fc-title {\n    font-weight: bold;\n    position: relative;\n\n    .reference {\n      display: inline-block;\n      position: relative;\n      margin-left: -2em;\n      margin-right: 0.5em;\n      font-size: 1em;\n      font-weight: bold;\n    }\n  }\n\n  .fc-table {\n    display: table;\n    padding: 0 2em;\n    margin: 1em 0 3em;\n    width: 100%;\n\n    .fc-tr {\n      display: table-row;\n    }\n\n    .fc-td {\n      display: table-cell;\n      padding: 0.2em 1em;\n\n      & > .fc-p {\n        padding-left: 0;\n      }\n    }\n  }\n\n  .fc-section-qas {\n    border-bottom: 1px solid #e5e5e5;\n  }\n\n  .fc-question {\n    display: table-row;\n    color: #1460d1;\n    font-size: 1.8em;\n    padding: 11px 0px 0px 0px;\n    line-height: 1.3em;\n    margin-bottom: 0px; /*25*/\n    font-weight: 700;\n    text-decoration: none !important;\n\n    .fc-question-number {\n      vertical-align: top;\n      display: table-cell;\n      white-space: nowrap;\n      padding-right: 0.4em;\n    }\n\n    .fc-question {\n      vertical-align: top;\n      display: table-cell;\n      font-size: 1em;\n      padding: 0;\n    }\n\n    .fc-question-number,\n    .fc-question {\n      padding-top: 0.1em;\n\n      .tablet({\n        padding-top: 0.3em;\n      });\n    }\n\n    .path {\n      font-weight: normal;\n      font-size: 0.75em;\n      color: #006621;\n      margin: 0.5em 0 0;\n\n      span + span:before {\n        content: \" > \";\n        color: #006621;\n      }\n    }\n  }\n\n  .row {\n    .col-fluid {\n      display: table-cell;\n      vertical-align: top;\n      width: 100%;\n      padding: 0 17px;\n    }\n\n    .col-checkbox {\n      display: table-cell;\n      vertical-align: top;\n      &:first-child {\n        padding: 0 0 0 17px;\n      }\n      &:last-child {\n        padding: 0 17px 0 0;\n      }\n    }\n\n    .tablet({\n      .col-checkbox:last-child {\n        padding-right: 8px;\n      }\n      .col-checkbox:first-child {\n        padding-left: 8px;\n      }\n      .col-fluid {\n        padding: 0 8px;\n      }\n    });\n  }\n\n  .fc-qa,\n  .fc-section-header {\n    &.review {\n      padding-left: 18px;\n    }\n  }\n\n  /* === Section / Level Specific Styles === */\n\n  .fc-answer.collapse.in {\n    margin-bottom: 8px;\n  }\n\n  .fc-answer {\n    display: block;\n    // padding-top: 2em;\n    padding-bottom: 0.8em;\n    // font-size: 1.6em;\n\n    p {\n      margin: 0.5em 0;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    ol {\n      list-style-type: lower-alpha;\n      padding-left: 2em;\n      margin-bottom: 0px;\n      ol {\n        list-style-type: lower-roman;\n      }\n    }\n\n    a {\n      // white-space: nowrap;\n      overflow: hidden;\n      // text-overflow: ellipsis;\n      // max-width: 250px;\n      // display: inline-block;\n      display: inline;\n      vertical-align: top;\n    }\n  }\n\n  .fc-answer-wrap p,\n  .fc-glossary,\n  .fc-legislation {\n    font-weight: 400;\n    color: #231f20;\n\n    font-size: 1em;\n  }\n\n  .fc-legislation {\n    border-bottom: 1px dashed #a6a6a6;\n    top: 0;\n    left: 0;\n    outline: none;\n    cursor: pointer;\n\n    &:hover {\n      // text-decoration: underline;\n    }\n\n    .fc-reference,\n    .fc-labels {\n      display: none;\n    }\n\n    .fc-glossary {\n      border-bottom: none;\n    }\n  }\n\n  .legislation-reference-title {\n    width: 100%;\n\n    td.title {\n      max-width: 0;\n      padding-bottom: 0.4em;\n    }\n\n    a {\n      text-overflow: ellipsis;\n      display: block;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n    // display: block;\n    // position: absolute;\n    // white-space: nowrap;\n    // overflow: hidden;\n    // width: 90%;\n    // a {\n    //   text-overflow: ellipsis;\n    // }\n  }\n\n  .legislation-reference-body {\n    position: absolute;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    bottom: 0;\n    top: 6em;\n    z-index: 1;\n    padding-right: 10px;\n    right: 0;\n    left: 15px;\n\n    .fc-section-body {\n      .fc-section-header {\n        background: none;\n        border-bottom: none;\n      }\n\n      .header-depth-2 {\n        font-size: 1.8em;\n        font-weight: bold;\n      }\n      .header-depth-3 {\n        font-size: 1.8em;\n        font-weight: bold;\n      }\n      .header-depth-4 {\n        font-size: 1.8em;\n        margin-left: 1em;\n      }\n    }\n\n    .fc-section-qas {\n      border-bottom: none;\n      .fc-qa {\n        border-bottom: none;\n        padding: 0 !important;\n      }\n    }\n\n    .tablet({\n      top: 6em;\n    });\n  }\n\n  .fc-answer-wrap ul,\n  .fc-answer-wrap ol {\n    font-weight: 400;\n  }\n\n  .fc-glossary {\n    white-space: nowrap;\n    border-bottom: 1px dashed #a6a6a6;\n    top: 0;\n    left: 0;\n    outline: none;\n    cursor: pointer;\n\n    &.focus {\n      position: relative;\n\n      .mobile({\n        background: #DDDDDD;\n      });\n    }\n  }\n\n  a.fc-cross-reference,\n  a.fc-news-reference,\n  a.fc-document-reference {\n    color: @color-link;\n    display: inline;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  li p {\n    margin-bottom: 0px;\n  }\n\n  p {\n    margin-bottom: 9px;\n  }\n\n  p a {\n    color: @color-link;\n  }\n\n  .fc-legislation-reference,\n  .fc-legislation-reference-range,\n  .fc-canonical-case-reference {\n    display: none;\n    visibility: hidden;\n  }\n\n  .fc-case-reference {\n    font-weight: bold;\n  }\n\n  .popover {\n    max-width: 300px;\n  }\n\n  .fc-partialnote,\n  .fc-jurisdictionnote {\n    font-size: 0.8em;\n    font-style: italic;\n    color: #555;\n    display: inline-block;\n    font-weight: normal;\n    padding: 0.4em 1em;\n    background: #eee;\n  }\n\n  .tablet({\n    h1, .fc-section-header h1{\n      font-size: 1.7em;\n    }\n\n    .fc-section-header {\n      h2 {\n        font-size: 1.8em;\n      }\n      h3 {\n        font-size: 1.7em;\n      }\n      h4 {\n        font-size: 1.6em;\n      }\n      h5 {\n        font-size: 1.6em;\n      }\n      h6 {\n        font-size: 1.6em;\n      }\n    }\n\n    .fc-question {\n      padding-left: 0px;\n      padding-right: 20px;\n      font-size: 1.4em;\n    }\n\n    .fc-answer > p {\n      padding-left: 0px;\n      padding-right: 20px;\n    }\n\n    .fc-answer ol {\n      padding-left: 1.5em;\n      padding-right: 1.5em;\n      margin-bottom: 1em;\n    }\n\n    /* Targetted */\n    & > section > .fc-section-body > .fc-section-children > section > .fc-section-body >\n    .fc-section-children > section > .fc-section-header h3 {\n      padding: 12px 1px 12px 0px;\n    }\n  });\n\n  .reference-range {\n    font-size: 14px;\n    .mobile({\n      font-size: 11px;\n    });\n  }\n\n  /* Mobile Devices */\n  .mobile({\n\n    .fc-answer ol {\n      padding-left: 18px;\n    }\n\n    // .fc-qa:first-child .fc-question {\n    //   padding-top: 14px;\n    // }\n\n    .fc-qa:last-child {\n      margin-bottom: 16px;\n      .fc-answer-wrap {\n        padding-bottom: 0px;\n      }\n    }\n\n  });\n\n  &.content-review {\n    .fc-answer-wrap {\n      font-size: 1.8em;\n      margin: 1.4em 0 0;\n      display: block;\n    }\n  }\n\n  .copyright-footer {\n    font-size: 1.4em;\n    line-height: 1.3;\n    padding: 1.5em 2em;\n    color: #888;\n  }\n\n  .large {\n    font-size: 1.8em;\n  }\n  // we want to apply to all tables when we do not have div.ca-content as immeditate child to .content-text,\n  // however sometimes the immediate child IS the table so we need to test for that separately\n  .content-text > :not(.ca-content) table:not(.tinymce-generated-content),\n  .content-text > table:not(.tinymce-generated-content) {\n    border-spacing: 1.5em;\n    border-collapse: separate;\n    margin: 0 -1.5em;\n  }\n\n  .content-text [class^=\"icon-bottle\"] {\n    font-size: 1.5em;\n    vertical-align: sub;\n  }\n\n  .bottle-icon {\n    display: inline-block;\n    vertical-align: middle;\n    width: 2.4em;\n    height: 2.4em;\n    background-size: 2.4em !important;\n  }\n\n  .nowrap {\n    white-space: nowrap;\n  }\n}\n\nspan.wj {\n  font-size: 0 !important;\n}\n\n.flavour-full .section-heading .right-align .flavoured,\n.color-full {\n  color: @fullSearch;\n  fill: @fullSearch;\n  &.active {\n    color: @white;\n    fill: @white;\n  }\n}\n.flavour-semi .section-heading .right-align .flavoured,\n.color-semi {\n  color: @semiSearch;\n  fill: @semiSearch;\n  &.active {\n    color: @white;\n    fill: @white;\n  }\n}\n.flavour-skimmed .section-heading .right-align .flavoured,\n.color-skimmed {\n  color: @skimmedSearch;\n  fill: @skimmedSearch;\n  &.active {\n    color: @white;\n    fill: @white;\n  }\n}\n.flavour-archive .section-heading .right-align .flavoured,\n.color-archive {\n  color: @archive;\n  fill: @archive;\n  &.active {\n    color: @white;\n    fill: @white;\n  }\n}\n\n.color-legislation {\n  color: @legislation;\n  fill: @legislation;\n  &.active {\n    color: @white;\n    fill: @white;\n  }\n}\n\n.content-depth {\n  font-size: 1em;\n  color: #fff;\n  margin-right: 0.2em;\n  margin-left: 1em;\n\n  .content-depth-text {\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .desc {\n    color: #666;\n  }\n\n  i {\n    font-size: 1.7em !important;\n    vertical-align: sub;\n  }\n\n  &.full {\n    color: @fullSearch;\n  }\n  &.semi {\n    color: @semiSearch;\n  }\n  &.skimmed {\n    color: @skimmedSearch;\n  }\n}\n\n.popover-container {\n  font-size: 1.6em;\n\n  .popover {\n    margin-top: 10px;\n    max-width: 450px;\n    font-size: 0.8em;\n    .transition(opacity 0.2s);\n\n    p {\n      margin: 0;\n    }\n\n    p + p {\n      margin: 1em 0 0;\n    }\n\n    .mobile({\n      font-size: 1em;\n      max-width: calc(100vw - 1.5rem);\n    });\n\n    &.show {\n      opacity: 1;\n      &.fade-leave-active {\n        opacity: 0;\n      }\n    }\n  }\n}\n\n.comment-body .public-DraftEditor-content,\n.comment-body .content-view {\n  h1 {\n    font-size: 1.4em;\n    font-weight: normal;\n    margin: 0 0 0.3em;\n    padding: 0;\n    line-height: normal;\n  }\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: 1.2em;\n    font-weight: normal;\n    margin: 0 0 0.4em 0.8em;\n    padding: 0;\n    line-height: normal;\n  }\n  p,\n  .paragraph {\n    margin: 0 0 0.5em 1em;\n  }\n\n  ol,\n  ul {\n    margin-left: 0.5em;\n  }\n\n  ol li::before {\n    content: \"(\" counter(li) \")\";\n  }\n}\n\n.comment-body .public-DraftEditor-content .paragraph {\n  margin: 0 0 0.5rem 0;\n}\n","// For helpful information on how to customize Material-ui components please read\n// material-ui.com/customization/components/#customizing-components\n\n// For workarounds concerning Material-ui Grid issues please read\n// material-ui.com/components/grid/#limitations\n\n@import '../../node_modules/normalize.css/normalize.css';\n@import '../../node_modules/react-toastify/dist/ReactToastify.css';\n@import 'config/fonts/stylesheet.less';\n@import 'config/variables';\n@import 'config/media';\n\n@import 'base';\n\n@import 'utils/layout';\n@import 'utils/spacing';\n@import 'utils/theming';\n@import 'utils/typography';\n@import 'home-page';\n@import 'precedents';\n@import 'texteditor';\n@import 'markets-search';\n@import 'icons';\n\n@import 'fix';\n@import 'grid';\n@import 'helpers';\n@import 'hamburger';\n@import 'custom';\n@import 'pdf';\n\n// legacy BS I didn't want to have to deal with right now\n@import 'config/legacy-variables.less';\n@import 'accordion-legacy.less';\n@import 'content.less'; // don't think we can ever remove this but we can at least make sure its not using legacy config eventually\n\n\n.svg-base {\n  display: inline-block;\n  line-height: 1;\n  svg {\n    fill: currentColor;\n    vertical-align: middle;\n    width: 100%;\n    height: 100%;\n    g {\n      stroke: currentColor;\n    }\n    path {\n      fill: inherit;\n    }\n  }\n}\n\n.icon-base {\n  position: relative;\n  height: auto;\n  svg {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n  }\n}\n\n.icon-base:after {\n  content: \"\";\n  display: block;\n  padding-bottom: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
